import * as React from 'react';
import { Typography, OutlinedInput, InputAdornment, FormControl, InputLabel, Select, Badge, Tab, Tabs, Autocomplete, Grid, Checkbox, FormControlLabel, FormGroup, Table, TableHead, TableRow, TableCell, TableBody, TableContainer,  Card, Switch } from '@mui/material';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import { withRouter } from "react-router-dom";
import RouterComponent from '../Utility/RouterComponent';
import './NavbarApp.css';
import Avatar from '@mui/material/Avatar';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { localGetItem, localClearAll, clearAllCachevalue, localClearItem, clearCachevalue, localSetItem, setCachevalue, getCachevalue, getClinicIdWithContext } from '../Utility/Services/CacheProviderService';
import Dialog from '@mui/material/Dialog';
import { NewSideMenu } from '../Utility/SideMenuList';
import TextField from '@mui/material/TextField';
import { Trans, withTranslation } from 'react-i18next';
import { Colors } from "../Styles/Colors";
import Loader from '../Components/Loader';
import { AppBarMenus } from './AppBarMenus';
import Settings from '../Shell/MenuComponents/Settings';
import Button from '@mui/material/Button';
import { Modal, Paper } from '@mui/material';
import Success from '../Assets/Animation/Success.gif'
import DialogPop from '../Components/Dialog'
import { ImagePaths } from '../Utility/ImagePaths';
import Saved_Bill from '../Modules/Laboratory/Home/Saved_Bill';
import Transmit from '../Modules/Laboratory/Home/Transmit';
import { Serviceurls } from '../Utility/API/Serviceurls';
import RestAPIService, { APP_Support_Label, APP_Version_Label } from '../Utility/Services/RestAPIService';
import ToastMsg from '../Components/ToastMsg/ToastMsg';
import '../Styles/CommonTableStyles.css';
import GridViewIcon from '@mui/icons-material/GridView';
import { CommonGridHeaderOnlySearch, CommonPatientDetails, CommonPopUp, ConfirmPopup, DeletePopup, NewCommonPatientDetails, renderInsCorpDetails } from '../Components/Common Components/CommonComponents';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import HistoryIcon from '@mui/icons-material/History';
import Webcam from "react-webcam";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { AmountFormat, CalculateAgeFromDob, convertDateTime, formatDate, formatDateAndTimeMeth2, GetInvestigationName, timeOnlyConvert, ContentInTooltip, clearAccessCache,fetchAndConvertToBase64 } from "../Components/CommonFunctions/CommonFunctions";
import { Edit, HelpOutline } from '@mui/icons-material';
import { DateTime } from 'luxon';
import ErrorIcon from '@mui/icons-material/Error';
import { appointment_Status_opt, DOC_PRINT_DEFAULT, Header_Filter_Fields, NO_Internet_Connection, OTHER_INVESTIGATION_CONFIG_DATA,FO_DOC_PRINT_DEFAULT, labelMap, Cancel_appointment_Status_opt } from '../Utility/Constants';
import CloseIcon from '@mui/icons-material/Close';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import DescriptionIcon from '@mui/icons-material/Description';
import Prescription from '../Modules/Pharmacy/PharmacyHome/HeaderComponents/Prescription';
import SavedBill from '../Modules/Pharmacy/PharmacyHome/HeaderComponents/SavedBill';
import IPReturns from '../Modules/Pharmacy/PharmacyHome/HeaderComponents/IPReturns';
import IPRequest from '../Modules/Pharmacy/PharmacyHome/HeaderComponents/IPRequest';
import Appointments from '../Modules/Pharmacy/PharmacyHome/HeaderComponents/Appointments';
import CommonValidation from '../Components/CommonFunctions/CommonValidation';
import CircularProgress from '@mui/material/CircularProgress';
import { DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import LabIPList from '../Modules/Laboratory/Home/LabIPList';
import { Close } from '@material-ui/icons';
import { DataGrid } from '@mui/x-data-grid';
import WarningIcon from '@mui/icons-material/Warning';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import DrQueuePopup from './MenuComponents/DrQueuePopup';
import ReceiptIcon from "@mui/icons-material/Receipt";
import VisibilityIcon from '@mui/icons-material/Visibility';
import OtIpRequestPopup from '../Modules/OT/OtIpRequestPopup';
import { City, Country, State } from 'country-state-city';
import PrintPreviewPop from '../Components/Common Components/PrintPreviewPop';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import OgttGraph from '../Modules/Laboratory/Home/OgttGraph';
import OpToIpPopup from './MenuComponents/OpToIpPopup';
import CashCounterIPList from '../Modules/Laboratory/Home/CashCounterIPList';
import PatientHeaderSearch from '../Components/Common Components/PatientHeaderSearch';
import CreateTeleRequest from '../Components/Common Components/CreateTeleRequst';
import { createFilterOptions } from "@mui/material/Autocomplete";
import DocumentPreviewPop from '../Components/Common Components/DocumentPreviewPop';

import { PermissionsContext  } from "../Utility/PermissionContext";
import { filterMenuBySubscription  } from "../Utility/AccessUtils";
import RTDiscApprovalPopup from './MenuComponents/RTDiscApprovalPopup';

import { BILLING_DATA_TOGGLE_EVENT } from '../Utility/BillingDataSourceHelper';

const openedMixin = (theme) => ({
  width: '20vw',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: '20vw',
    width: `calc(100% - 20vw)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: '20vw',
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

let flag = true

const STYLES = {
  FONT_SIZE_LOW_2: "14px",
  FONT_SIZE_LOW_3: "12px",
  FONT_WEIGHT: "bold"
};

const bookedThroughObj = {
  "Mobile": { title: "MobileAppointment", icon: ImagePaths.Phone.default },
  "FO": { title: "TelephonicAppointment", icon: ImagePaths.Telephonic.default },
  "Web": { title: "WebAppointment", icon: ImagePaths.Web.default }
}

const module_typeObj = {
  "front_office": "fo",
  "Laboratory": "lab",
  "Radiology": "radiology",
  "Pharmacy": "pharmacy",
  "Doctor": "fo",
}

const restrictedLabels = new Set(["Reports", "Report", "Billing Transaction", "Login", "Audit Track", "Settings", "Dashboard", "Masters", "Registry", "MRD"]);
const MAX_RECONNECT_ATTEMPTS = 5;

class MiniDrawer extends React.Component {
  static contextType = PermissionsContext;
  constructor(props) {
    super(props);
    this.webcamRef = React.createRef();
    this.state = {
      drawer_Open: false,
      anchorElUser: false,
      loggedInuserInfo: JSON.parse(localGetItem("loggedInUserInfo")),
      checked: false,
      globalSearch: '',
      menuId: null,
      selectedMenuId: null,
      selectedSubMenuId: null,
      isLoader: false,
      isSavedBill: false,
      isHelpdeskClicked: false,
      helpDescription: "",
      helpSubject: "",
      isTranmitedBill: false,
      searchkey: "",
      searchPatientDetails: {},
      selectedPageName: "",
      isPatientSearch: false,
      configSearch: '',
      selectedSubScreen: "",
      purchaseSearch: '',
      inventorySearch: "",
      reportSearch: "",
      clinicData: [],
      clinic_name: null,
      clinicId: null,
      DoctorsList: [],
      SelectedDoctor: 0,
      PatientSearchClicked: false,
      AddressFilterClicked: false,
      SearchedPatientList: [],
      PatientNameSearchKey: "",
      PatientAddressKey: "",
      PatientFathHusKey: "",
      SelectedIPDoctor: 0,
      temp_patient_img: null,
      patient_img: null,
      FoRequestList: [],
      logedUsername: "",
      LabPatientSearch: false,
      searchPatientDatas: [],
      selectedPatientData: {},
      filterDate: new Date(),
      datePicker: new Date(),
      isOnline: window.navigator.onLine,
      RequestPopUp: false,
      DatePickerOpen: false,
      ph_returns: false,
      ph_Prescrition: false,
      ph_SavedBill: false,
      ph_request: false,
      ph_Appointments: false,
      pharmaPatientList: [],
      pharmaSearchClicked: false,
      pharmaNameSearchKey: '',
      isPatientisSearching: false,
      SelectedRequestTab: "appointment_request",
      RequestMobileNumber: "",
      SearchedRequestPatientList: [],
      SelectedRequestPatient: {},
      RequestPatientMenuPop: false,
      doctorList: [],
      filteredDocList: [],
      spcInfo: [],
      RequestSelectedDocID: null,
      RequestSelectedSpecID: null,
      RequestPatientName: "",
      RequestPatientAge: "",
      RequestPatientDOB: null,
      RequestPatientGender: "",
      RequestAppointDatetym: new Date(),
      POVList: [],
      RequestpurposeOfVisit: "",
      SelectedDoctorClinic: '',
      SearchDoctorPatientList: [],
      ClinicList: [],
      isFrontCamera: true, 
      facingMode : 'user', 
      devices : [],
      disableProcess : false,
      doctorAnchor: null,
      openDoctorPrint: false,
      all: true,
      booked: true,
      arrived: true,
      withNurse: true,
      withDoctor: true,
      completed: true,
      cancelled: true,
      doctorClinicId: '',
      doctorAppointmentDate: new Date(),
      doctorAppointmentAnchor: null,
      doctorAppointmentData: [],
      openDoctorAppointment: false,
      doctorTab: 'one',
      patientDetails: {},
      postLoad: false,
      doctorPatientAppointmentId: '',
      doctorPatientId: '',
      openDoctorNotesPrintAnchor: null,
      openDoctorNotesPrint: false,
      fullReport: false,
      symptoms: true,
      allergies: false,
      vitals: false,
      examination: false,
      diagnosis: true,
      prescription: true,
      prevPrescrip: false,
      test: false,
      plan: false,
      counselling: true,
      generalPatient: true,
      complaints: true,
      ocular: true,
      Illness: true,
      vision: true,
      gonioscopy: true,
      autoRefract: false,
      prevGlassPower: false,
      subjectiveRefract: false,
      retinoscopicRefract: false,
      IntraPressure: true,
      Anterior: true,
      AnteriorImg: true,
      Posterior: true,
      fundus: false,
      Keratometry: false,
      medication: true,
      glassPrescrib: true,
      Review: true,
      Treatment: true,
      investigation: true,
      OtherInvestigation: true,
      editAppointmentId: null,
      isClked: false,
      isappointRequest: false,
      editPatientId: null,
      docDateOpen: false,
      docSelectedRequestTab: 'appointment_request',
      docDatePickerOpen: false,
      docRequestMobileNumber: "",
      docSelectedRequestPatient: {},
      docRequestSelectedDocID: null,
      docRequestSelectedSpecID: null,
      docRequestPatientAge: "",
      docRequestPatientName: "",
      docRequestPatientDOB: null,
      docRequestPatientGender: "",
      docRequestAppointDatetym: new Date(),
      docRequestpurposeOfVisit: "",
      docfilteredDocList: [],
      doceditAppointmentId: null,
      doceditPatientId: null,
      docisClked: false,
      docDatePicker: new Date(),
      isDocAppointRequest: false,
      docSearchedRequestPatientList: [],
      docRequestPatientMenuPop: false,
      ph_IpPatientList: false,
      ipPatientListData: {},
      Lab_IpPatientList: false,
      App_DocID: null,
      isOPT: false,
      isOptometry: false,
      transferReqData: [],
      unlockDocData: [],
      followUpData: [],
      follow_up_date: new Date(),
      followDatePickerOpen: false,
      TransAppoint: false,
      OTrequestPopup: false,
      OTallocationPopup: false,
      OTreqData: [],
      allocationDetails: {},
      AcceptRequest: false,
      OTRoomData: [],
      selectedOT: null,
      selectedSlot: null,
      OTdetails: [],
      disableBtn: false,
      // Radiology Keys
      searchPatientRadiologyList: [],
      rad_request: false,
      rad_appointment: false,
      radAppAnchorEL: null,
      radReqAnchorEl: null,
      radAppointmentList: [],
      radIpList: [],
      searchRadAppointment: '',
      searchRadIpList: '',
      dupIpListData: '[]',
      dupAppointmentList: '[]',
      radAppointmentDate: new Date(),
      radIpListDate: new Date(),
      radDatePickerOpen: false,
      radSavedBillListData: [],
      dupRadSavedBill: '[]',
      rad_saved_bill: false,
      radSavedBillAnchcor: null,
      saveReason: false,
      removeData: false,
      selectedSavedId: null,
      address_2 : "",
      address_1: "",
      city: "",
      cityName: City.getCitiesOfState("IN", "TN"),
      country_code: 'IN',
      state_code: 'TN',
      AllCountry: Country.getAllCountries(),
      AllStates: State.getStatesOfCountry("IN"),
      pin_code: "",
      overallNotes: false,
      deletePopup: false,
      selectedId: null,
      patientSearch: '',
      duplicateFoReqList: [],
      unlockDocDataCount: 0,
      PatientMotherKey: "",
      error: false,
      errorFathhus: false,
      labHistoryData: [],
      labHistoryPopup: false,
      labPatientData: null,
      page: 0,
      pageSize: 10,
      viewCultureData: [],
      isViewHistory: false,
      IdleAlertPopup: false,
      OcularResponse: false,
      common_uhid: false,
      rowsPerPage: 5,
      page: 0,
      badgeCount: {},
      smsAlert: false,
      FoNotifyList: {},
      notifyPopup: false,
      drQueueData: [],
      isInfoMsg: false,
      CallPatientTrigger: false,
      isInfoMsgText: '',

      // New Print States In Doctor Notes
      doctorPrintList: {},
      dupDocPrintList: '{}',
      printLoad: false,
      QrEntryList: [],
      QRPatientName: "",
      RegistrationDate: new Date(),
      QREntryPopUp: false,
      
       // New FO Print States for Doctor Notes
      doctorFOPrintList: FO_DOC_PRINT_DEFAULT ? JSON.parse(JSON.stringify(FO_DOC_PRINT_DEFAULT)) : [],
      // dupFODocPrintList: '[]',
      openFoNotesPrintAnchor: null,
      openFODocNotesPrint: false,

      // radiology transmit 
      rad_transmit: false,
      radTransAnchorEL: null,
      radTransmitList: [],
      srchRadTranskey: "",
      radTransFltDate: new Date(),
      printOTApp: false,
      is_labOpList_clked: false,

      // Lab Ip Request and Transmit states
      isIPRequest: false,
      ipReqAnchor: null,
      labDatePickerOpen: false,
      labIpReqDate: new Date(),
      ipLabRequestList: [],
      dupLabReqList: '[]',
      searchLabIpRequest: '',
      labNameList: [],
      labId: '',
      labName: '',
      ipLabTransmitList: [],
      dupLabTraList: '[]',
      ipTraLoad: false,
      ipTransAnchor:null,
      isIPTrans:false,
      labTransDatePickerOpen:false,
      labIpTransDate:new Date(),
      unlockDate: "",

      FilterDob : null,
      FilterUHID : "",
      FilterIP: "",
      FilterOP: "",
      OT_IP_Request: false,
      indent_Count: {},
      pdfPreview: false,
      pdfData: '',
      ImgData: '',
      radSavedBillDate: new Date(),

      openTransferList: false,
      transDatePickerOpen: false,
      datePickerTrans: new Date(),
      transDataList: [],
      transPage: 0,
      transPageSize: 10,
      loading: false,
      IncludeRadiology: true,
      IncludeLab: true,

      // New Doctor Notes States
      openAlertPopup: false,

      specialization  : "",
      CashCounterRefundRequestList : [],
      isOpDraft:false,
      isOpDraftAnchor:null,
      searchOpDraftList:'',
      opDraftDate:new Date(),
      opDraftDatePickerOpen:false,
      opDraftList:[],
      opDraftPage:0,
      opDraftPageSize:10,
      isOpList:false,
      isOpListAnchor:null,
      opListData:[],
      opListDate:new Date(),
      opListDatePickerOpen:false,
      opListLoad:false,
      searchOpList:'',
      dupOpList:'[]',
      isOpOrder:false,
      isOpOrderAnchor:null,
      opOrderDate:new Date(),
      opOrderList:[],
      searchOpOderList:'',
      opOrderPage:0,
      opOrderPageSize:10,
      opOderDatePickerOpen:false,
      dupOpDraftList:'[]',

      approverDate:new Date,
      approverDatePickerOpen:false,
      approverList:[],
      dupApproverList:'[]',
      openApproverList:false,
      searchApproverList:'',
      dupOpOrderList: '[]',
      isViewOgtt: false,
      viewOgttData: {},
      selectedOgttRowId: null,
      hasAbha: false,
      AbhaQrList: [],
      AbhaQrPopUp: false,
      AbhaQrPatientName: '',
      AbhaQRRegDate: new Date(),
      isAbhaQrRegistered: false,
      abhaPopupData: {},
      isUpdateAbhaPopup: false,
      AbhaExistingData: null,
      AbhaPatientdata: null,
      AbhaPatientUHID: null,
      AbhaCompareQrID: null,
      approverLoad: false,
      // move to op to ip
      oPRequestPopUp: false,

       isIpList:false,
      isIpListAnchor:null,
      ipList:[],
      ipListDate:new Date(),
      ipListDatePickerOpen:false,
      ipListLoad:false,
      searchIpList:'',
      dupIpList:'[]',
      cash_IpList: false,
      whatsappAlert: false,
      insuToolOpen: true,
      isNotifyLoader: false,
      notifyTabIndex: "0",
      notifyCount: 0,
      radHistoryPopup: false,
      patientHistory:[],
      patientDatasRow:{},
      printPreviewPop: false,
      printPreviewData: [],
      pdfName: '',
      // Multi Doctor Dropdown
      MultiDoctorValue: null,
      MultiDoctorList: [],
      //data fetching flag
      doctorRequestData:[],
      DoctorRequestPopup: false,
      pathName: "",
      subscription_alert_message: "",
      subscription_expired: false,
      walkInAppointData: [],
      dupwalkInAppointData: "[]",
      RTDiscApprovalDeails : null,
      isRTConcession: false,
      pharmaCashCounterBillsOpen: false,
      pharmaCashCounterBillsAnchor: null,
      pharmaCashCounterBillsList: [],
      pharmaCashCounterBillsCount: 0,
      pharmaCashCounterBillsLoad: false,
      pharmaBillsDenyPopupOpen: false,
      pharmaBillsDenySelectedItem: null,
      pharmaCashCounterBillsDate: new Date(),
      pharmaCashCounterBillsDatePickerOpen: false,
      searchPharmaCashCounterBills: '',
      dupPharmaCashCounterBillsList: '[]',
      returnAllBillsPopup: false,
      returnAllBillsPatient: null,
    }
    setCachevalue(0, "SelectedDoctorID")
    setCachevalue(0, "SelectedIPDoctorID")
    this.IdleTimer = null;
    this.resetIdleTimer = this.resetIdleTimer.bind(this);
    this.AutoLogOutOnIdle = this.AutoLogOutOnIdle.bind(this);
    this.EmergencySocket = null;
    this.DocRunningLate = null;
    this.DocOutofOfficeLate = null;
    this.PaitentCall = null;
    this.DocCallPatient = null;
    this.FoToDocSocket = null;
    this.FoToDocTokenSocket = null;
    this.reconnectTimers = {};
    this.reconnectAttempts = {};
    this.isComponentUnmounted = false;
    this.pendingPatientCallPayload = null;
    this.hasConnectedSockets = false;
  }
  /* Login UserName Api Function start  */
  componentDidMount() {
    this.isComponentUnmounted = false;
    this.getConnectedDevices()
    this.startTimer()
    this.setState({pathName: window?.location?.pathname || ""});
        
    window.addEventListener('mousemove', this.resetIdleTimer);
    window.addEventListener('mousedown', this.resetIdleTimer);
    window.addEventListener('touchstart', this.resetIdleTimer);
    window.addEventListener('touchmove', this.resetIdleTimer);
    window.addEventListener('click', this.resetIdleTimer);
    window.addEventListener('keydown', this.resetIdleTimer);
    window.addEventListener('scroll', this.resetIdleTimer, true);
    if (window.location.pathname === "/") {
      this.resetCache()
    }
    if (localGetItem("isLoggedIn")) {

      if (window.location.pathname === "/") {
        this.resetCache()
      }
      if ((window.location.pathname === '/PharmacyBilling' || (window.location.pathname && window.location.pathname.startsWith('/PharmacyBilling/'))) && this.isPharmaMoveToCashCounterFlowEnabled()) {
        this.getPharmaCashCounterBillsCount()
      }
      setTimeout(() => {
        this.setState({ insuToolOpen: undefined });
      }, 2000);
      let smsAlert = JSON.parse(localGetItem("show_sms_alert"))
      let whatsappAlert = JSON.parse(localGetItem("show_whatsapp_alert"))
      const subscription_alert_message = localGetItem("subscription_alert_message")
      const subscription_expired = JSON.parse(localGetItem("subscription_expired"))
      var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
      let isfaceRecognizationEnabled = JSON.parse(localGetItem("is_enable_face_data")) ? true : false
      var UserData = myUser
       let specialization  = UserData?.specialization_name
      this.setState({
        loginName: UserData?.display_name,
        loginType: UserData?.module_name,
        labType: myUser?.laboratory_type,
        isfaceRecognizationEnabled : isfaceRecognizationEnabled,
        loggedInuserInfo: JSON.parse(localGetItem("loggedInUserInfo")),
        logedUsername: localGetItem("LogedUserName"),
        doctorClinicId: localGetItem('SelectedDoctorClinicId'),
        doctorAppointmentDate: localGetItem('DoctorAppointmentDate'),
        DoctorsList: localGetItem("DoctorsList") ? JSON.parse(localGetItem("DoctorsList")) : [],
        isOPT: UserData?.service_type === "OPT" ? true : false,
        vitals: UserData?.service_type === "OPT" ? true : false,
        isOptometry: UserData?.service_type === "OPTOMETRY" ? true : false,
        isENT: UserData?.service_type === "ENT" ? true : false,
        SelectedDoctorClinic: localGetItem('SelectedDoctorClinicId') ? localGetItem('SelectedDoctorClinicId') : (UserData?.service_type === "OPTOMETRY" ? "all" : ""),
        smsAlert: smsAlert ? smsAlert : false,
        hasAbha: localGetItem("has_abha_service") === "true" ? true : false,
        whatsappAlert: whatsappAlert ? whatsappAlert : false,
        subscription_alert_message: subscription_alert_message ? subscription_alert_message : "",
        subscription_expired: subscription_expired,
        specialization : specialization
      }, () => {
        if ((this.state.labType === "Inhouse Laboratory") && (window.location.pathname === "/MainHome")) {
          this.getClinicdata()
        }
        if ((window.location.pathname === "/OPHome") || (window.location.pathname === "/IPHome")) {
          // this.getDoctorsList()
          this.getAppointRequests()
          this.getQREntryList()
        }
        if((window.location.pathname === "/ABDM/Register" || window.location.pathname === "/ABDM") && this.state.hasAbha){
          this.getAbhaQrList()
        }
        if ((window.location.pathname === "/OPHome" || window.location.pathname === "/OTHome") && localGetItem("ipComplaintsDataList") === null) {
          this.getIPcomlaintsdata()
        }
        if (((window.location.pathname === "/DoctorHome") || (window.location.pathname === "/OPHome") || (window.location.pathname === "/MainHome") || (window.location.pathname === `/${GetInvestigationName()}Home`) || (window.location.pathname === "/PharmacyBilling")) && (localGetItem("noShowStatus") === null || localGetItem("Allow_Pharma_CreditBill_In_FO") === null || localGetItem("Show_Pharmacy_Bills_In_FO") === null)) {
          this.GetCustomConfig()
        }
        if ((window.location.pathname === '/PharmacyBilling' || (window.location.pathname && window.location.pathname.startsWith('/PharmacyBilling/'))) && this.isPharmaMoveToCashCounterFlowEnabled()) {
          this.getPharmaCashCounterBillsCount()
        }
        if ((window.location.pathname === "/DoctorHome")) {
          if (this.state.loggedInuserInfo?.module_name === "Doctor") {
            this.getDoctorClinicData()
            this.getTransferAppointmentData()
            this.getUnlockNotesData()
            this.getDoctorNotesPrintTemplate()
          } else if (this.state.loggedInuserInfo?.module_name === "Optometry") {
            this.getDoctorClinicData(true)
            localSetItem('other_investigation_config', JSON.stringify(OTHER_INVESTIGATION_CONFIG_DATA))
          }else if(this.state.loggedInuserInfo?.clinic_staff){
            this.getJMODoctor()
          }
        }
        if (window.location.pathname === '/DoctorHome/DoctorNotes' && (this.state.loggedInuserInfo?.module_name === "Doctor" || this.state.loggedInuserInfo?.clinic_staff) ) {
          this.getDoctorNotesPrintTemplate()
        }
        if (window.location.pathname === "/OTHome" && this.state.loggedInuserInfo?.module_name === "ot_management") {
          this.getotRequestList()
          this.getIndentCount()
        }
      })
    }
    if (
      window.location.pathname === "/MainHome" || window.location.pathname === '/IPHome' || window.location.pathname === '/RadiotherapyWalkIn' || window.location.pathname === '/CreditSettlement' ||
      (window.location.pathname === '/Billing' || window.location.pathname === '/Billing/LabBilling') || window.location.pathname === '/ChartDashboard' || window.location.pathname === '/Revert' ||
      (window.location.pathname === '/HospitalBilling' || window.location.pathname === '/HospitalBilling/HospitalBilling') || 
      (window.location.pathname === '/LabBilling' || window.location.pathname === '/LabBilling/HospitalBilling') || (window.location.pathname === '/LabReports' || window.location.pathname === '/Inventory' || window.location.pathname === '/Purchase' || window.location.pathname === '/SettingsHome') ||
      (window.location.pathname === `/${GetInvestigationName()}Billing` || window.location.pathname === `/${GetInvestigationName()}Billing/HospitalBilling`) ||
      (window.location.pathname === '/DoctorBilling' || window.location.pathname === '/DoctorBilling/DoctorBilling' || (window.location.pathname === '/PharmacyBilling/CashCounter'))||
      (window.location.pathname === `/${GetInvestigationName()}Order` || window.location.pathname === `/${GetInvestigationName()}Order/Order`)
    ) {
      this.getBadgeCount()
    }
    if (((window.location.pathname === "/OPHome")) && localGetItem("PurposeOfVisit") === null) {
      this.getPurposeOfVisitList()
    }
    if ((window.location.pathname === `/${GetInvestigationName()}Home`) && localGetItem("PurposeOfVisit") === null) {
      this.getPurposeOfVisitList()
    }
    if ((window.location.pathname === `/${GetInvestigationName()}Home`)) {
      if (localGetItem('isNewBilling') !== "true") {
        this.getRadIPListData()
        this.getRadSavedBillList()
      }
      this.getBadgeCount()
      this.getRadAppointmentListData()
    }
    if ((window.location.pathname === '/Billing' || window.location.pathname === '/Billing/HospitalBilling' || window.location.pathname === '/Billing/LabBilling' || window.location.pathname === '/Billing/MultiBilling')) {
      this.getLaboratoryListData()
    }
    if (window.location.pathname === "/Billing/RadiologyBilling" || window.location.pathname === `/${GetInvestigationName()}Home`) {
       if (localGetItem('isNewBilling') !== "true") {
        this.getRadTransmitList()
       }
    }
    if(
      (window.location.pathname === '/HospitalBilling' || window.location.pathname === '/HospitalBilling/HospitalBilling') || 
      (window.location.pathname === "/MainHome" || window.location.pathname === '/LabBilling' || window.location.pathname === '/LabBilling/HospitalBilling') || 
      (window.location.pathname === `/${GetInvestigationName()}Billing` || window.location.pathname === `/${GetInvestigationName()}Billing/HospitalBilling`) ||  
      (window.location.pathname === '/PharmacyBilling/CashCounter')  
      // || (window.location.pathname === '/DoctorBilling' || window.location.pathname === '/DoctorBilling/DoctorBilling')
    ){
      this.getRadAppointmentListData()
    }
    if((window.location.pathname === "/HospitalBilling/CashCounter" || window.location.pathname ==="/LabBilling/CashCounter" || window.location.pathname === `/${GetInvestigationName()}Billing/CashCounter` || window.location.pathname === '/PharmacyBilling/CashCounter') && localGetItem('isNewBilling') === "true"){
      this.getRefundRequestData()
      this.getIpAdmissionListData()
      if(UserData?.enable_radiotherapy){
        this.GetRtWalkinData()
      }
    }
    if (window.location.pathname === "/MainHome") {
      JSON.parse(localGetItem('isNewBilling')) ?
        this.getNotificationData()
        : this.getLabNotificationData()
    }
    if ((window.location.pathname === "/OPHome" || window.location.pathname === "/IPHome" || window.location.pathname === "/PharmacyBilling"
      || window.location.pathname === `/${GetInvestigationName()}Home`) && JSON.parse(localGetItem('isNewBilling'))) {
      this.getNotificationData();
    }
    if (window.location.pathname === "/DoctorHome" && this.state.loggedInuserInfo?.module_name === "Doctor") {
      this.getDoctorRequestData();
    }
    if (window.location.pathname === "/DoctorHome" && (myUser.service_type === "OPT" || myUser.service_type === "OPTOMETRY") && !myUser?.new_doctor_notes_template) {
      if (localGetItem("AnteriorSuggestionData") === null) {
        this.getAnteriorSuggestionData()
      }
      if (localGetItem("PosteriorSuggestionData") === null) {
        this.getPosteriorSuggestionData()
      }
      if (localGetItem("PrescriptionFavouriteData") === null && myUser.service_type === "OPT") {
        this.getPrescriptionFavouriteData()
      }
    }
  }

  /* Login UserName Api Functionend  */

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if(window.location.pathname !== this.state.pathName){
      this.setState({pathName: window.location.pathname});
      if (window.location.pathname === "/") {
        this.resetCache()
      }
      if ((window.location.pathname === '/PharmacyBilling' || (window.location.pathname && window.location.pathname.startsWith('/PharmacyBilling/'))) && this.isPharmaMoveToCashCounterFlowEnabled()) {
        this.getPharmaCashCounterBillsCount()
      }
      setTimeout(() => {
        this.setState({ insuToolOpen: undefined });
      }, 2000);
      if (this.state.unlockDate != "" && window.location.pathname != "/DoctorHome") {
        // var currentDate = new Date();
        // var formattedDate = currentDate.toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' });
        // formattedDate = formattedDate.split("/").reverse().join("-")
        this.setState({
          unlockDate: ""
        })
      }
      if (localGetItem("isLoggedIn")) {
        let smsAlert = JSON.parse(localGetItem("show_sms_alert"))
        let whatsappAlert = JSON.parse(localGetItem("show_whatsapp_alert"))
        const subscription_alert_message = localGetItem("subscription_alert_message")
        const subscription_expired = JSON.parse(localGetItem("subscription_expired"))
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        let isfaceRecognizationEnabled = JSON.parse(localGetItem("is_enable_face_data"))
        var UserData = myUser
        this.setState({
          loginName: UserData?.display_name,
          loginType: UserData?.module_name,
          labType: myUser?.laboratory_type,
          isfaceRecognizationEnabled : isfaceRecognizationEnabled ,
          loggedInuserInfo: JSON.parse(localGetItem("loggedInUserInfo")),
          logedUsername: localGetItem("LogedUserName"),
          DoctorsList: localGetItem("DoctorsList") ? JSON.parse(localGetItem("DoctorsList")) : [],
          isOPT: UserData?.service_type === "OPT" ? true : false,
          vitals: UserData?.service_type === "OPT" ? true : false,
          isOptometry: UserData?.service_type === "OPTOMETRY" ? true : false,
          isENT: UserData?.service_type === "ENT" ? true : false,
          SelectedDoctorClinic: UserData?.service_type === 'OPTOMETRY' && getCachevalue("DoctorUserChanged") === "true" ? "all" : localGetItem('SelectedDoctorClinicId') ? localGetItem('SelectedDoctorClinicId') : (UserData?.service_type === "OPTOMETRY" ? "all" : "" ),
          smsAlert: smsAlert ? smsAlert : false,
          hasAbha: localGetItem("has_abha_service") === "true" ? true : false,
          whatsappAlert: whatsappAlert ? whatsappAlert : false,
          subscription_alert_message: subscription_alert_message ? subscription_alert_message : "",
          subscription_expired: subscription_expired,
          isIPTrans : false,
        }, () => {
          if (this.state.labType === "Inhouse Laboratory" && (window.location.pathname === "/MainHome")) {
            this.getClinicdata()
          }
          if ((window.location.pathname === "/OPHome") || (window.location.pathname === "/IPHome")) {
            // this.getDoctorsList()
          }
          if((window.location.pathname === "/ABDM/Register" || window.location.pathname === "/ABDM") && this.state.hasAbha){
          this.getAbhaQrList()
          }
          if ((window.location.pathname === "/OPHome")) {
            this.getAppointRequests()
            this.getQREntryList()
            this.getFollowUpData()
            this.getBadgeCount()
            if(myUser?.module_name !== "nurse"){
              this.getNotificationData()
            }
            if (myUser?.is_qms_enabled) {
              this.getDoctorQueueData()
            }
          }
          if ((window.location.pathname === "/OPHome") || (window.location.pathname === "/DoctorHome")) {
            if (myUser?.is_qms_enabled) {
              this.WebSocketConnention();
              this.FoCallPatientConnect();
              // if (window.location.pathname === "/OPHome") {
              // }
            }
          }
          if ((window.location.pathname === "/OPHome") && localGetItem("PurposeOfVisit") === null) {
            this.getPurposeOfVisitList()
          }
          if ((window.location.pathname === "/OPHome" || window.location.pathname === "/OTHome") && localGetItem("ipComplaintsDataList") === null) {
            this.getIPcomlaintsdata()
          }
          if (((window.location.pathname === "/DoctorHome") || (window.location.pathname === "/OPHome") || (window.location.pathname === "/MainHome") || (window.location.pathname === `/${GetInvestigationName()}Home`) || (window.location.pathname === "/PharmacyBilling")) && (localGetItem("noShowStatus") === null || localGetItem("Allow_Pharma_CreditBill_In_FO") === null || localGetItem("Show_Pharmacy_Bills_In_FO") === null)) {
            this.GetCustomConfig()
          }
          if (((window.location.pathname === "/PharmacyBilling") || (window.location.pathname === "/SubLocationBilling")) && Object.keys(this.state.badgeCount)?.length === 0) {
            if(window.location.pathname !== "/SubLocationBilling"){
              this.getBadgeCount()
            }
            if (window.location.pathname === "/PharmacyBilling" || window.location.pathname === "/SubLocationBilling") {
              this.getIndentCount()
            }
          }
          if ((window.location.pathname === '/PharmacyBilling' || (window.location.pathname && window.location.pathname.startsWith('/PharmacyBilling/'))) && this.isPharmaMoveToCashCounterFlowEnabled()) {
            this.getPharmaCashCounterBillsCount()
          }
          if ((window.location.pathname === "/DoctorHome")) {
            if (this.state.loggedInuserInfo?.module_name === "Doctor") {
              this.getDoctorNotesPrintTemplate()
              this.getDoctorClinicData()
              this.getTransferAppointmentData()
              this.getUnlockNotesData()
            } else if (this.state.loggedInuserInfo?.module_name === "Optometry") {
              this.getDoctorClinicData(true)
              localSetItem('other_investigation_config', JSON.stringify(OTHER_INVESTIGATION_CONFIG_DATA))
            } else if(this.state.loggedInuserInfo?.clinic_staff){
              this.getJMODoctor()
            }
          }
          if (window.location.pathname === '/DoctorHome/DoctorNotes' && (this.state.loggedInuserInfo?.module_name === "Doctor"  || this.state.loggedInuserInfo?.clinic_staff)) {
            this.getDoctorNotesPrintTemplate()
          }
          if ((window.location.pathname === `/${GetInvestigationName()}Home`) && localGetItem("PurposeOfVisit") === null) {
            this.getPurposeOfVisitList()
          }
          if ((window.location.pathname === `/${GetInvestigationName()}Home`)) {
            if (localGetItem('isNewBilling') !== "true") {
              this.getRadIPListData()
              this.getRadSavedBillList()
            }
            this.getBadgeCount()
            this.getRadAppointmentListData()
          }
          if (window.location.pathname === "/OTHome" && this.state.loggedInuserInfo?.module_name === "ot_management") {
            this.getBadgeCount()
            this.getotRequestList()
            this.getIndentCount()
          }
          if (
            (window.location.pathname === "/MainHome") || (window.location.pathname === "/IPHome") || (window.location.pathname === '/RadiotherapyWalkIn') || (window.location.pathname === '/CreditSettlement') ||
            (window.location.pathname === '/Billing' || window.location.pathname === '/Billing/LabBilling') || (window.location.pathname === '/ChartDashboard') || (window.location.pathname === '/Revert') ||
            (window.location.pathname === '/HospitalBilling' || window.location.pathname === '/HospitalBilling/HospitalBilling') ||
            (window.location.pathname === '/LabBilling' || window.location.pathname === '/LabBilling/HospitalBilling') || (window.location.pathname === '/LabReports' || window.location.pathname === '/Inventory' || window.location.pathname === '/Purchase' || window.location.pathname === '/SettingsHome' ) ||
            (window.location.pathname === `/${GetInvestigationName()}Billing` || window.location.pathname === `/${GetInvestigationName()}Billing/HospitalBilling`) ||
            (window.location.pathname === '/DoctorBilling' || window.location.pathname === '/DoctorBilling/DoctorBilling') ||
            (window.location.pathname === "/BillingTransaction") || (window.location.pathname === "/FOReports") || (window.location.pathname === "/Settings")||
            (window.location.pathname === `/${GetInvestigationName()}Order` || window.location.pathname === `/${GetInvestigationName()}Order/Order`)
          ) {
            this.getBadgeCount()
          }
          if ((window.location.pathname === '/Billing' || window.location.pathname === '/Billing/HospitalBilling' || window.location.pathname === '/Billing/LabBilling')) {
            this.getLaboratoryListData()
          }
          if (window.location.pathname === "/Billing/RadiologyBilling" || window.location.pathname === `/${GetInvestigationName()}Home`) {
             if (localGetItem('isNewBilling') !== "true") {
               this.getRadTransmitList()
             }
          }
          if (this.state.clinicId === null && localGetItem("clinicId") !== null && this.state.clinicId !== localGetItem("clinicId")) {
            this.setState({
              clinicId: localGetItem("clinicId")
            })
          }
          if(
            window.location.pathname === '/HospitalBilling' || window.location.pathname === '/HospitalBilling/HospitalBilling' || 
            (window.location.pathname === "/MainHome" || window.location.pathname === '/LabBilling' || window.location.pathname === '/LabBilling/HospitalBilling') || 
            (window.location.pathname === `/${GetInvestigationName()}Billing` || window.location.pathname === `/${GetInvestigationName()}Billing/HospitalBilling`) || 
            (window.location.pathname === '/PharmacyBilling/CashCounter')
            // || (window.location.pathname === '/DoctorBilling' || window.location.pathname === '/DoctorBilling/DoctorBilling')
          ){
            this.getRadAppointmentListData()
          }
          if((window.location.pathname === "/HospitalBilling/CashCounter" || window.location.pathname ==="/LabBilling/CashCounter" || window.location.pathname === `/${GetInvestigationName()}Billing/CashCounter` || window.location.pathname === '/PharmacyBilling/CashCounter') && localGetItem('isNewBilling') === "true"){
            this.getRefundRequestData()
            this.getIpAdmissionListData()
            if (UserData?.enable_radiotherapy) {
              this.GetRtWalkinData()
            }
          }
        })
        if (window.location.pathname === "/MainHome") {
          JSON.parse(localGetItem('isNewBilling')) ?
            this.getNotificationData()
            : this.getLabNotificationData()
        }
        if ((window.location.pathname === "/IPHome" || window.location.pathname === "/PharmacyBilling"
          || window.location.pathname === `/${GetInvestigationName()}Home`) && JSON.parse(localGetItem('isNewBilling')) && myUser?.module_name !== "nurse") {
          this.getNotificationData();
        }
      }
      this.setState({
        selectedPatientData: {}
      })
      if (window.location.pathname === "/DoctorHome" && this.state.loggedInuserInfo?.module_name === "Doctor")  {
        this.getDoctorRequestData();
      }
      if (window.location.pathname === "/DoctorHome" && (myUser.service_type === "OPT" || myUser.service_type === "OPTOMETRY") && !myUser?.new_doctor_notes_template) {
        if (localGetItem("AnteriorSuggestionData") === null) {
          this.getAnteriorSuggestionData()
        }
        if (localGetItem("PosteriorSuggestionData") === null) {
          this.getPosteriorSuggestionData()
        }
        if (localGetItem("PrescriptionFavouriteData") === null && myUser.service_type === "OPT") {
          this.getPrescriptionFavouriteData()
        }
      }
    }
    }
    window.addEventListener("online", this.handleOnlineStatus);
    window.addEventListener("offline", this.handleOfflineStatus);
  }

  componentWillUnmount() {
    this.clearTimer();
    this.WebSocketDisconnect()
    window.removeEventListener('mousemove', this.resetIdleTimer);
    window.removeEventListener('mousedown', this.resetIdleTimer);
    window.removeEventListener('touchstart', this.resetIdleTimer);
    window.removeEventListener('touchmove', this.resetIdleTimer);
    window.removeEventListener('click', this.resetIdleTimer);
    window.removeEventListener('keydown', this.resetIdleTimer);
    window.removeEventListener('scroll', this.resetIdleTimer, true);
    window.removeEventListener("online", this.handleOnlineStatus);
    window.removeEventListener("offline", this.handleOfflineStatus);
  }

  createWebSocket = (name, url, onMessage) => {
    // if (this.isComponentUnmounted) return;
    const existingSocket = this[name];
    // Prevent duplicate connections
    if (existingSocket && (existingSocket.readyState === WebSocket.OPEN ||
      existingSocket.readyState === WebSocket.CONNECTING)
    ) {
      console.log(`${name}: Max reconnect attempts reached returnnnn`);
      return;
    }

    // Initialize reconnect count if not exists
    if (!this.reconnectAttempts[name]) {
      this.reconnectAttempts[name] = 0;
    }

    // Stop if max attempts reached
    if (this.reconnectAttempts[name] >= MAX_RECONNECT_ATTEMPTS) {
      console.log(`${name}: Max reconnect attempts reached`);
      return;
    }

    console.log(`${name}: Creating WebSocket`, url);

    const socket = new WebSocket(url);
    this[name] = socket;

    socket.onopen = () => {
      console.log(`${name} WebSocket connected`);
      this.reconnectAttempts[name] = 0;
    };

    socket.onmessage = (e) => {
      // if (this.isComponentUnmounted) return;
      try {
        const data = JSON.parse(e.data);
        console.log(`${name} Message`, data);
        onMessage(data);
      } catch (err) {
        console.warn(`${name} Non-JSON message`, e.data);
      }
    };

    socket.onerror = (error) => {
      console.log(`${name} WebSocket Error`, error);
      // socket.close();
    };

    socket.onclose = (event) => {
      console.log(`${name} WebSocket disconnected`);
      this[name] = null;
      if (event.code === 1000 || this.isComponentUnmounted) {
        console.log(`${name}: Server closed connection. No reconnect.${event.code}`);
        return;
      }
      this.reconnectAttempts[name] += 1;
      const delay = Math.min(1000 * Math.pow(2,  this.reconnectAttempts[name]), 30000);


      if (!this.isComponentUnmounted) {
        this.reconnectTimers[name] = setTimeout(() => {
          this.createWebSocket(name, url, onMessage);
        }, delay); // reconnect after 3 sec
      }
    };
  };

  WebSocketConnention = () => {
    const userData = JSON.parse(localGetItem("loggedInUserInfo"))
    const org_id = userData.org_id;
    console.log("WebSocketConnention userData", userData, org_id);

    const handleMessage = (name, data) => {
      if (data) {
        if ((name !== "DocCallPatient" || localGetItem("show_notification_banner_fo") === "true") && window.location.pathname !== "/DoctorHome") {
          // enqueueSnackbar(data?.message)
          this.infoMessage(data?.message)
        }
        if (name === "DocCallPatient") {
          this.getDoctorQueueData()
        }
        if ((name === "EmergencySocket" || name === "DocRunningLate" || name === "DocOutofOfficeLate") && window.location.pathname !== "/DoctorHome") {
          this.getNotificationData()
        }
      }
      console.log(`${name} WebSocket Message`, data);
    }

    this.createWebSocket(
      "EmergencySocket",
      `${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.DOC_EMERGENCY_WEBSOCKET}${userData.emergency_channel_name}/?org_id=${org_id}`,
      (data) => handleMessage("EmergencySocket", data)
    );

    this.createWebSocket(
      "DocRunningLate",
      `${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.DOC_RUNNINGLATE_WEBSOCKET}${userData.late_channel_name}/?org_id=${org_id}`,
      (data) => handleMessage("DocRunningLate", data)
    );

    this.createWebSocket(
      "DocOutofOfficeLate",
      `${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.DOC_OUTOFOFFICE_WEBSOCKET}${userData.out_channel_name}/?org_id=${org_id}`,
      (data) => handleMessage("DocOutofOfficeLate", data)
    );

    this.createWebSocket(
      "DocCallPatient",
      `${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.DOC_PATIENTCALL_WEBSOCKET}${userData.doctor_call_channel_name}/?org_id=${org_id}`,
      (data) => handleMessage("DocCallPatient", data)
    );
    this.hasConnectedSockets = true;
  }

  FoCallPatientConnect = () => {
    let userData = JSON.parse(localGetItem("loggedInUserInfo"));
    let callPatientChannel = userData?.fo_call_channel_name;
    let tokenScreen = userData?.token_screen_channel_name;
    let org_id = userData?.org_id;

    // init reconnect counter
    if (!this.reconnectAttempts.PaitentCall) {
      this.reconnectAttempts.PaitentCall = 0;
    }

    // stop after max attempts
    if (this.reconnectAttempts.PaitentCall >= MAX_RECONNECT_ATTEMPTS) {
      console.log("PaitentCall: Max reconnect attempts reached");
      return;
    }

    /* ---------- Patient Call Socket ---------- */

    if (this.PaitentCall === null || this.PaitentCall.readyState === WebSocket.CLOSED) {
      this.PaitentCall = new WebSocket(`${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.FO_CALLPATIENT_WEBSOCKET}${callPatientChannel}/?org_id=${org_id}`);
    }

    this.PaitentCall.onopen = () => {
      console.log("Patient Call WebSocket connected");
      this.reconnectAttempts.PaitentCall = 0;
      if (this.pendingPatientCallPayload) {
        this.PaitentCall.send(this.pendingPatientCallPayload);
        this.pendingPatientCallPayload = null;
      }
    };

    this.PaitentCall.onerror = (error) => {
      console.log("Patient Call WebSocket Error", error);
      // if (this.PaitentCall) {
      //   this.PaitentCall.close()
      //   this.PaitentCall = null
      // }
    };

    this.PaitentCall.onclose = (event) => {
      console.log("Patient Call WebSocket disconnected", event.code);
      this.PaitentCall = null;

      // only skip reconnect on NORMAL close
      if (event.code === 1000 || this.isComponentUnmounted) {
        return;
      }

      this.reconnectAttempts.PaitentCall += 1;
      const delay = Math.min(1000 * Math.pow(2, this.reconnectAttempts.PaitentCall), 30000);

      if (!this.isComponentUnmounted) {
        clearTimeout(this.reconnectTimers.PaitentCall);
        this.reconnectTimers.PaitentCall = setTimeout(() => {
          this.FoCallPatientConnect();
        }, delay);
      }
    };

    /* ---------- Token Screen Socket ---------- */

    if (tokenScreen && (this.FoToDocTokenSocket === null ||
      this.FoToDocTokenSocket.readyState === WebSocket.CLOSED)) {
      this.FoToDocTokenSocket = new WebSocket(`${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.TOKENSCREEN_WEBSOCKET}${tokenScreen}/?org_id=${org_id}`);

      this.FoToDocTokenSocket.onopen = () => {
        console.log("FoToDocTokenSocket connected");
      };

      this.FoToDocTokenSocket.onerror = (error) => {
        console.log("FoToDocTokenSocket error", error);
        this.FoToDocTokenSocket.close();
      };

      this.FoToDocTokenSocket.onclose = () => {
        console.log("FoToDocTokenSocket closed");
        this.FoToDocTokenSocket = null;
      };
    }

    /* ---------- Message Handling ---------- */

    this.PaitentCall.onmessage = (e) => {
      const data = JSON.parse(e.data);
      if (data && this.state.loggedInuserInfo?.module_name === "Doctor" && data?.doctor_id === userData?.doctor_id) {
        this.infoMessage(data?.message);

        if (data?.status === "Cancelled") {
          if (this.FoToDocTokenSocket && this.FoToDocTokenSocket.readyState === WebSocket.OPEN && tokenScreen) {
            this.FoToDocTokenSocket.send(
              JSON.stringify({
                message_id: data?.message_id,
                action: "remove_message"
              })
            );
          } else {
            console.log("FoToDocTokenSocket not open, cannot send remove_message");
          }

          this.setState({ CallPatientTrigger: true });
        }
        console.log(`Patien Call WebSocket Message`, data);
      }
    };
  };

  WebSocketDisconnect = () => {
    let userData = JSON.parse(localGetItem("loggedInUserInfo"))
    if (userData?.is_qms_enabled) {
      this.isComponentUnmounted = true;
      this.hasConnectedSockets = false;
      Object.values(this.reconnectTimers).forEach(clearTimeout);
      this.reconnectTimers = {};
      this.reconnectAttempts = {};

      if (this.EmergencySocket) {
        this.EmergencySocket.close()
        this.EmergencySocket = null
      }
      if (this.DocRunningLate) {
        this.DocRunningLate.close()
        this.DocRunningLate = null
      }
      if (this.DocOutofOfficeLate) {
        this.DocOutofOfficeLate.close()
        this.DocOutofOfficeLate = null
      }
      if (this.PaitentCall) {
        this.PaitentCall.close()
        this.PaitentCall = null
      }
      this.pendingPatientCallPayload = null;
      if (this.DocCallPatient) {
        this.DocCallPatient.close()
        this.DocCallPatient = null
      }
      if (this.FoToDocSocket) {
        this.FoToDocSocket.close()
        this.FoToDocSocket = null
      }
      if (this.FoToDocTokenSocket) {
        this.FoToDocTokenSocket.close()
        this.FoToDocTokenSocket = null
      }
    }
  }

  handleAgeCalculation = date => {
    // let age = "";
    // let dob = DateTime.fromJSDate(date);
    // var year_age = DateTime.now().diff(dob, 'years');
    // age = Math.floor(year_age.years) || 0;
    // return age;
    let age = "";
    let dob = new Date(date);
    let m = moment(dob, "DD-MM-YYYY");
    var end_date = moment();

    var year_age = end_date.diff(m, 'year') || 0;
    // reset(year) year with difference year
    m = moment(m).add(year_age, 'years');

    var month_age = end_date.diff(m, 'month') || 0;
    // reset(month) month with difference month
    m = moment(m).add(month_age, 'months');

    var day_age = end_date.diff(m, 'days') || 0;

    if (year_age > 0) {
      age = year_age || 0;
    } else {
      age = year_age + "Y/" + month_age + "M/" + day_age + "D";
    }
    return (date < new Date() && date > new Date("1872-01-01")) ? age : "";
  }

  handleFindApproxDob = ageEntered => {

    var year = 0;
    var month = 0;
    var days = 0;
    var tempDate;
    year = +(ageEntered)
    if (!year) {
      tempDate = null;
    } else {
      tempDate = DateTime.now().minus({ years: year }).toBSON();
    }

    return tempDate;
  }

  startTimer() {
    if (this.state.IdleAlertPopup) {
      this.setState({
        IdleAlertPopup: false
      })
    }
    let customLogoutTime = localGetItem("auto_log_out_time") ? +localGetItem("auto_log_out_time") : 15
    this.IdleTimer = setTimeout(this.AutoLogOutOnIdle, customLogoutTime * 60 * 1000); // auto logout on 15 mins idle
    this.IdleAlertTimer = setTimeout(() => { this.setState({ IdleAlertPopup: true }) }, (customLogoutTime - 3) * 60 * 1000); // alert popup on 12 mins idle
  }

  resetIdleTimer() {
    clearTimeout(this.IdleTimer);
    clearTimeout(this.IdleAlertTimer);
    this.startTimer();
  }

  clearTimer() {
    clearTimeout(this.IdleTimer);
    clearTimeout(this.IdleAlertTimer);
  }

  AutoLogOutOnIdle() {
    if (window.location.pathname === "/") {
      this.clearTimer()
    } else {
      this.logout()
      this.props?.history.push('/')
    }
  }

  handleOnlineStatus = () => {
    this.setState({ isOnline: true });
  };

  handleOfflineStatus = () => {
    this.setState({ isOnline: false });
  };

  cancelTransRequest = (id, status) => {
    const { history } = this.props;
    try {
      var data = {
        "id": id,
        "status": status
      }
      RestAPIService.updateWithOutId(data, Serviceurls.DOC_TRANSFER_REQUEST).
        then((response) => {
          if (response.data.status === "success") {
            this.successMessage(response.data.message)
            this.setState({
              TransAppoint: false
            }, () => {
              this.getTransferAppointmentData()
              history.push({ pathname: "/DoctorHome", state: { NewAppointmentCreated: true, NewMessage: response.data?.message, reload: true } })
            })
          } else {
            this.errorMessage(response.data.message)
          }
        }).catch(error => {
          if (error?.response?.data?.status === "fail") {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  removeDataList = (item) => {
    try {
      RestAPIService.delete(Serviceurls.DOC_FOLLOWUP_DLT + `?id=${item?.id}&doctor_id=${item?.doctor_id ? item?.doctor_id : null}`).
        then((response) => {
          if (response.data.status === "success") {
            this.getFollowUpData();
          } else {
            this.errorMessage(response.data.message)
          }
        })
        .catch(error => {
          if (error?.response?.data?.status === "fail") {
            this.errorMessage(error.response.data.message);
          }
        });
    } catch (e) {
      this.errorMessage(e.message, false);
    }
  }

  getBadgeCount = () => {
    try {
      let moduleName = this.state.loggedInuserInfo?.module_name === "Doctor" ? 'front_office' : (this.state.loggedInuserInfo?.module_name || '');
      let clinicId = localGetItem('clinicId') || localGetItem('SelectedDoctorClinicId') || this.state.loggedInuserInfo?.clinic_id || '';
      const isDoctor = this.state.loggedInuserInfo?.module_name === "Doctor";
      RestAPIService.getAll(Serviceurls.FO_BADGE_COUNT_GET + `?module_name=${moduleName}&clinic_id=${clinicId}&billed_from=${isDoctor ? 'DOCTOR' : ''}&doctor_id=${isDoctor ? this.state.loggedInuserInfo?.doctor_id  : ""}`)
        .then((response) => {
          if (response?.data?.status === "success") {
            this.setState({
              badgeCount: response?.data?.data ? response?.data?.data : 0,
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error?.message)
          }
        })

    } catch (e) {
      this.errorMessage(e?.message)
    }
  }

  getIndentCount = () => {
    try {
      RestAPIService.getAll(Serviceurls.INDENT_REQ_COUNT)
        .then((response) => {
          if (response?.data?.status === "success") {
            this.setState({
              indent_Count: response?.data?.data ? response?.data?.data : {},
            }, () => {
              setCachevalue(response?.data?.data?.inbound, 'subInbound')
              setCachevalue(response?.data?.data?.outbound, 'subOutbound')
              setCachevalue(response?.data?.data?.branch_inbound, 'branchInbound')
              setCachevalue(response?.data?.data?.branch_outbound, 'branchOutbound')
              setCachevalue(response?.data?.data?.sub_location, 'subTotal')
              setCachevalue(response?.data?.data?.branch, 'branchTotal')
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error?.message)
          }
        })

    } catch (e) {
      this.errorMessage(e?.message)
    }
  }

  getJMODoctor = () => {
    try {
      RestAPIService.getAll(Serviceurls.JMO_DOCTOR_LIST_GET)
        .then((response) => {
          if (response.data.status === "success") {
              this.setState({
                ClinicList: response.data.data || []
              },() => {
                if (!localGetItem('JMODoctor')) {
                this.setState({
                  SelectedDoctorClinic: response?.data?.data[0]?.id
                }, () => {
                  localSetItem('JMODoctor', response?.data?.data[0]?.id)
                  setCachevalue(response?.data?.data[0]?.id, "SelectedDoctorID")
                  setCachevalue(response?.data?.data[0]?.id, "SelectedDoctorClinic")
                  localSetItem('ServiceType', response?.data?.data[0]?.service_type)
                  localSetItem('regNo', response?.data?.data[0]?.registration_number)
                  this.ChangeLoginTokken(response?.data?.data[0]?.id)
                })
              }
              })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  getDoctorsList(ForRequest = false) {
    try {
      let API_URL = ""
      if (ForRequest) {
        var date = new Date(this.state.RequestAppointDatetym)
        var appointment_date = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd')
        var appointment_time = DateTime.fromJSDate(date).toFormat('HH:mm')
        API_URL = Serviceurls.FO_CONFIG_OPDOCTORNAME + "?date=" + appointment_date + "&time=" + appointment_time
      }
      //  else {
      //   API_URL = Serviceurls.FO_CONFIG_OPDOCTORNAME
      // }
      RestAPIService.getAll(API_URL).
        then((response) => {
          if (response.data.status === "success") {
            if (ForRequest) {
              this.setState({
                doctorList: response.data.data.filter((item) => (item.specialization_active === true))
              })
            }
            //  else {
            //   this.setState({
            //     DoctorsList: response.data.data.filter((item) => (item.specialization_active === true))
            //   })
            // }
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }
  getIPcomlaintsdata() {
    try {
      let clinicId = localGetItem('clinicId') || localGetItem('SelectedDoctorClinicId') || this.state.loggedInuserInfo?.clinic_id || null;
      RestAPIService.getAll(Serviceurls.IP_COMPLAINTS_DATASET + `?clinic_id=${clinicId ? clinicId :""}`).
        then((response) => {
          if (response.data.status === "success") {
            let Array = []
            response.data.data.forEach((element) => { Array.push(element.reason) })
            localSetItem("ipComplaintsDataList", JSON.stringify(Array))
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  getAbhaQrList = () => {
    try {
      RestAPIService.getAll(Serviceurls.ABHA_QR_ENTRY_LIST + `?patient_name=${this.state.AbhaQrPatientName}&date=${DateTime.fromJSDate(new Date(this.state.AbhaQRRegDate)).toFormat('yyyy-MM-dd')}`).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              AbhaQrList: response?.data?.data
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  getQREntryList = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_QR_ENTRY_LIST + `?patient_name=${this.state.QRPatientName}&date=${DateTime.fromJSDate(new Date(this.state.RegistrationDate)).toFormat('yyyy-MM-dd')}`).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              QrEntryList: response?.data?.data
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }


  GetCustomConfig() {
    try {
      RestAPIService.getAllTwo(Serviceurls.CUSTOM_CONFIG)
        .then((response) => {
          if (response.data.status === "success") {
            localSetItem("noShowStatus", response.data.data?.allow_no_show_update ? response.data.data?.allow_no_show_update : false);
            localSetItem("Allow_Pharma_CreditBill_In_FO", response.data.data?.allow_fo_pharmacy_bill_complete ? response.data.data?.allow_fo_pharmacy_bill_complete : false);
            localSetItem("enable_outsource_test_visibility", response.data.data?.enable_outsource_test_visibility ? response.data.data?.enable_outsource_test_visibility : false);
            localSetItem("show_active_IP_patient_details", response.data.data?.show_active_ip_patient_details_in_ot_stocks ? response.data.data?.show_active_ip_patient_details_in_ot_stocks : false);
            localSetItem("Show_Pharmacy_Bills_In_FO", response.data.data?.show_pharmacy_bills_in_fo ? response.data.data?.show_pharmacy_bills_in_fo : false);
            localSetItem("enable_manual_entry_time", response.data.data?.enable_manual_entry_for_sample_report_time ? response.data.data?.enable_manual_entry_for_sample_report_time : false);
            localSetItem("enable_billing_access", response.data.data?.enable_op_billing_access_for_ip_patient ? response.data.data?.enable_op_billing_access_for_ip_patient : false);
            localSetItem("show_corporate_service_head", response.data.data?.show_corporate_service_head_service_name ? response.data.data?.show_corporate_service_head_service_name : false);
            localSetItem("allow_billing_date_fo", response.data.data?.allow_billing_date_fo ? response.data.data?.allow_billing_date_fo : false);
            localSetItem("allow_billing_date_range", response.data.data?.allow_billing_date_range ? response.data.data?.allow_billing_date_range : "Default");
            localSetItem("default_PayFromAdvance_On_Checkout", response.data.data?.default_pay_from_advance_for_checkout ? response.data.data?.default_pay_from_advance_for_checkout : false);
            localSetItem("allow_doctor_fees_split_up", response.data.data?.allow_doctor_fees_split_up ? response.data.data?.allow_doctor_fees_split_up : false);
            localSetItem("Copy_IP_Mediction_To_DischargeSummery", response.data.data?.copy_ip_medication_to_discharge_summary ? response.data.data?.copy_ip_medication_to_discharge_summary : false);
            localSetItem('day_end_value', response.data.data?.day_end_type ? response.data.data?.day_end_type : 1)
            localSetItem("Show_Radiology_Bills_In_FO", response.data.data?.block_radiology_bills_in_fo ? response.data.data?.block_radiology_bills_in_fo : false)
            localSetItem('billing_concession_type', response.data.data?.billing_concession_type ? response.data.data?.billing_concession_type : 1)
            localSetItem('appointment_status', JSON.stringify(response.data.data?.appointment_status ? response.data.data?.appointment_status : appointment_Status_opt))
            localSetItem('cancel_appointment_status', JSON.stringify(response.data.data?.cancel_appointment_status ? response.data.data?.cancel_appointment_status : Cancel_appointment_Status_opt))
            localSetItem('lab_test_code', response.data.data?.lab_test_code ? response.data.data?.lab_test_code : false)
            localSetItem('op_ip_service_code', response.data.data?.op_ip_service_code ? response.data.data?.op_ip_service_code : false)
            localSetItem('lab_cancel_bill', response.data.data?.lab_cancel_bill ? response.data.data?.lab_cancel_bill : false)
            localSetItem('lab_con_name_mandatory', response.data.data?.lab_con_name_mandatory ? response.data.data?.lab_con_name_mandatory : false)
            localSetItem('lab_con_name_specialization', response.data.data?.lab_con_name_specialization ? response.data.data?.lab_con_name_specialization : false)
            localSetItem('radiology_service_code', response.data.data?.radiology_service_code ? response.data.data?.radiology_service_code : false)
            localSetItem('Show_PH_Bills_In_Credit_Settle', response.data.data?.allow_pharmacy_bills_in_credit_settlement ? response.data.data?.allow_pharmacy_bills_in_credit_settlement : false)
            localSetItem('dvr_print_config', response.data.data?.dvr_preview_print ? response.data.data?.dvr_preview_print : 'newtab')
            localSetItem('drug_search', response.data.data?.drug_search ? response.data.data?.drug_search : 1)
            localSetItem('display_latest_token_number', response.data.data?.display_latest_token_number ? response.data.data?.display_latest_token_number : false)
            localSetItem('credit_bill_flt_config', response.data.data?.default_filter_option_for_credit_bills ? response.data.data?.default_filter_option_for_credit_bills : 'admission_wise')
            localSetItem('is_expense_maximum_enabled', response.data.data?.is_expense_maximum_enabled)
            localSetItem('expense_maximum_amount', response.data.data?.expense_maximum_amount || 0)
            localSetItem('deduct_expense_at_day_end', response.data.data?.deduct_expense_at_day_end)
            localSetItem('enable_specialization_auto_bill', response.data.data?.enable_specialization_auto_bill)
            localSetItem('allow_patient_credit_bills', response.data.data?.allow_patient_credit_bills)
            localSetItem('allow_ip_request_cancel_in_pharmacy', response.data.data?.allow_ip_request_cancel_in_pharmacy)
            localSetItem('no_of_days_allowed_for_future_op_billing', response.data.data?.no_of_days_allowed_for_future_op_billing || 0)
            let GSTData = {
              is_room_charge_gst_applicable: response.data.data?.is_room_charge_gst_applicable,
              room_charge_gst_limit: response.data.data?.room_charge_gst_limit || 0,
              room_charge_gst_percent: response.data.data?.room_charge_gst_percent || 0,
            }
            localSetItem('gst_room_charge', JSON.stringify(GSTData))
            localSetItem('is_transaction_number_mandatory', response.data.data?.is_transaction_number_mandatory ? response.data.data?.is_transaction_number_mandatory : false)
            localSetItem('is_admission_datetime_editable', response.data.data?.is_admission_datetime_editable ? response.data.data?.is_admission_datetime_editable : false)
            localSetItem('admission_min_days', response.data.data?.admission_min_days ? response.data.data?.admission_min_days : 3)
            localSetItem('set_due_date_for_credit_billing', (response.data.data?.set_due_date_for_credit_billing || false))
            localSetItem('show_patient_tag_filter', (response.data.data?.show_patient_tag_filter || false))
            localSetItem('referred_doctor_billing', (response.data.data?.enable_refferal_doctor_in_billing || false))
            localSetItem('reason_reschedule_is_mandatory', response.data.data?.reason_for_reschedule_is_mandatory)
            localSetItem('print_option_for_draft_bills', response.data.data?.print_option_for_draft_bills || false)
            localSetItem('show_ip_admission_sheet', response.data.data?.show_ip_admission_sheet || false)
            localSetItem('allow_manual_entry_in_credit_settlement', response.data.data?.allow_manual_entry_in_credit_settlement)
            localSetItem('enable_lab_result_approval', response.data.data?.enable_lab_result_approval || false)
            localSetItem('enable_line_item_remarks', String(!!response.data.data?.enable_line_item_remarks))
            localSetItem('restrict_op_appointment_in_ip_patients', response.data.data?.restrict_op_appointment_in_ip_patients || false)
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }
  getAppointRequests(Clicked = false) {
    try {
      const dateStr = DateTime.fromJSDate(new Date(this.state.datePicker)).toFormat('yyyy-MM-dd')
      const docId = this.state.App_DocID?.doctor_id
      const requestUrl = docId != null && docId !== ''
        ? `${Serviceurls.FO_APPOINT_REQUESTS}?date=${dateStr}&doctor_id=${docId}`
        : `${Serviceurls.FO_APPOINT_REQUESTS}?date=${dateStr}`
      RestAPIService.getAll(requestUrl).
        then((response) => {
          if (response.data.status === "success") {
            const Data = response.data.data ? response.data.data?.map((item, idx) => ({
                ...item,
                sno: idx + 1,
              }))  : []
            this.setState({
              FoRequestList: Data,
              duplicateFoReqList: Data,
              // SelectedRequestTab: "appointment_request",
            }, () => {
              if (this.state.patientSearch) {
                this.handlePatientSearch()
              }
              // if (Clicked && response.data.data.length === 0) {
              //   this.errorMessage("No Records To Be Shown")
              // }
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
      if (Clicked) {
        RestAPIService.getAll(Serviceurls.FO_CONFIG_OPSPECIALIZATION)
          .then(response => {
            if (response.data.status === "success") {
              this.setState({
                spcInfo: response.data.data.filter((item) => (item.is_active === true)),
              });
            }
          })
          .catch(error => {

          });
        this.getDoctorsList(true)
      }
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  getDoctorQueueData = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_DOC_QUEUE_GET + `?appointment_date=${DateTime.fromJSDate(new Date(this.state.datePicker))?.toFormat('yyyy-MM-dd')}`)
        .then((response) => {
          if (response?.data?.status === "success") {
            this.setState({
              drQueueData: response.data.data ? response.data.data : []
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response?.data?.message)
          } else {
            this.errorMessage(error?.message)
          }
        })
    } catch (e) {
      this.errorMessage(e?.message)
    }
  }

  getNotificationData = () => {
    try {
      const userInfo = JSON.parse(localGetItem("loggedInUserInfo"));
      const moduleName = userInfo?.module_name;
      this.setState({ isNotifyLoader: true })
      RestAPIService.getAll(Serviceurls.FO_NOTIFICATION_GET + `?date=${DateTime.fromJSDate(new Date(this.state.datePicker)).toFormat('yyyy-MM-dd')}&module_type=${module_typeObj[moduleName] ?? GetInvestigationName()?.toLowerCase() ?? ""}`)
        .then((response) => {
          if (response?.data?.status === "success") {
            let data = response.data.data;
            const isArray = Array.isArray(data);
            const path = window.location.pathname;
            const typeMap = {
              "/IPHome": "IP",
              "/OPHome": "OP"
            };

            const creditData = data?.credit_due || [];

            const filteredData = typeMap[path]
              ? creditData?.filter(item => item.patient_type === typeMap[path])
              : creditData;

            data = isArray ? data : { ...data, ...(creditData.length > 0 ? { credit_due: filteredData } : {}) }

            this.setState({
              FoNotifyList: data,
              isNotifyLoader: false, 
              notifyCount: isArray
                ? (data?.length || 0)
                : (
                  (Array.isArray(data?.doctor_info) ? data?.doctor_info.length : 0) +
                  (Array.isArray(data?.credit_due) ? data?.credit_due.length : 0) +
                  (Array.isArray(data?.outsource_test_due) ? data?.outsource_test_due.length : 0)
                )
            })
          }
        }).catch((error) => {
          this.setState({ isNotifyLoader: false })
          this.errorMessage(error.response?.data?.message || error?.message)
        })
    } catch (e) {
      this.setState({ isNotifyLoader: false })
      this.errorMessage(e?.message)
    }
  }

  getLabNotificationData = () => {
    try {
      this.setState({isNotifyLoader: true})
      RestAPIService.getAll(Serviceurls.LAB_NOTIFICATION_GET)
        .then((response) => {
          if (response?.data?.status === "success") {
            this.setState({
              FoNotifyList: response.data.data,
              isNotifyLoader: false
            })
          }
        }).catch((error) => {
          this.setState({isNotifyLoader: false})
          this.errorMessage(error.response?.data?.message || error?.message)
        })
    } catch (e) {
      this.setState({isNotifyLoader: false})
      this.errorMessage(e?.message)
    }
  }

  getAppointRequestsPrint = () => {
    try {
      let DocId = this.state.App_DocID?.doctor_id ? this.state.App_DocID?.doctor_id : ''
      let LineItemIDs = []
      this.state.FoRequestList.forEach((list) => {
        LineItemIDs.push(list?.id)
      })
      RestAPIService.getAll(`${Serviceurls.FO_APPOINT_REQUESTS}?date=${DateTime.fromJSDate(new Date(this.state.datePicker)).toFormat('yyyy-MM-dd')}&doctor_id=${DocId}&ids=${LineItemIDs}&export_type=pdf`).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          this.errorMessage(error.response?.data?.message)
        })
    } catch (error) {
      this.errorMessage("Error occured on print")
    }
  }

  fetchMultiDoctorOption = (FirstClinicID = "") => {
    try {
      var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
      let clinicId = FirstClinicID || localGetItem('SelectedDoctorClinicId') 
      RestAPIService.getAll(`${Serviceurls.OTHER_DOCTOR_LIST_GET}?clinic_id=${clinicId}`).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              MultiDoctorList: response?.data?.data || []
            },()=> {
              if(myUser?.module_name === "Doctor" && this.state.MultiDoctorValue === null){
                const selectedDoc = response?.data?.data?.find((doc) => doc?.doctor_id === myUser?.doctor_id)
                if(selectedDoc){
                  this.setState({
                    MultiDoctorValue: selectedDoc
                  }) 
              }}
            })
          } else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  resetState = () => {
    this.setState({
      drawer_Open: false,
      anchorElUser: false,
      loggedInuserInfo: "",
      checked: false,
      globalSearch: '',
      menuId: null,
      selectedMenuId: null,
      selectedSubMenuId: null,
      isLoader: false,
      selectedPageName: "",
      searchkey: "",
      searchPatientDatas: [],
      selectedPatientData: {},
      pharmaNameSearchKey: '',
      PatientNameSearchKey: '',
      PatientFathHusKey: '',
      PatientAddressKey: '',
      FilterDob: null,
      FilterUHID: "",
      PatientMotherKey: '',
      IdleAlertPopup: false,
      common_uhid: false,
      FilterIP: "",
      FilterOP: "",
      MultiDoctorValue: null,
      SelectedDoctor: 0,
      clinicId : null,
      // unit : 10,
      RTDiscApprovalDeails : null,
      isRTConcession: false,
    })
    clearAccessCache()
  }
  Menuitem = (id) => {
    this.setState({
      meunId: id
    })
  }
  handleChange = () => {
    this.setState({
      checked: true
    })
  };

  handleDrawerOpen = () => {
    this.setState({
      drawer_Open: true,

    })
  };
  handleDrawerClose = () => {
    this.setState({
      drawer_Open: false,
    })
  };
  handleOpenUserMenu = (e) => {
    this.setState({
      anchorElUser: true,
      RequestAnchor: e.currentTarget
    })
  };
  handleCloseUserMenu = (event) => {
    this.setState({
      anchorElUser: false
    })
  };

  resetCache = () => {
    this.resetState();
    localClearAll();
    clearAllCachevalue();
  }

  logout = () => {
    const { history } = this.props;
    // this.WebSocketDisconnect(); this.handleCloseUserMenu(); this.logout(); history.push('/'); 
    // this.resetState();
    // localClearAll();
    // clearAllCachevalue();

    try{
    var data = {}
    RestAPIService.create(data,Serviceurls.API_LOG_OUT)
      .then((response) => {
        if (response.data.status === "success") {
          this.WebSocketDisconnect(); this.handleCloseUserMenu(); this.resetState();
          localClearAll();
          history.push('/');
          this.successMessage(response.data?.message)
        } else {
          this.errorMessage(response.data.message)
        }
      }).catch((error) => {
        if (error?.response?.data?.message) {
          this.errorMessage(error.response.data.message)
        } else {
          this.errorMessage(error.message)
        }
      })
    }catch(e){
      this.errorMessage(e.message)
    }
  }

  /*Routing and Loader Functions Start*/
  onClick = () => {
    setTimeout(() => {
      this.setState({
        isLoader: false,
      })
    }, 1000)
    if (this.state.selectedMenuId == 3) {
      var open = this.state.checked
      this.setState({
        checked: !open
      })
    } else if (this.state.selectedMenuId == 4) {
      var open = this.state.checked
      this.setState({
        checked: !open
      })
    } else if (this.state.selectedMenuId == 5) {
      var open = this.state.checked
      this.setState({
        checked: !open
      })
    }
  }
  /*Routing and Loader Functions End*/

  search = (event) => {
    this.setState({
      globalSearch: event.target.value,
    });
  };
  clearSearch = () => {
    this.setState({
      globalSearch: ''
    })
  }
  ModuleDialogClose = () => {
    this.setState({ menuComp: false })
  }
  dialogCloseFunction = () => {
    this.setState({ ModuleSucessPop: false })
  }

  ModuleSuccess = () => {
    this.setState({ ModuleSucessPop: true })
    setTimeout(() => {
      this.setState({ ModuleSucessPop: false })
    }, 2000)
  }
  onClickSavedBills = (flag) => {
    this.setState({
      isSavedBill: flag
    })
  }
  savedBillClose = () => {
    this.setState({
      isSavedBill: false
    })
  }
  transmitedClose = () => {
    this.setState({
      isTranmitedBill: false
    })
  }
  onClickTranmittedBills = (flag) => {
    this.setState({
      isTranmitedBill: flag
    })
  }
  returnClose = () => {
    this.setState({
      ph_returns: false
    })
  }
  PrescriptionClose = () => {
    this.setState({
      ph_Prescrition: false,
      DocQueuePopup: false
    })
  }
  onClickSavedBillClose = (flag) => {
    this.setState({
      ph_SavedBill: flag
    })
  }
  savedBillClose = () => {
    this.setState({
      ph_SavedBill: false
    })
  }
  requestClose = () => {
    this.setState({
      ph_request: false
    })
  }
  onClickPrescriptionClose = (flag) => {
    this.setState({
      ph_Prescrition: flag
    })
  }
  onClickrequestClose = (flag) => {
    this.setState({
      ph_request: flag
    })
  }
  onClickreturnClose = (flag) => {
    this.setState({
      ph_returns: flag
    })
  }
  clearSearch = () => {
    this.setState({
      configSearch: '',
      searchkey: '',
      purchaseSearch: '',
      inventorySearch: "",
      reportSearch: ""
    })
  }

  onChangeHandler = (e) => {
    const { name, value } = e.target
    this.setState({
      [name]: value
    })
  }

  CancelQrRequest = (item) => {
    try {
      let data = {
        "id": item?.id,
      }
      RestAPIService.create(data, Serviceurls.FO_QR_ENTRY_LIST)
        .then(response => {
          if (response.data.status === "success") {
            this.setState({
              QRPatientName: ""
            }, () => { this.getQREntryList() })
          }
        })
        .catch(e => {
          if (e?.response?.data?.message) {
            this.errorMessage(e.response.data.message)
          } else {
            this.errorMessage(e.message)
          }
        });
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  helpDeskPost = () => {
    try {
      var states = this.state
      let data = {
        "subject": states.helpSubject,
        "content": states.helpDescription,
      }
      if (states.helpSubject && states.helpDescription) {
        RestAPIService.create(data, Serviceurls.HELPDESK)
          .then(response => {
            if (response.data.status === "success") {
              this.setState({
                helpDescription: "",
                helpSubject: "",
                isHelpdeskClicked: false
              })
            }
          })
          .catch(e => {
            if (e?.response?.data?.message) {
              this.errorMessage(e.response.data.message)
            } else {
              this.errorMessage(e.message)
            }
          });
      } else {
        this.errorMessage("Please enter the All Details")
      }
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  renderHelpDeskPopup = () => {
    const { t } = this.props
    return (
      <>
        <Modal open={this.state.isHelpdeskClicked} >
          <Box className='eMed_rts_popup'>
            <Box className='eMed_rts_home_header'>
              <Typography component={'label'} variant='h6' fontWeight={600}>{t("Customer Support")}</Typography>
              <Typography component={'p'} className='eMed_rts_home_txt_one'>{t("Kindly describe the issue which you are facing. We will help you.")}</Typography>
            </Box>
            <Box component={'div'} margin="1vw" >
              <TextField
                variant='outlined'
                size='small'
                fullWidth
                placeholder='Subject'
                className='eMed_rts_home_txt'
                value={this.state.helpSubject}
                name='helpSubject'
                onChange={(e) => this.onChangeHandler(e)}
              />
            </Box>
            <Box component={'div'} margin="1vw" >
              <TextField
                variant='outlined'
                size='small'
                multiline
                rows={3}
                fullWidth
                placeholder='Description'
                className='eMed_rts_home_txt'
                value={this.state.helpDescription}
                name='helpDescription'
                onChange={(e) => this.onChangeHandler(e)}
              />
            </Box>
            <Box component='div' margin={'1vw'} display={'flex'} justifyContent='flex-end'>
              <Button variant='outlined'
                className='eMed_rts_home_btn'
                size='small'
                onClick={() => {
                  this.setState({
                    helpDescription: "",
                    helpSubject: "",
                    isHelpdeskClicked: false
                  })
                }} >{t("Back")}</Button>
              <Button
                variant='contained'
                className='eMed_rts_home_btn_two'
                size='small'
                onClick={() => { this.helpDeskPost() }}
              >{t("Send")}</Button>
            </Box>
          </Box>
        </Modal>
      </>
    )
  }

  changeScreen = (screenId) => {
    var { selectedMenuId, selectedPageName } = this.state
    if (parseInt(screenId) == 1) {
      selectedMenuId = 1
      selectedPageName = 'MainHome'
    } else if (screenId == 2) {
      selectedMenuId = 2
      selectedPageName = 'Reports'
    } else if (screenId == 3) {
      selectedMenuId = 3
      selectedPageName = 'Inventory'
    } else if (screenId == 4) {
      selectedMenuId = 4
      selectedPageName = 'Purchase'
    } else if (screenId == 5) {
      selectedMenuId = 5
      selectedPageName = 'Config'
    }

    this.setState({
      selectedMenuId,
      selectedPageName
    })
  }

  subScreenChange = (screen) => {
    this.setState({
      selectedSubScreen: screen,
      searchkey: ""
    })
  }
  getcountNotification = (flag) => {
    if (flag) {
      this.getIndentCount()
    }
  }

  getClinicdata = () => {
    try {
      RestAPIService.getAll(Serviceurls.LAB_CLINIC_LIST_GET).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              clinicData: response.data.data,
              clinicId: response.data.data[0].clinic_id
            }, () => {
            })
          } else {
            this.setState({
              isErrorMsg: true,
              isErrorMsgText: response?.data?.message
            }, () => {
              setTimeout(() => {
                this.setState({ isErrorMsg: false })
              }, 2000);
            })
          }
        }).catch((error) => {
          this.setState({
            isErrorMsg: true,
            isErrorMsgText: error?.response?.data?.message
          }, () => {
            setTimeout(() => {
              this.setState({ isErrorMsg: false })
            }, 2000);
          })
        })
    } catch (error) {
      this.setState({
        isErrorMsg: true,
        isErrorMsgText: error
      }, () => {
        setTimeout(() => {
          this.setState({ isErrorMsg: false })
        }, 2000);
      })
    }
  }

  isSearchClear = (flag) => {
    const { history } = this.props;
    if (flag) {
      this.setState({
        searchkey: ""
      }, () => {
        history.push({ pathname: "/MainHome", state: { search_key: "" } })
      })
    }
  }
  returnSideMenus = () => {
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser

    if (UserData?.module_name === "front_office") {
      return NewSideMenu.FO()
    }
    else if (UserData?.module_name === "nurse") {
      return NewSideMenu.Nurse()
    }
    else if (UserData?.module_name === "Laboratory") {
      return NewSideMenu.lab()
    }
    else if (UserData?.module_name === 'Pharmacy') {
      return NewSideMenu.Pharmacy()
    }
    else if (UserData?.module_name === 'sub_location' || UserData?.module_name === 'Store Sub Location') {
      if (myUser?.sub_location_module === 'Front Office') {
        return NewSideMenu.FO_SubLocation()
      } else if (myUser?.sub_location_module === 'LAB') {
        return NewSideMenu.LAB_SubLocation()
      } else if (myUser?.sub_location_module === 'Radiology') {
        return NewSideMenu.Radiology_SubLocation()
      } else if (myUser?.sub_location_module === 'Pharmacy') {
        return NewSideMenu.Pharmacy_SubLocation()
      } else {
        return NewSideMenu.SubLocation()
      }
    }
    else if (UserData?.module_name === "ot_management") {
      return NewSideMenu.OT()
    }
    else if (UserData?.module_name === "counsellor") {
      return NewSideMenu.Counsellor()
    }
    else if (UserData?.module_name === "Doctor" || UserData?.module_name === "Optometry") {
      return NewSideMenu.Doctor()
    }
    else if (UserData?.module_name === 'Radiology' || localGetItem('investigation_name')) {
      return NewSideMenu.Radiology()
    }
    else if (UserData?.module_name === "Organization") {
      return NewSideMenu.OrganizationAdmin()
    }
    else if (UserData?.module_name === "master_record_department") {
      return NewSideMenu.MRD()
    }
    else if (UserData?.module_name === "canteen") {
      return NewSideMenu.Canteen()
    }
    else if (UserData?.module_name === "asset_management") {
      return NewSideMenu.Asset()
    }
    else if (UserData?.module_name === "JMO") {
      return NewSideMenu.JMO()
    }
    else if (UserData?.module_name === "store_module") {
      return NewSideMenu.Store()
    }
    else if (UserData?.module_name === "Radiotherapy") {
      return NewSideMenu.Radiotherapy()
    }
    else {
      return []
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  infoMessage = (message) => {
    this.setState({
      isInfoMsg: true,
      isInfoMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: '',
      isInfoMsg: false,
      isInfoMsgText: '',
    })
  }

  FOPatientSearch(ForRequest = false, MobNum = null) {
    try {
      let { t } = this.props;
      let API_URL = ""
      if (ForRequest) {
        API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${MobNum}&address_key=&father_husband_key=&address=true`
        this.AppointMobileSrch(true);
      } else {
        var DobDate = new Date(this.state.FilterDob)
        var date = this.state.FilterDob ? DateTime.fromJSDate(DobDate).toFormat('yyyy-MM-dd') : ""
        API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${this.state.PatientNameSearchKey}&address_key=${this.state.PatientAddressKey}&father_husband_key=${this.state.PatientFathHusKey}&mother_name_key=${this.state.PatientMotherKey}&uhid=${this.state.FilterUHID}&dob=${date}&ip_number=${this.state.FilterIP}&op_number=${this.state.FilterOP}`
        this.isPatientisSearching(true)
      }
      // this.isPatientisSearching(true)
      RestAPIService.getAll(API_URL).
        then((response) => {
          if (response.data.status === "success") {
            this.isPatientisSearching(false)
            this.AppointMobileSrch(false);
            if (ForRequest) {
              this.setState({
                SearchedRequestPatientList: response.data.data,
                RequestPatientMenuPop: response.data.data.length > 0 ? true : false
              })
            } else {
              this.setState({
                SearchedPatientList: response.data.data,
                common_uhid: response?.data?.common_uhid ? response?.data?.common_uhid : false
              }, () => {
                if (this.state.PatientNameSearchKey !== "" || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "" || ((window.location.pathname === "/OPHome") ? this.state.FilterOP !== "" : this.state.FilterIP !== "")) {
                  if (response.data.data.length > 0) {
                    this.setState({ PatientSearchClicked: true, AddressFilterClicked: false })
                  } else {
                    this.setState({ PatientSearchClicked: false, AddressFilterClicked: false })
                    this.errorMessage(t("NoRecordsFound"))
                  }
                }
              })
            }
          }
          else {
            this.isPatientisSearching(false)
            this.AppointMobileSrch(false);
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error?.message)
          }
          this.isPatientisSearching(false)
          this.AppointMobileSrch(false);
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  getIpPatientData = (patientId) => {
    try {
      RestAPIService.getAll(Serviceurls.FO_PATIENT_UPDATE + '?patient_id=' + patientId).
        then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              ipPatientListData: response?.data?.data
            }, () => {
              this.props.history.push({ pathname: "/IPHome/CreateAppointment", state: { SelectedPatientDetails: this.state.ipPatientListData, PatientClicked: true } })
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error?.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  handleSearchSubmit = (value, module_name, FromFO = false) => {
    if(module_name === "Fo"){
      this.setState({ PatientNameSearchKey: value}, () => {
        if ((this.state.PatientNameSearchKey !== "" && this.state.PatientNameSearchKey.length > 2) || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "" || ((window.location.pathname === "/OPHome") ? this.state.FilterOP !== "" : this.state.FilterIP !== "")) {
          this.FOPatientSearch();
        }
      });
    }
    else if (module_name === "Lab"){
      this.setState({searchkey: value, LabPatientSearch : true}, () =>{
        this.getPatientSearchData(FromFO)
      });
    }
    else if (module_name === "Pharmacy") {
      this.setState({ pharmaNameSearchKey: value }, () => {
        if (CommonValidation.removeSpace(this.state.pharmaNameSearchKey) !== "" && this.state.pharmaNameSearchKey?.length > 2) {
          this.PharmaPatientSearch();
        }
      });
    }
    else if (module_name === "Radiology" || module_name === "Investigation"){
      this.setState({ PatientNameSearchKey: value}, () => {
        if((this.state.PatientNameSearchKey !== "" && this.state.PatientNameSearchKey.length > 2) || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== ""){
          this.radiologyPatientSearch()
        }
      });
    }
    else if (module_name === "Doctor"){
      this.setState({ PatientNameSearchKey: value}, () => {
        if((this.state.PatientNameSearchKey !== "" && this.state.PatientNameSearchKey.length > 2) || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "" || this.state.FilterOP !== ""){
          this.DoctorPatientSearch()
        }
      }); 
    }
  };

  handleSearchClear = (module_name) => {
    if(module_name === "Pharmacy"){
      this.setState({ pharmaSearchClicked: false });
    }
    else if (module_name === "Lab"){
      this.setState({ LabPatientSearch: false });
    }
    else{
      this.setState({ PatientSearchClicked: false });
    }
  };

  handleFilterOpen = () => {
    this.setState({ AddressFilterClicked: true })
  }

  handleFaceOpen = (module_name) => {
    if(module_name === "Doctor"){
      this.setState({ docFaceRecogClicked: true },()=>{ this.getConnectedDevices()})
    }
    else{
      this.setState({ FaceRecogClicked: true },()=>{ this.getConnectedDevices()})
    }
  }

  FOheaderSearch = () => {
    const { t } = this.props;
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser
    let DoctorsList = this.state.DoctorsList?.length > 0 ? this.state.DoctorsList : localGetItem("DoctorsList") ? JSON.parse(localGetItem("DoctorsList")) : []
    const filter = createFilterOptions({
      stringify: (option) => option.doctor_name,
    })
    const restrict_op_appointment_in_ip_patients = localGetItem('restrict_op_appointment_in_ip_patients') === 'true';
    return (
      <Box sx={{ marginLeft: '3.2vw' }}>
        <Box component={'div'} display={'flex'} flexDirection={'row'} sx={{ borderRadius: "0.3vw" }}>
           <FormControl size='small' sx={{ width: "13vw", borderRadius: '0.3vw' }}>
            <Autocomplete
              size="small"
              disableClearable={true}
              clearOnEscape
              sx={{ borderRadius: "0.3vw" }}
              filterOptions={filter}
              options={[{ doctor_id: 0, doctor_name: "All Doctors" }, ...DoctorsList]}
              getOptionLabel={(option) => option?.doctor_name || ""}
              isOptionEqualToValue={(option, value) =>
                option?.doctor_id === value?.doctor_id
              }
              value={
                window.location.pathname === "/OPHome"
                  ? (this.state.SelectedDoctor === 0
                    ? { doctor_id: 0, doctor_name: "All Doctors" }
                    : DoctorsList.find((d) => d.doctor_id === this.state.SelectedDoctor) || null)
                  : (this.state.SelectedIPDoctor === 0
                    ? { doctor_id: 0, doctor_name: "All Doctors" }
                    : DoctorsList.find((d) => d.doctor_id === this.state.SelectedIPDoctor) || null)
              }
              onChange={(e, newValue) => {
                const selectedID = newValue?.doctor_id ?? null;
                if (window.location.pathname === "/OPHome") {
                  this.setState({ SelectedDoctor: selectedID }, () => {
                    setCachevalue(selectedID, "SelectedDoctorID");
                  });
                } else if (window.location.pathname === "/IPHome") {
                  this.setState({ SelectedIPDoctor: selectedID }, () => {
                    setCachevalue(selectedID, "SelectedIPDoctorID");
                  });
                }
              }}
              onClose={(event) => {
                const isOP = window.location.pathname === "/OPHome";
                const key = isOP ? "SelectedDoctor" : "SelectedIPDoctor";
                const cacheKey = isOP ? "SelectedDoctorID" : "SelectedIPDoctorID";
                const inputText = event?.target?.value ?? "";
                const val = this.state[key];
                if (val === null || val === "" || val === undefined || inputText.trim() === "") {
                  this.setState({ [key]: 0 }, () => setCachevalue(0, cacheKey));
                }
              }}

              renderInput={(params) => (
                <TextField {...params} size="small" sx={{ backgroundColor: "white",borderRadius: "0.3vw" }} placeholder="Search doctor..." />
              )}
            />
          </FormControl>
          {UserData?.module_name !== "nurse" ?
            // <OutlinedInput
            //   placeholder={t("SearchPatients")}
            //   onKeyDown={(event) => {
            //     if (event.key === "Enter" && event.target.value != "" && event.target.value.length > 2) {
            //       event.preventDefault();
            //       this.FOPatientSearch();
            //     } else if (event.key === "Enter" && event.target.value === "" && event.target.value.length <= 0) {
            //       this.setState({ PatientSearchClicked: false })
            //     }
            //   }}
            //   onChange={(e) => {
            //     this.setState({
            //       PatientNameSearchKey: e.target.value
            //     })
            //   }}
            //   value={this.state.PatientNameSearchKey}
            //   size="small"
            //   className='eMed_header_Input'
            //   endAdornment={
            //     <Box component={'div'} display={'flex'} flexDirection={'row'}>
            //       <Divider orientation="vertical" variant="middle" flexItem />
            //       {this.state.isPatientisSearching ?
            //         <Box sx={{ display: 'flex', alignItems: "center", justifyContent: "center", width: '2.5vw' }}>
            //           <InputAdornment position="end"><CircularProgress size={15} /></InputAdornment>
            //         </Box> :
            //         <Tooltip title={t("Search")} arrow>
            //           <IconButton disabled={this.state.PatientNameSearchKey === "" && this.state.PatientAddressKey === "" && this.state.PatientFathHusKey === "" && this.state.PatientMotherKey === "" && this.state.FilterDob === null && this.state.FilterUHID === "" && ((window.location.pathname === "/OPHome") ? this.state.FilterOP === "" : this.state.FilterIP === "")}
            //             onClick={(e) => {
            //               if ((this.state.PatientNameSearchKey !== "" && this.state.PatientNameSearchKey.length > 2) || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "" || ((window.location.pathname === "/OPHome") ? this.state.FilterOP !== "" : this.state.FilterIP !== "")) {
            //                 this.FOPatientSearch()
            //               }
            //             }} position="end">
            //             <SearchIcon />
            //           </IconButton>
            //         </Tooltip>}
            //       <Tooltip title={t("Filter")} arrow>
            //         <IconButton onClick={() => { this.setState({ AddressFilterClicked: true }) }} position="end">
            //           <Badge color="error" size='small' variant="dot" max={999} invisible={this.state.PatientAddressKey === "" && this.state.PatientFathHusKey === "" && this.state.PatientMotherKey === "" && this.state.FilterDob === null && this.state.FilterUHID === "" && ((window.location.pathname === "/OPHome") ? this.state.FilterOP === "" : this.state.FilterIP === "")}>
            //             <FilterAltIcon />
            //           </Badge>
            //         </IconButton>
            //       </Tooltip>
            //      {this.state.isfaceRecognizationEnabled ? <Tooltip title={t("FaceRecognition")} arrow>
            //         <IconButton onClick={() => { this.setState({ FaceRecogClicked: true },()=>{ this.getConnectedDevices()}) }} position="end">
            //           <CenterFocusWeakIcon />
            //         </IconButton>
            //       </Tooltip> : null}
            //     </Box>
            //   }
            // /> 
            <>
            <PatientHeaderSearch
                t={this.props.t}
                isLoading={this.state.isPatientisSearching}
                filterVisible={this.state.PatientAddressKey === "" && this.state.PatientFathHusKey === "" && this.state.PatientMotherKey === "" && this.state.FilterDob === null && this.state.FilterUHID === "" && ((window.location.pathname === "/OPHome") ? this.state.FilterOP === "" : this.state.FilterIP === "")}
                flterOpen = {this.handleFilterOpen}
                faceOpen = {this.handleFaceOpen}
                module_name = {"Fo"}
                faceVisible = {this.state.isfaceRecognizationEnabled}
                onSearchSubmit={this.handleSearchSubmit}
                onClear={this.handleSearchClear}
                searchValue={this.state.PatientNameSearchKey}
              />
              </>
            : null}
        </Box>
        <Menu
          open={this.state.PatientSearchClicked}
          className="eMed_Header_Search_Pop"
          disableAutoFocus
          disableEnforceFocus
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          MenuListProps={{
            autoFocus: false
          }}
          onClose={() => {
            this.setState({
              PatientSearchClicked: false,
              // PatientNameSearchKey: "",
              PatientAddressKey: "",
              PatientFathHusKey: "",
              PatientMotherKey: "",
              FilterDob : null ,
              FilterUHID : "",
              FilterOP : "",
              FilterIP : "",
            })
          }}
        >
          {
            (this.state.SearchedPatientList.length > 0 && !this.state.hasAbha) ?
              this.state.SearchedPatientList.map((list) => {
                let PatientFullName = `${list.first_name} ${list.last_name}`
                list["patient_name"] = PatientFullName
                list["patient_mobile_number"] = list.mobile_number
                list["patient_photo_url"] = list.photo_url
                const disableAddIcon = (localGetItem('isNewBilling') === "true" && restrict_op_appointment_in_ip_patients && list?.ip_has_current_appointment) ? true : false;
                
                return (
                  <Box>
                    <Box className="eMed_Header_Search_item">
                      <CommonPatientDetails data={list} fromSearch={true} isCommonUhid={this.state.common_uhid} />
                      <Tooltip title={t("Last Visit Date")} arrow>
                        <div style={{ fontSize: "0.65vw", fontWeight: "bold" }}>Last Visited Date</div>
                        <Typography sx={{ fontSize: '0.85vw' }}>OP: {formatDate(list?.op_last_visit_date)}</Typography>
                        <Typography sx={{ fontSize: '0.85vw' }}>IP: {formatDate(list?.ip_last_visit_date)}</Typography>
                      </Tooltip>
                      {
                        ((window.location.pathname === "/OPHome")) ?
                          (list.appointment_date === "" || list.appointment_status === "Cancelled") ?
                            <Box component={'div'} className="eMed_Header_Search_icons">
                              <Tooltip title={t("EditPatientDetails")} arrow>
                                <IconButton onClick={() => {
                                  this.setState({
                                    PatientNameSearchKey: "",
                                    PatientAddressKey: "",
                                    PatientFathHusKey: "",
                                    PatientMotherKey: "",
                                    PatientSearchClicked: false,
                                    SearchedPatientList: [],
                                    common_uhid: false,
                                    FilterDob: null,
                                    FilterUHID: "",
                                    FilterOP: "",
                                    FilterIP: "",
                                  }, () => {
                                    this.getDoctorPatientDetailData(list?.patient_id, "fromOpHomeEdit", false, list)
                                  })
                                }}
                                  position="end">
                                  <Edit color='primary' />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={t("CreateAppointment")} arrow>
                                <IconButton disabled = {(localGetItem('isNewBilling') === "true") ? disableAddIcon : list?.op_has_current_appointment} onClick={() => {
                                  this.setState({
                                    PatientNameSearchKey: "",
                                    PatientAddressKey: "",
                                    PatientFathHusKey: "",
                                    PatientMotherKey: "",
                                    FilterDob: null,
                                    FilterUHID: "",
                                    FilterOP: "",
                                    FilterIP: "",
                                    PatientSearchClicked: false,
                                    SearchedPatientList: [],
                                    common_uhid: false,
                                  }, () => {
                                    setCachevalue(list.patient_id, "OP_CreateAppointment_PatientId")
                                    this.props.history.push({ pathname: (localGetItem('isNewBilling') === "true") ? "/OPHome/Billing/NewQuickBilling" : "/OPHome/Billing/QuickBilling" })
                                  })
                                }}
                                  position="end">
                                  <PersonAddAlt1Icon sx={{ color: (list?.op_has_current_appointment || disableAddIcon) ? Colors.disableLabelColor : Colors.themeDark }}/>
                                </IconButton>
                              </Tooltip>
                            </Box> :  
                            <Box component={'div'} className="eMed_Header_Search_icons">
                              <Tooltip title={t("EditPatientDetails")} arrow>
                                <IconButton onClick={() => {
                                  this.setState({
                                    PatientNameSearchKey: "",
                                    PatientAddressKey: "",
                                    PatientFathHusKey: "",
                                    PatientMotherKey: "",
                                    FilterDob: null,
                                    FilterUHID: "",
                                    FilterIP: "",
                                    FilterOP: "",
                                    PatientSearchClicked: false,
                                    SearchedPatientList: [],
                                    common_uhid: false,
                                  }, () => {
                                     this.getDoctorPatientDetailData(list?.patient_id, "fromOpHomeEdit", false, list)
                                  })
                                }}
                                  position="end">
                                  <Edit color='primary' />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={t("CreateAppointment")} arrow>
                                <IconButton disabled = {(localGetItem('isNewBilling') === "true") ? disableAddIcon : list?.op_has_current_appointment } onClick={() => {
                                  this.setState({
                                    PatientNameSearchKey: "",
                                    PatientAddressKey: "",
                                    PatientFathHusKey: "",
                                    PatientMotherKey: "",
                                    FilterDob: null,
                                    FilterUHID: "",
                                    FilterOP: "",
                                    FilterIP: "",
                                    PatientSearchClicked: false,
                                    SearchedPatientList: [],
                                    common_uhid: false
                                  }, () => {
                                    setCachevalue(list.patient_id, "OP_CreateAppointment_PatientId")
                                    this.props.history.push({ pathname: (localGetItem('isNewBilling') === "true") ? "/OPHome/Billing/NewQuickBilling" : "/OPHome/Billing/QuickBilling" })
                                  })
                                }}
                                  position="end">
                                  <PersonAddAlt1Icon sx={{ color: (list.op_has_current_appointment && (localGetItem('isNewBilling') === "false") || disableAddIcon) ? Colors.disableLabelColor : Colors.themeDark }} />
                                </IconButton>
                              </Tooltip>
                              {/* <Typography>{list.appointment_date && formatDate(list.appointment_date)}</Typography> */}
                            </Box>
                          :
                          <Box component={'div'} className="eMed_Header_Search_icons">
                            <Tooltip title={t("ViewPatientDetails")} arrow>
                              <IconButton onClick={() => {
                                this.setState({
                                  PatientNameSearchKey: "",
                                  PatientAddressKey: "",
                                  PatientFathHusKey: "",
                                  PatientMotherKey: "",
                                  FilterDob: null,
                                  FilterUHID: "",
                                  FilterOP: "",
                                  FilterIP: "",
                                  PatientSearchClicked: false,
                                  SearchedPatientList: [],
                                  common_uhid: false
                                }, () => {
                                  this.getDoctorPatientDetailData(list?.patient_id, "fromIpHomeEdit", false, list)
                                })
                              }}
                                position="end">
                                <img src={ImagePaths.View.default} />
                              </IconButton>
                            </Tooltip>
                            {list.is_admitted ? <Typography>{list.admission_date && formatDate(list.admission_date)}</Typography> :
                              <Tooltip title={t("CreateAdmission")} arrow>
                                <IconButton disabled={list?.ip_has_current_appointment}
                                  onClick={() => {
                                    this.setState({
                                      PatientNameSearchKey: "",
                                      PatientAddressKey: "",
                                      PatientFathHusKey: "",
                                      PatientMotherKey: "",
                                      FilterDob: null,
                                      FilterUHID: "",
                                      FilterOP: "",
                                      FilterIP: "",
                                      PatientSearchClicked: false,
                                      SearchedPatientList: [],
                                      PatientMotherKey: "",
                                      common_uhid: false,
                                    }, () => {
                                      this.getIpPatientData(list?.patient_id)
                                    })
                                  }} position="end">
                                  <PersonAddAlt1Icon sx={{ color: list.ip_has_current_appointment ? Colors.disableLabelColor : Colors.themeDark }} />
                                </IconButton>
                              </Tooltip>}
                          </Box>
                      }
                    </Box>
                    <Divider />
                  </Box>
                )
              }) : (this.state.SearchedPatientList.length > 0 && this.state.hasAbha) ?
              this.state.SearchedPatientList.map((list) => {
                let PatientFullName = `${list.first_name} ${list.last_name}`
                list["patient_name"] = PatientFullName
                list["patient_mobile_number"] = list.mobile_number
                list["patient_photo_url"] = list.photo_url
                const disableAddIcon = (localGetItem('isNewBilling') === "true" && restrict_op_appointment_in_ip_patients && list?.ip_has_current_appointment) ? true : false;

                return (
                  <Box>
                    <Box className="eMed_Header_Search_item_abha">
                      <CommonPatientDetails data={list} fromSearch={true} isCommonUhid={this.state.common_uhid} />
                      <Tooltip title={t("ABHA Details")} arrow>
                      <div style={{ fontSize: "0.65vw", fontWeight: "bold", width:'13.5vw' }}>ABHA Details</div>
                      <Typography sx={{ fontSize: '0.85vw' }}>{list?.abha_health_id || "-"}</Typography>
                      <Typography sx={{ fontSize: '0.85vw' }}>{list?.abha_health_address || "-"}</Typography>
                      </Tooltip>

                      <Tooltip title={t("Last Visit Date")} arrow>
                        <div style={{ fontSize: "0.65vw", fontWeight: "bold", width:"8.5vw" }}>Last Visited Date</div>
                        <Typography sx={{ fontSize: '0.85vw' }}>OP: {formatDate(list?.op_last_visit_date)}</Typography>
                        <Typography sx={{ fontSize: '0.85vw' }}>IP: {formatDate(list?.ip_last_visit_date)}</Typography>
                      </Tooltip>
                      {
                        ((window.location.pathname === "/OPHome")) ?
                          (list.appointment_date === "" || list.appointment_status === "Cancelled") ?
                            <Box component={'div'} className="eMed_Header_Search_icons">
                              <Tooltip title={t("EditPatientDetails")} arrow>
                                <IconButton onClick={() => {
                                  this.setState({
                                    PatientNameSearchKey: "",
                                    PatientAddressKey: "",
                                    PatientFathHusKey: "",
                                    PatientMotherKey: "",
                                    PatientSearchClicked: false,
                                    SearchedPatientList: [],
                                    common_uhid: false,
                                    FilterDob: null,
                                    FilterUHID: "",
                                    FilterOP: "",
                                    FilterIP: "",
                                  }, () => {
                                    setCachevalue(JSON.stringify(list), "patientData")
                                    this.props.history.push({ pathname: "/OPHome/PatientDetails/Demographics", state: {abha_health_id: list?.abha_health_id || null} })
                                  })
                                }}
                                  position="end">
                                  <Edit color='primary' />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={t("CreateAppointment")} arrow>
                                <IconButton disabled = {list?.op_has_current_appointment || disableAddIcon} onClick={() => {
                                  this.setState({
                                    PatientNameSearchKey: "",
                                    PatientAddressKey: "",
                                    PatientFathHusKey: "",
                                    PatientMotherKey: "",
                                    FilterDob: null,
                                    FilterUHID: "",
                                    FilterOP: "",
                                    FilterIP: "",
                                    PatientSearchClicked: false,
                                    SearchedPatientList: [],
                                    common_uhid: false,
                                  }, () => {
                                    setCachevalue(list.patient_id, "OP_CreateAppointment_PatientId")
                                    this.props.history.push({ pathname: (localGetItem('isNewBilling') === "true") ? "/OPHome/Billing/NewQuickBilling" : "/OPHome/Billing/QuickBilling" })
                                  })
                                }}
                                  position="end">
                                  <PersonAddAlt1Icon sx={{ color: (list.op_has_current_appointment || disableAddIcon) ? Colors.disableLabelColor : Colors.themeDark }}/>
                                </IconButton>
                              </Tooltip>
                            </Box> :  
                            <Box component={'div'} className="eMed_Header_Search_icons">
                              <Tooltip title={t("EditPatientDetails")} arrow>
                                <IconButton onClick={() => {
                                  this.setState({
                                    PatientNameSearchKey: "",
                                    PatientAddressKey: "",
                                    PatientFathHusKey: "",
                                    PatientMotherKey: "",
                                    FilterDob: null,
                                    FilterUHID: "",
                                    FilterIP: "",
                                    FilterOP: "",
                                    PatientSearchClicked: false,
                                    SearchedPatientList: [],
                                    common_uhid: false,
                                  }, () => {
                                    setCachevalue(JSON.stringify(list), "patientData")
                                    this.props.history.push({ pathname: "/OPHome/PatientDetails/Demographics", state: {abha_health_id: list?.abha_health_id || null} })
                                  })
                                }}
                                  position="end">
                                  <Edit color='primary' />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={t("CreateAppointment")} arrow>
                                <IconButton disabled = {list?.op_has_current_appointment || disableAddIcon} onClick={() => {
                                  this.setState({
                                    PatientNameSearchKey: "",
                                    PatientAddressKey: "",
                                    PatientFathHusKey: "",
                                    PatientMotherKey: "",
                                    FilterDob: null,
                                    FilterUHID: "",
                                    FilterOP: "",
                                    FilterIP: "",
                                    PatientSearchClicked: false,
                                    SearchedPatientList: [],
                                    common_uhid: false
                                  }, () => {
                                    setCachevalue(list.patient_id, "OP_CreateAppointment_PatientId")
                                    this.props.history.push({ pathname: (localGetItem('isNewBilling') === "true") ? "/OPHome/Billing/NewQuickBilling" : "/OPHome/Billing/QuickBilling" })
                                  })
                                }}
                                  position="end">
                                  <PersonAddAlt1Icon sx={{ color: (list.op_has_current_appointment || disableAddIcon)? Colors.disableLabelColor : Colors.themeDark }} />
                                </IconButton>
                              </Tooltip>
                              {/* <Typography>{list.appointment_date && formatDate(list.appointment_date)}</Typography> */}
                            </Box>
                          :
                          <Box component={'div'} className="eMed_Header_Search_icons">
                            <Tooltip title={t("ViewPatientDetails")} arrow>
                              <IconButton onClick={() => {
                                this.setState({
                                  PatientNameSearchKey: "",
                                  PatientAddressKey: "",
                                  PatientFathHusKey: "",
                                  PatientMotherKey: "",
                                  FilterDob: null,
                                  FilterUHID: "",
                                  FilterOP: "",
                                  FilterIP: "",
                                  PatientSearchClicked: false,
                                  SearchedPatientList: [],
                                  common_uhid: false
                                }, () => {
                                  setCachevalue(JSON.stringify(list), "IppatientData")
                                  setCachevalue(JSON.stringify(list), "patientData")
                                  this.props.history.push({ pathname: "/IPHome/Demographics/Demographics", state: {abha_health_id: list?.abha_health_id || null}  })
                                })
                              }}
                                position="end">
                                <img src={ImagePaths.View.default} />
                              </IconButton>
                            </Tooltip>
                            {list.is_admitted ? <Typography>{list.admission_date && formatDate(list.admission_date)}</Typography> :
                              <Tooltip title={t("CreateAdmission")} arrow>
                                <IconButton disabled={list?.ip_has_current_appointment}
                                  onClick={() => {
                                    this.setState({
                                      PatientNameSearchKey: "",
                                      PatientAddressKey: "",
                                      PatientFathHusKey: "",
                                      PatientMotherKey: "",
                                      FilterDob: null,
                                      FilterUHID: "",
                                      FilterOP: "",
                                      FilterIP: "",
                                      PatientSearchClicked: false,
                                      SearchedPatientList: [],
                                      PatientMotherKey: "",
                                      common_uhid: false,
                                    }, () => {
                                      this.getIpPatientData(list?.patient_id)
                                    })
                                  }} position="end">
                                  <PersonAddAlt1Icon sx={{ color: list.ip_has_current_appointment ? Colors.disableLabelColor : Colors.themeDark }} />
                                </IconButton>
                              </Tooltip>}
                          </Box>
                      }
                    </Box>
                    <Divider />
                  </Box>
                )
              }) : null
          }
        </Menu>
        <Menu
          open={this.state.AddressFilterClicked}
          className="eMed_Header_Filter_Pop"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={() => {
            this.setState({ AddressFilterClicked: false })
          }}
        >
          {this.DynamicFilterFeilds()}
        </Menu>
      </Box>
    )
  }

  returnHeaderFilds = (value) => {
    const { t } = this.props;
    switch (value) {
      case "address": return <TextField
        sx={{ marginY: "0.5vw" }}
        label={t("SearchByAddress")}
        inputProps={{ maxLength: 50 }}
        autoComplete='off'
        size='small'
        value={this.state.PatientAddressKey}
        onChange={(e) => { this.setState({ PatientAddressKey: e.target.value }) }}
        onKeyDown={(e) => e.stopPropagation()} />
      case "father husband name": return <TextField
        sx={{ marginY: "0.5vw" }}
        label={t("SearchByFatherSpouseName")}
        inputProps={{ maxLength: 50 }}
        autoComplete='off'
        size='small'
        value={this.state.PatientFathHusKey}
        onChange={(e) => {
          var isSpecial = /^[ A-Za-z.,/]*$/.test(e.target.value)
          if (isSpecial) {
            this.setState({ PatientFathHusKey: e.target.value, errorFathhus: false, error: false })
          } else {
            // this.setState({ errorFathhus: true, error: false })
          }
        }}
        // error={this.state.errorFathhus}
        // helperText={this.state.errorFathhus ? "Enter Only Alphabets" : null}
        onKeyDown={(e) => e.stopPropagation()} />
      case "dob": return <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={this.state.FilterDob}
          name={"datePicker"}
          inputFormat='DD-MM-YYYY'
          views={["year", "month", "day"]}
          maxDate={new Date()}
          onChange={
            (newDate) => {
              this.setState({
                FilterDob: newDate,
              });
            }}
          renderInput={(params) => <TextField size='small' sx={{ marginY: "0.5vw" }} {...params} label={"Date of Birth"} />}
        />
      </LocalizationProvider>
      case "mother name": return <TextField
        sx={{ marginY: "0.5vw" }}
        label={t("Search By Mother Name")}
        autoComplete='off'
        inputProps={{ maxLength: 50 }}
        size='small'
        value={this.state.PatientMotherKey}
        onChange={(e) => {
          var isSpecial = /^[ A-Za-z.,/]*$/.test(e.target.value)
          if (isSpecial) {
            this.setState({ PatientMotherKey: e.target.value })
          } else {
            // this.setState({ errorFathhus: true, error: false })
          }
        }}
        onKeyDown={(e) => e.stopPropagation()} />
      case "uhid": return <TextField
        sx={{ marginY: "0.5vw" }}
        label={t("Search By UHID")}
        autoComplete='off'
        inputProps={{ maxLength: 20 }}
        size='small'
        value={this.state.FilterUHID}
        onChange={(e) => { this.setState({ FilterUHID: e.target.value }) }}
        onKeyDown={(e) => e.stopPropagation()} />
      case "op_ip_number":
          return (
            <TextField
              sx={{ marginY: "0.5vw" }}
              label={
                t((window.location.pathname === "/OPHome" || window.location.pathname === "/DoctorHome" ) ?
                 "Search By OP Appointment Id" : "Search By IP Adminssion Id")
              }
              autoComplete="off"
              inputProps={{ maxLength: 50 }}
              size="small"
              value={
                (window.location.pathname === "/OPHome" || window.location.pathname === "/DoctorHome")
                  ? this.state.FilterOP
                  : this.state.FilterIP
              }
              onChange={(e) =>
                this.setState(
                  (window.location.pathname === "/OPHome" || window.location.pathname === "/DoctorHome" )
                    ? { FilterOP: e.target.value }
                    : { FilterIP: e.target.value }
                )
              }
              onKeyDown={(e) => e.stopPropagation()}
            />
          );
      default: break;
    }
  }

  DynamicFilterFeilds = (FromRadiology = false) => {
    const { t } = this.props;
    let LoggedData = JSON.parse(localGetItem("loggedInUserInfo"))
    let FeildData = LoggedData?.header_filter_fields ? LoggedData?.header_filter_fields : JSON.parse(JSON.stringify(Header_Filter_Fields))
    return (
      <Box className="eMed_Header_Filter_item" sx={{ height: 'auto' }}>
        {
          FeildData?.map((list) => {
            if (list?.is_checked) {
              return this.returnHeaderFilds(list?.value)
            }
          })
        }
        <Box component={'div'} display='flex' flexDirection='row' justifyContent={'center'}  >
          <Button id="eMed_Config_btn" variant='contained' size='small' disabled={(this.state.PatientAddressKey === "" && this.state.PatientFathHusKey === "" && this.state.PatientMotherKey === "" && this.state.FilterUHID === "" && ((window.location.pathname === "/DoctorHome" || window.location.pathname === "/OPHome") ? this.state.FilterOP === "" : this.state.FilterIP === "") && this.state.FilterDob === null) || (this.state.FilterDob !== null && isNaN(Date.parse(this.state.FilterDob))) || (this.state.error || this.state.errorFathhus) || (this.state.isPatientisSearching)} onClick={() => { 
            if (FromRadiology) {
              this.radiologyPatientSearch()
            } else {
              (window.location.pathname === "/DoctorHome") ? this.DoctorPatientSearch() : this.FOPatientSearch()
            }
          }}>Search</Button>
          <Button id="eMed_Config_btn" variant='outlined' size='small' sx={{ marginLeft: "2vw" }} onClick={() => { this.setState({ PatientAddressKey: "", PatientFathHusKey: "", PatientMotherKey: "", error: false, errorFathhus: false, FilterDob : null, FilterUHID : "", FilterOP: "", FilterIP: "" }) }}>Clear</Button></Box>
      </Box>
    )
  }

  isPatientisSearching(flag) {
    this.setState({ isPatientisSearching: flag })
  }

  AppointMobileSrch(flag) {
    this.setState({ isappointRequest: flag, isDocAppointRequest: flag })
  }

  PharmaPatientSearch() {
    try {
      var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
      var UserData = myUser
      if (UserData?.pharmacy_type === 'Standalone Pharmacy') {
        var url = Serviceurls.PHARMA_HEADER_SEARCH
      } else {
        var url = Serviceurls.FO_PATIENT_SEARCH
      }
      let { t } = this.props;
      this.isPatientisSearching(true)
      RestAPIService.getAll(url + `?search_key=${CommonValidation.removeSpace(this.state.pharmaNameSearchKey)}`).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              pharmaPatientList: response.data.data,
              common_uhid: response?.data?.common_uhid,
            }, () => {
              this.isPatientisSearching(false)
              if (CommonValidation.removeSpace(this.state.pharmaNameSearchKey) !== "") {
                if (response.data.data.length > 0) {
                  this.setState({ pharmaSearchClicked: true })
                } else {
                  this.errorMessage(t("NoRecordsFound"))
                }
              }
            })
          }
          else {
            this.isPatientisSearching(false)
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          if (error?.response?.data?.status === 'fail') {
            this.errorMessage(error.response.data.message)
          }
          this.isPatientisSearching(false)
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }
  PharmaheaderSearch = () => {
    const { t } = this.props;
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser
    return (
      <Box sx={{ marginLeft: '3.2vw' }}>
        <Box component={'div'} display={'flex'} flexDirection={'row'} sx={{ borderRadius: "0.3vw" }}>
          {UserData?.module_name !== "nurse" ?
            <PatientHeaderSearch
              t={this.props.t}
              module_name = {"Pharmacy"}
              isLoading={this.state.isPatientisSearching}
              onSearchSubmit={this.handleSearchSubmit}
              onClear={this.handleSearchClear}
              searchValue={this.state.pharmaNameSearchKey}
            />
            // <OutlinedInput
            //   placeholder={t("SearchPatients")}
            //   onKeyDown={(event) => {
            //     if (event.key === "Enter" && event.target.value != "" && event.target.value.length > 2) {
            //       event.preventDefault();
            //       this.PharmaPatientSearch()
            //     } else if (event.key === "Enter" && event.target.value === "" && event.target.value.length <= 0) {
            //       this.setState({ pharmaSearchClicked: false })
            //     }
            //   }}
            //   onChange={(e) => {
            //     this.setState({
            //       pharmaNameSearchKey: e.target.value
            //     })
            //   }}
            //   value={this.state.pharmaNameSearchKey}
            //   size="small"
            //   className='eMed_Pharmaheader_Input'
            //   endAdornment={
            //     <Box component={'div'} display={'flex'} flexDirection={'row'}>
            //       <Divider orientation="vertical" variant="middle" flexItem />
            //       {
            //         this.state.isPatientisSearching ?
            //           <Box sx={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            //             <InputAdornment position="end"><CircularProgress size={15} /></InputAdornment>
            //           </Box> :
            //           <Tooltip title={t("Search")} arrow>
            //             <IconButton disabled={CommonValidation.removeSpace(this.state.pharmaNameSearchKey) === ""}
            //               onClick={(e) => {
            //                 if (CommonValidation.removeSpace(this.state.pharmaNameSearchKey) !== "" && this.state.pharmaNameSearchKey?.length > 2) {
            //                   this.PharmaPatientSearch()
            //                 }
            //               }} position="end">
            //               <SearchIcon />
            //             </IconButton>
            //           </Tooltip>
            //       }
            //     </Box>
            //   }
            // />
             : null}
        </Box>
        <Menu
          open={this.state.pharmaSearchClicked}
          className="eMed_pharmaHeader_Search_Pop"
          disableAutoFocus
          disableEnforceFocus
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          MenuListProps={{
            autoFocus: false
          }}
          onClose={() => {
            this.setState({
              pharmaSearchClicked: false,
              // pharmaNameSearchKey: "",
            })
          }}
        >
          {

            this.state.pharmaPatientList.length > 0 ?
              this.state.pharmaPatientList.map((list) => {
                let PatientFullName = `${list.first_name} ${list.last_name}`
                list["patient_name"] = PatientFullName
                list["patient_mobile_number"] = list.mobile_number
                list["patient_photo_url"] = list.photo_url
                return (
                  <Box>
                    <Box className="eMed_Header_Search_item" width={"28vw"}>
                      <CommonPatientDetails data={list} fromSearch={true} isCommonUhid={this.state.common_uhid} />
                      <Box component={'div'} className="eMed_Header_Search_icons">
                        <Tooltip title={t('CreateBill')} placement='top' arrow>
                          <IconButton size='small' variant='contained' onClick={() => {
                            this.setState({
                              pharmaNameSearchKey: "",
                              pharmaSearchClicked: false,
                              pharmaPatientList: [],
                              common_uhid: false,
                            }, () => {
                              this.props.history.push({ pathname: "/PharmacyBilling", state: { Patient_ID: list?.patient_id, showHistory: true } })
                            })
                          }}
                            position="end">
                            <img style={{ width: '1.5vw', height: '1.5vw' }} src={ImagePaths.BillCreated.default} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Box>
                  </Box>
                )
              }) : null
          }
        </Menu>
      </Box>
    )
  }

  dataURItoBlob = (dataURI) => {
    var byteString = atob(dataURI?.split(",")[1]);
    var mimeString = dataURI?.split(",")[0]?.split(":")[1]?.split(";")[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString?.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  processFaceRecog(FaceData, fromDoc = false) {
    try {
      var states = this.state
      const dataForm = new FormData();

      dataForm.append("face_photo", !FaceData ? "" : this.dataURItoBlob(FaceData))
      let params = ''
      if (fromDoc) {
        let loggedinInfo = JSON.parse(localGetItem('loggedInUserInfo'))
        let clinicId = localGetItem('SelectedDoctorClinicId')
        // params = Serviceurls.FACE_RECOG_SEARCH + '?clinic_id=' + clinicId
        params = Serviceurls.FACE_RECOG_SEARCH + `?clinic_id=${clinicId ? clinicId : loggedinInfo?.clinic_id ? loggedinInfo?.clinic_id :""}`
      } else {
        let loggedinInfo = JSON.parse(localGetItem('loggedInUserInfo'))
        params = Serviceurls.FACE_RECOG_SEARCH + `?clinic_id=${loggedinInfo?.clinic_id ? loggedinInfo?.clinic_id :""}`
      }
      RestAPIService.create(dataForm, params) 
        .then((response) => {
          if (response.data.status === 'success') {
            if (response?.data?.data?.length > 0) {
              this.setState({
                SearchedPatientList: response.data.data,
                PatientSearchClicked: true,
                FaceRecogClicked: false,
                temp_patient_img: null,
                docFaceRecogClicked: false,
                disableProcess : false,
              })
            } else {
              this.errorMessage("Face Not Matched ! ")
              this.setState({disableProcess : false})
            }
          }
        }).catch((e) => {
          if (e?.response?.data?.message) {
            this.errorMessage(e.response.data.message)
            this.setState({disableProcess : false})
          } else {
            this.errorMessage(e.message)
            this.setState({disableProcess : false})
          }
        })


    } catch (e) {
      if (e?.response?.data?.message) {
        this.errorMessage(e.response.data.message)
        this.setState({disableProcess : false})
      } else {
        this.errorMessage(e?.message)
        this.setState({disableProcess : false})
      }

    }
  }
  getConnectedDevices = () => {
    navigator.mediaDevices.enumerateDevices()
      .then(devices => {
        console.log("devicesConnected",devices)
        const videoDevices = devices?.filter(device => device.kind === 'videoinput');
        this.setState({
          devices: videoDevices,
        });
      })
      .catch(error => {
        console.error('Error enumerating devices:', error);
      });
  }

  videoConstraints = () => ({
    facingMode: this.state.isFrontCamera ? 'user' : 'environment',
  });

  toggleCameraButton = () => {
    this.setState({
      isFrontCamera: !this.state.isFrontCamera,
      temp_patient_img: null
    }, () => { this.videoConstraints() })
  }

  OpenFaceRecogPop(fromDoc = false) {
    try {
      return (
        <Box>
          <Modal open={true}>
            <Box className="eMed_WebCamPop_Main">
              <Box component={'div'} className="eMed_WebCam_Header">
                <Typography variant='h6'>{"Patient Profile "}</Typography>
                <Button onClick={() => { this.setState({ temp_patient_img: this.state.patient_img, docFaceRecogClicked: false, FaceRecogClicked: false, }) }} >
                  <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                </Button>
              </Box>
              <Box component={'div'}>
                {
                  this.state.temp_patient_img === null ?
                    <Webcam
                      className='eMed_WebCam_Div'
                      audio={false}
                      mirrored={this.state.isFrontCamera}
                      ref={this.webcamRef}
                      screenshotFormat="image/jpeg"
                      videoConstraints={this.videoConstraints()}
                    /> :

                    <img className='eMed_WebCam_Img_Div' src={this.state.temp_patient_img} />
                }
              </Box>
              <Box component={'div'} className="eMed_WebCam_Btn_div_faceRecog">
                <Button variant='contained' size='small' id="eMed_Config_btn" disabled ={this.state.disableProcess || this.state.temp_patient_img !== null}  onClick={() => { this.setState({ temp_patient_img: this.webcamRef?.current?.getScreenshot(), disableProcess :true}, () => { this.processFaceRecog(this.state?.temp_patient_img, fromDoc) }) }}>Process</Button>
                <Button variant='contained' size='small' id="eMed_Config_btn" onClick={() => { this.setState({ temp_patient_img: null }) }}>Retake</Button>
                {this.state.devices?.length > 1 &&
                  <Button variant='contained' size='small' id="eMed_Config_btn" sx={{width: '10.5vw'}}   onClick={() => { this.toggleCameraButton() }} >
                    Switch to {this.state.isFrontCamera ? "Back" : "Front"} Camera
                  </Button>}
              </Box>
            </Box>
          </Modal>
        </Box>
      );
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  postRequest(list, Status) {
    try {
      var states = this.state
      const convertTime12to24 = moment(list?.appointment_time, ["h:mm A"]).format("HH:mm");
      let data = {
        "id": list?.id,
        "status": Status,
        "patient_id": list?.patient_id,
        "doctor_id": list?.doctor_id,
        "patient_account_number": list?.patient_account_number,
        "appointment_date": list?.appointment_date,
        "appointment_start_time": convertTime12to24,
        "purpose_of_visit": list?.message,
        "patient_appointment_type": list?.booked_through === "Mobile" ? "Mobile Appointment" : "Web Appointment"
      }
      RestAPIService.create(data, Serviceurls.FO_APPOINT_REQUESTS)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              RequestPopUp: false,
              patientSearch: '',
              App_DocID: null,
            }, () => { this.getAppointRequests() })
            this.props.history.push({ pathname: "/OPHome", state: { RequestBool: true, RequestMessage: response?.data?.message } })
          }
        }).catch((e) => {
          if (e?.response?.data?.message) {
            this.errorMessage(e.response.data.message)
          } else {
            this.errorMessage(e.message)
          }
        })
    } catch (e) {
      if (e?.response?.data?.message) {
        this.errorMessage(e.response.data.message)
      } else {
        this.errorMessage(e.message)
      }

    }
  }
  optometryPrintAppList() {
    try {
      let status = [];
      let states = this.state
      if (states.all) {
        status = []
      } else {
        if (states.booked) {
          status?.push('Booked')
        }
        if (states.arrived) {
          status?.push('Arrived')
        }
        if (states.withNurse) {
          status?.push('With Nurse')
        }
        if (states?.withDoctor) {
          status?.push('With Doctor')
        }
        if (states.completed) {
          status?.push('Completed')
        }
        if (states.cancelled) {
          status?.push('Cancelled')
        }
      }
      let myUser = JSON.parse(localGetItem("loggedInUserInfo"))
      let UserData = myUser
      let optometryPrint = (window.location.pathname === "/DoctorHome") && (UserData?.service_type === "OPTOMETRY" )
      var date = getCachevalue('OpAppDate')
      var opstatus = getCachevalue('OPStatus')
      let DoctorId = this.state.SelectedDoctor === 0 ? "" : this.state.SelectedDoctor
      this.setState({ disableBtn: true })
      let clinicID = localGetItem("clinicId") ? localGetItem("clinicId") : ""
      RestAPIService.getAll(Serviceurls.DOC_OPTHOMETRY_APPOINTMENT_LIST + "?appointment_date=" + date +  (optometryPrint ? ("&clinic_id=" + clinicID ) : ("&doctor_id=" + DoctorId ))+ "&appointment_status=" +( optometryPrint ? status : opstatus ) + "&export_type=pdf").
        then((response) => {
          if (response) {
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //Open the URL on new Window
            window.open(fileURL);
            this.setState({ disableBtn: false })
          }
        }).catch((error) => {
          this.setState({ disableBtn: false })
          console.log(error.message)
        })
    } catch (e) {
      this.setState({ disableBtn: false })
      console.log(e.message)
    }
  }


  // // Print Appointment list for 4.0 start
  // printAppList() {
  //   try {
  //     var date = getCachevalue('OpAppDate')
  //     var opstatus = getCachevalue('OPStatus')
  //     let DoctorId = this.state.SelectedDoctor === 0 ? "" : this.state.SelectedDoctor
  //     this.setState({ disableBtn: true })
  //     RestAPIService.PrintPDF(Serviceurls.FO_APPINMENT_PRIENT + "?appointment_date=" + date + "&doctor_id=" + DoctorId + "&appointment_status=" + opstatus).
  //       then((response) => {
  //         if (response) {
  //           //Create a Blob from the PDF Stream
  //           const file = new Blob(
  //             [response.data],
  //             { type: 'application/pdf' });
  //           //Build a URL from the file
  //           const fileURL = URL.createObjectURL(file);
  //           //Open the URL on new Window
  //           window.open(fileURL);
  //           this.setState({ disableBtn: false })
  //         }
  //       }).catch((error) => {
  //         this.setState({ disableBtn: false })
  //         console.log(error.message)
  //       })
  //   } catch (e) {
  //     this.setState({ disableBtn: false })
  //     console.log(e.message)
  //   }
  // }
  CounsellerModulePrint() {
    try {
      let fromDate = getCachevalue('Counseller From Date')
      let toDate = getCachevalue('Counseller To Date')
      let ClinicID = getCachevalue('Counseller Clinic ID')
      let selectedCard = getCachevalue('Counseller Status Data')
      RestAPIService.PrintPDF(Serviceurls.GET_COUNSELLOR_APPOINTMENTS + "?from_date=" + fromDate + "&to_date=" + toDate + "&clinic_id=" + ClinicID + "&status_data=" + selectedCard + "&export_type=pdf").
        then((response) => {
          if (response) {
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //Open the URL on new Window
            window.open(fileURL);
            this.setState({ disableBtn: false })
          }
        }).catch((error) => {
          this.setState({ disableBtn: false })
          console.log(error.message)
        })
    } catch (e) {
      this.setState({ disableBtn: false })
    }
  }
  // Print Appointment list for 4.0 end
  // Print IP-Appointment list for 4.0 start
  printIPAppList(fromDocModule = false) {
    try {
      var fromDate = getCachevalue('FormDate')
      var toDate = getCachevalue('ToDate')
      var status = getCachevalue('Status')
      var ward_name = getCachevalue('wardName')
      var block_name = getCachevalue('blockName')
      var floor_number = getCachevalue('floorNumber')
      let DoctorId = this.state.SelectedDoctor === 0 ? "" : this.state.SelectedDoctor
      const clinic_id = JSON.parse(localGetItem('SelectedDoctorClinicId'));
      this.setState({ disableBtn: true })
      let url = `${Serviceurls.IP_APP_PRINT}?from_date=${fromDate}&to_date=${toDate}&doctor_id=${DoctorId}&admission_status=${status}`;
      if (fromDocModule) {
        url = `${url}&clinic_id=${clinic_id}&ward_name=${ward_name || ""}&block_name=${block_name || ""}&floor_number=${floor_number || ""}`
      }
      RestAPIService.getAll(url).
        then((response) => {
          if (response) {
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //Open the URL on new Window
            window.open(fileURL);
            this.setState({ disableBtn: false })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
          this.setState({ disableBtn: false })
        })
    } catch (e) {
      this.setState({ disableBtn: false })
      console.log(e.message)
    }
  }
  // Print IP-Appointment list for 4.0 end

  getPatientSearchData = (FromFO) => {
    try {
      const { t } = this.props
      var search_key = this.state.searchkey ? this.state.searchkey : ""
      let serviceUrl = ""
      if (FromFO) {
        serviceUrl = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${search_key}`
      } else if (this.state.labType === "Standalone Laboratory") {
        serviceUrl = Serviceurls.LAB_SEARCH_PATIENT + "?search_key=" + search_key
      } else {
        serviceUrl = Serviceurls.LAB_PATIENT_TRANSMIT_SEARCH + "?search_key=" + search_key

      }
      this.isPatientisSearching(true)
      RestAPIService.getAll(serviceUrl)
        .then(response => {
          if (response.data.status == "success") {
            var data = response.data.data
            if (data.length > 0) {
              this.setState({ searchPatientDatas: data, isPatientisSearching: false, common_uhid: response?.data?.common_uhid })
            } else {
              this.isPatientisSearching(false)
              this.errorMessage(t("NoRecordsFound"))
            }
          }
        })
        .catch(e => {
          if (e?.response?.data?.message) {
            this.isPatientisSearching(false)
            this.errorMessage(e?.response?.data?.message)
          } else {
            this.isPatientisSearching(false)
            this.errorMessage(e?.message)
          }
        });
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  LabHeaderSearch = (FromFO = false, radiology = false) => {
    const { t, history } = this.props;
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser
    return (
      <>{
        // this.props?.history?.location?.pathname !== "/Results" ? 
        <Box sx={{ marginLeft: '3.2vw' }} className='Lab_Home_Patient_Search'>

          <Box component={'div'} display={'flex'} flexDirection={'row'} sx={{ borderRadius: "0.3vw" }}>
            {FromFO && this.state.labType !== "Inhouse Laboratory" ? null :
              <FormControl size='small' sx={{ width: "13vw", borderRadius: '0.2vw', }} >
                <Select
                  className='mui_header_card_dropdown_fo'
                  value={this.state.clinicId}
                  onChange={(e) => {
                    this.setState({ clinicId: e.target.value })
                  }}
                  sx={{ backgroundColor: '#E4F2F0' }}
                  MenuProps={{ style: { maxHeight: 250 } }}
                >
                  {this.state.clinicData && this.state.clinicData.length > 0 && this.state.clinicData.map((item) => (
                    <MenuItem key={item.clinic_id} value={item.clinic_id} >{item.clinic_name}</MenuItem>
                  ))}
                </Select>
              </FormControl>}
              <PatientHeaderSearch
                t={this.props.t}
                isLoading={this.state.isPatientisSearching}
                module_name = {"Lab"}
                onSearchSubmit={this.handleSearchSubmit}
                onClear={this.handleSearchClear}
                FromFo={FromFO}
                searchValue={this.state.searchkey}
              />
            {/* <OutlinedInput
              placeholder="Search Patients Name, Number, UHID"
              onKeyDown={(event) => {
                if (event.key === "Enter" && event.target.value != "" && event.target.value.length > 2) {
                  this.setState({ LabPatientSearch: true }, () => this.getPatientSearchData(FromFO))

                  // history.push({ pathname: "/MainHome", state: { search_key: this.state.searchkey ? this.state.searchkey : "" } })
                } else if (event.key === "Enter" && event.target.value === "" && event.target.value.length <= 0) {
                  this.setState({ LabPatientSearch: false })
                }
              }}
              onChange={(e) => {
                var data = e.target.value
                if (data == "") {
                  // history.push({ pathname: "/MainHome", state: { search_key: data } })
                }
                this.setState({
                  searchkey: e.target.value
                })
              }}
              value={this.state.searchkey}
              size="small"
              className='eMed_header_Input'
              sx={{ backgroundColor: FromFO ? "white" : '#E4F2F0' }}
              endAdornment={
                <Box component={'div'} display={'flex'} flexDirection={'row'}>
                  <Divider orientation="vertical" variant="middle" flexItem />
                  {this.state.isPatientisSearching ?
                    <Box sx={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
                      <InputAdornment position="end"><CircularProgress size={15} /></InputAdornment>
                    </Box> :
                    <Tooltip title={t("Search")} arrow>
                      <IconButton onClick={() => {
                        this.setState({ LabPatientSearch: true }, () => {
                          if (this.state.searchkey != '' && this.state.searchkey?.length > 2) {
                            this.getPatientSearchData(FromFO)
                          }
                        })
                        // history.push({ pathname: "/MainHome", state: { search_key: this.state.searchkey ? this.state.searchkey : "" } })
                      }} position="end">
                        <i class="fas fa-search"></i>
                      </IconButton>
                    </Tooltip>}
                </Box>
              }
            /> */}
          </Box>
          <Menu
            sx={{ left: this.state.labType === "Inhouse Laboratory" ? "3vw" : "-9.5vw" }}
            open={this.state.LabPatientSearch && this.state.searchPatientDatas?.length > 0}
            disableAutoFocus
            disableEnforceFocus
            className="eMed_Header_Search_Pop"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            MenuListProps={{
              autoFocus: false
            }}
            onClose={() => {
              this.setState({
                LabPatientSearch: false,
                searchPatientDatas: [],
                common_uhid: false,
                // searchkey: ""
              })
            }}
          >
            {this.state.searchPatientDatas?.length > 0 ?
              this.state.searchPatientDatas.map((item) => {
                let PatientNameText = item.first_name || item.patient_name
                let PatientAgeText = `(${item?.patient_age ? item?.patient_age : ""}/${item?.gender ? item?.gender.toUpperCase() : ""})`
                let branchName = item?.branch_name ? item.branch_name : "-"
                return (
                  <Box width={"25vw"} padding={'0.5vw'}>
                    <Box display={'flex'} alignItems={'center'}>
                      <Avatar id='eMed_IconAvatar' src={item.photo_url || item.patient_photo_url ? item.photo_url || item.patient_photo_url : ImagePaths.Default} sx={{ boxShadow: 3, minWidth: '13%', marginTop: '1vh', marginRight: '2vh', marginBottom: '1vh' }} />
                      <div style={{ minWidth: '55%' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Box component={'div'}>
                            {PatientNameText ? PatientNameText?.length > 16 ?
                              <Tooltip placement='top' title={PatientNameText} arrow>
                                <Typography sx={{ margin: "0vw", fontSize: '0.9vw' }}>{PatientNameText.slice(0, 15) + "..."}</Typography></Tooltip> :
                              <Typography sx={{ margin: "0vw", fontSize: '0.9vw' }}>{PatientNameText}</Typography> : "-"}</Box>
                          <Typography sx={{ margin: "0vw", marginLeft: "0.5vw", fontSize: '0.8vw' }}>{PatientAgeText}</Typography>
                        </Box>
                        <div className='search_sub_container'>
                          <Typography className='eMed_Com_Patient_UhidText' sx={{ fontSize: "0.8vw" }}>{item.mobile_number || item.patient_mobile_number}</Typography>
                          <Typography className='eMed_Com_Patient_UhidText' sx={{ fontSize: "0.8vw", marginLeft: "0.5vw" }}>{" | " + item.patient_account_number ? item.patient_account_number : ""}</Typography>
                        </div>
                        <div>
                          {this.state.common_uhid ? <Typography className='eMed_Com_Patient_UhidText' sx={{ fontSize: "0.8vw" }}>Branch Name: {branchName?.length > 22 ? <Tooltip placement="top" title={branchName} arrow><span id='eMed_Com_Patient_UhidText'>{branchName?.slice(0, 19) + "..."}</span></Tooltip> : branchName ? branchName : "-"}</Typography> : null}
                        </div>
                      </div>
                      <button size="small" className='Lab_Search_Button' onClick={() => {
                        this.setState({
                          selectedPatientData: item,
                          LabPatientSearch: false,
                          searchkey: "",
                          searchPatientDatas: [],
                          common_uhid: false,
                        }, () => {
                        if(localGetItem('isNewBilling') === 'true'){
                          if(this.state.loggedInuserInfo?.module_name === 'Laboratory'){
                            setCachevalue(this.state.selectedPatientData?.patient_id,'OP_CreateAppointment_PatientId')
                            history.push({ pathname: "/LabBilling/NewQuickBilling", state: { patientData: this.state.selectedPatientData } })
                          }
                        }else{
                          if (FromFO && !radiology) {
                            history.push({ pathname: "/Billing", state: { selectedPatientDetails: this.state.selectedPatientData } })
                            // history.push({ pathname: "/Billing/LabBilling", state: { selectedPatientData: this.state.selectedPatientData } })
                          } else if (FromFO && radiology) {
                            history.push({ pathname: "/Billing/RadiologyBilling", state: { selectedPatientDetails: this.state.selectedPatientData } })
                          } else {
                            history.push({ pathname: "/MainHome", state: { selectedPatientData: this.state.selectedPatientData } })
                          }
                        }
                        })
                      }}><p className='Lab_saved_Bill_Text'>{t("Proceed")}</p></button>
                      {!radiology ? <Button
                        className='Common_Btn_Min_Width'
                        sx={{ height: "2vw", width: '2vw', ml: '1vw' }}
                        onClick={() => this.setState({ labHistoryPopup: true, labPatientData: item }, () => this.getLabPateintHistoryData())}
                      >
                        <Box component={'img'} src={ImagePaths.ResultHistory.default} height={'2vw'} width={'2vw'} />
                      </Button> : null}
                    </Box>
                    <Divider />
                  </Box>

                )
              }) : <Box component={'div'} padding={"1vw"}>{t("NoRecordsFound")}</Box>
            }
          </Menu>
        </Box>
      }</>

    )
  }

  getLabPateintHistoryData = () => {
    try {
      let laboratoryId = getCachevalue("Laboratory_id")
      RestAPIService.getAll(Serviceurls.LAB_PATIENT_TEST_HISTORY + `?patient_id=${this.state.labPatientData?.patient_id}&laboratory_id=${laboratoryId}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              labHistoryData: response.data.data
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  PopUpClose = () => {
    this.setState({
      isViewHistory: false,
      viewCultureData: [],
      testName: "",
    })
  }

  viewCultureTest = (data) => {
    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        height: "47vh",
        overflowY: "auto",
      }}
      >
        {data?.map((items, indexs) => {
          return (
            <div key={indexs} style={{ width: "70vw", marginBottom: "1vw" }}>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: "1vw", marginBottom: "1vw" }}>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <Box component={'div'} sx={{ display: "flex" }}>
                    <Typography>{`ORGANISM ISOLATED 0${indexs + 1} : `}</Typography>
                    <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                      {items?.bacteria ? items?.bacteria?.length > 20 ?
                        <Tooltip placement='top' title={items?.bacteria} arrow>
                          <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                            {items?.bacteria.slice(0, 20) + '...'}
                          </Typography>
                        </Tooltip> :
                        <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>{items?.bacteria}</Typography> : '-'}
                    </Typography>
                  </Box>
                </div>
                <Box component={'div'} sx={{ display: "flex" }}>
                  <Typography>{`MICROSCOPY : `}</Typography>
                  <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                    {items?.microscopy ? items?.microscopy?.length > 20 ?
                      <Tooltip placement='top' title={items?.microscopy} arrow>
                        <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                          {items?.microscopy.slice(0, 20) + '...'}
                        </Typography>
                      </Tooltip> :
                      <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>{items?.microscopy}</Typography> : '-'}
                  </Typography>
                </Box>
                <Box component={'div'} sx={{ display: "flex" }}>
                  <Typography>{`COLONY COUNT : `}</Typography>
                  <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                    {items?.colony_count ? items?.colony_count?.length > 20 ?
                      <Tooltip placement='top' title={items?.colony_count} arrow>
                        <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                          {items?.colony_count.slice(0, 20) + '...'}
                        </Typography>
                      </Tooltip> :
                      <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>{items?.colony_count}</Typography> : '-'}
                  </Typography>
                </Box>
                <Box component={'div'} sx={{ display: "flex" }}>
                  <Typography>{`METHOD : `}</Typography>
                  <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                    {items?.method_type ? items?.method_type?.length > 20 ?
                      <Tooltip placement='top' title={items?.method_type} arrow>
                        <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                          {items?.method_type.slice(0, 20) + '...'}
                        </Typography>
                      </Tooltip> :
                      <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>{items?.method_type}</Typography> : '-'}
                  </Typography>
                </Box>
              </div>
              <TableContainer style={{ maxHeight: "35vh" }}>
                <Table style={{ border: "1px solid gray" }} stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell size='small' sx={{ backgroundColor: "#F5F8F7" }}><b>{"SNo"}</b></TableCell>
                      <TableCell size='small' sx={{ backgroundColor: "#F5F8F7" }}><b>{"Antibiotic"}</b></TableCell>
                      <TableCell size='small' sx={{ backgroundColor: "#F5F8F7" }}><b>{"MIC Result/Range"}</b></TableCell>
                      <TableCell size='small' sx={{ backgroundColor: "#F5F8F7" }}><b>{"Zone Result/Range"}</b></TableCell>
                      <TableCell size='small' sx={{ backgroundColor: "#F5F8F7" }}><b>{"Interpretaion"}</b></TableCell>
                      <TableCell size='small' sx={{ backgroundColor: "#F5F8F7" }}><b>{"Efficiency Ration"}</b></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {items?.antibacteria?.length > 0 ?
                      items?.antibacteria?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>
                            {item?.antibiotic ? item?.antibiotic?.length > 20 ?
                              <Tooltip placement='top' title={item?.antibiotic} arrow>
                                <Typography>
                                  {item?.antibiotic.slice(0, 20) + '...'}
                                </Typography>
                              </Tooltip> :
                              <Typography>{item?.antibiotic}</Typography> : '-'}
                          </TableCell>
                          <TableCell>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                              <Typography>{item?.mic_break_point ? item?.mic_break_point?.length > 20 ?
                                <Tooltip placement='top' title={item?.mic_break_point} arrow>
                                  <div>{item?.mic_break_point.slice(0, 20) + '...' + " "}</div>
                                </Tooltip> : (item?.mic_break_point + " ") : '-'}</Typography>
                              {item?.mic_break_point_std ?
                                <Typography style={{ marginLeft: "0.25vw" }}>{item?.mic_break_point_std ? item?.mic_break_point_std?.length > 20 ?
                                  <Tooltip placement='top' title={item?.mic_break_point_std} arrow>
                                    <div>{" / " + item?.mic_break_point_std.slice(0, 20) + '...'}</div>
                                  </Tooltip> : (" / " + item?.mic_break_point_std) : '-'}</Typography> : null}
                            </div>
                          </TableCell>
                          <TableCell>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                              <Typography>{item?.zone_size ? item?.zone_size?.length > 20 ?
                                <Tooltip placement='top' title={item?.zone_size} arrow>
                                  <div>{item?.zone_size.slice(0, 20) + '...' + " "}</div>
                                </Tooltip> : (item?.zone_size + " ") : '-'}</Typography>
                              {item?.zone_size_std ?
                                <Typography style={{ marginLeft: "0.25vw" }}>{item?.zone_size_std ? item?.zone_size_std?.length > 20 ?
                                  <Tooltip placement='top' title={item?.zone_size_std} arrow>
                                    <div>{" / " + item?.zone_size_std.slice(0, 20) + '...'}</div>
                                  </Tooltip> : (" / " + item?.zone_size_std) : '-'}</Typography> : null
                              }
                            </div>
                          </TableCell>
                          <TableCell>
                            {item?.interpretation ? item?.interpretation?.length > 20 ?
                              <Tooltip placement='top' title={item?.interpretation} arrow>
                                <Typography>
                                  {item?.interpretation.slice(0, 20) + '...'}
                                </Typography>
                              </Tooltip> :
                              <Typography>{item?.interpretation}</Typography> : '-'}
                          </TableCell>
                          <TableCell>
                            {item?.methodThreeBacteriaResult ? item?.methodThreeBacteriaResult?.length > 20 ?
                              <Tooltip placement='top' title={item?.methodThreeBacteriaResult} arrow>
                                <Typography>
                                  {item?.methodThreeBacteriaResult.slice(0, 20) + '...'}
                                </Typography>
                              </Tooltip> :
                              <Typography>{item?.methodThreeBacteriaResult}</Typography> : '-'}
                          </TableCell>
                        </TableRow>
                      ))
                      : <TableRow>
                        <TableCell align="center" colSpan={6}>No Records To Be Shown</TableCell>
                      </TableRow>}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )
        })}
      </div>
    )
  }

  getS3Key = async (doc_key, id) => {
    try {
      const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + doc_key);

      if (response.data.status === "success") {
        const Data = response.data;
        return {
          data_url: Data.data,
          id: id,
          type: doc_key?.split('.')?.pop() === "pdf" ? "pdf" : "image"
        };
      }
    } catch (e) {
      this.errorMessage("Error fetching S3 URL")
    }
  }

  sourceOpen = async (list) => {
    let tempArr = [];
    const image = (typeof list?.result_image === "string" && list.result_image.trim() !== "")
      ? JSON.parse(list.result_image)
      : list?.result_image ?? [];
    if (image !== null) {
      for (let j = 0; j < image?.length; j++) {
        let doc_key = image[j];
        let id = list.id;
        let getData = await this.getS3Key(doc_key, id);
        tempArr.push(getData);
      }
      this.setState({
        sourceOpen: true,
        selectedUploadData: list,
        uploadedImages: tempArr,
        selectedImage: null,
      });
    }
  }

  convertToBase64 = async (url) => {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const blob = await response.blob();
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader?.result);
        reader.onerror = () => reject(reader?.error);
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error', error);
    }
  }

  renderSourcePopUp = () => {
    const { t } = this.props
    return (
      <>
        <Modal
          open={this.state.sourceOpen}
          onClose={() => this.setState({ sourceOpen: false })}
        >
          <Box className='emedhub_popup_outsource_list' sx={{ top: '50%' }}>
            <div className='emedhub_popup_title'>
              <label id="modal-title" className='emedhub_popup_title_left'>{"Test Report"}</label>
              <div className='emedhub_card_close_button'>
                <img
                  className='emedhub_popup_title_right'
                  src={ImagePaths.LabCloseButton.default}
                  onClick={() => this.setState({ sourceOpen: false })}
                  alt="close"
                />
              </div>
            </div>
            <div className='emedhub_print_popup'>
              <div className='image_top_header'>
                <label className='test_name_style'><b>{"Test Name"}:</b>
                  <span style={{ marginLeft: "5px" }}>{"  " + this.state?.selectedUploadData?.test_name}</span>
                </label>
              </div>
              <div style={{ display: "flex", width: "100%", overflow: "auto", overflowY: "hidden" }}>
                {this.state.uploadedImages?.map((item, index) => (
                  <div key={index} className='emedhub_multiple_image_size_outlist'>
                    <img
                      alt="Uploaded Preview"
                      src={item?.type === "image" ? item["data_url"] : ImagePaths.DocumentPreview.default}
                      className='emedhub_multiple_image_resolution'
                      onClick={() => {
                        if (item?.type === "pdf") {
                          this.setState({ pdfPreview: true, pdfData: item["data_url"] })
                        } else if (item.type === "application/pdf") {
                          this.setState({ pdfPreview: true, pdfData: URL.createObjectURL(item) })
                        } else if (item?.type === "image") {
                          this.setState({ pdfPreview: true, ImgData: item["data_url"] })
                        }
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </Box>
        </Modal>
      </>
    )
  }

  ClosePopUp = () => {
    this.setState({ pdfPreview: false, pdfData: '', ImgData: '' })
  }

  renderLabHistoryPopup = () => {
    try {
      const { t } = this.props
      this.state.labHistoryData?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        { field: 'sno', headerName: 'S.No', flex: 0.05 },
        {
          field: 'test_date', headerName: (localGetItem('isNewBilling') === "true") ? 'Order Date And Time ' : 'Bill Date And Time', flex: 0.2,
          renderCell: (params) => (
            <Box component={'div'}>{params?.row?.test_date ? params?.row?.test_date : '-'}</Box>
          )
        },
        {
          field: 'test_name', headerName: 'Test Name', flex: 0.3,
          renderCell: (params) => (<Box component={'div'}>
            {params?.row?.test_name ? params?.row?.test_name?.length > 25 ?
              <Tooltip placement='top' title={params?.row?.test_name}><Typography>{params?.row?.test_name?.slice(0, 25) + '...'}</Typography></Tooltip> :
              <Typography>{params?.row?.test_name}</Typography> : '-'}
          </Box>)
        },
        {
          field: 'status', headerName: 'Result', flex: 0.3,
          renderCell: ({ row }) => (
            (row?.is_outsource && row?.result_image) ? <div>
              <Button
                variant='contained'
                sx={{ textTransform: "capitalize" }}
                onClick={() => {
                  this.setState({ selectedImageRowId: row.id, uploadData: row })
                  this.sourceOpen(row, row.id)
                }}>{"View PDF"}
              </Button>
            </div> :
            (row?.method === "Culture Test Result" && row?.result?.value?.length > 0) ?
              <Button size="small" variant="contained" sx={{ textTransform: "capitalize" }}
                onClick={() => {
                  this.setState({
                    isViewHistory: true,
                    viewCultureData: row?.result?.value?.length > 0 ? row?.result?.value : [],
                    testName: row.test_name,
                  })
                }}>{"View Culture History"}</Button>
                : (row?.method === "OGTT" && row?.result?.value && Object.keys(row?.result?.value)?.length > 0) ?
                  <Button size="small" variant="contained" sx={{ textTransform: "capitalize" }}
                    onClick={() => {
                      this.setState({
                        selectedOgttRowId: row.id,
                        isViewOgtt: true,
                        viewOgttData: row,
                        testName: row.test_name,
                      })
                    }}>{"View OGTT History"}</Button> :
              <Box component={'div'}>{row?.result?.value?.length > 20 ?
                <Tooltip placement='top' title={row?.result?.value} arrow><div>{row?.result?.value?.slice(0, 20) + "..."}</div></Tooltip>
                : row?.result?.value ? row?.result?.value
                  : (row?.status === "Result Completed" || row?.status === "Result Delivered") ?
                    "Result Not Entered"
                    : "Result yet to complete"}</Box>)
        },
        {
          field: 'comments', headerName: 'Comments', flex: 0.2,
          renderCell: (params) => (<Box component={'div'}>
            {params?.row?.result?.comment ? params?.row?.result?.comment?.length > 25 ?
              <Tooltip placement='top' title={params?.row?.result?.comment}><Typography>{params?.row?.result?.comment?.slice(0, 25) + '...'}</Typography></Tooltip> :
              <Typography>{params?.row?.result?.comment}</Typography> : '-'}
          </Box>)
        },
      ]
      let patient_name = this.state.labPatientData?.patient_name || this.state.labPatientData?.first_name
      let patient_mobile = this.state.labPatientData?.patient_mobile_number || this.state.labPatientData?.mobile_number
      return (
        <Box component={'div'}>
          <Modal open={this.state.labHistoryPopup}>
            <Box component={'div'} className='eMed_lab_history_popup'>
              <Box component={'div'} height={'7vh'} pl={'1vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Typography fontSize={'0.9vw'} fontWeight={600}>Patient History</Typography>
                <Button
                  onClick={() => this.setState({ labHistoryPopup: false, labPatientData: null, page: 0 })}
                >
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                </Button>
              </Box>
              <Box component={'div'} borderTop={'1px solid lightgray'} p={'0.5vw'}>
                <Typography fontSize={'0.8vw'} color={Colors.grayShade}>Patient Details</Typography>
                <Typography fontSize={'0.9vw'} fontWeight={600}>{patient_name}
                  <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600}>{`(${this.state.labPatientData?.patient_age})`}</Typography>
                  {renderInsCorpDetails(this.state.labPatientData, this.state.insuToolOpen)}
                </Typography>
                <Typography fontSize={'0.8vw'} color={Colors.grayShade}>{`${this.state.labPatientData?.patient_account_number} | `}
                  <Typography component={'span'} fontSize={'0.8vw'} color={Colors.grayShade}>{patient_mobile}</Typography>
                </Typography>
              </Box>
              <Box component={'div'} p={'0.5vw'}>
                <DataGrid
                  columns={columns}
                  rows={this.state.labHistoryData}
                  getRowId={(row) => row['sno']}
                  sx={{ height: '58dvh' }}
                  page={this.state.page}
                  pageSize={this.state.pageSize}
                  onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                  onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                  rowsPerPageOptions={[10, 20, 30]}
                  localeText={{
                    toolbarColumns: "",
                    toolbarDensity: "",
                    toolbarExport: "",
                    toolbarFilters: "",
                    toolbarExportPrint: ""
                  }}
                  components={{
                    Toolbar: CommonGridHeaderOnlySearch.CommonToolBarOnlySearch,
                    NoRowsOverlay: () => (
                      <Box height="100%" display={'flex'} alignItems="center" justifyContent="center">
                        {t("NoRecordsFound")}
                      </Box>
                    )
                  }}
                  headerHeight={40}
                  disableSelectionOnClick
                />
              </Box>
            </Box>
          </Modal>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderOgttTbl = (data, ogttConfig) => {
    const keys = Object.keys(ogttConfig).filter(key => ogttConfig[key]);
    return (
      <TableContainer sx={{ width: "100%", height: "100%" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell size='small' sx={{ backgroundColor: "#F5F8F7", fontWeight: "bold" }}>Hour</TableCell>
              {keys.map((item) => (<TableCell size='small' sx={{ backgroundColor: "#F5F8F7", fontWeight: "bold" }} key={item}>{labelMap[item]}</TableCell>))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Blood Glucose</TableCell>
              {keys.map((key) => (
                <TableCell key={key}>{data['bloodGlucose'][key]}</TableCell>
              ))}
            </TableRow>
            <TableRow>
              <TableCell>Urine Glucose</TableCell>
              {keys.map((key) => {
                const value = data['urineGlucose'][key];
                return (
                  <TableCell key={key}>{value?.length > 20 ?
                    <Tooltip arrow title={value}>
                      <div>{value.slice(0, 20) + "..."}</div>
                    </Tooltip> : value || "-"}</TableCell>
                )
              })}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>)
  }

  ogttTestView = () => {
    let { isViewOgtt, isViewGraph, viewOgttData, testName } = this.state;
    const { normal_range, result } = viewOgttData;
    return (
      <Modal sx={{ border: "none", outline: "none" }} open={isViewOgtt}>
        <Box className='emedhub_popup' sx={{ width: "65vw", height: "fit-content" }}>
          <div className=''>
            <div className='emedhub_popup_title'>
              <label className='emedhub_popup_title_left'>Test Report</label>
              <div className='emedhub_card_close_button'>
                <img
                  className='emedhub_popup_title_right'
                  src={ImagePaths.LabCloseButton.default}
                  onClick={() => {
                    this.setState({
                      isViewOgtt: false,
                      selectedOgttRowId: null,
                      isViewGraph: false
                    })
                  }}
                  alt='close'
                />
              </div>
            </div>
            <div className='emedhub_popup_title_2' style={{ marginTop: "0.5vw", justifyContent: "space-between" }}>
              <div style={{ display: "flex", gap: "1vw", alignItems: "center" }}>
              <Typography sx={{whiteSpace: "nowrap"}}>{`OGTT Test - ${testName}`}</Typography>
                <FormControl size="small" fullWidth>
                  <InputLabel id="glucose-type-select-label">Glucose Type</InputLabel>
                  <Select
                    labelId="glucose-type-select-label"
                    value={result?.value?.glucose_type_selection || ""}
                    label="Glucose Type"
                    sx={{ width: "10vw" }}
                    disabled
                  >
                    <MenuItem value="">-- Select --</MenuItem>
                    <MenuItem value="75">75gms</MenuItem>
                    <MenuItem value="100">100gms</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <Button variant='contained'
                onClick={() => { this.setState((prevState) => ({ isViewGraph: !prevState.isViewGraph })) }}
                sx={{ textTransform: "capitalize" }}>
                {isViewGraph ? "Back" : "View Graph"} </Button>
            </div>
          </div>
          <div style={{ width: "100%", height: "20vw", marginTop: "1vw" }}>
            {isViewGraph ? <OgttGraph ogttData={result?.value} />
              : this.renderOgttTbl(result?.value, {
                is_fasting: normal_range[0]?.is_fasting,
                is_30min: normal_range[0]?.is_30min,
                is_1hr: normal_range[0]?.is_1hr,
                is_1_5hr: normal_range[0]?.is_1_5hr,
                is_2hr: normal_range[0]?.is_2hr,
                is_2_5hr: normal_range[0]?.is_2_5hr,
                is_3hr: normal_range[0]?.is_3hr
              })}
          </div>
        </Box>
      </Modal>
    )
  }

  getPurposeOfVisitList() {
    let clinicId = localGetItem('SelectedDoctorClinicId') || this.state.loggedInuserInfo?.clinic_id || null;
    try {
      RestAPIService.getAll(Serviceurls.FO_POV_LIST + `?clinic_id=${clinicId}` ).
        then((response) => {
          if (response.data.status === "success") {
            let data = response?.data && response?.data?.data?.length > 0 ? response.data.data : []
            let PurposeOfVisitList = []
            data.forEach(item => PurposeOfVisitList.push(item))
            localSetItem("PurposeOfVisit", JSON.stringify(PurposeOfVisitList))
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  getAnteriorSuggestionData = () => {
    try {
      RestAPIService.getAll(`${Serviceurls.DOC_SUGGESTION_ANTERIOR_SEGMENT}`)
        .then((response) => {
          if (response.data.status === 'success') {
            const data = response.data?.data;
            if (!data || Object.keys(data)?.length === 0) return;
            localSetItem("AnteriorSuggestionData", JSON.stringify(data));
            window.dispatchEvent(new CustomEvent("anteriorSuggestionUpdated", { detail: {...data, _ts: Date.now()} }));
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error?.message)
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getPosteriorSuggestionData = () => {
    try {
      RestAPIService.getAll(`${Serviceurls.OPT_SUGGESTION_POSTERIOR_SEGMENT}`)
        .then((response) => {
          if (response.data.status === 'success') {
            const data = response.data?.data;
            if (!data || Object.keys(data)?.length === 0) return;
            localSetItem("PosteriorSuggestionData", JSON.stringify(data))
            window.dispatchEvent(new CustomEvent("posteriorSuggestionUpdated", { detail: {...data, _ts: Date.now()} }));
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error?.message)
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getPrescriptionFavouriteData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_PRESCRIPTION_FAV)
        .then((response) => {
          if (response?.data?.status === 'success') {
            const data = response.data?.data;
            if (!data || data?.length === 0) return;
            localSetItem("PrescriptionFavouriteData", JSON.stringify(data))
            window.dispatchEvent(new CustomEvent("prescriptionFavouriteUpdated", { detail: [ ...data]}));
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error?.message)
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getOptSuggestionData = (callFunc) => {
    switch (callFunc) {
      case "AnteriorSegment":
        this.getAnteriorSuggestionData();
        break;
      case "PosteriorSegment":
        this.getPosteriorSuggestionData();
        break;
      case "PrescriptionFavourite":
        this.getPrescriptionFavouriteData();
        break;
      default:
        break;
    }
  }

  getListCount = (status) => {
    if (status == true) {
      this.getBadgeCount()
      this.getPharmaCashCounterBillsCount()
    }
  }

  triggerNotifyCount = (status) => {
    if (!status) return;
    const isNewBilling = JSON.parse(localGetItem('isNewBilling') || "false");
    const { loginType } = this.state;

    if (isNewBilling) {
      this.getNotificationData();
    } else if (loginType === 'Laboratory') {
      this.getLabNotificationData();
    }
  }

  getRefundRefundCOunt = (status) => {
    if (status == true && localGetItem('isNewBilling') === "true") {
      this.getRefundRequestData()
    }
  }

  ClearCalledTrigger = () => {
    if (this.state.CallPatientTrigger) {
      this.setState({ CallPatientTrigger: false })
    }
  }

  getRadTransmitBillCount = (status) => {
    if (status === true) {
      this.getRadTransmitList()
    }
  }

  // renderDropdown = (label, mt, Data = [], stateKey) => {
  //   var states = this.state
  //   return (
  //     <Box sx={{ width: '45%', mt: mt }}>
  //       <Autocomplete
  //         size='small'
  //         clearIcon={false}
  //         sx={{ width: '14vw', marginTop: '1vw' }}
  //         componentsProps={{ popper: { style: { width: label === 'Doctor' ? "23vw" : "14vw" } } }}
  //         disabled={this.props?.is_Nurse && label === "Specialization" ? true : false}
  //         options={Data}
  //         getOptionLabel={(item) => ((label === "Doctor" ? item.doctor_name : label === "Specialization" ? item.name : label === "Patient Tag" ? item.patient_tag_name : label === "Appointment Type" ? item.appoinment_type : label === "Nurse" ? item.nurse : ""))}
  //         value={states[stateKey]}
  //         renderOption={label === 'Doctor' ? (props, item) => (
  //           <Box>
  //             {props["data-option-index"] === 0 ?
  //               <Box className="eMed_App_Doctor_table_head">
  //                 <Typography width={"50%"} fontWeight={'600'} fontSize={"0.8vw"}>Doctor Name</Typography>
  //                 <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>Total App</Typography>
  //                 <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>New App</Typography>
  //               </Box> : null}
  //             <Box component="li" className='eMed_App_Doctor_table_data' {...props}>
  //               <div style={{ width: "50%" }}>{item?.doctor_name.length > 15 ? <Tooltip placement="top" title={item?.doctor_name} arrow><div>{item?.doctor_name.slice(0, 16) + "..."}</div></Tooltip> : item?.doctor_name ? item?.doctor_name : "-"}</div>
  //               <Typography width={"25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.total_appointment}</Typography>
  //               <Typography width={"25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.new_appointment}</Typography>
  //             </Box>
  //           </Box>) : null}
  //         onChange={(event, newValue) => {
  //           states[stateKey] = newValue
  //           if (newValue !== null && "doctor_id" in newValue) {
  //             let docDetail = { ...newValue }
  //             docDetail["name"] = docDetail["specialization_name"];
  //             delete docDetail.specialization_name;
  //             docDetail["id"] = docDetail["specialization_id"];
  //             delete docDetail.specialization_id;
  //             states["RequestSelectedSpecID"] = docDetail;
  //           }
  //           if (newValue !== null && "name" in newValue) {
  //             let filteredLst = states["doctorList"].length > 0 && states["doctorList"].filter(item => item["specialization_id"] === newValue["id"])
  //             states["filteredDocList"] = filteredLst.length > 0 && filteredLst;
  //             states["RequestSelectedDocID"] = null;
  //           }
  //           if (newValue === null && label === "Specialization") {
  //             states["filteredDocList"] = states["doctorList"];
  //           }
  //           this.setState({ states })
  //         }}
  //         onKeyDown={(e) => e.stopPropagation()}
  //         renderInput={(params) => (
  //           <TextField
  //             {...params}
  //             label={label}
  //             placeholder={label}
  //           // onKeyDown={(e) => { e.stopPropagation() }}
  //           />
  //         )}
  //       />
  //     </Box>
  //   )
  // }

  // CreateAppointRequest(fromDoctor = false) {
  //   this.setState({ isClked: true })
  //   try {
  //     const { t } = this.props;
  //     var states = this.state;
  //     if ((states?.RequestMobileNumber.length === 10 && CommonValidation.numberOnly(states?.RequestMobileNumber) && CommonValidation.removeSpace(states?.RequestPatientName) != "") ||
  //       (states?.docRequestMobileNumber.length === 10 && CommonValidation.numberOnly(states?.docRequestMobileNumber) && CommonValidation.removeSpace(states?.docRequestPatientName) !== "")) {
  //       var AptDateTime = states.RequestAppointDatetym ? new Date(states.RequestAppointDatetym) : new Date(states.RequestAppointDatetym)
  //       var DocAptDateTime = states.docRequestAppointDatetym ? new Date(states.docRequestAppointDatetym) : new Date(states.docRequestAppointDatetym)
  //       var AptDate = DateTime.fromJSDate(AptDateTime).toFormat('yyyy-MM-dd')
  //       var DocAptDate = DateTime?.fromJSDate(DocAptDateTime)?.toFormat('yyyy-MM-dd')
  //       var Aptime = DateTime.fromJSDate(AptDateTime).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
  //       var DocAptime = DateTime?.fromJSDate(DocAptDateTime)?.toLocaleString(DateTime.TIME_24_WITH_SECONDS);
  //       let data = {}
  //       if (fromDoctor) {
  //         let clinicId = localGetItem('SelectedDoctorClinicId')
  //         data = {
  //           "patient_name": CommonValidation.removeSpace(states?.docRequestPatientName),
  //           "patient_id": states?.docSelectedRequestPatient?.patient_id ? states?.docSelectedRequestPatient?.patient_id : states?.doceditPatientId ? states?.doceditPatientId : null,
  //           "doctor_id": states?.docRequestSelectedDocID?.doctor_id ? states?.docRequestSelectedDocID?.doctor_id : null,
  //           "mobile": states?.docRequestMobileNumber,
  //           "reason": states?.docRequestpurposeOfVisit ? states?.docRequestpurposeOfVisit : "",
  //           "appointment_date": DocAptDate,
  //           "appointment_time": DocAptime,
  //           'clinic_id': clinicId,
  //           "address_line_1" : states.address_1 === null ? "" : CommonValidation.removeSpace(states.address_1),
  //           "address_line_2" :states.address_2 === null ? "" : CommonValidation.removeSpace(states.address_2),
  //           "city_name" : states.city === null ? "" : CommonValidation.removeSpace(states.city),
  //           "state_name":states.state_code === null ? "" : CommonValidation.removeSpace(states.AllStates.find((item)=>( item.isoCode === states.state_code))?.name),
  //           "country" : states.country_code === null ? "" : CommonValidation.removeSpace(states.AllCountry.find((item)=>( item.isoCode === states.country_code))?.name),
  //           "pincode" :states.pin_code === null ? "" : CommonValidation.removeSpace(states.pin_code),
  //           "speciality_id": states.docRequestSelectedSpecID?.id ? states.docRequestSelectedSpecID?.id : null,
  //           "gender": states.docRequestPatientGender ? states.docRequestPatientGender : null,
  //         }
  //         if (this.state.doceditAppointmentId) {
  //           data["id"] = states?.doceditAppointmentId
  //           data["age"] = states?.docRequestPatientAge === "" ? null : states?.docRequestPatientAge
  //         } else {
  //           data["age"] = states?.docRequestPatientAge ? states?.docRequestPatientAge : null
  //         }
  //       } else {
  //         let AgeKey = typeof states?.RequestPatientAge === "string" ? states?.RequestPatientAge?.includes("Y") ? states?.RequestPatientAge : (states?.RequestPatientAge ? (states?.RequestPatientAge + "Y") : null) : (states?.RequestPatientAge ? (states?.RequestPatientAge + "Y") : null);
  //         data = {
  //           "patient_name": CommonValidation.removeSpace(states?.RequestPatientName),
  //           "patient_id": states?.SelectedRequestPatient?.patient_id ? states?.SelectedRequestPatient?.patient_id : states?.editPatientId ? states?.editPatientId : null,
  //           "doctor_id": states?.RequestSelectedDocID?.doctor_id ? states?.RequestSelectedDocID?.doctor_id : null,
  //           "mobile": states?.RequestMobileNumber,
  //           "reason": states?.RequestpurposeOfVisit ? states?.RequestpurposeOfVisit : "",
  //           // "age": states?.SelectedRequestPatient?.patient_id ? null : states?.RequestPatientAge ? states?.RequestPatientAge?.replace('Y', '') : null,
  //           "age": AgeKey === "" ? null : AgeKey,
  //           "appointment_date": AptDate,
  //           "appointment_time": Aptime,
  //           "address_line_1" : states.address_1 === null ? "" : CommonValidation.removeSpace(states.address_1),
  //           "address_line_2" :states.address_2 === null ? "" : CommonValidation.removeSpace(states.address_2),
  //           "city_name" : states.city === null ? "" : CommonValidation.removeSpace(states.city),
  //           "state_name":states.state_code === null ? "" : CommonValidation.removeSpace(states.AllStates.find((item)=>( item.isoCode === states.state_code))?.name),
  //           "country" : states.country_code === null ? "" : CommonValidation.removeSpace(states.AllCountry.find((item)=>( item.isoCode === states.country_code))?.name),
  //           "pincode" :states.pin_code === null ? "" : CommonValidation.removeSpace(states.pin_code),
  //           "speciality_id": states.RequestSelectedSpecID?.id ? states.RequestSelectedSpecID?.id : null,
  //           "gender": states.RequestPatientGender ? states.RequestPatientGender : null,
  //         }
  //         if (this.state.editAppointmentId) {
  //           data["id"] = states?.editAppointmentId
  //         }
  //       }
  //       RestAPIService.create(data, Serviceurls.FO_TELE_APPOINTMENT_REQUEST)
  //         .then((response) => {
  //           if (response.data.status === "success") {
  //             this.successMessage(response.data.message)
  //             this.setState({ SelectedRequestTab: "appointment_request" })
  //             if (fromDoctor) {
  //               this.getDoctorAppointmentList(true)
  //               this.docClearRequestData()
  //             } else {
  //               this.props.history.push({ pathname: "/OPHome", state: { NewAppointmentCreated: true, NewMessage: response?.data?.message } })
  //               this.getAppointRequests()
  //               this.ClearRequestData()
  //             }
  //           }
  //         }).catch((e) => {
  //           if (e?.response?.data?.message) {
  //             this.setState({ isClked: false })
  //             this.errorMessage(e.response.data.message)
  //           } else {
  //             this.setState({ isClked: false })
  //             this.errorMessage(e.message)
  //           }
  //         })
  //     } else {
  //       this.setState({ isClked: false }, () => {
  //         if (states?.RequestMobileNumber === "") {
  //           this.errorMessage("Enter Mobile Number")
  //         }
  //         // else if ((!CommonValidation.removeSpace(states?.RequestPatientAge)) || (fromDoctor && !CommonValidation.removeSpace(states?.docRequestPatientAge))) {
  //         //   this.errorMessage("Enter Patient Age")
  //         // }
  //         else if (CommonValidation.numberOnly(states?.RequestMobileNumber) && states?.RequestMobileNumber.length !== 10) {
  //           this.errorMessage("Mobile Number Must be in 10 Digits")
  //         }
  //         else if (!CommonValidation.numberOnly(states?.RequestMobileNumber) && Object.keys(this.state.SelectedRequestPatient).length === 0) {
  //           this.errorMessage("Invaild Mobile Number")
  //         }
  //         else if (CommonValidation.removeSpace(states?.RequestPatientName) === "") {
  //           this.errorMessage("Enter Patient Name")
  //         }
  //       })
  //     }
  //   }
  //   catch (e) {
  //     this.setState({ isClked: false })
  //     this.errorMessage(e.message)
  //   }
  // }

  ClearRequestData() {
    this.setState({
      RequestPatientName: "",
      RequestMobileNumber: "",
      SelectedRequestPatient: {},
      RequestSelectedDocID: null,
      RequestSelectedSpecID: null,
      RequestPatientAge: "",
      RequestPatientName: "",
      RequestAppointDatetym: new Date(),
      RequestpurposeOfVisit: "",
      filteredDocList: [],
      editAppointmentId: null,
      editPatientId: null,
      isClked: false,
      patientSearch: '',
      address_1: "",
      address_2: "",
      city: "",
      cityName: City.getCitiesOfState("IN", "TN"),
      country_code: 'IN',
      state_code: 'TN',
      AllCountry: Country.getAllCountries(),
      AllStates: State.getStatesOfCountry("IN"),
      pin_code: "",
      RequestPatientMenuPop: false, 
      // RequestPatientListAnchor : null,
      SearchedRequestPatientList : [],
      RequestPatientDOB: null,
      RequestPatientGender: "",
    },() => {
      let city_name = localGetItem('city_name')
      let state_name = localGetItem('state_name')
      let List = State.getAllStates()?.find(item => item?.name?.toLowerCase() === state_name?.toLowerCase())
      let stateList = State.getStatesOfCountry(List?.countryCode)
      let cityList = City.getCitiesOfState(List?.countryCode, List?.isoCode)
      this.setState({ city: city_name, state_code: List?.isoCode, AllStates: stateList, cityName: cityList })
    })
  }

  docClearRequestData() {
    this.setState({
      docRequestPatientName: "",
      docRequestMobileNumber: "",
      docSelectedRequestPatient: {},
      docRequestSelectedDocID: null,
      docRequestSelectedSpecID: null,
      docRequestPatientAge: "",
      docRequestPatientName: "",
      docRequestAppointDatetym: new Date(),
      docRequestpurposeOfVisit: "",
      docfilteredDocList: [],
      doceditAppointmentId: null,
      doceditPatientId: null,
      isClked: false,
      docDatePicker: new Date(),
      patientSearch: '',
      App_DocID: null,
      address_1: "",
      address_2: "",
      city: "",
      cityName: City.getCitiesOfState("IN", "TN"),
      country_code: 'IN',
      state_code: 'TN',
      AllCountry: Country.getAllCountries(),
      AllStates: State.getStatesOfCountry("IN"),
      pin_code: "",
      docRequestPatientMenuPop: false, 
      // docRequestPatientListAnchor : null, 
      docSearchedRequestPatientList : [],
      docRequestPatientDOB: null,
      docRequestPatientGender: "",
    }, () => { this.getDoctorAppointmentList() })
  }

  handlePatientSearch = () => {
    let data = this.state.duplicateFoReqList
    if (this.state.patientSearch !== "") {
      data = this.state.duplicateFoReqList.filter((item) => (
        (item?.first_name === "" ? "" : item?.first_name?.toLowerCase()?.includes(this.state.patientSearch?.toLowerCase()))
      ))
      this.setState({ FoRequestList: data })
    } else {
      this.getAppointRequests()
    }
  }

  handlePatientSearchClose = () => {
    this.setState({ patientSearch: '' })
    this.getAppointRequests()
  }

  handleQRPatientSearchClose = () => {
    this.setState({ AbhaQrPatientName : '' })
    this.getAbhaQrList()
  }

  QREntryList = () => {
    const { t } = this.props;
    return (
      <Menu
        open={this.state.QREntryPopUp}
        sx={{ height: '60vh' }}
        className="eMed_Header_Request_Pop"
        anchorEl={this.state.RequestAnchor}
        onClose={() => {
          this.setState({ QREntryPopUp: false, DateOpen: false, RegistrationDate: new Date(), QRPatientName: '' }, () => {
            this.getQREntryList()
          })
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} alignItems={'center'}>
          <Box>
            <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} alignItems={'center'}>
              <OutlinedInput
                className="emed_ordersearch"
                placeholder="Patient Name"
                onChange={(e) => {
                  let validate = CommonValidation.alphabetOnly(e.target.value)
                  validate &&
                    this.setState({ QRPatientName: e.target.value }, () => {
                      this.getQREntryList()
                    })
                }}
                inputProps={{ emed_tid: "patient_search" }}
                value={this.state.QRPatientName}
                size="small"
                sx={{ width: "15vw", marginRight: "0.5vw" }}
                endAdornment={
                  <InputAdornment position="end">
                    <i class="fas fa-search"></i>
                  </InputAdornment>
                }
              />

              <div style={{ padding: "0.5vw" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    open={this.state.DatePickerOpen}
                    onOpen={() => { this.setState({ DatePickerOpen: true }) }}
                    onClose={() => { this.setState({ DatePickerOpen: false }) }}
                    value={this.state.RegistrationDate}
                    name={"datePicker"}
                    inputFormat='DD-MM-YYYY'
                    views={["year", "month", "day"]}
                    onChange={
                      (newDate) => {
                        this.setState({
                          RegistrationDate: newDate
                        }, () => {
                          this.getQREntryList()
                        });
                      }}
                    renderInput={(params) => <TextField
                      onKeyDown={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                      }} style={{ width: '12vw' }} size='small' {...params} inputProps={{ ...params.inputProps, 'emed_tid': 'QR_Date_Search' }} onClick={() => { this.setState({ DatePickerOpen: true }) }} />}
                  />
                </LocalizationProvider>
              </div>
            </Box>
          </Box>
        </Box>
        <Box>
          <Box className="eMed_App_reqest_table_head" sx={{ width: '51.5vw' }}>
            <Typography width={"20%"} fontWeight={'600'} fontSize={"0.8vw"}>Date & Time</Typography>
            <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>Patient Details</Typography>
            <Typography width={"35%"} fontWeight={'600'} fontSize={"0.8vw"}>Address</Typography>
            <Typography width={"20%"} fontWeight={'600'} fontSize={"0.8vw"} textAlign={'center'}>Action</Typography>
          </Box>
          <Divider />
          <Box height={"30vh"} overflow={"scroll"}>
            {
              this.state.QrEntryList.length > 0 ?
                this.state.QrEntryList.map((list) => {
                  let PatientName = `${list.patient_name} (${list?.age}/${list?.gender === 'm' ? "M" : list?.gender === 'f' ? "F" : "T"})`;
                  return (
                    <Box>
                      <Box className="eMed_Header_Request_item">
                        <Box width={'20%'}>
                          <Typography fontWeight={'600'} fontSize={"0.85vw"}>{list?.created_date ? formatDate(list.created_date) : "-"}</Typography>
                          <Typography fontSize={"0.7vw"}>{list?.created_date ? `${list?.created_date.split(" ")[1]} ${list?.created_date.split(" ")[2]}` : "-"}</Typography>
                        </Box>
                        <Box width={'25%'}>
                          <Typography fontWeight={'600'} fontSize={"0.85vw"}>
                            {PatientName ? PatientName?.length > 20 ?
                              <Tooltip placement='top' title={PatientName} arrow>
                                <div>{PatientName.slice(0, 20) + "..."}</div></Tooltip> :
                              PatientName : "-"}
                          </Typography>
                          {(list?.mobile_number) ?
                            <Typography fontSize={"0.7vw"}>{list.mobile_number}</Typography> : null}
                        </Box>
                        <Box width={'35%'}>
                          {list?.address ?
                            <Typography fontWeight={'600'} fontSize={"0.85vw"}>
                              {list?.address ? list?.address?.length > 20 ?
                                <Tooltip placement='top' title={list?.address} arrow>
                                  <div style={{ fontWeight: "600", fontSize: "0.85vw" }}>{list?.address.slice(0, 20) + "..."}</div></Tooltip> :
                                list?.address : "-"}
                            </Typography> :
                            list?.address_line_1 || list?.address_line_2 ?
                              <Box>
                                <Typography fontWeight={'600'} fontSize={"0.85vw"}>
                                  {list?.address_line_1 ? list?.address_line_1?.length > 20 ?
                                    <Tooltip placement='top' title={list?.address_line_1} arrow>
                                      <div style={{ fontWeight: "600", fontSize: "0.85vw" }}>{list?.address_line_1.slice(0, 20) + "..."}</div></Tooltip> :
                                    list?.address_line_1 : "-"}
                                </Typography>
                                <Typography fontWeight={'600'} fontSize={"0.85vw"}>
                                  {list?.address_line_2 ? list?.address_line_2?.length > 20 ?
                                    <Tooltip placement='top' title={list?.address_line_2}><div style={{ fontWeight: "600", fontSize: "0.85vw" }}>{list?.address_line_2.slice(0, 20) + "..."}</div></Tooltip>
                                    : list?.address_line_2 : '-'}
                                </Typography>
                              </Box> : null
                          }
                        </Box>
                        <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} width={'20%'}>
                          <Tooltip title={t("Create Appointment")} arrow placement='top'>
                            <IconButton emed_tid="create_appointment" onClick={() => {
                              this.setState({ QREntryPopUp: false, DateOpen: false, RegistrationDate: new Date(), QRPatientName: '' }, () => {
                                setCachevalue(JSON.stringify(list), "QRRequestPatientData")
                                if (formatDate(list.created_date) === DateTime.fromJSDate(new Date()).toFormat('dd-MM-yyyy')) {
                                  this.props.history.push({ pathname: (localGetItem('isNewBilling') === "true") ? "/OPHome/Billing/NewQuickBilling" : "/OPHome/Billing/QuickBilling" })
                                } else {
                                  this.props.history.push({ pathname: "/OPHome/Billing/CreateAppointment" })
                                }
                              })
                            }}
                              position="end">
                              <img className="eMed_Tick_img" style={{ height: "2vw", width: "2vw" }} src={ImagePaths.Tick.default} alt={"Tick"} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={t("Cancel Request")} arrow placement='top'>
                            <IconButton emed_tid="cancel_request" onClick={() => { this.CancelQrRequest(list) }}>
                              <CancelIcon sx={{ height: '1.8vw', width: '1.8vw' }} color='error' />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Box>
                      <Divider />
                    </Box>
                  )
                }) :
                <Box>
                  <Box className="eMed_Header_Request_item" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '20vh' }}>
                    <Typography>{t("NoRecordsFound")}</Typography>
                  </Box>
                </Box>
            }
          </Box>
        </Box>
      </Menu>
    )
  }

  postAbhaQrRegister = (ID, row={}) => {
    try {
      this.setState({
        isLoader: true
      })
      var data = {
        "qr_id": ID,
        "from_qr": true,
        "link_hip": true
      }
      if(this.state.AbhaPatientUHID && this.state.AbhaCompareQrID){
        data['uhid'] = this.state.AbhaPatientUHID
        data['allow_update'] = true;
        data['link_hip'] = false;
      }
      RestAPIService.create(data, Serviceurls.ABHA_PATIENT_ABHA_REGISTER)
        .then((response) => {
            this.setState({
              isLoader: false
            })
          if (response.data.status === "success") {
            if(response.data?.message === "Patient is already mapped with the ABHA service.") {
              this.setState({
                isUpdateAbhaPopup: true,
                AbhaExistingData: response?.data?.existing_data,
                AbhaPatientUHID: response.data?.uhid,
                AbhaQrPopUp: false, RequestAnchor: null, isAbhaQrRegistered: false, abhaPopupData: {},
                AbhaPatientdata: row,
                AbhaCompareQrID: ID
              })
            }else{
              this.successMessage(response.data?.message)
              this.setState({ AbhaQrPopUp: false, RequestAnchor: null, isAbhaQrRegistered: true, abhaPopupData: (response.data?.register_data ||  response.data?.data), AbhaCompareQrID: null, isUpdateAbhaPopup: false, AbhaExistingData: null, AbhaPatientUHID: null, AbhaPatientdata: null}, () => {
                this.getAbhaQrList()
              })
            }
          } else {
            this.errorMessage(response.data.message)
          }
        }).catch((e) => {
          this.setState({
              isLoader: false
          })
          if (e?.response?.data?.message) {
            this.errorMessage(e.response.data.message)
          } else {
            this.errorMessage(e.message)
          }
        })
    }catch (e) {
      this.errorMessage(e.message)
    }
  }

  AbhaQrList = () => {
    const { t } = this.props;
    return (
      <Menu
        open={this.state.AbhaQrPopUp}
        sx={{ height: '60vh' }}
        className="eMed_Header_Request_Pop"
        anchorEl={this.state.RequestAnchor}
        onClose={() => {
          this.setState({ AbhaQrPopUp: false }, () => {
            this.getAbhaQrList()
          })
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} alignItems={'center'}>
          <TextField
            placeholder={t("Patient Name")}
            onChange={(e) => {
              let validate = CommonValidation.alphabetOnly(e.target.value)
              validate &&
                this.setState({ AbhaQrPatientName: e.target.value }, () => {
                  this.getAbhaQrList()
                })
            }}
            value={this.state.AbhaQrPatientName}
            size="small"
            sx={{ width: "10vw" }}
            onKeyDown={(e) => { e.stopPropagation() }}
            autoComplete='off'
            inputProps={{ emed_tid: 'ApptReq_PatientSearch' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {this.state.AbhaQrPatientName.length ?
                    <IconButton onClick={this.handleQRPatientSearchClose} emed_tid='ApptReq_PatientSearch_ClearBtn'>
                      <CloseIcon fontSize='small' />
                    </IconButton>
                    : null}
                </InputAdornment>
              ),
            }}
          />
          <div style={{ padding: "0.5vw" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                open={this.state.DatePickerOpen}
                onOpen={() => { this.setState({ DatePickerOpen: true }) }}
                onClose={() => { this.setState({ DatePickerOpen: false }) }}
                value={this.state.AbhaQRRegDate}
                name={"datePicker"}
                inputFormat='DD-MM-YYYY'
                views={["year", "month", "day"]}
                onChange={
                  (newDate) => {
                    this.setState({
                      AbhaQRRegDate: newDate
                    }, () => {
                      this.getAbhaQrList()
                    });
                  }}
                renderInput={(params) => <TextField
                  onKeyDown={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                  }} style={{ width: '10vw' }} size='small' {...params} onClick={() => { this.setState({ DatePickerOpen: true }) }} />}
              />
            </LocalizationProvider>
          </div>
        </Box>
        <Box>
          <Box className="eMed_App_reqest_table_head" sx={{ width: '51.5vw' }}>
            <Typography width={"20%"} fontWeight={'600'} fontSize={"0.8vw"}>Date & Time</Typography>
            <Typography width={"10%"} fontWeight={'600'} fontSize={"0.8vw"}>Token</Typography>
            <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>Patient Details</Typography>
            <Typography width={"30%"} fontWeight={'600'} fontSize={"0.8vw"}>ABHA Details</Typography>
            <Typography width={"15%"} fontWeight={'600'} fontSize={"0.8vw"} textAlign={'center'}>Action</Typography>
          </Box>
          <Divider />
          <Box height={"30vh"} overflow={"scroll"}>
            {
              this.state.AbhaQrList.length > 0 ?
                this.state.AbhaQrList.map((list) => {
                  return (
                    <Box>
                      <Box className="eMed_Header_Request_item">
                        <Box width={'20%'}>
                          <Typography fontWeight={'600'} fontSize={"0.85vw"}>{list?.created_date ? formatDate(list.created_date) : "-"}</Typography>
                          {/* <Typography fontSize={"0.7vw"}>{list?.created_date ? `${list?.created_date.split(" ")[1]} ${list?.created_date.split(" ")[2]}` : "-"}</Typography> */}
                        </Box>
                        <Box width={'10%'}>
                          <Typography fontWeight={'600'} fontSize={"0.85vw"}>{list?.id}</Typography>
                        </Box>
                        <Box width={'25%'} flexWrap={'wrap'}>
                          <Typography
                            fontWeight={'600'}
                            fontSize={"0.85vw"}
                            sx={{
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              maxWidth: "100%"
                            }}
                          >
                            {list?.name}
                          </Typography>
                          {/* <Typography fontWeight={'600'} fontSize={"0.85vw"}>
                            {(list?.name) ? (list?.name)?.length > 20 ?
                              <Tooltip placement='top' title={(list?.name)} arrow>
                                <div>{(list?.name).slice(0, 20) + "..."}</div></Tooltip> :
                              (list?.name) : "-"}
                          </Typography> */}
                          {(list?.mobile_number) ?
                            <Typography fontSize={"0.7vw"}>{list?.mobile_number}</Typography> : null}
                        </Box>
                        <Box width={'30%'}>
                            <Typography fontWeight={'600'} fontSize={"0.85vw"}>
                              {list?.abha_health_address ? list?.abha_health_address?.length > 30 ?
                                <Tooltip placement='top' title={list?.abha_health_address} arrow>
                                  <div style={{ fontWeight: "600", fontSize: "0.85vw" }}>{list?.abha_health_address.slice(0, 20) + "..."}</div></Tooltip> :
                                list?.abha_health_address : "-"}
                            </Typography> 
                            <Typography fontSize={"0.7vw"}>{list?.abha_health_id}</Typography>
                        </Box>
                        <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} width={'15%'}>
                          <Tooltip title={t("Register")} arrow placement='top'>
                            <IconButton emed_tid="abha_qr_register" onClick={() => {
                              this.setState({ QREntryPopUp: false})
                              this.postAbhaQrRegister(list?.id, list)
                            }}
                              position="end">
                              <img className="eMed_Tick_img" style={{ height: "2vw", width: "2vw" }} src={ImagePaths.Tick.default} alt={"Tick"} />
                            </IconButton>
                          </Tooltip>
                          {/* <Tooltip title={t("Cancel Request")} arrow placement='top'>
                            <IconButton emed_tid="cancel_request" onClick={() => { this.CancelQrRequest(list) }}>
                              <CancelIcon sx={{ height: '1.8vw', width: '1.8vw' }} color='error' />
                            </IconButton>
                          </Tooltip> */}
                        </Box>
                      </Box>
                      <Divider />
                    </Box>
                  )
                }) :
                <Box>
                  <Box className="eMed_Header_Request_item" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '20vh' }}>
                    <Typography>{t("NoRecordsFound")}</Typography>
                  </Box>
                </Box>
            }
          </Box>
        </Box>
      </Menu>
    )
  }

  renderAppointmentReqTbl = (list, from = "request", height, width) => {
    const { t } = this.props;
    this.state.renderAppointmentReqTbl?.forEach((element, index) => element.sno = index + 1)
    const restrict_op_appointment_in_ip_patients = localGetItem('restrict_op_appointment_in_ip_patients') === "true";   
    
    const columns = [
      {
        field: 'sno', headerName: 'S.No', flex: 0.1,
      },
      {
        field: 'created_date', headerName: 'Req Date & Time', flex: 0.16,
        renderCell: ({ row }) => {
          return (
            <Box>
              <Typography fontWeight={'600'} fontSize={"0.85vw"}>{row?.created_date ? formatDate(row.created_date) : "-"}</Typography>
              <Typography fontSize={"0.7vw"}>{row?.created_time || '-'}</Typography>
            </Box>
          )
        },
        valueGetter: (params) => {
          return new Date(`${params.row.created_date} ${params.row.created_time || "00:00"}`);
        },
      },
      {
        field: 'appointment_date', headerName: 'App Date & Time', flex: 0.16,
        renderCell: ({ row }) => {
          return (
            <Box>
              <Typography fontWeight={'600'} fontSize={"0.85vw"}>{row?.appointment_date ? formatDate(row.appointment_date) : "-"}</Typography>
              <Typography fontSize={"0.7vw"}>{row?.appointment_time}</Typography>
            </Box>
          )
        },
        valueGetter: (params) => {
          return new Date(`${params.row.appointment_date} ${params.row.appointment_time || "00:00"}`);
        },
      },
      {
        field: 'first_name', headerName: 'Patient Details', flex: 0.20,
        renderCell: ({ row }) => {
          const PatientName = row.first_name + " " + row.last_name;
          return (
            <Box>
              <Typography fontWeight={'600'} fontSize={"0.85vw"}>
                {PatientName ? PatientName?.length > 20 ?
                  <Tooltip placement='top' title={PatientName} arrow>
                    <div>{PatientName.slice(0, 20) + "..."}</div></Tooltip> :
                  PatientName : "-"}
              </Typography>
              {(row?.mobile_number || row?.patient_account_number) ?
                <Typography fontSize={"0.7vw"}>{row.mobile_number} | {row.patient_account_number ? row.patient_account_number : "-"}</Typography> : null}
            </Box>
          )
        },
        valueGetter: (params) => {
          return `${params.row.first_name ?? ""} ${params.row.last_name ?? ""}`.trim().toLowerCase();
        },
      },
      {
        field: 'doctor_name', headerName: 'Clinic / Hospital', flex: 0.16,
        renderCell: ({ row }) => {
          return (
            <Box>
              {row?.doctor_name ? row?.doctor_name?.length > 20 ?
                <Tooltip placement='top' title={row?.doctor_name} arrow>
                  <div>{row?.doctor_name.slice(0, 20) + "..."}</div></Tooltip> :
                row?.doctor_name : "-"}
              <Typography fontSize={"0.7vw"}>{row?.clinic_name}</Typography>
            </Box>
          )
        },
        valueGetter: (params) => {
          return `${params.row.doctor_name ?? ""} ${params.row.clinic_name ?? ""}`.trim().toLowerCase();
        }
      },
      {
        field: 'booked_through', headerName: 'Source', flex: 0.16, headerAlign: 'center', align: 'center', sortable: false,
        renderCell: ({ row }) => {
          const { title, icon } = bookedThroughObj[row?.booked_through] || bookedThroughObj["Web"];
          return (
            <Box>
              {
                <Tooltip title={t(title)} arrow placement='top'>
                  <img style={{ height: '1.5vw', width: '1.5vw' }} src={icon}></img>
                </Tooltip>
              }
            </Box>
          )
        }
      },
      {
        field: 'action', headerName: 'Action', flex: 0.16, headerAlign: 'center', align: 'center', sortable: false,
        renderCell: ({ row }) => {
          const disableAddIcon = (localGetItem('isNewBilling') === "true" && restrict_op_appointment_in_ip_patients && row?.ip_has_current_appointment) ? true : false;
          return (
            <>

              {from === "docModule" ? <Box display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'}>
                <Tooltip title={t("Edit Appointment")} arrow placement='top'>
                  <IconButton size="small" onClick={() => {
                    // ======> Commented for no doctor and specialization for doctor module
                    // let doctorData = {}, spcData = {};
                    // if (list?.doctor_id) {
                    //   doctorData = this.state.doctorList?.length > 0 ? this.state.doctorList?.find(item => item?.doctor_id === list?.doctor_id) : {};
                    //   spcData = (this.state.spcInfo?.length > 0 && Object.keys(doctorData)?.length > 0) ? this.state.spcInfo?.find(data => data?.id === doctorData?.specialization_id) : {};
                    // }
                    let age = typeof (row?.age) !== "number" ? row?.age?.split("/") : row?.age;

                    this.setState({
                      docSelectedRequestTab: "create_request",
                      doceditAppointmentId: row?.id,
                      doceditPatientId: row?.patient_id,
                      docRequestMobileNumber: row?.mobile_number ? row?.mobile_number : row?.mobile,
                      docRequestPatientName: row?.patient_name ? row?.patient_name : row?.first_name,
                      docRequestPatientAge: age?.length > 0 ? parseInt(age[0]) : age,
                      // docRequestSelectedDocID: Object.keys(doctorData)?.length > 0 ? doctorData : null,
                      // docRequestSelectedSpecID: Object.keys(spcData)?.length > 0 ? spcData : null,
                      docRequestAppointDatetym: row?.appointment_date + row?.appointment_time,
                      docRequestpurposeOfVisit: row?.message,
                      address_1: row?.address_line_1 ? row.address_line_1 : "",
                      address_2: row?.address_line_2 ? row?.address_line_2 : "",
                      country_code: this.state.AllCountry?.find((item) => (item.name === row?.country))?.isoCode,
                      AllStates: State.getStatesOfCountry(this.state.AllCountry?.find((item) => (item.name === row?.country))?.isoCode),
                      state_code: State.getStatesOfCountry(this.state.AllCountry?.find((item) => (item.name === row?.country))?.isoCode)?.find((item) => (item.name === row?.state_name))?.isoCode,
                      city: row?.city_name ? row?.city_name : "",
                      pin_code: row.pincode ? row.pincode : "",
                    })
                  }}
                    position="end">
                    <Edit color='primary' sx={{ height: '1.5vw', width: '1.5vw' }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title={t("Create Appointment")} arrow placement='top'>
                  <IconButton size="small"
                  disabled={row?.availability === "unavailable" || disableAddIcon}
                  onClick={() => {
                    // this.postRequest(row, "Approve")
                    this.setState({
                      doctorAppointmentAnchor: null,
                      openDoctorAppointment: false,
                      docDatePicker: new Date()
                    }, () => {
                      if (row?.patient_id) {
                        setCachevalue(JSON.stringify(row), "AppRequestPatientData")
                        this.props.history.push({ pathname: "/DoctorHome/Doctor/Demographics", state: { fromRequest: false, fromCreate: true, patientId: row?.patient_id } })
                        // this.getDoctorPatientDetailData(row?.patient_id, 'Request Create', row)
                      } else {
                        setCachevalue(JSON.stringify(row), "AppRequestPatientData")
                        this.props.history.push({ pathname: "/DoctorHome/Doctor/Demographics", state: { fromCreate: true, fromRequest: true } })
                      }
                    })
                  }}>
                    <CheckCircleIcon sx={{ height: '1.5vw', width: '1.5vw' }} color={(row?.availability === "unavailable" || disableAddIcon) ? 'disabled' : 'primary'} />
                  </IconButton>
                </Tooltip>
                <Tooltip title={t("Cancel Request")} arrow placement='top'>
                  <IconButton size="small" onClick={() => { this.postDoctorCancelAppointment(row?.id) }}>
                    <CancelIcon sx={{ height: '1.5vw', width: '1.5vw' }} color='error' />
                  </IconButton>
                </Tooltip>
              </Box>
                : <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} width={'18%'} paddingRight={'0.5vw'}>
                  <Tooltip title={t("Edit Appointment")} arrow placement='top'>
                    <IconButton onClick={() => {
                      let doctorData = {}, spcData = {};
                      if (row?.doctor_id) {
                        doctorData = this.state.doctorList?.length > 0 ? this.state.doctorList?.find(item => item?.doctor_id === row?.doctor_id) : {};
                        spcData = (this.state.spcInfo?.length > 0 && Object.keys(doctorData)?.length > 0) ? this.state.spcInfo?.find(data => data?.id === doctorData?.specialization_id) : {};
                      } else if (row?.speciality_id) {
                        spcData = (this.state.spcInfo?.length > 0) ? this.state.spcInfo?.find(data => data?.id === row?.speciality_id) : {};
                      }
                      let age = typeof (row?.age) !== "number" ? row?.age?.split("/") : row?.age;
                      this.setState({
                        SelectedRequestTab: "create_request",
                        editAppointmentId: row?.id,
                        editPatientId: row?.patient_id,
                        RequestMobileNumber: row?.mobile_number ? row?.mobile_number : row?.mobile,
                        RequestPatientName: row?.patient_name ? row?.patient_name : row?.first_name,
                        RequestPatientAge: age?.length > 0 ? row?.age : age,
                        RequestSelectedDocID: Object.keys(doctorData)?.length > 0 ? doctorData : null,
                        RequestSelectedSpecID: Object.keys(spcData)?.length > 0 ? spcData : null,
                        RequestAppointDatetym: row?.appointment_date + row?.appointment_time,
                        RequestpurposeOfVisit: row.message,
                        address_1: row?.address_line_1 ? row?.address_line_1 : "",
                        address_2: row?.address_line_2 ? row?.address_line_2 : "",
                        country_code: this.state.AllCountry.find((item) => (item.name === row?.country))?.isoCode,
                        AllStates: State.getStatesOfCountry(this.state.AllCountry.find((item) => (item.name === row?.country))?.isoCode),
                        state_code: State.getStatesOfCountry(this.state.AllCountry.find((item) => (item.name === row?.country))?.isoCode).find((item) => (item.name === row?.state_name))?.isoCode,
                        city: row?.city_name ? row?.city_name : "",
                        pin_code: row.pincode ? row.pincode : "",
                        RequestPatientDOB: row?.age ? this.handleFindApproxDob(typeof row?.age === "string" ? row?.age?.includes("Y") ? row?.age?.replace('Y', '') : row?.age : row?.age) : null,
                        RequestPatientGender: row?.gender ? row?.gender : "",
                      })
                    }}
                      position="end">
                      <Edit color='primary' />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("Create Appointment")} arrow placement='top'>
                    <IconButton 
                    disabled={row?.availability === "unavailable" || disableAddIcon}
                    onClick={() => {
                      this.setState({ RequestPopUp: false, DateOpen: false, patientSearch: '', App_DocID: null }, () => {
                        setCachevalue(JSON.stringify(row), "AppRequestPatientData")
                        if (row?.appointment_date === DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')) {
                          this.props.history.push({ pathname: (localGetItem('isNewBilling') === "true") ? "/OPHome/Billing/NewQuickBilling" : "/OPHome/Billing/QuickBilling" })
                        } else {
                          this.props.history.push({ pathname: "/OPHome/Billing/CreateAppointment" })
                        }
                      })
                    }}>
                      <CheckCircleIcon sx={{ height: '1.8vw', width: '1.8vw' }} color={(row?.availability === "unavailable" || disableAddIcon) ? 'disabled' : 'primary'} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("Cancel Request")} arrow placement='top'>
                    <IconButton onClick={() => { this.postRequest(row, "Cancel") }}>
                      <CancelIcon sx={{ height: '1.8vw', width: '1.8vw' }} color='error' />
                    </IconButton>
                  </Tooltip>
                </Box>}
            </>
          )
        }
      },
    ];

    return (
      <Box height={height} width={width}>
        <DataGrid
          columns={columns}
          rows={list}
          getRowId={(row) => row['sno']}
          localeText={{
            toolbarColumns: "",
            toolbarDensity: "",
            toolbarExport: "",
            toolbarFilters: "",
            toolbarExportPrint: ""
          }}
          components={{
            NoRowsOverlay: () => (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                {'No Records To Be Shown'}
              </Box>
            )
          }}
          headerHeight={40}
          disableSelectionOnClick
          hideFooter
        />
      </Box>
    )
  }

  AppointmentRequestPop = () => {
    const { t } = this.props;
    var states = this.state
    return (
      <Menu
        open={this.state.RequestPopUp}
        // sx={{ height: '60vh' }}
        className="eMed_Header_Request_Pop"
        sx={{height :"80vw"}}
        anchorEl={this.state.RequestAnchor}
        onClose={() => {
          this.setState({ RequestPopUp: false, DateOpen: false, SelectedRequestTab: "appointment_request", datePicker: new Date(), App_DocID: null, patientSearch: '', RequestPatientListAnchor : null }, () => {
            this.ClearRequestData()
            this.getAppointRequests()
          })
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Tabs

            value={this.state.SelectedRequestTab}
            onChange={(e, newValue) => {
              this.setState({ SelectedRequestTab: newValue, DateOpen: false, datePicker: new Date(), isappointRequest: false }, () => {
                this.ClearRequestData()
                if (this.state.SelectedRequestTab === "appointment_request") { this.getAppointRequests() }
                else { 
                  let city_name = localGetItem('city_name')
                  let state_name = localGetItem('state_name')
                  let List = State.getAllStates()?.find(item => item?.name?.toLowerCase() === state_name?.toLowerCase())
                  let stateList = State.getStatesOfCountry(List?.countryCode)
                  let cityList = City.getCitiesOfState(List?.countryCode, List?.isoCode)
                  this.setState({ city: city_name, state_code: List?.isoCode, AllStates: stateList, cityName: cityList })
                 }
              })
            }}
          // sx={{ backgroundColor: Colors.DataTblHeaderbg }}
          >
            <Tab value="appointment_request" label="Appointment Req" className='eMed_tab_header' />
            <Tab value="create_request" label="Create Tele Req" className='eMed_tab_header' />
          </Tabs>
          <Box>
            {
              this.state.SelectedRequestTab === "appointment_request" ?
                <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} alignItems={'center'}>
                  <TextField
                    placeholder={t("Patient Name")}
                    onChange={(e) => {
                      let validate = CommonValidation.alphabetOnly(e.target.value)
                      validate &&
                        this.setState({ patientSearch: e.target.value }, () => {
                          this.handlePatientSearch()
                        })
                    }}
                    value={this.state.patientSearch}
                    size="small"
                    sx={{ width: "10vw" }}
                    onKeyDown={(e) => { e.stopPropagation() }}
                    autoComplete='off'
                    inputProps={{ emed_tid: 'ApptReq_PatientSearch' }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {this.state.patientSearch.length ?
                            <IconButton onClick={this.handlePatientSearchClose} emed_tid='ApptReq_PatientSearch_ClearBtn'>
                              <CloseIcon fontSize='small' />
                            </IconButton>
                            : null}
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div style={{ padding: "0.5vw" }}>
                    <Autocomplete
                      size='small'
                      // clearIcon={false}
                      sx={{ width: '10vw' }}
                      options={this.state.doctorList}
                      getOptionLabel={(item) => (item.doctor_name)}
                      value={this.state.App_DocID}
                      onChange={(event, newValue) => {
                        states['App_DocID'] = newValue
                        this.setState({ states }, () => { this.getAppointRequests() })
                      }}
                      onKeyDown={(e) => e.stopPropagation()}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={'Select Doctor'}
                          placeholder={'Select Doctor'}
                        // onKeyDown={(e) => { e.stopPropagation() }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props} key={option?.doctor_id}>
                          {option?.doctor_name}
                        </li>
                      )}
                    />
                  </div>
                  <div style={{ padding: "0.5vw" }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        open={this.state.DatePickerOpen}
                        onOpen={() => { this.setState({ DatePickerOpen: true }) }}
                        onClose={() => { this.setState({ DatePickerOpen: false }) }}
                        value={this.state.datePicker}
                        name={"datePicker"}
                        inputFormat='DD-MM-YYYY'
                        views={["year", "month", "day"]}
                        onChange={
                          (newDate) => {
                            this.setState({
                              datePicker: newDate
                            }, () => {
                              this.getAppointRequests()
                            });
                          }}
                        renderInput={(params) => <TextField
                          onKeyDown={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }} style={{ width: '10vw' }} size='small' {...params} onClick={() => { this.setState({ DatePickerOpen: true }) }} />}
                      />
                    </LocalizationProvider>
                  </div>
                  <Tooltip title={"Print"} placement='top' arrow>
                    <IconButton size="small" disabled={this.state.FoRequestList.length ? false : true} onClick={() => this.getAppointRequestsPrint()}>
                      <img
                        className='eMed_action_img'
                        src={ImagePaths.LabPrintIcon.default}
                        alt="print"
                      />
                    </IconButton>
                  </Tooltip>
                </Box> : null}
          </Box>
        </Box>
        {
          this.state.SelectedRequestTab === "appointment_request" ?
            this.renderAppointmentReqTbl(this.state.FoRequestList, "request", '48.4vh', '62vw')
            :
            <CreateTeleRequest
             state={this.state}
             history={this.props.history}
              isEditable={true}
              onClear={this.handleSearchClear.bind(this)}
              FOPatientSearch={this.FOPatientSearch.bind(this)}
              getDoctorsList={this.getDoctorsList.bind(this)}
              // getPincodeToCity={this.getPincodeToCity.bind(this)}
              handleAgeCalculation={this.handleAgeCalculation.bind(this)}
              handleFindApproxDob={this.handleFindApproxDob.bind(this)}
              ClearRequestData={this.ClearRequestData.bind(this)}
              getAppointRequests={this.getAppointRequests.bind(this)}
              AppointMobileSrch={this.AppointMobileSrch.bind(this)}
              isPatientisSearching={this.isPatientisSearching.bind(this)}
              errorMessage={this.errorMessage.bind(this)}
              t={t}
            />
            // <Box className="eMEd_CreateRequest_Box" height={"53.2vh"} sx={{ width: '60vw' }}>
            //   <Grid container className='eMed_IPappoint_Grid_row'>
            //     <Grid item xs={4} paddingTop={"1vw"}>
            //       <TextField
            //         sx={{ width: '14vw', position: "relative" }}
            //         size='small'
            //         inputProps={{ maxLength: 15 }}
            //         label={Object.keys(this.state.SelectedRequestPatient).length > 0 ? "Mobile Number *" : "Mobile / UHID *"}
            //         value={this.state.RequestMobileNumber}
            //         InputProps={{
            //           endAdornment: this.state.isappointRequest ?
            //             <InputAdornment position="end"><CircularProgress size={15} /></InputAdornment>
            //             : null,
            //         }}
            //         onChange={(e) => {
            //           let number = CommonValidation.numberOnly(e.target.value);
            //           this.setState({ RequestMobileNumber: e.target.value, }, () => {
            //             if (Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId) {
            //               this.setState({
            //                 SelectedRequestPatient: {},
            //                 RequestPatientName: "",
            //                 RequestPatientAge: "",
            //                 editPatientId: null,
            //                 RequestPatientListAnchor: null,
            //                 RequestPatientDOB: null,
            //                 RequestPatientGender: "",
            //               })
            //             }
            //             if (number && this.state.RequestMobileNumber.length >= 10) {
            //               this.setState({}, () => { this.FOPatientSearch(true, this.state.RequestMobileNumber) })
            //             }
            //           })
            //         }}
            //         onKeyDown={(e) => {
            //           e.stopPropagation()
            //           if (this.state.RequestPatientListAnchor) {
            //             if (this.state.RequestMobileNumber.length > 5 && e.key === "Enter") {
            //               this.setState({}, () => { this.FOPatientSearch(true, this.state.RequestMobileNumber) })
            //             }
            //             if (this.state.RequestMobileNumber.length <= 5 && e.key === "Enter") {
            //               this.errorMessage("Enter atleast 6 Characters for search")
            //             }
            //           } else {
            //             this.setState({
            //               RequestPatientListAnchor: e.currentTarget
            //             }, () => {
            //               if (this.state.RequestMobileNumber.length > 5 && e.key === "Enter") {
            //                 this.setState({}, () => { this.FOPatientSearch(true, this.state.RequestMobileNumber) })
            //               }
            //               if (this.state.RequestMobileNumber.length <= 5 && e.key === "Enter") {
            //                 this.errorMessage("Enter atleast 6 Characters for search")
            //               }
            //             })
            //           }
            //         }}
            //       />
            //       <Menu
            //         open={this.state.RequestPatientMenuPop}
            //         anchorEl={this.state.RequestPatientListAnchor}
            //         // sx={{ position: 'absolute', top: '4vw', left: "-9.3vw" }}
            //         className="eMed_Header_CreateRequest_Pop"
            //         onClose={() => {
            //           this.setState({ RequestPatientMenuPop: false, RequestPatientListAnchor : null,SearchedRequestPatientList : []  })
            //         }}
            //       >
            //         <Typography className='eMed_Request_sugg_Head'>Patient Name | UHID</Typography>
            //         {
            //           this.state.SearchedRequestPatientList.length > 0 ? this.state.SearchedRequestPatientList.map((item, index) => {
            //             let PatientFullName = `${(item?.first_name ? item?.first_name : "")} ${(item?.last_name ? item?.last_name : "")}`
            //             return(
            //               <MenuItem key={index} onClick={() => {
            //                 this.setState({
            //                   SelectedRequestPatient: item,
            //                   RequestPatientMenuPop: false,
            //                   RequestMobileNumber: item?.mobile_number,
            //                   RequestPatientName: item?.first_name ? item?.first_name + " " + item?.last_name : "-",
            //                   RequestPatientAge: item?.patient_age ? (typeof item?.patient_age === "string" ? item?.patient_age?.includes("Y") ? item?.patient_age?.replace('Y', '') : item?.patient_age : item?.patient_age) : CalculateAgeFromDob(item.dob !== null ? new Date(item?.dob) : new Date(item?.approx_dob)),
            //                   address_1 :item?.address_line_1 ? item?.address_line_1 : "",
            //                   address_2 :item?.address_line_2 ? item?.address_line_2 : "",
            //                   city: item?.city_name ? item?.city_name : "",
            //                   state_code: item?.state_name ? State.getStatesOfCountry(this.state.AllCountry?.find((list) => (list.name === item?.country))?.isoCode)?.find((list) => (list.name === item?.state_name))?.isoCode : "",
            //                   country_code: item?.country ? this.state.AllCountry?.find((list) => (list.name === item?.country))?.isoCode : "",
            //                   pin_code: item?.pincode ? item?.pincode : "",
            //                   RequestPatientDOB: item?.patient_age ? this.handleFindApproxDob(typeof item?.patient_age === "string" ? item?.patient_age?.includes("Y") ? item?.patient_age?.replace('Y', '') : item?.patient_age : item?.patient_age) : null,
            //                   RequestPatientGender: item?.patient_gender ? ((item?.patient_gender === "M" || item?.patient_gender === "m" || item?.patient_gender === "Male") ? "m" : (item?.patient_gender === "F" || item?.patient_gender === "f" || item?.patient_gender === "Female") ? "f" : (item?.patient_gender === "T" || item?.patient_gender === "t" || item?.patient_gender === "Trans") ? "t" : "") : "",
            //                 })
            //               }}
            //                 sx={{ width: '14vw' }}>
            //                 <Box sx={{ display: 'flex', alignItems: 'center', width: '14vw' }}>
            //                   {(PatientFullName?.length > 15) ? <Tooltip title={PatientFullName} placement='top' arrow><div>
            //                     <Typography fontWeight={600} fontSize={"0.8vw"} paddingRight={"0.3vw"}>{(PatientFullName?.length > 12 ? PatientFullName?.slice(0, 10) + ("...") : PatientFullName)}</Typography></div>
            //                   </Tooltip> : <Typography fontWeight={600} fontSize={"0.8vw"} paddingRight={"0.3vw"}>{PatientFullName}</Typography>} | {item?.patient_account_number?.length > 10 ? <Tooltip title={item?.patient_account_number} placement='top' arrow><div>
            //                     <Typography paddingX={"0.3vw"} fontSize={"0.8vw"}>{("..." + item?.patient_account_number?.slice(-8))}</Typography></div>
            //                   </Tooltip> : <Typography paddingX={"0.3vw"} fontSize={"0.8vw"}>{item?.patient_account_number}</Typography>}
            //                 </Box>
            //               </MenuItem>
            //             )
            //           }) : null
            //         }
            //       </Menu>
            //     </Grid>
            //     <Grid item xs={4} paddingTop={"1vw"} >
            //       <TextField
            //         sx={{ width: '14vw' }}
            //         inputProps={{ maxLength: 32 }}
            //         disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
            //         label="Patient Name *"
            //         value={this.state.RequestPatientName}
            //         onChange={(e) => {
            //           var isAlpha = CommonValidation.alphabetOnly(e.target.value)
            //           if ((isAlpha || e.target.value == "") && ( e.target.value?.length <= 100)) {
            //             this.setState({ RequestPatientName: e.target.value })
            //           }
            //         }}
            //         size='small'
            //         onKeyDown={(e) => { e.stopPropagation() }}
            //       />
            //     </Grid>
            //     <Grid item xs={4} paddingTop={"1vw"}>
            //       <TextField
            //         sx={{ width: '14vw' }}
            //         inputProps={{ maxLength: 3 }}
            //         disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
            //         label="Patient Age"
            //         value={this.state.RequestPatientAge}
            //         onChange={(e) => {
            //           let number = CommonValidation.numberOnly(e.target.value);
            //           if ((e.target.value < 150) && (number || e.target.value === "")) {
            //             this.setState({ RequestPatientAge: e.target.value }, () => {
            //               var approxDob = this.handleFindApproxDob(e.target.value);
            //               this.setState({
            //                 RequestPatientDOB: approxDob
            //               })
            //             })
            //           }
            //         }}
            //         size='small'
            //         onKeyDown={(e) => { e.stopPropagation() }}
            //       />
            //     </Grid>
            //   </Grid>
            //   <Grid container className='eMed_IPappoint_Grid_row' marginTop={"2vw"}>
            //     <Grid item xs={4}>
            //       <FormControl size='small'>
            //         <InputLabel id="gender-select-label">{"Gender"}</InputLabel>
            //         <Select
            //           sx={{ width: '14vw' }}
            //           labelId='gender-select-label'
            //           size='small'
            //           label="Gender *"
            //           value={this.state.RequestPatientGender}
            //           onChange={(e) => {
            //             states["RequestPatientGender"] = e.target.value
            //             this.setState({
            //               states
            //             })
            //           }}
            //         >
            //           <MenuItem key={1} value={"m"}>{t("Male")}</MenuItem>
            //           <MenuItem key={2} value={"f"}>{t("Female")}</MenuItem>
            //           <MenuItem key={2} value={"t"}>{t("TransGender")}</MenuItem>
            //         </Select>
            //       </FormControl>
            //     </Grid>
            //     <Grid item xs={4}>
            //       <LocalizationProvider dateAdapter={AdapterDateFns}>
            //         <DatePicker
            //           sx={{ width: '33vw' }}
            //           size='small'
            //           label="Date of Birth"
            //           inputFormat={"dd-MM-yyyy"}
            //           autoComplete="off"
            //           value={this.state.RequestPatientDOB}
            //           minDate={new Date("1872-01-01")}
            //           maxDate={DateTime.now()}
            //           onChange={(newDate) => {
            //             var age = this.handleAgeCalculation(newDate)
            //             this.setState({
            //               RequestPatientDOB: newDate,
            //               RequestPatientAge: age
            //             })
            //           }}
            //           renderInput={(params) => <TextField sx={{ width: '31vw' }}  {...params} size='small' autoComplete="off"
            //             variant="outlined" fullWidth />}
            //         />
            //       </LocalizationProvider>
            //     </Grid>
            //   </Grid>
            //   <Grid container className='eMed_IPappoint_Grid_row' marginTop={"1vw"}>
            //     <Grid item xs={4}>
            //       {this.renderDropdown("Doctor", "0vw", this.state.filteredDocList.length > 0 ? this.state.filteredDocList : this.state.doctorList, "RequestSelectedDocID")}
            //     </Grid>
            //     <Grid item xs={4}>
            //       {this.renderDropdown("Specialization", "0vw", this.state.spcInfo, "RequestSelectedSpecID")}
            //     </Grid>
            //     <Grid item xs={4} >
            //       <Box sx={{ width: '93%', mt: '1vw' }}>
            //         <LocalizationProvider dateAdapter={AdapterDateFns}>
            //           <DateTimePicker
            //             open={this.state.DateOpen}
            //             onOpen={() => { this.setState({ DateOpen: true }) }}
            //             onClose={() => { this.setState({ DateOpen: false }) }}
            //             inputFormat='dd-MM-yyyy & hh:mm a'
            //             value={this.state.RequestAppointDatetym}
            //             disabled={this.state.editPatientId}
            //             minDate={new Date()}
            //             maxDate={new Date((new Date).getFullYear(), (new Date).getMonth() + 3, 0)}
            //             onChange={(newDate) => {
            //               if (newDate === null) {
            //                 this.setState({ RequestAppointDatetym: new Date() })
            //               }
            //               else {
            //                 this.setState({ RequestAppointDatetym: newDate }, () => this.getDoctorsList(true))
            //               }
            //             }}
            //             renderInput={(params) => <TextField
            //               sx={{ width: '14vw' }}
            //               size='small'
            //               inputProps={{ style: { fontSize: '0.8vw' } }}
            //               onKeyDown={(e) => {
            //                 e.preventDefault()
            //                 e.stopPropagation()
            //               }}
            //               disabled={this.state.editPatientId}
            //               onClick={() => { this.setState({ DateOpen: true }) }}
            //               {...params}
            //               fullWidth
            //               variant='outlined'
            //               label="Appointment Date & Time *"
            //             />}
            //           />
            //         </LocalizationProvider>

            //       </Box>
            //     </Grid>
            //   </Grid>
            //   <Grid container className='eMed_IPappoint_Grid_row' marginTop={"2vw"}>
            //     <Grid item xs={4}>
            //       {
            //         <TextField
            //           sx={{ width: "14vw" }}
            //           size="small"
            //           inputProps={{ maxLength: 100, autoComplete: "new-password" }}
            //           autoComplete="off"
            //           disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
            //           label={t("Address 01")}
            //           value={this.state.address_1}
            //           onChange={(e) => {
            //             this.setState({ address_1: e.target.value })
            //           }}
            //           onKeyDown={(e) => {
            //             e.stopPropagation()}}
            //           name="random-address-field" 
            //         />
            //       }
            //     </Grid>
            //     <Grid item xs={4}>
            //       {
            //         <TextField
            //           sx={{ width: "14vw" }}
            //           size="small"
            //           inputProps={{ maxLength: 100 , autoComplete: "new-password"}}
            //           disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
            //           autoComplete='off'
            //           label={t("Address 02")}
            //           value={this.state.address_2}
            //           onChange={(e) => {
            //             this.setState({ address_2: e.target.value })
            //           }}
            //           onKeyDown={(e) => {
            //             e.stopPropagation()}}
            //             name="random-address-field" 
            //         />
            //       }
            //     </Grid>
            //     <Grid item xs={4} >
            //       <Autocomplete
            //         sx={{ width: "14vw" }}
            //         size="small"
            //         options={states.cityName ? states.cityName : []}
            //         getOptionLabel={(option) => typeof (option) === "string" ? option : option.name}
            //         disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
            //         onChange={(e, value) => {
            //           this.setState({
            //             city: value?.name ? value?.name : '',
            //             // pin_code: '',
            //           })
            //         }}
            //         clearIcon={false}
            //         value={states.city}
            //         renderInput={(params) => (
            //           <TextField
            //             label={"City"}
            //             autoComplete='off'
            //             InputProps={{ ...params.InputProps }}
            //             onChange={(e) => this.setState({
            //               city: e.target.value,
            //               // pin_code: ''
            //             })}  
            //          {...params}
            //           />)}
            //         onKeyDown={(e) => e.key === "Enter" ? e.preventDefault() : null}
            //       />
            //     </Grid>
            //   </Grid>
            //   <Grid container className='eMed_IPappoint_Grid_row' marginTop={"2vw"}>
            //     <Grid item xs={4}>
            //       <FormControl size='small' sx={{ width: '12vw' }}>
            //         <InputLabel id="title-select-label">{"Select State"}</InputLabel>
            //         <Select
            //            sx={{ width: '14vw' }}
            //           MenuProps={{ style: { maxHeight: 250, maxWidth: '12vw' } }}
            //           labelId='gender-select-label'
            //           disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
            //           size='small'
            //           label={"Select State"}
            //           value={states.state_code}
            //           onChange={(e) => {
            //             this.setState({ state_code: e.target.value },
            //               () => {
            //                 this.setState({ cityName: City.getCitiesOfState(this.state.country_code, this.state.state_code), city: '' })
            //               })
            //           }}
            //         >
            //           {
            //             states.AllStates.map((list) => (
            //               <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
            //             ))
            //           }
            //         </Select>
            //       </FormControl>
            //     </Grid>
            //     <Grid item xs={4}>
            //       <FormControl size='small' sx={{ width: '12vw', maxWidth: '12vw' }}>
            //         <InputLabel id="title-select-label">{"Select Country"}</InputLabel>
            //         <Select
            //           // disabled={this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)}
            //           sx={{ width: '14vw' }}
            //           MenuProps={{ style: { maxHeight: 250, maxWidth: '12vw' } }}
            //           labelId='gender-select-label'
            //           disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
            //           label={"Select Country"}
            //           size='small'
            //           value={states.country_code}
            //           onChange={(e) => {
            //             this.setState({ country_code: e.target.value, state_code: "", city: '' }, () => {
            //               this.setState({ AllStates: State.getStatesOfCountry(this.state.country_code), cityName: '' })
            //             })
            //           }}
            //         >
            //           {
            //             states.AllCountry.map((list) => (
            //               <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
            //             ))
            //           }
            //         </Select>
            //       </FormControl>
            //     </Grid>
            //     <Grid item xs={4} >
            //       <TextField
            //       sx={{ width: '14vw' }}
            //         // disabled={((data.label === "First Name") ? Object.keys(this.state.RequestedPatientData).length > 0 : false) || (this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess))}
            //          autoComplete='off'
            //         inputProps={{ maxLength: 6 , autoComplete: "new-password"}}
            //         label={"Pincode"}
            //         disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
            //         variant="outlined"
            //         value={this.state.pin_code}
            //         onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
            //         onChange={(e) => {
            //           if ((CommonValidation.numberOnly(e.target.value) || e.target.value == "") && e.target.value?.length <= 6) {
            //             this.state.pin_code = e.target.value
            //             this.setState({
            //               states
            //             }, () => {
            //               if (this.state.pin_code && this.state.pin_code?.length === 6) {
            //                 this.getPincodeToCity(this.state.pin_code)
            //               }
            //             })
            //           }
            //         }}
            //         size="small"
            //         name="random-address-field"
            //       />
            //     </Grid>
            //   </Grid>
            //   <Autocomplete
            //     inputProps={{ maxLength: 250 }}
            //     options={this.state.POVList}
            //     getOptionLabel={(options) => options}
            //     onChange={(e, value) => {
            //       this.setState({
            //         RequestpurposeOfVisit: value
            //       })
            //     }}
            //     onKeyDown={(e) => { e.stopPropagation() }}
            //     clearIcon={false}
            //     size='small'
            //     sx={{ width: '44vw', paddingLeft: '2vw', mt: "2vw" }}
            //     value={this.state.RequestpurposeOfVisit}
            //     renderInput={(params) => <TextField sx={{ width: "48vw" }} onChange={(event) => {
            //       this.setState({
            //         RequestpurposeOfVisit: event.target.value
            //       })
            //     }}
            //       {...params}
            //       placeholder="Purpose Of Visit"
            //     />}
            //   />
            //   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            //     <Typography marginLeft={"2vw"}>{Object.keys(this.state.SelectedRequestPatient).length > 0 ? `UHID : ${this.state.SelectedRequestPatient?.patient_account_number}` : ""}</Typography>
            //     <Box className="eMed_CreateRequest_BtnBox">
            //       <Button size='small' id="eMed_Config_btn" sx={{ marginRight: '1vw' }} onClick={() => { this.ClearRequestData() }} variant='outlined'>Clear</Button>
            //       <Button size='small' id="eMed_Config_btn" disabled={this.state.isClked} variant='contained' onClick={() => this.setState({ isClked: true }, () => this.CreateAppointRequest())}>{this.state.editAppointmentId ? "Update Request" : "Create Request"}</Button>
            //     </Box>
            //   </Box>
            // </Box>
        }
      </Menu>
    )
  }

  renderNotifyTbl = (title, data = [], coulmns = []) => {
    const rows = data?.length > 0 ? data?.map((item, index) => ({...item, sno: index+1})) : [];
    return (
      <Box width="100%" height="100%">
        {title && (
          <>
            <Typography fontWeight={600} fontSize="0.95vw">
              {title}
            </Typography>
            <hr />
          </>
        )}

        <Box sx={{ height: "calc(80vh - 8rem)" }}>
          <DataGrid
            columns={coulmns}
            rows={rows}
            getRowId={(row) => row['sno']}
            page={this.state.transPage}
            pageSize={this.state.transPageSize}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarExportPrint: ""
            }}
            components={{
              NoRowsOverlay: () => (
                <Box sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  {'No Records To Be Shown'}
                </Box>
              )
            }}
            onPageChange={(newPage) => { this.setState({ transPage: newPage }) }}
            onPageSizeChange={(newPageSize) => this.setState({ transPageSize: newPageSize })}
            rowsPerPageOptions={[10, 20, 30]}
            pagination
            headerHeight={40}
            disableSelectionOnClick
            loading={this.state.isNotifyLoader}
          />
        </Box>
      </Box>
    )
  }

  renderOutsourceNotifyTbl = (title = "", data) => {
    const rows = data?.length > 0 ? data?.map((item, index) => ({...item, sno: index+1})) : [];
    const columns = [
      {
        field: "patient_details",
        headerName: "Patient Details",
        flex: 0.35,
        renderCell: ({row}) => <CommonPatientDetails data={row} />,
      },
      {
        field: "patient_type",
        headerName: "Patient Type",
        flex: 0.20,
        renderCell: ({row}) => (<Typography fontSize="0.90vw"> {row.patient_type || "-"}</Typography>),
      },
      {
        field: "lab_transit",
        headerName: "Lab Transit Details",
        flex: 0.25,
        renderCell: ({row}) => (
          <Box display="flex" flexDirection="column">
            {ContentInTooltip(row?.outsource_lab || "-", 25, "0.80vw", 50)}
            {ContentInTooltip(row?.outsourse_contact_person || "-", 25, "0.80vw", 50)}
            {ContentInTooltip(row?.contact_person_mobile_no || "-", 25, "0.80vw", 50)}
          </Box>
        ),
      },
      {
        field: "outsource_due_date",
        headerName: "Outsource Due Date",
        flex: 0.20, headerAlign: "center", align: "center",
        renderCell: ({row}) => (<Typography fontSize="0.90vw"> {row.outsource_due_date || "-"} </Typography>),
      },
    ];
    return (this.renderNotifyTbl(title, rows, columns))
  }

  renderCreditFollowUp = (title = "", data = []) => {

    const columns = [
      {
        field: "patient_details",
        headerName: "Patient Details",
        flex: 0.30,
        renderCell: ({row}) => <CommonPatientDetails data={row} />,
      },
      {
        field: "patient_type",
        headerName: "Patient Type",
        flex: 0.10,
        renderCell: ({row}) => (<Typography fontSize="0.90vw"> {row.patient_type || "-"}</Typography>),
      },
      {
        field: "bill_amount",
        headerName: "Bill Amount",
        flex: 0.20, headerAlign: "center", align: "center",
        renderCell: ({row}) => (<Typography fontSize="0.90vw">{AmountFormat(row?.bill_amount)}</Typography>)
      },
      {
        field: "due_date",
        headerName: "Follow-Up Date",
        flex: 0.20, headerAlign: "center", align: "center",
        renderCell: ({row}) => (<Typography fontSize="0.90vw">{row?.due_date || "-"}</Typography>)
      },
      {
        field: "pending_amount",
        headerName: "Pending Amount",
        flex: 0.20, headerAlign: "center", align: "center",
        renderCell: ({row}) => (<Typography fontSize="0.90vw"> {AmountFormat(row.pending_amount)} </Typography>),
      },
    ];
    return (this.renderNotifyTbl(title, data, columns))
  }

  renderQMSNotify = (data) => {
    return (
      <Box width="100%" height="100%">{
        this.state.isNotifyLoader ? (
          <Box sx={{ width: "100%", height: "calc(80vh - 8rem)", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress size={24} />
          </Box>
        ) : data?.length > 0 ? data?.map((item) => {
          let DateTime = item?.reason_type === "In Permission" ? `${item?.session_date} (${item?.from_time} - ${item?.to_time})` : `(${item?.from_date} - ${item?.to_date})`
          return (
            <Box key={item.id} sx={{ display: 'flex', alignItems: 'center', gap: '1vw', borderBottom: '1px solid black', padding: '1vw' }}>
              <Box><img src={ImagePaths.NotiTick.default} alt='tick' style={{ height: '2vw', width: '2vw' }} /></Box>
              <Box>
                <Typography fontWeight={'600'}>{item?.doctor_name ? item?.doctor_name : ''} - {item?.reason_type ? item?.reason_type : ''}</Typography>
                <Typography fontWeight={'600'}>{item?.reason_type === "Out For Emergency" ? "" : `${DateTime}`}</Typography>
                <Typography>{item?.reason ? item?.reason?.length > 32 ? <Tooltip placement="top" title={item.reason} arrow><div>{item.reason?.slice(0, 30) + '...'}</div></Tooltip> : item?.reason : ''}</Typography>
              </Box>
            </Box>)
        }) :
          <Box sx={{ width: "100%", height: "calc(80vh - 8rem)", display: "flex", justifyContent: "center", alignItems: "center" }}>
            {'No Records To Be Shown'}
          </Box>}
      </Box>)
  }

  NotificationPopup = () => {
    const isNewBilling = localGetItem('isNewBilling') ? JSON.parse(localGetItem('isNewBilling')) : false
    const is_credit_followup = localGetItem('set_due_date_for_credit_billing') ? JSON.parse(localGetItem('set_due_date_for_credit_billing')) : false;
    const { FoNotifyList } = this.state;
    return (
      <Modal open={this.state.notifyPopup} onClose={() => { this.setState({ notifyPopup: false }) }}>
        <Paper sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          outline: "none",
          height: "80vh", width: "55vw", padding: '0.5vw', overflow: 'hidden'
        }}>
          <Box display={'flex'} justifyContent={'space-between'}>
            <Typography fontWeight={'600'}>Notification</Typography>
            <IconButton onClick={() => { this.setState({ notifyPopup: false }) }} size="small" ><img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt={"close"} /></IconButton>
          </Box>
          <hr />
          <Box sx={{ height: "calc(80vh - 4rem)", padding: "0.5vw" }}>
            {
              isNewBilling ? (
                this.state.selectedPageName === "MainHome" ?
                  (<Box>
                    <Tabs value={this.state.notifyTabIndex} onChange={(event, newValue) => {
                      this.setState({ notifyTabIndex: newValue });
                    }}>
                      <Tab value = "0" label="Outsource Due" className='eMed_tab_header'/>
                      {is_credit_followup && <Tab value = "1" label="Credit Follow Up" className='eMed_tab_header'/>}
                    </Tabs>
                    {
                      this.state.notifyTabIndex === "0" ?
                        this.renderOutsourceNotifyTbl("", FoNotifyList?.outsource_test_due || [])
                        : this.renderCreditFollowUp("", FoNotifyList?.credit_due || [])
                    }
                  </Box>)
                  : window.location.pathname === "/OPHome" ? (<Box>
                    <Tabs value={this.state.notifyTabIndex} onChange={(event, newValue) => {
                      this.setState({ notifyTabIndex: newValue });
                    }}>
                      <Tab value = "0" label="QMS Notification" className='eMed_tab_header'/>
                      {is_credit_followup && <Tab value = "1" label="Credit Follow Up" className='eMed_tab_header'/>}
                    </Tabs>
                    {
                      this.state.notifyTabIndex === "0" ?
                        this.renderQMSNotify(FoNotifyList?.doctor_info || [])
                        : this.renderCreditFollowUp("", FoNotifyList?.credit_due || [])
                    }
                  </Box>)
                    : (this.renderCreditFollowUp("Credit Follow Up", window.location.pathname === "/IPHome" ?  FoNotifyList?.credit_due || [] : FoNotifyList || []))
              ) : (
                this.state.selectedPageName === "MainHome" ? (this.renderOutsourceNotifyTbl("Outsource Due", FoNotifyList || []))
                  : window.location.pathname === "/OPHome" ? this.renderQMSNotify(FoNotifyList)
                    : null
              )
            }
          </Box>
        </Paper>
      </Modal>
    )
  }

  //Doctor Module Header Search

  getDoctorClinicData = (isOpthometry = false) => {
    try {
      RestAPIService.getAll(isOpthometry ? Serviceurls.DOC_OPTHOMETRY_CLINIC_LIST_GET : Serviceurls.DOC_CLINIC_LIST_GET)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              ClinicList: response.data.data
            }, () => {
              if (!localGetItem('SelectedDoctorClinicId') && !getCachevalue('SelectedDoctorClinic')) {
                this.setState({
                  SelectedDoctorClinic: isOpthometry ? (this.state.SelectedDoctorClinic === "all" ? "all" : response?.data?.data[0]?.doctor_id) : response?.data?.data[0]?.clinic_id
                }, () => {
                  let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
                  localSetItem('SelectedDoctorClinicId', this.state.SelectedDoctorClinic)
                  if(!UserData?.clinic_staff){
                    setCachevalue(this.state.SelectedDoctorClinic === 'all' ? UserData?.clinic_id : this.state.SelectedDoctorClinic, "SelectedDoctorClinic")
                  }
                  if (localGetItem("enable_other_doctor_list") === 'true' && window.location.pathname === "/DoctorHome") {
                    this.fetchMultiDoctorOption(response?.data?.data[0]?.clinic_id)
                  }
                  if (isOpthometry) {

                  } else {
                    this.getDoctorAppointmentList()
                    this.getFollowUpData()
                    if (localGetItem("PurposeOfVisit") === null) {
                      this.getPurposeOfVisitList()
                    }
                  }
                })
              } else if (!isOpthometry) {
                if (localGetItem("enable_other_doctor_list") === 'true' && window.location.pathname === "/DoctorHome") {
                  this.fetchMultiDoctorOption(response?.data?.data[0]?.clinic_id)
                }
                this.getDoctorAppointmentList()
                this.getFollowUpData()
                if (localGetItem("PurposeOfVisit") === null) {
                  this.getPurposeOfVisitList()
                }
              }

            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getTransferAppointmentData = () => {
    try {
      let startdate = new Date()
      let date = DateTime.fromJSDate(startdate).toFormat('yyyy-MM-dd')
      RestAPIService.getAll(Serviceurls.DOC_TRANSFER_REQUEST + '?appointment_date=' + date)
        .then((response) => {
          if (response.data.status === 'success') {
            let dataList = response.data.data
            dataList?.forEach(element => {
                let gender = element?.gender === 'm' ? 'M' : element.gender === 'f' ? 'F' : 'T'
                element.patientDetails = `${element?.title} ${element?.first_name} ${element?.last_name} (${element.patient_age}/${gender})`
                element.patientUnidMob = `${element?.patient_account_number} | ${element?.patient_mobile}`
                element.doctorName = `${element.from_doctor__title} ${element?.from_doctor__first_name} ${element?.from_doctor__qualifications}`
                element.doctor_data = null
                element.specialization_data = null
            })
            this.setState({
              transferReqData: dataList?.filter(item => item?.doctor_id === this.state.loggedInuserInfo?.doctor_id || item.doctor_id === null)
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getFollowUpData = () => {
    let clinicId = localGetItem('SelectedDoctorClinicId')
    var date = new Date(this.state.follow_up_date)
    var appointment_date = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd')
    try {
      RestAPIService.getAll(Serviceurls.DOC_FOLLOWUP_GET + `?clinic_id=${clinicId ?? getClinicIdWithContext()}&follow_up_date=${appointment_date}&follow_up_to_date=${appointment_date}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              followUpData: response.data.data?.follow_up
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getDoctorRequestData = () => {
  let doctorId = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo"))?.doctor_id : null
  try {
    RestAPIService.getAll(Serviceurls.DOCTOR_REQUST_APPROVAL + `?doctor_id=${doctorId}`)
      .then((response) => {
        if (response.data.status === 'success') {
          this.setState({
            doctorRequestData: response?.data?.data  || []
          })
        }
      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          this.errorMessage(error.response.data.message)
        } else {
          this.errorMessage(error.message)
        }
      })
  } catch (error) {
    this.errorMessage(error.message)
  }
}

  handleAccept = (item) => {
    let itemID = item
  try {
    const data = { 
      status: "APPROVED",
      doctor_id: this.state.loggedInuserInfo?.doctor_id,
      request_id: itemID,
    };

    RestAPIService.updateWithOutId( data, Serviceurls.DOCTOR_REQUST_APPROVAL)
      .then((response) => {
        if (response?.data?.status === "success") {
          this.successMessage("Request accepted successfully.");
          this.getDoctorRequestData(); 
          this.setState({
            CallPatientTrigger: true,
            // DoctorRequestPopup: false,
          })
        }
      })
      .catch((error) => {
        this.errorMessage(error?.response?.data?.message );
      });
  } catch (error) {
    this.errorMessage(error?.response?.data?.message );
  }
};


  handleReject = (item) => {
    let itemID = item
    try {
      const data = { 
      status: "REJECTED",
      doctor_id: this.state.loggedInuserInfo?.doctor_id,
      request_id: itemID,
       };
      RestAPIService.updateWithOutId(data,Serviceurls.DOCTOR_REQUST_APPROVAL).
      then((response) => {
        if (response?.data?.status === "success") {
          this.successMessage("Request rejected successfully.");
          this.getDoctorRequestData(); 
          this.setState({
            CallPatientTrigger: true,
            // DoctorRequestPopup: false,
          })
        }
      }).catch((error) => {
        this.errorMessage(error?.response?.data?.message );
      })
    } catch (error) {
      this.errorMessage(error?.response?.data?.message );
    }
  };

//   closeDoctorRequestPopup = () => {
//   // this.setState({ doctorRequestData: [] });
//   this.setState({ showDoctorRequestPopup: false });
// };

  GetOTRoomList(item) {
    try {
      RestAPIService.getAll(Serviceurls.OT_ROOM_CONFIG + `?surgery_date=${(item?.surgery_date).split("T")[0]}`).
        then((response) => {
          if (response.data.status === "success") {
            let data = response.data.data
            this.setState({
              OTRoomData: data
            }, () => {
              this.setState({ OTallocationPopup: true })
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          if (error?.response?.data?.status === "fail") {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    }
    catch (error) {
      if (error?.response?.data?.status === "fail") {
        this.errorMessage(error.response.data.message)
      } else {
        this.errorMessage(error.message)
      }
    }
  }

  getotRequestList = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_OT_REQUEST_GET)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              OTreqData: response?.data?.data ? response?.data?.data : [],
              AcceptRequest: false
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getUnlockNotesData = () => {
    try {
      let clinicId = localGetItem('SelectedDoctorClinicId')
      if (clinicId) {
        RestAPIService.getAll(Serviceurls.DOC_UNLOCK_DOCTOR_NOTES + `?clinic_id=${clinicId}`)
          .then((response) => {
            if (response.data.status === 'success') {
              this.setState({
                unlockDocData: response.data.data,
                unlockDocDataCount: response.data?.total_count ? response.data?.total_count : 0
              })
            }
          }).catch((error) => {
            if (error?.response?.data?.message) {
              this.errorMessage(error.message)
            } else {
              this.errorMessage(error.message)
            }
          })
      }
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  ChangeLoginTokken = (DoctorId, FromMultiDoctor = false) => {
    try {
      var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
      var BranchId = localGetItem("BranchId") ? JSON.parse(localGetItem("BranchId")) : null
      let APiUrl = ""
      if (FromMultiDoctor) {
        APiUrl = Serviceurls.MODULES_DATA_GET + `?linked_modules=${DoctorId?.module_name === "optometrist" ? "Optometry" : DoctorId?.module_name === "counsellor" ? "counsellor" :  "Doctor"}` + "&id=" + (DoctorId?.module_name === "optometrist" ? DoctorId?.optometrist_id : DoctorId?.module_name === "counsellor" ? DoctorId?.counsellor_id :  DoctorId?.doctor_id) + "&clinic_id=" + null + "&branch_id=" + BranchId + "&doctor_id=" + (DoctorId?.module_name === "doctor" ? DoctorId?.doctor_id : "")
      } else {
        APiUrl = Serviceurls.MODULES_DATA_GET + "?linked_modules=JMO" + "&id=" + myUser?.clinic_staff_id + "&clinic_id=" + null + "&branch_id=" + BranchId + "&doctor_id=" + DoctorId
      }
      RestAPIService.LoginAuthGetModules(APiUrl)
        .then((response) => {
            if (response.data.status === 'success') {
              localSetItem("AccessToken", response.data.data.token);
              if (FromMultiDoctor) {
                var loginUser = structuredClone(myUser);
                loginUser.module_name = response.data.data?.module_name
                if (DoctorId?.module_name === "doctor") {
                  loginUser.service_type = DoctorId?.service_type
                  localSetItem("loggedInUserInfo", JSON.stringify(loginUser))
                  this.setState({
                    CallPatientTrigger: true,
                    SelectedDoctorClinic: localGetItem('SelectedDoctorClinicId') ? localGetItem('SelectedDoctorClinicId') : this.state.SelectedDoctorClinic
                  })
                } else if (DoctorId?.module_name === "optometrist") {
                  loginUser.service_type = response?.data?.data?.service_type
                  loginUser.clinic_id = response?.data?.data?.clinic_id
                  localSetItem("loggedInUserInfo", JSON.stringify(loginUser))
                  this.setState({
                    SelectedDoctorClinic: "all",
                    CallPatientTrigger: true,
                  })
                } else if (DoctorId?.module_name === "counsellor") {
                  loginUser.service_type = response?.data?.data?.service_type
                  loginUser.clinic_id = response?.data?.data?.clinic_id
                }
                localSetItem("loggedInUserInfo", JSON.stringify(loginUser))
                setTimeout(()=>{ this.setState({ CallPatientTrigger : false })}, 1500)
              } else {
                localSetItem('SelectedDoctorClinicId', response.data.data.clinic_id)
                setCachevalue(this.state.SelectedDoctorClinic === 'all' ? myUser?.clinic_id : DoctorId, "SelectedDoctorClinic")
              }
              if (localGetItem("enable_other_doctor_list") === 'true' && window.location.pathname === "/DoctorHome") {
                this.fetchMultiDoctorOption(response.data.data.clinic_id)
              }if(FromMultiDoctor && DoctorId?.module_name === "counsellor" ){
              this.props.history.push({ pathname: "/Counsellor" });
              }else{
              this.props.history.push({ pathname: ( window.location.pathname === "/IPDoctorHome" ? "/IPDoctorHome" : "/DoctorHome"), state: { SelectedDoctorClinic: DoctorId } })
              }}
          }).catch((error) => {
            if (error?.response?.data?.message) {
              this.errorMessage(error.message)
            } else {
              this.errorMessage(error.message)
            }
          })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  DoctorPatientSearch(DocRequest = false, MobNum = null) {
    try {
      let { t } = this.props;
      let API_URL = ''
      if (DocRequest) {
        API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${MobNum}&address_key=&father_husband_key=&clinic_id=${this.state.SelectedDoctorClinic}&address=true`
        this.AppointMobileSrch(true);
      } else if (this.state.isOptometry) {
        API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${this.state.PatientNameSearchKey}&address_key=${this.state.PatientAddressKey}&father_husband_key=${this.state.PatientFathHusKey}&clinic_id=${this.state.loggedInuserInfo?.clinic_id}&mother_name_key=${this.state.PatientMotherKey}`
      } else {
        var DobDate = new Date(this.state.FilterDob)
        var date = this.state.FilterDob ? DateTime.fromJSDate(DobDate).toFormat('yyyy-MM-dd') : ""
        API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${this.state.PatientNameSearchKey}&address_key=${this.state.PatientAddressKey}&father_husband_key=${this.state.PatientFathHusKey}&clinic_id=${this.state.SelectedDoctorClinic}&mother_name_key=${this.state.PatientMotherKey}&uhid=${this.state.FilterUHID}&dob=${date}&op_number=${this.state.FilterOP}`
        this.isPatientisSearching(true)
      }
      RestAPIService.getAll(API_URL).
        then((response) => {
          if (response.data.status === "success") {
            if (DocRequest) {
              this.setState({
                docSearchedRequestPatientList: response.data.data,
                docRequestPatientMenuPop: response.data.data.length > 0 ? true : false
              })
            } else {
              this.setState({
                SearchDoctorPatientList: response.data.data,
                // RequestPatientMenuPop: response?.data?.data?.patient?.length > 0 ? true : false
              }, () => {
                if (this.state.PatientNameSearchKey !== "" || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "" || this.state.FilterOP !== "") {
                  if (response.data.data?.length > 0) {
                    this.setState({ PatientSearchClicked: true, AddressFilterClicked: false })
                  } else {
                    this.errorMessage(t("NoRecordsFound"))
                  }
                }
              })
            }
            this.isPatientisSearching(false)
            this.AppointMobileSrch(false);
          }
          else {
            this.isPatientisSearching(false)
            this.AppointMobileSrch(false);
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error?.message)
          }
          this.isPatientisSearching(false)
          this.AppointMobileSrch(false);
        })
    }
    catch (e) {
      this.isPatientisSearching(false)
      this.AppointMobileSrch(false);
      this.errorMessage(e.message)
    }
  }

  getDoctorPatientDetailData = (id, status, fromOPT, item, Type, doctor_id = null) => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + id)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              patientDetails: response?.data?.data
            }, () => {
              let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
              let fromFO = UserData?.module_name === "front_office" ? true : false
              if (fromOPT && !fromFO) {
                if (Type == "TransferAppoint") {
                  setCachevalue(JSON.stringify(this.state.patientDetails), "DoctorPatientData")
                  this.props.history.push({ pathname: "/DoctorHome/Doctor/Demographics", state: { fromCreate: true, patientId: id, transferID: item?.id } })
                } else {
                  setCachevalue(JSON.stringify(this.state.patientDetails), "DoctorPatientData")
                  this.props.history.push({ pathname: "/DoctorHome/Doctor/Demographics", state: { fromCreate: true, patientId: id, followupID: item?.id, AppointDate: item?.follow_up_date } })
                }
              } else if (fromFO && Type === "follow_ups") {
                let patientDetails = {
                  ...this.state.patientDetails,
                  doctor_id: doctor_id
                }
                setCachevalue(JSON.stringify(patientDetails), "AppRequestPatientData")
                if (item?.follow_up_date === DateTime.fromJSDate(new Date()).toFormat('dd-MM-yyyy')) {
                  this.props.history.push({ pathname: (localGetItem('isNewBilling') === "true") ? "/OPHome/Billing/NewQuickBilling" : "/OPHome/Billing/QuickBilling", state: { fromFollowUp: true, followupID: item?.id, AppointDate: item?.appointment_date } })
                } else {
                  this.props.history.push({ pathname: "/OPHome/Billing/CreateAppointment", state: { fromFollowUp: true, followupID: item?.id, AppointDate: item?.appointment_date } })
                }
              } else if(fromFO && status === "fromOpHomeEdit"){
                setCachevalue(JSON.stringify({...item, ...this.state.patientDetails}), "patientData")
                this.props.history.push({ pathname: "/OPHome/PatientDetails/Demographics" })
              } else if(fromFO && status === "fromIpHomeEdit") {
                setCachevalue(JSON.stringify({...item, ...this.state.patientDetails}), "IppatientData")
                setCachevalue(JSON.stringify({...item, ...this.state.patientDetails}), "patientData")
                this.props.history.push({ pathname: "/IPHome/Demographics/Demographics" })
              }else {
                if (status === 'Edit Patient') {
                  setCachevalue(JSON.stringify(this.state.patientDetails), "DoctorPatientData")
                  this.props.history.push({ pathname: "/DoctorHome/Demographics/Update", state: { fromCreate: false, doctorUpdate: true } })
                } else if ((status === 'Create Patient') || (status === 'Request Create')) {
                  setCachevalue(JSON.stringify(this.state.patientDetails), "DoctorPatientData")
                  this.props.history.push({ pathname: "/DoctorHome/Doctor/Demographics", state: { fromCreate: true, patientId: id, followupID: item?.id, AppointDate: item?.follow_up_date } })
                }
              }
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  RenderMultiDoctorList = () => {
    return (
      <Box>
        <Autocomplete
          size="small"
          disableClearable
          options={this.state.MultiDoctorList}
          value={this.state.MultiDoctorValue || null}
          onChange={(event, newValue) => {
            this.setState({ MultiDoctorValue: newValue || "" }, ()=>{
              let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
              if (UserData?.doctor_id === newValue?.doctor_id && newValue?.doctor_id) {
                setCachevalue("false", "DoctorUserChanged");
              } else {
                setCachevalue("true", "DoctorUserChanged");
              }
            if (newValue?.module_name === "doctor" || newValue?.module_name === "optometrist") {
              this.ChangeLoginTokken(newValue, true)
            } else if (newValue?.module_name === "counsellor") {
              this.ChangeLoginTokken(newValue, true)
            }
            });
            
          }}
          getOptionLabel={(option) =>
            option?.module_name === "doctor"
              ? option.doctor_name
              : option?.module_name === "optometrist"
                ? option.optometrist_name
                : option?.module_name === "counsellor"
                  ? option.counsellor_name
                  : option?.module_name || ""
          }
          sx={{
            width: "13vw",
            "& .MuiInputBase-root": {
              height: "2.56vw",
              borderRadius: "0.2vw",
              backgroundColor: "white",
            },
          }}
          renderInput={(params) => (
            <TextField {...params} placeholder="Select..." variant="outlined" />
          )}
        />
      </Box>
    )
  }

  DoctorHeaderSearch = () => {
    const { t } = this.props;
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser
    const restrict_op_appointment_in_ip_patients = localGetItem('restrict_op_appointment_in_ip_patients') === 'true';
    return (
      <Box>
        <Box component={'div'} display={'flex'} flexDirection={'row'} sx={{ borderRadius: "0.3vw" }}>
          <FormControl size='small' sx={{ width: "13vw", borderRadius: '0.2vw', }} >
            <Select
              className='mui_header_card_dropdown_fo'
              value={UserData?.clinic_staff ? (localGetItem("JMODoctor") ? JSON.parse(localGetItem("JMODoctor")) : (this.state.ClinicList[0]?.id ? this.state.ClinicList[0]?.id : null)) : this.state.SelectedDoctorClinic}
              onChange={(e) => {
                this.setState({ SelectedDoctorClinic: e.target.value }, () => {
                  if (UserData?.clinic_staff) {
                    const selectedClinicObj = this.state.ClinicList.find(item =>
                      (this.state.isOptometry ? item?.doctor_id : UserData?.clinic_staff ? item.id : item?.clinic_id) === e.target.value
                    );
                    if (UserData?.clinic_staff) {
                      localSetItem('JMODoctor', this.state.SelectedDoctorClinic)
                      localSetItem('ServiceType', selectedClinicObj.service_type)
                      localSetItem('regNo', selectedClinicObj.registration_number)
                    }
                    this.ChangeLoginTokken(this.state.SelectedDoctorClinic)
                  } else {
                    localSetItem('SelectedDoctorClinicId', this.state.SelectedDoctorClinic)
                    setCachevalue(this.state.SelectedDoctorClinic === 'all' ? myUser?.clinic_id : this.state.SelectedDoctorClinic, "SelectedDoctorClinic")
                    this.props.history.push({ pathname: "/DoctorHome", state: { SelectedDoctorClinic: this.state.SelectedDoctorClinic } })
                  }
                  if (localGetItem("enable_other_doctor_list") === 'true' && window.location.pathname === "/DoctorHome") {
                    this.fetchMultiDoctorOption(this.state.SelectedDoctorClinic)
                  }
                })
              }}
              sx={{ backgroundColor: 'white' }}
              MenuProps={{ style: { maxHeight: 250 } }}
            >
              {UserData?.service_type === "OPTOMETRY" ? <MenuItem value={"all"}>{"All Doctors"}</MenuItem> : null}
              {
                (window.location.pathname === "/DoctorHome" || window.location.pathname === "/IPDoctorHome") ?
                  this.state.ClinicList?.length > 0 && this.state.ClinicList?.map((item, index) => (
                    <MenuItem key={index} value={this.state.isOptometry ? item?.doctor_id : UserData?.clinic_staff ? item.id : item?.clinic_id}>{this.state.isOptometry ? item?.first_name : UserData?.clinic_staff ? item.name : item?.clinic_name}</MenuItem>
                  )) : null
              }
            </Select>
          </FormControl>
          {(localGetItem('enable_other_doctor_list') === 'true' && getCachevalue("InRTDocApprovals") !== "true") ? this.RenderMultiDoctorList() : null}
          {/* {UserData?.service_type === "OPTOMETRY" ? null : */}
          {UserData?.clinic_staff ? null :  <PatientHeaderSearch
            t={this.props.t}
            isLoading={this.state.isPatientisSearching}
            filterVisible={this.state.PatientAddressKey === "" && this.state.PatientFathHusKey === "" && this.state.PatientMotherKey === "" && this.state.FilterDob === null && this.state.FilterUHID === "" && this.state.FilterOP === ""}
            flterOpen = {this.handleFilterOpen}
            faceOpen = {this.handleFaceOpen}
            module_name = {"Doctor"}
            onSearchSubmit={this.handleSearchSubmit}
            onClear={this.handleSearchClear}
            searchValue={this.state.PatientNameSearchKey}
            faceVisible = {this.state.isfaceRecognizationEnabled}
          />}
          {/* <OutlinedInput
            placeholder={t("SearchPatients")}
            onKeyDown={(event) => {
              if (event.key === "Enter" && event.target.value != "" && event.target.value?.length > 2) {
                event.preventDefault();
                this.DoctorPatientSearch()
              } else if (event.key === "Enter" && event.target.value === "" && event.target.value.length <= 0) {
                this.setState({ PatientSearchClicked: false })
              }
            }}
            onChange={(e) => {
              this.setState({
                PatientNameSearchKey: e.target.value
              })
            }}
            inputProps={{ maxLength: 25 }}
            value={this.state.PatientNameSearchKey}
            size="small"
            className='eMed_header_Input'
            endAdornment={
              <Box component={'div'} display={'flex'} flexDirection={'row'}>
                <Divider orientation="vertical" variant="middle" flexItem />
                {this.state.isPatientisSearching ?
                  <Box sx={{ display: 'flex', alignItems: "center", justifyContent: "center", width: '2.5vw' }}>
                    <InputAdornment position="end"><CircularProgress size={15} /></InputAdornment>
                  </Box> :
                  <Tooltip title={t("Search")} arrow>
                      <IconButton disabled={this.state.PatientNameSearchKey === "" && this.state.PatientAddressKey === "" && this.state.PatientFathHusKey === "" && this.state.PatientMotherKey === "" && this.state.FilterDob === null && this.state.FilterUHID === "" && this.state.FilterOP === ""}
                      onClick={(e) => {
                        if ((this.state.PatientNameSearchKey !== "" && this.state.PatientNameSearchKey.length > 2) || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "" || this.state.FilterOP !== "") {
                          this.DoctorPatientSearch()
                        }
                      }} position="end">
                      <SearchIcon />
                    </IconButton>
                  </Tooltip>}
                <Tooltip title={t("Filter")} arrow>
                  <IconButton onClick={() => { this.setState({ AddressFilterClicked: true }) }} position="end">
                    <Badge color="error" size='small' variant="dot" max={999} invisible={this.state.PatientAddressKey === "" && this.state.PatientFathHusKey === "" && this.state.PatientMotherKey === "" && this.state.FilterDob === null && this.state.FilterUHID === "" && this.state.FilterOP === ""}>
                      <FilterAltIcon />
                    </Badge>
                  </IconButton>
                </Tooltip>
                
              </Box>
            }
          /> */}
          {/* } */}
        </Box>
        <Menu
          open={this.state.PatientSearchClicked}
          className="eMed_Header_Search_Pop"
          disableAutoFocus
          disableEnforceFocus
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          MenuListProps={{
            autoFocus: false
          }}
          onClose={() => {
            this.setState({
              PatientSearchClicked: false,
              // PatientNameSearchKey: "",
              PatientAddressKey: "",
              PatientFathHusKey: "",
              PatientMotherKey: "",
              FilterDob : null,
              FilterUHID : "",
              FilterOP : "",
            })
          }}
        >
          {
            (this.state.SearchDoctorPatientList.length > 0 && !this.state.hasAbha) ?
              this.state.SearchDoctorPatientList?.map((list) => {
                let PatientFullName = `${list.first_name} ${list.last_name}`
                list["patient_name"] = PatientFullName
                list["patient_mobile_number"] = list.mobile_number
                list["patient_photo_url"] = list.photo_url
                const disableAddIcon = (localGetItem('isNewBilling') === "true" && restrict_op_appointment_in_ip_patients && list?.ip_has_current_appointment) ? true : false;
                return (
                  <Box>
                    <Box className="eMed_Header_Search_item_abha">
                      <CommonPatientDetails data={list} fromSearch={true} isCommonUhid={this.state.common_uhid} />
                      <Tooltip title={t("Last Visit Date")} arrow>
                        <div style={{ fontSize: "0.65vw", fontWeight: "bold" }}>Last Visited Date</div>
                        <Typography sx={{ fontSize: '0.85vw' }}>OP: {formatDate(list?.op_last_visit_date)}</Typography>
                        <Typography sx={{ fontSize: '0.85vw' }}>IP: {formatDate(list?.ip_last_visit_date)}</Typography>
                      </Tooltip>
                      {(window.location.pathname === "/DoctorHome") ?
                        (list.appointment_date === "" || list.appointment_status === "Cancelled") ?
                          <Box component={'div'} className="eMed_Header_Search_icons">
                            {this.state.isOptometry ?
                              <>  
                                <Tooltip placement='top' title={'View'} arrow>
                                  <IconButton
                                    onClick={() => {
                                      this.setState({
                                        PatientNameSearchKey: "",
                                        PatientAddressKey: "",
                                        PatientFathHusKey: "",
                                        FilterDob: null,
                                        FilterUHID: "",
                                        FilterOP: "",
                                        PatientSearchClicked: false,
                                        SearchedPatientList: [],
                                        PatientMotherKey: "",
                                        common_uhid: false,
                                      }, () => this.props.history?.push({ pathname: 'DoctorHome/Reports/DoctorVisit', state: { patientDetails: list, fromView: true } }))
                                    }}
                                  ><VisibilityIcon color='primary' /></IconButton>
                                </Tooltip>
                              </> :
                              <>
                                <Tooltip title={t("EditPatientDetails")} arrow>
                                  <IconButton onClick={() => {
                                    this.setState({
                                      PatientNameSearchKey: "",
                                      PatientAddressKey: "",
                                      PatientFathHusKey: "",
                                      FilterDob: null,
                                      FilterUHID: "", 
                                      FilterOP: "",
                                      PatientSearchClicked: false,
                                      SearchedPatientList: [],
                                      PatientMotherKey: "",
                                      common_uhid: false,
                                    }, () => {
                                      this.getDoctorPatientDetailData(list?.patient_id, 'Edit Patient')
                                    })
                                  }}
                                    position="end">
                                    <Edit color='primary' />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip disabled = {list?.op_has_current_appointment || disableAddIcon} title={t("CreateAppointment")} arrow>
                                  <IconButton onClick={() => {
                                    this.setState({
                                      PatientNameSearchKey: "",
                                      PatientAddressKey: "",
                                      PatientFathHusKey: "",
                                      FilterDob: null,
                                      FilterUHID: "",
                                      FilterOP: "",
                                      PatientSearchClicked: false,
                                      SearchedPatientList: [],
                                      PatientMotherKey: "",
                                      common_uhid: false,
                                    }, () => {
                                      this.getDoctorPatientDetailData(list?.patient_id, 'Create Patient')
                                    })
                                  }}
                                    position="end">
                                    <PersonAddAlt1Icon sx={{ color: (list.op_has_current_appointment || disableAddIcon) ? Colors.disableLabelColor : Colors.themeDark }}/>
                                  </IconButton>
                                </Tooltip>
                              </>}
                          </Box>
                          :
                          <Box component={'div'} className="eMed_Header_Search_icons">
                            {this.state.isOptometry ?
                              <>
                                <Tooltip placement='top' title={'View'} arrow>
                                  <IconButton
                                    onClick={() => {
                                      this.setState({
                                        PatientNameSearchKey: "",
                                        PatientAddressKey: "",
                                        PatientFathHusKey: "",
                                        FilterDob: null,
                                        FilterUHID: "",
                                        FilterOP: "",
                                        PatientSearchClicked: false,
                                        SearchedPatientList: [],
                                        PatientMotherKey: "",
                                        common_uhid: false,
                                      }, () => this.props.history?.push({ pathname: 'DoctorHome/Reports/DoctorVisit', state: { patientDetails: list, fromView: true } }))
                                    }}
                                  ><VisibilityIcon color='primary' /></IconButton>
                                </Tooltip>
                              </> :
                              <>
                                <Tooltip title={t("EditPatientDetails")} arrow>
                                  <IconButton onClick={() => {
                                    this.setState({
                                      PatientNameSearchKey: "",
                                      PatientAddressKey: "",
                                      PatientFathHusKey: "",
                                      FilterDob: null,
                                      FilterUHID: "",
                                      FilterOP: "",
                                      PatientSearchClicked: false,
                                      SearchedPatientList: [],
                                      PatientMotherKey: "",
                                      common_uhid: false,
                                    }, () => {
                                      setCachevalue(JSON.stringify(list), "DoctorPatientData")
                                      this.props.history.push({ pathname: "/DoctorHome/Demographics/update", state: { fromCreate: false, doctorUpdate: true } })
                                    })
                                  }}
                                    position="end">
                                    <Edit color='primary' />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip disabled = {list?.op_has_current_appointment || disableAddIcon} title={t("CreateAppointment")} arrow>
                                  <IconButton onClick={() => {
                                    this.setState({
                                      PatientNameSearchKey: "",
                                      PatientAddressKey: "",
                                      PatientFathHusKey: "",
                                      FilterDob: null,
                                      FilterUHID: "",
                                      FilterOP: "",
                                      PatientSearchClicked: false,
                                      SearchedPatientList: [],
                                      PatientMotherKey: "",
                                      common_uhid: false,
                                    }, () => {
                                      this.getDoctorPatientDetailData(list?.patient_id, 'Create Patient')
                                    })
                                  }}
                                    position="end">
                                    <PersonAddAlt1Icon sx={{ color: (list.op_has_current_appointment || disableAddIcon) ? Colors.disableLabelColor : Colors.themeDark }}/>
                                  </IconButton>
                                </Tooltip>
                                {/* <Typography>{list.appointment_date && formatDate(list.appointment_date)}</Typography> */}
                              </>
                            }
                          </Box>
                        : null
                      }
                    </Box>
                    <Divider />
                  </Box>
                )
              }) : (this.state.SearchDoctorPatientList.length > 0 && this.state.hasAbha) ?
              this.state.SearchDoctorPatientList?.map((list) => {
                let PatientFullName = `${list.first_name} ${list.last_name}`
                list["patient_name"] = PatientFullName
                list["patient_mobile_number"] = list.mobile_number
                list["patient_photo_url"] = list.photo_url
                const disableAddIcon = (localGetItem('isNewBilling') === "true" && restrict_op_appointment_in_ip_patients && list?.ip_has_current_appointment) ? true : false;

                return (
                  <Box>
                    <Box className="eMed_Header_Search_item">
                      <CommonPatientDetails data={list} fromSearch={true} isCommonUhid={this.state.common_uhid} />
                      <Tooltip title={t("ABHA Details")} arrow>
                      <div style={{ fontSize: "0.65vw", fontWeight: "bold" }}>ABHA Details</div>
                      <Typography sx={{ fontSize: '0.85vw' }}>{list?.abha_health_id || "-"}</Typography>
                      <Typography sx={{ fontSize: '0.85vw' }}>{list?.abha_health_address || "-"}</Typography>
                      </Tooltip>
                      <Tooltip title={t("Last Visit Date")} arrow>
                        <div style={{ fontSize: "0.65vw", fontWeight: "bold" }}>Last Visited Date</div>
                        <Typography sx={{ fontSize: '0.85vw' }}>OP: {formatDate(list?.op_last_visit_date)}</Typography>
                        <Typography sx={{ fontSize: '0.85vw' }}>IP: {formatDate(list?.ip_last_visit_date)}</Typography>
                      </Tooltip>
                      {(window.location.pathname === "/DoctorHome") ?
                        (list.appointment_date === "" || list.appointment_status === "Cancelled") ?
                          <Box component={'div'} className="eMed_Header_Search_icons">
                            {this.state.isOptometry ?
                              <>  
                                <Tooltip placement='top' title={'View'} arrow>
                                  <IconButton
                                    onClick={() => {
                                      this.setState({
                                        PatientNameSearchKey: "",
                                        PatientAddressKey: "",
                                        PatientFathHusKey: "",
                                        FilterDob: null,
                                        FilterUHID: "",
                                        FilterOP: "",
                                        PatientSearchClicked: false,
                                        SearchedPatientList: [],
                                        PatientMotherKey: "",
                                        common_uhid: false,
                                      }, () => this.props.history?.push({ pathname: 'DoctorHome/Reports/DoctorVisit', state: { patientDetails: list, fromView: true } }))
                                    }}
                                  ><VisibilityIcon color='primary' /></IconButton>
                                </Tooltip>
                              </> :
                              <>
                                <Tooltip title={t("EditPatientDetails")} arrow>
                                  <IconButton onClick={() => {
                                    this.setState({
                                      PatientNameSearchKey: "",
                                      PatientAddressKey: "",
                                      PatientFathHusKey: "",
                                      FilterDob: null,
                                      FilterUHID: "", 
                                      FilterOP: "",
                                      PatientSearchClicked: false,
                                      SearchedPatientList: [],
                                      PatientMotherKey: "",
                                      common_uhid: false,
                                    }, () => {
                                      this.getDoctorPatientDetailData(list?.patient_id, 'Edit Patient')
                                    })
                                  }}
                                    position="end">
                                    <Edit color='primary' />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip disabled = {(localGetItem('isNewBilling') === "true") ? disableAddIcon : list?.op_has_current_appointment} title={t("CreateAppointment")} arrow>
                                  <IconButton onClick={() => {
                                    this.setState({
                                      PatientNameSearchKey: "",
                                      PatientAddressKey: "",
                                      PatientFathHusKey: "",
                                      FilterDob: null,
                                      FilterUHID: "",
                                      FilterOP: "",
                                      PatientSearchClicked: false,
                                      SearchedPatientList: [],
                                      PatientMotherKey: "",
                                      common_uhid: false,
                                    }, () => {
                                      this.getDoctorPatientDetailData(list?.patient_id, 'Create Patient')
                                    })
                                  }}
                                    position="end">
                                    <PersonAddAlt1Icon sx={{ color: (list.op_has_current_appointment && (localGetItem('isNewBilling') === "false") || disableAddIcon) ? Colors.disableLabelColor : Colors.themeDark }}/>
                                  </IconButton>
                                </Tooltip>
                              </>}
                          </Box>
                          :
                          <Box component={'div'} className="eMed_Header_Search_icons">
                            {this.state.isOptometry ?
                              <>
                                <Tooltip placement='top' title={'View'} arrow>
                                  <IconButton
                                    onClick={() => {
                                      this.setState({
                                        PatientNameSearchKey: "",
                                        PatientAddressKey: "",
                                        PatientFathHusKey: "",
                                        FilterDob: null,
                                        FilterUHID: "",
                                        FilterOP: "",
                                        PatientSearchClicked: false,
                                        SearchedPatientList: [],
                                        PatientMotherKey: "",
                                        common_uhid: false,
                                      }, () => this.props.history?.push({ pathname: 'DoctorHome/Reports/DoctorVisit', state: { patientDetails: list, fromView: true } }))
                                    }}
                                  ><VisibilityIcon color='primary' /></IconButton>
                                </Tooltip>
                              </> :
                              <>
                                <Tooltip title={t("EditPatientDetails")} arrow>
                                  <IconButton onClick={() => {
                                    this.setState({
                                      PatientNameSearchKey: "",
                                      PatientAddressKey: "",
                                      PatientFathHusKey: "",
                                      FilterDob: null,
                                      FilterUHID: "",
                                      FilterOP: "",
                                      PatientSearchClicked: false,
                                      SearchedPatientList: [],
                                      PatientMotherKey: "",
                                      common_uhid: false,
                                    }, () => {
                                      setCachevalue(JSON.stringify(list), "DoctorPatientData")
                                      this.props.history.push({ pathname: "/DoctorHome/Demographics/update", state: { fromCreate: false, doctorUpdate: true } })
                                    })
                                  }}
                                    position="end">
                                    <Edit color='primary' />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip disabled = {(localGetItem('isNewBilling') === "true") ? disableAddIcon : list?.op_has_current_appointment} title={t("CreateAppointment")} arrow>
                                  <IconButton onClick={() => {
                                    this.setState({
                                      PatientNameSearchKey: "",
                                      PatientAddressKey: "",
                                      PatientFathHusKey: "",
                                      FilterDob: null,
                                      FilterUHID: "",
                                      FilterOP: "",
                                      PatientSearchClicked: false,
                                      SearchedPatientList: [],
                                      PatientMotherKey: "",
                                      common_uhid: false,
                                    }, () => {
                                      this.getDoctorPatientDetailData(list?.patient_id, 'Create Patient')
                                    })
                                  }}
                                    position="end">
                                    <PersonAddAlt1Icon sx={{ color: (list.op_has_current_appointment && localGetItem('isNewBilling') === "false" || disableAddIcon) ? Colors.disableLabelColor : Colors.themeDark }}/>
                                  </IconButton>
                                </Tooltip>
                                {/* <Typography>{list.appointment_date && formatDate(list.appointment_date)}</Typography> */}
                              </>
                            }
                          </Box>
                        : null
                      }
                    </Box>
                    <Divider />
                  </Box>
                )
              }) : null
          }
        </Menu>
        <Menu
          open={this.state.AddressFilterClicked}
          className="eMed_Header_Filter_Pop"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={() => {
            this.setState({ AddressFilterClicked: false })
          }}
        >
          {this.DynamicFilterFeilds()}
        </Menu>
      </Box>
    )
  }

  checkallfunc() {
    if (this.state.booked && this.state.arrived && this.state.withDoctor && this.state.completed && this.state.cancelled && this.state.withNurse) {
      this.setState({
        all: true
      })
    }
  }

  handleCheckBox = (e, key) => {
    var states = this.state
    states[key] = e.target.checked
    this.setState({ states }, () => {
      switch (key) {
        case 'booked':
          this.setState({
            booked: e.target.checked, all: false
          }, () => { this.checkallfunc() })
          break;
        case 'arrived':
          this.setState({
            arrived: e.target.checked, all: false
          }, () => { this.checkallfunc() })
          break;
        case 'withDoctor':
          this.setState({
            withDoctor: e.target.checked, all: false
          }, () => { this.checkallfunc() })
          break;
        case 'withNurse':
          this.setState({
            withNurse: e.target.checked, all: false
          }, () => { this.checkallfunc() })
          break;
        case 'cancelled':
          this.setState({
            cancelled: e.target.checked, all: false
          }, () => { this.checkallfunc() })
          break;
        case 'completed':
          this.setState({
            completed: e.target.checked, all: false
          }, () => { this.checkallfunc() })
          break;
        case 'all':
          this.setState({
            all: this.state.all
          }, () => {
            this.setState({
              booked: this.state.all, arrived: this.state.all, withDoctor: this.state.all,
              completed: this.state.all, cancelled: this.state.all, withNurse: this.state.all
            })
          })
          break;
        default:
          if (states.booked && states.arrived && states.withDoctor && states.completed && states.cancelled && states.withNurse) {
            this.setState({
              all: true
            })
          } else {
            this.setState({
              all: true, booked: true, arrived: true, withDoctor: true,
              completed: true, cancelled: true, withNurse: true
            })
          }
          break;
      }

      if (key === 'fullReport') {
        if (this.state.isOPT) {
          this.setState({
            fullReport: e.target.checked, complaints: true, ocular: true,
            Illness: true, vision: true,
            gonioscopy: true, autoRefract: true,
            prevGlassPower: true, subjectiveRefract: true,
            retinoscopicRefract: true, IntraPressure: true,
            Anterior: true, Posterior: true, AnteriorImg: true, OtherInvestigation: true,
            fundus: true, Keratometry: true, medication: true,
            glassPrescrib: true, Review: true,
            Treatment: true, investigation: true,
            diagnosis: true, vitals: true, counselling: true, overallNotes: true, OcularResponse: true
          }, () => {
            if (this.state.fullReport) {
              this.setState({
                fullReport: e.target.checked, complaints: true, ocular: true,
                Illness: true, vision: true,
                gonioscopy: true, autoRefract: true,
                prevGlassPower: true, subjectiveRefract: true,
                retinoscopicRefract: true, IntraPressure: true,
                Anterior: true, Posterior: true, AnteriorImg: true, Keratometry: true,
                fundus: true, medication: true, OtherInvestigation: true,
                glassPrescrib: true, Review: true,
                Treatment: true, investigation: true,
                diagnosis: true, vitals: true, counselling: true, overallNotes: true, OcularResponse: true
              })
            } else {
              this.setState({
                fullReport: false, complaints: false, ocular: false,
                Illness: false, vision: false,
                gonioscopy: false, autoRefract: false,
                prevGlassPower: false, subjectiveRefract: false,
                retinoscopicRefract: false, IntraPressure: false,
                Anterior: false, Posterior: false, AnteriorImg: false, Keratometry: false,
                fundus: false, medication: false, OtherInvestigation: false,
                glassPrescrib: false, Review: false,
                Treatment: false, investigation: false,
                diagnosis: false, vitals: false, counselling: false, overallNotes: false, OcularResponse: false
              })
            }
          })
        } else {
          this.setState({
            fullReport: e.target.checked, symptoms: true,
            allergies: true, vitals: true,
            examination: true, diagnosis: true,
            prescription: true, prevPrescrip: true,
            test: true, plan: true,
            counselling: true, generalPatient: true
          }, () => {
            if (this.state.fullReport) {
              this.setState({
                fullReport: e.target.checked, symptoms: true,
                allergies: true, vitals: true,
                examination: true, diagnosis: true,
                prescription: true, prevPrescrip: true,
                test: true, plan: true,
                counselling: true, generalPatient: true
              })
            } else {
              this.setState({
                fullReport: false, symptoms: false,
                allergies: false, vitals: false,
                examination: false, diagnosis: false,
                prescription: false, prevPrescrip: false,
                test: false, plan: false,
                counselling: false, generalPatient: false
              })
            }
          })
        }
      } else {
        if (this.state.isOPT) {
          if (states.complaints && states.ocular && states.Illness && states.vitals && states.vision && states.gonioscopy && states.autoRefract && states.prevGlassPower && states.subjectiveRefract && states.retinoscopicRefract && states.IntraPressure && states.Anterior && states.AnteriorImg && states.OtherInvestigation && states.Posterior && states.Keratometry && states.fundus && states.diagnosis && states.medication && states.glassPrescrib && states.Review && states.Treatment && states.counselling && states.investigation && states.overallNotes && states.OcularResponse) {
            this.setState({ fullReport: true })
          } else {
            this.setState({ fullReport: false })
          }
        } else {
          if (states.symptoms && states.allergies && states.vitals && states.examination && states.diagnosis && states.prescription && states.test && states.plan && states.generalPatient && states.counselling) {
            this.setState({ fullReport: true })
          } else {
            this.setState({ fullReport: false })
          }
        }
      }
    })
  }

  onClickDoctorNotesDefault = () => {
    try {
      this.setState({ doctorPrintList: JSON.parse(this.state.dupDocPrintList) })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }


  postDoctorPrint = () => {
    try {
      let status = [];
      let states = this.state
      if (states.all) {
        status = []
      } else {
        if (states.booked) {
          status.push('Booked')
        }
        if (states.arrived) {
          status.push('Arrived')
        }
        if (states.withNurse) {
          status.push('With Nurse')
        }
        if (states.withDoctor) {
          status.push('With Doctor')
        }
        if (states.completed) {
          status.push('Completed')
        }
        if (states.cancelled) {
          status.push('Cancelled')
        }
      }
      let clinicId = localGetItem('SelectedDoctorClinicId')
      let startDate = new Date(this.state.doctorAppointmentDate)
      let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      RestAPIService.getAll(Serviceurls.DOC_APPOINTMENT_LIST + `?appointment_date=${date}&clinic_id=${clinicId}&appointment_status=${status}&export=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({
            doctorAnchor: null, openDoctorPrint: false, all: true,
            booked: true, arrived: true, withNurse: true, withDoctor: true,
            completed: true, cancelled: true
          })
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getDoctorAppointmentList = (fromUpdate = false) => {
    try {
      let clinicId = this.state.doctorClinicId || localGetItem('SelectedDoctorClinicId') || getCachevalue('SelectedDoctorClinic')
      let startDate = this.state.docDatePicker ? new Date(this.state.docDatePicker) : new Date(this.state.datePicker)
      let selectedDate = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      RestAPIService.getAll(Serviceurls.DOC_APPOINTMENT_REQUEST + '?from_date=' + selectedDate + '&to_date=' + selectedDate + '&clinic_id=' + clinicId)
        .then((response) => {
          if (response?.data?.status === 'success') {
            const data = response?.data?.data ? response?.data?.data?.map((item, idx) => ({...item, sno: idx + 1})) : [];
            if (fromUpdate) {
              this.setState({
                doctorAppointmentData: data,
                docSelectedRequestTab: 'appointment_request'
              })
            } else {
              this.setState({
                doctorAppointmentData: data,
              })
            }
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  postDoctorCancelAppointment = (selectedId) => {
    try {
      let data = {
        id: selectedId,
        status: 'Cancel'
      }
      this.setState({ postLoad: true })
      RestAPIService.create(data, Serviceurls.DOC_APPOINTMENT_REQUEST)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              doctorAppointmentAnchor: null,
              openDoctorAppointment: false,
              postLoad: false,
              datePicker: new Date()
            }, () => this.successMessage(response.data.message))
            this.getDoctorAppointmentList()
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ postLoad: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ postLoad: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ postLoad: false })
      this.errorMessage(error.message)
    }
  }

  createOTAppointment = (id, status) => {
    try {
      let data = {
        id: id,
        status: status,
        slot_id: status === "Reject" ? null : this.state?.selectedSlot?.id
      }
      this.setState({ postLoad: true })
      RestAPIService.updateWithOutId(data, Serviceurls.DOC_OT_REQUEST_GET)
        .then((response) => {
          if (response.data.status === 'success') {
            this.successMessage(response.data.message)
            this.setState({
              OTallocationPopup: false,
              OTrequestPopup: false,
              selectedOT: null, selectedSlot: null,
              AcceptRequest: true, deletePopup: false
            }, () => { this.getotRequestList() })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ postLoad: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ postLoad: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ postLoad: false })
      this.errorMessage(error.message)
    }
  }

  getDoctorNotesPrint = () => {
    try {
      let notesList = [];
      let states = this.state
      let flag = false
      if (states.isOPT) {
        flag = states.doctorPrintList?.opt_doctor?.every(item => !item.is_checked)
        let fullReport = states.doctorPrintList?.opt_doctor?.find(item => item?.label === 'Full Report')
        if (fullReport?.is_checked) {
          // states.doctorPrintList?.opt_doctor?.filter(item => item?.is_checked && item.label !== 'Full Report')?.forEach(element => {
          //   if(this.state.loggedInuserInfo?.new_doctor_notes_template){
          //     if(element?.value !== 'RectinoscopicAcceptance'){
          //       notesList?.push('FullReport')
          //     }
          //   }else{
          //     notesList?.push('FullReport')
          //   }
          // })
          notesList?.push('FullReport') // Above Line Commented for full report
        } else {
          states.doctorPrintList?.opt_doctor?.filter(item => item?.is_checked && item.label !== 'Full Report')?.forEach(element => {
            if(this.state.loggedInuserInfo?.new_doctor_notes_template){
              if(element?.value !== 'RectinoscopicAcceptance'){
                if (element?.is_checked) {
                  notesList?.push(element?.value)
                }
              }
            }else{
              if (element?.is_checked) {
                notesList?.push(element?.value)
              }
            }
          })
        }
      } else {
        flag = states.doctorPrintList?.other_doctor?.every(item => !item.is_checked)
        let fullReport = states.doctorPrintList?.other_doctor?.find(item => item?.label === 'Full Report')
        if (fullReport?.is_checked) {
          notesList?.push('FullReport')
        } else {
          states.doctorPrintList?.other_doctor?.filter(item => item?.is_checked && item.label !== 'Full Report')?.forEach(element => {
            if (element?.is_checked) {
              notesList?.push(element?.value)
            }
          })
        }
      }
      if (!flag) {
        let patientDetails = getCachevalue('DoctorPatientData')
        let appointmentId = JSON.parse(patientDetails)
        
        const UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        const ServiceURL = (this.state.loggedInuserInfo?.new_doctor_notes_template && this.state.isOPT ? 
          Serviceurls.NEW_DOC_NOTES_VISIT_REPORT_PRINT : UserData?.new_doctor_notes_template_others ? Serviceurls.SARAS_DOC_VISIT_REPORT_GET : this.state.isOPT ? Serviceurls.DOC_DOCTOR_NOTES_PRINT_OPT : Serviceurls.DOC_DOCTOR_NOTES_PRINT)
        RestAPIService.getAllPrint(ServiceURL + `?appointment_id=${appointmentId?.appointment_id}&patient_id=${appointmentId?.patient_id}&doctor_notes=${notesList}`)
          .then((response) => {
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            this.setState({ openDoctorNotesPrintAnchor: null, openDoctorNotesPrint: false, doctorPrintList: JSON.parse(this.state.dupDocPrintList) })
          }).catch((error) => {
            if (error?.response?.data?.message) {
              this.errorMessage(error.response.data.message)
            } else {
              this.errorMessage(error.message)
            }
          })
      } else {
        this.errorMessage('Please Select Atleast one for Print')
      }
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  printDoctorHistoryData = () => {
    try {
      let patientDetails = getCachevalue('DoctorPatientData')
      let appointmentId = JSON.parse(patientDetails)
      RestAPIService.getAll(Serviceurls.DOC_HISTORY_REPORT_PRINT + `?appointment_id=${appointmentId?.appointment_id}&patient_id=${appointmentId?.patient_id}&export=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  printImmunizationData = () => {
    try {
      let patientDetails = getCachevalue('DoctorPatientData')
      let appointmentId = JSON.parse(patientDetails)
      RestAPIService.getAll(Serviceurls.PD_IMMUNIZATION_CHART + `?patient_id=${appointmentId?.patient_id}&export_type=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  // Doctor Apponintment Request Popup starts =====>
  doctorAppointmentRequest = () => {
    const { t } = this.props;
    return (
      <Menu
        open={this.state.openDoctorAppointment}
        className=""
        sx={{ position: 'absolute', top: '3vw', left: '5vw' }}
        anchorEl={this.state.doctorAppointmentAnchor}
        onClose={() => {
          this.setState({ openDoctorAppointment: false, docDateOpen: false, docSelectedRequestTab: "appointment_request", docDatePicker: new Date(), docRequestPatientListAnchor : null }, () => {
            this.docClearRequestData()
            this.getDoctorAppointmentList()
          })
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Tabs
            value={this.state.docSelectedRequestTab}
            onChange={(e, newValue) => {
              this.setState({ docSelectedRequestTab: newValue, docDateOpen: false, docDatePicker: new Date(), isDocAppointRequest: false }, () => {
                this.docClearRequestData()
                if (this.state.docSelectedRequestTab === "appointment_request") { this.getDoctorAppointmentList() }
              })
            }}
          >
            <Tab value="appointment_request" label="Appointment Request" className='eMed_tab_header' />
            <Tab value="create_request" label="Create Telephonic Request" className='eMed_tab_header' />
          </Tabs>
          <Box component={'div'}>
            {
              this.state.docSelectedRequestTab === "appointment_request" ?
                <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} alignItems={'center'}>
                  <div style={{ padding: "0.5vw" }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        open={this.state.docDatePickerOpen}
                        onOpen={() => { this.setState({ docDatePickerOpen: true }) }}
                        onClose={() => { this.setState({ docDatePickerOpen: false }) }}
                        value={this.state.docDatePicker}
                        name={"datePicker"}
                        inputFormat='DD-MM-YYYY'
                        views={["year", "month", "day"]}
                        onChange={
                          (newDate) => {
                            this.setState({
                              docDatePicker: newDate
                            }, () => {
                              this.getDoctorAppointmentList()
                            });
                          }}
                        renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()} style={{ width: '10vw' }} size='small' {...params} onClick={() => { this.setState({ docDatePickerOpen: true }) }} />}
                      />
                    </LocalizationProvider>
                  </div>
                </Box> : null
            }
          </Box>
        </Box>
        {this.state.docSelectedRequestTab === 'appointment_request' ? this.renderAppointmentTab() 
        : <CreateTeleRequest 
            state={this.state}
            FromDoctor={true} 
            getDoctorAppointmentList={this.getDoctorAppointmentList.bind(this)}
            DoctorPatientSearch={this.DoctorPatientSearch.bind(this)}
            // getPincodeToCity={this.getPincodeToCity.bind(this)}
            docClearRequestData={this.docClearRequestData.bind(this)}
            AppointMobileSrch={this.AppointMobileSrch.bind(this)}
            isPatientisSearching={this.isPatientisSearching.bind(this)}
            errorMessage={this.errorMessage.bind(this)}
            isEditable={true}
            t={t}
        />
        }
      </Menu>
    )
  }

  renderAppointmentTab = () => {
    try {
      const { t } = this.props
      return (this.renderAppointmentReqTbl(this.state.doctorAppointmentData, "docModule", '35.3vh', '52.5vw'))
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderAllocationValues = (Heading, value) => {
    const emedTid = Heading.replace(/\s+/g, '_').toLowerCase();
    return (
      <div style={{ marginLeft: "0.85vw", marginTop: "0.75vw" }} emed_tid={`ot_allocation_${emedTid}`}>
        <div style={{ color: Colors.SecondaryText, fontSize: "0.85vw" }} emed_tid={`ot_allocation_${emedTid}_label`}>{Heading}</div>
        <div style={{ fontWeight: 600, marginTop: "0.5vw" }} emed_tid={`ot_allocation_${emedTid}_value`}>
          {value?.length > 15 ?
            <Tooltip placement='top' title={value} emed_tid={`ot_allocation_${emedTid}_tooltip`}>
              <Typography fontSize={'0.9vw'} fontWeight={600} emed_tid={`ot_allocation_${emedTid}_truncated`}>{value?.slice(0, 15) + '...'}</Typography>
            </Tooltip> :
            <Typography fontSize={'0.9vw'} fontWeight={600} emed_tid={`ot_allocation_${emedTid}_full`}>{value ? value : "-"}</Typography>
          }
        </div>
      </div>
    )
  }

  popupClose = () => {
    this.setState({ deletePopup: false })
  }
  removeappointment = () => {
    this.createOTAppointment(this.state?.selectedId, "Reject")
  }

  OTallocationTable = () => {
    const { t } = this.props
    var states = this.state?.allocationDetails
    try {
      return (
        <div emed_tid="ot_allocation_table_container">
          <div style={{ borderBottom: "1px solid #E3E2E2", paddingLeft: "-1vw", paddingRight: "-1vw" }} emed_tid="ot_allocation_table_header">
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: "0.65vw" }} emed_tid="ot_allocation_table_header_inner">
              <div emed_tid="ot_allocation_table_title">OT Allocation</div>
              <Button className='Common_Btn_Min_Width' onClick={() => { this.setState({ selectedOT: null, selectedSlot: null }, () => { this.setState({ OTallocationPopup: false }) }) }} emed_tid="ot_allocation_table_close_btn">
                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} emed_tid="ot_allocation_table_close_icon" />
              </Button>
            </div>
          </div>
          <div className='eMed_App_DataView' style={{ width: '100%', height: "35vh", overflow: "auto" }} emed_tid="ot_allocation_table_content">
            <div style={{ borderBottom: "1px solid #E3E2E2" }} emed_tid="ot_allocation_table_patient_section">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }} emed_tid="ot_allocation_table_patient_details">
                <Typography fontSize={'0.9vw'} marginY={"0.25vw"} emed_tid="ot_allocation_table_patient_details_label">Patient Details</Typography>
                <Box component={'div'} mr={'0.5vw'} style={{ display: "flex", flexDirection: "row", alignItems: "center" }} emed_tid="ot_allocation_table_patient_info">
                  <div className="eMed_Com_Patient_Details" emed_tid="ot_allocation_table_patient_avatar_container">
                    <div className="eMed_Com_Patient_Avatar" emed_tid="ot_allocation_table_patient_avatar">
                      <img className="eMed_Com_Patient_AvaIcon" style={{ borderColor: '#29B6F6' }}
                        src={states?.photo_url === null || states?.photo_url === "" || states?.photo_url === undefined ? states?.gender === "m" ? ImagePaths.Male.default : ImagePaths.Female.default : states?.photo_url} alt={'Avatar'} emed_tid="ot_allocation_table_patient_avatar_img" />
                    </div>
                  </div>
                  <Box component={'div'} emed_tid="ot_allocation_table_patient_text">
                    <Typography component={'div'} emed_tid="ot_allocation_table_patient_name_container">
                      {(states?.patient_name?.length) > 20 ?
                        <Tooltip title={states?.patient_name} placement={'top'} arrow emed_tid="ot_allocation_table_patient_name_tooltip">
                          <div style={{ display: "flex", flexDirection: "row" }} emed_tid="ot_allocation_table_patient_name_truncated">
                            <Typography id='eMed_Com_Patient_Name' style={{ fontSize: "0.8vw" }} emed_tid="ot_allocation_table_patient_name">{(states?.patient_name ? `${states?.patient_title ? states?.patient_title + " " : ""}` + ((states?.patient_name?.slice(0, 20) + '...')) : '-') + ' ' + (states?.patient_age ? states?.patient_age : '-') + '/' + (states?.gender ? states?.gender : '-')}</Typography>
                          </div>
                        </Tooltip> :
                        <div style={{ display: "flex", flexDirection: "row" }} emed_tid="ot_allocation_table_patient_name_full">
                          <Typography id='eMed_Com_Patient_Name' style={{ fontSize: "0.8vw" }} emed_tid="ot_allocation_table_patient_name">{(states?.patient_name ? `${states?.patient_title ? states?.patient_title + " " : ""}` + states?.patient_name : '-') + ' ' + (states?.patient_age ? states?.patient_age : '-') + '/' + (states?.gender ? states?.gender : '-')}</Typography>
                        </div>
                      }
                    </Typography>
                    <Typography id='eMed_Com_Patient_UhidText' emed_tid="ot_allocation_table_patient_uhid">{(states?.uhid) + ' | ' + (states?.patients_mobile_number ? states?.patients_mobile_number : '-')}</Typography>
                  </Box>
                </Box>
              </div>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", paddingBottom: "0.5vw", marginLeft: "-0.5vw" }} emed_tid="ot_allocation_table_allocation_values">
                {this.renderAllocationValues("Surgery", states?.surgery_name)}
                {this.renderAllocationValues("Surgery Doctor", states?.surgeon_name)}
                {this.renderAllocationValues("Anaesthetist", states?.anaesthetist)}
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-around", paddingTop: "1vw" }} emed_tid="ot_allocation_table_selection">
              <Autocomplete
                disableClearable
                size='small'
                value={this.state.selectedOT}
                options={this.state.OTRoomData}
                getOptionLabel={(option) => (option?.ot_name)}
                style={{ width: "13vw" }}
                emed_tid="ot_allocation_table_ot_autocomplete"
                onChange={(event, newValue) => {
                  this.setState({
                    selectedOT: newValue,
                    OTdetails: newValue?.slot_data,
                    selectedSlot: null
                  })
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={"Select OT *"}
                    emed_tid="ot_allocation_table_ot_input"
                  />
                )} />
              <Autocomplete
                disableClearable
                size="small"
                disabled={!this.state.selectedOT}
                style={{ width: "13vw" }}
                value={this.state.selectedSlot}
                options={this.state.OTdetails}
                getOptionLabel={(option) => (option?.slot_name)}
                emed_tid="ot_allocation_table_slot_autocomplete"
                onChange={(event, newValue) => {
                  this.setState({
                    selectedSlot: newValue
                  })
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t('Select Slot *')}
                    emed_tid="ot_allocation_table_slot_input"
                  />
                )} />
            </div>
            <Box component={'div'} display={'flex'} justifyContent={"flex-end"} alignItems={'center'} mt={"1.5vw"} emed_tid="ot_allocation_table_footer">
              <Typography fontSize={'0.9vw'} color={'red'} style={{ marginRight: "5vw" }} emed_tid="ot_allocation_table_error_msg">{this.state?.OTRoomData.length > 0 ? null : "OT not available!"}</Typography>
              <Button
                sx={{ height: '2vw', width: '5vw', mr: '1vw' }}
                variant='outlined'
                onClick={() => { this.setState({ selectedOT: null, selectedSlot: null }, () => { this.setState({ OTallocationPopup: false }) }) }}
                emed_tid="ot_allocation_table_cancel_btn"
              >
                CANCEL
              </Button>
              <Button
                variant='contained'
                sx={{ height: '2vw', width: '7vw' }}
                onClick={() => { this.createOTAppointment(states?.id, "Accept") }}
                emed_tid="ot_allocation_table_add_btn"
              >
                ADD TO OT
              </Button>
            </Box>
          </div>
        </div>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  OTRequestTable = () => {
    const { t } = this.props
    try {
      return (
        <div emed_tid="ot_request_table_container">
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: "0.65vw" }} emed_tid="ot_request_table_header">
            <div emed_tid="ot_request_table_title">Counsellor Request</div>
            <IconButton onClick={() => { this.setState({ OTrequestPopup: false }) }} size="small" emed_tid="ot_request_table_close_btn"><img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt={"close"} emed_tid="ot_request_table_close_icon" /></IconButton>
          </div>
          {this.state.OTreqData && this.state.OTreqData.length > 0 ?
            <div className='eMed_App_DataView' style={{ width: '55vw' }} emed_tid="ot_request_table_content">
              <Box sx={{ maxHeight: '45vw', overflow: 'auto', border: '1px solid lightgray' }} component={'div'} emed_tid="ot_request_table_box">
                <Table stickyHeader size='small' emed_tid="ot_request_table">
                  <TableHead emed_tid="ot_request_table_head">
                    <TableRow emed_tid="ot_request_table_head_row">
                      <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }} emed_tid="ot_request_table_header_counsellor">Counseller</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }} emed_tid="ot_request_table_header_patient">Patient Details</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }} emed_tid="ot_request_table_header_surgery">Surgery</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }} emed_tid="ot_request_table_header_surgery_date">Surgery Date & Time</TableCell>
                      <TableCell align='center' sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }} emed_tid="ot_request_table_header_action">Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody emed_tid="ot_request_table_body">
                    {this.state.OTreqData?.length > 0 ? this.state.OTreqData?.map((item, index) => (
                      <TableRow key={index} emed_tid={`ot_request_table_row_${index}`}>
                        <TableCell emed_tid={`ot_request_table_cell_counsellor_${index}`}>
                          {item?.counsellor_name ? item?.counsellor_name?.length > 30 ?
                            <Tooltip placement='top' title={item?.counsellor_name} emed_tid={`ot_request_table_counsellor_tooltip_${index}`}>
                              <Typography fontSize={'0.9vw'} emed_tid={`ot_request_table_counsellor_truncated_${index}`}>{item?.counsellor_name?.slice(0, 30) + '...'}</Typography>
                            </Tooltip> :
                            <Typography fontSize={'0.9vw'} emed_tid={`ot_request_table_counsellor_full_${index}`}>{item?.counsellor_name ? item?.counsellor_name : "-"}</Typography>
                            : "-"}
                        </TableCell>
                        <TableCell style={{ fontSize: "0.9vw" }} emed_tid={`ot_request_table_cell_patient_${index}`}>
                          <div emed_tid={`ot_request_table_patient_details_${index}`}>
                            <div style={{ fontSize: "0.9vw" }} emed_tid={`ot_request_table_patient_name_${index}`}>{`${item?.patient_name ? `${item?.patient_title ? item?.patient_title : ""} ${item?.patient_name}` : ""}`}</div>
                            <div style={{ fontSize: "0.75vw" }} emed_tid={`ot_request_table_patient_info_${index}`}>{`${item?.patients_mobile_number ? item?.patients_mobile_number : "-"} | ${item?.uhid ? item?.uhid : "-"} `}</div>
                          </div>
                        </TableCell>
                        <TableCell emed_tid={`ot_request_table_cell_surgery_${index}`}>
                          {item?.surgery_name ? item?.surgery_name?.length > 15 ?
                            <Tooltip placement='top' title={item?.surgery_name} emed_tid={`ot_request_table_surgery_tooltip_${index}`}>
                              <Typography fontSize={'0.9vw'} emed_tid={`ot_request_table_surgery_truncated_${index}`}>{item?.surgery_name?.slice(0, 15) + '...'}</Typography>
                            </Tooltip> :
                            <Typography fontSize={'0.9vw'} emed_tid={`ot_request_table_surgery_full_${index}`}>{item?.surgery_name ? item?.surgery_name : "-"}</Typography>
                            : "-"}
                        </TableCell>
                        <TableCell emed_tid={`ot_request_table_cell_surgery_date_${index}`}>
                          <Typography fontSize={'0.9vw'} emed_tid={`ot_request_table_surgery_date_value_${index}`}>{item?.surgery_date ? `${(item?.surgery_date.split("T")[0]).split("-").reverse().join("-")} | ${timeOnlyConvert(item?.surgery_date.split("T")[1])}` : "-"}</Typography>
                        </TableCell>
                        <TableCell align='center' emed_tid={`ot_request_table_cell_action_${index}`}>
                          <Box component={'div'} display={'flex'} flexDirection={"row"} justifyContent={'center'} emed_tid={`ot_request_table_action_box_${index}`}>
                            <Tooltip title={t("Create Appointment")} arrow placement='top' emed_tid={`ot_request_table_create_appt_tooltip_${index}`}>
                              <IconButton onClick={() => {
                                this.setState({ allocationDetails: item }, () => { this.GetOTRoomList(item) })
                              }} emed_tid={`ot_request_table_create_appt_btn_${index}`}>
                                <CheckCircleIcon sx={{ height: '1.8vw', width: '1.8vw' }} color='primary' />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={t("Cancel Request")} arrow placement='top' emed_tid={`ot_request_table_cancel_tooltip_${index}`}>
                              <IconButton onClick={() => { this.setState({ deletePopup: true, selectedId: item?.id }) }} emed_tid={`ot_request_table_cancel_btn_${index}`}>
                                <CancelIcon sx={{ height: '1.8vw', width: '1.8vw' }} color='error' />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )) : null}
                  </TableBody>
                </Table>
              </Box>
            </div> :
            <div emed_tid="ot_request_table_no_records_container"><Typography id='eMed_Pres_pop_NORec' style={{ marginTop: "10vw" }} emed_tid="ot_request_table_no_records_text">{"No records found"}</Typography></div>}
        </div>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  DoctorRequestDetails = () => {
    const { t , getPatientDetails } = this.props;
    try {
      return (
        <div>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">Doctor Request</Typography>
            <IconButton onClick={() => this.setState({ DoctorRequestPopup: false })}>
              <CloseIcon />
            </IconButton>
          </Box>
          {this.state.doctorRequestData && this.state.doctorRequestData?.length > 0 ? (
            <div>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Patient Detail</TableCell>
                    <TableCell>Doctors Name</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.doctorRequestData.map((item, index) => (
                    <TableRow key={index}>
                      {/* Patient Detail Column */}
                      <TableCell>
                        <Box display="flex" alignItems="center">
                          <NewCommonPatientDetails data={item} />
                        </Box>
                      </TableCell>

                      {/* Doctor Name Column */}
                      <TableCell>
                        <Typography sx={{ fontWeight: 600, fontSize: '0.85vw' }}>
                          {item?.requested_by_name ? item?.requested_by_name : '-'}
                        </Typography>
                      </TableCell>

                      {/* Action Column */}
                      <TableCell align="center">
                        <Box display="flex" justifyContent="center">
                          <Tooltip title="Accept Request" arrow>
                            <IconButton onClick={() => {
                              this.handleAccept(item?.request_id);
                              this.setState({ doctorRequestData: [] });
                            }}>
                              <CheckCircleIcon sx={{ width: 20, height: 20 }} color="success" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Reject Request" arrow>
                            <IconButton onClick={() => {
                              this.handleReject(item?.request_id);
                              this.setState({ doctorRequestData: [] });
                            }}>
                              <CancelIcon sx={{ width: 20, height: 20 }} color="error" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                ))}
                </TableBody>
              </Table>
            </div>
          ) : (
            <div style={{ textAlign: 'center', marginTop: '10vh' }}>
              <Typography>{"No records found"}</Typography>
            </div>
          )}
        </div>
      );
    } catch (error) {
      this.errorMessage(error.message);
    }
  };


  FollowupTable = () => {
    const { t } = this.props
    try {
      return (
        <div>
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: "0.65vw" }}>
            <div>Follow-Up Appointment</div>
            <div>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={this.state.followDatePickerOpen}
                  onOpen={() => { this.setState({ followDatePickerOpen: true }) }}
                  onClose={() => { this.setState({ followDatePickerOpen: false }) }}
                  value={this.state.follow_up_date}
                  name={"datePicker"}
                  inputFormat='DD-MM-YYYY'
                  views={["year", "month", "day"]}
                  minDate={new Date()}
                  onChange={
                    (newDate) => {
                      this.setState({
                        follow_up_date: newDate
                      }, () => {
                        this.getFollowUpData()
                      });
                    }}
                  renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()} style={{ width: '10vw' }} size='small' {...params} onClick={() => { this.setState({ followDatePickerOpen: true }) }} />}
                />
              </LocalizationProvider>
            </div>
          </div>
          {this.state.followUpData && this.state.followUpData?.length > 0 ?
            <div style={{ width: '62vw', height: '65vh' }}> 
              <Box sx={{ maxHeight: '93%', overflow: 'auto', border: '1px solid lightgray' }} component={'div'}>
                <Table stickyHeader size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Patient Details</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Follow-Up Date</TableCell><TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Source Module</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Doctor Name</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Specilization</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Comments</TableCell>
                      <TableCell align='center' sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.followUpData?.length > 0 ? this.state.followUpData?.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ fontSize: "0.9vw" }}>
                          <div>
                            <div style={{ fontSize: "0.9vw" }}>{`${item?.patient_fname ? (item?.patient_fname) : ""} ${item?.patient_lname ? item?.patient_lname : ""}`}</div>
                            <div style={{ fontSize: "0.75vw" }}>{`${item?.patient_Mobile_no ? item?.patient_Mobile_no : "-"}`}</div>
                          </div>
                        </TableCell>
                        <TableCell style={{ fontSize: "0.9vw" }}>{item?.follow_up_date ? item?.follow_up_date : '-'}</TableCell>
                        <TableCell style={{ fontSize: "0.9vw" }}>{item?.source ? item?.source === 'In Patient' ? 'IP' : 'OP' : '-'}</TableCell>
                         <TableCell>
                          {item?.doctor_first_name ? item?.doctor_first_name?.length > 15 ?
                            <Tooltip placement='top' title={item?.doctor_title + item?.doctor_first_name}>
                              <Typography fontSize={'0.9vw'}>{item?.doctor_title + item?.doctor_first_name?.slice(0,15) + '...'}</Typography>
                            </Tooltip> :
                            <Typography fontSize={'0.9vw'}>{ item?.doctor_first_name ? (item?.doctor_title + '' + item?.doctor_first_name)  : "-"}</Typography>
                            : "-"}
                        </TableCell>
                        <TableCell fontSize={'0.9vw'}>
                          {item?.specialization ? item?.specialization >15 ?
                            <Tooltip placement='top' title={item?.specialization}>
                              <Typography fontSize={'0.9vw'}>{item?.specialization?.slice(0,15) + '...'}</Typography>
                            </Tooltip> :  
                            <Typography fontSize={'0.9vw'}>{item?.specialization ? item?.specialization : "-"}</Typography>
                            : "-"}
                        </TableCell>
                        <TableCell>
                          {item?.source === 'In Patient' ? 'IP Review' : 
                                item?.comments ? (item?.comments?.length > 15 ?
                            (<Tooltip placement='top' title={item?.comments}>
                              <Typography fontSize={'0.9vw'}>{item?.comments?.slice(0, 15) + '...'}</Typography>
                            </Tooltip>) :
                            (<Typography fontSize={'0.9vw'}>{item?.comments ? item?.comments : "-"}</Typography>))
                            : ("-")}
                        </TableCell>
                        <TableCell align='center'>
                          <Box component={'div'} display={'flex'} flexDirection={"row"} justifyContent={'center'}>
                            <Tooltip title={t("Create Appointment")} arrow placement='top'>
                              <IconButton onClick={() => {
                                this.setState({ FollowupPopup: false, follow_up_date: new Date() }, () => {
                                  if (item?.patient_id) {
                                    this.getDoctorPatientDetailData(item?.patient_id, 'Create Patient', true, item, "follow_ups", item?.doctor_id)
                                  }
                                })
                              }}>
                                <CheckCircleIcon sx={{ height: '1.8vw', width: '1.8vw' }} color='primary' />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={t("Cancel Request")} arrow placement='top'>
                              <IconButton onClick={() => { this.removeDataList(item) }}>
                                <CancelIcon sx={{ height: '1.8vw', width: '1.8vw' }} color='error' />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )) : null}
                  </TableBody>
                </Table>
              </Box>
            </div> :
            <div style={{ width: '62vw', height: '65vh' }}><Typography id='eMed_Pres_pop_NORec'>{"No records found"}</Typography></div>}
        </div>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  unlockNotesTable = () => {
    const { t } = this.props
    try {
      return (
        <div>
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: "0.65vw" }}>
            <div>Unlocked Doctor Notes</div>
          </div>
          <div>
            <Box>
              <Box className="eMed_App_reqest_table_head" width={'35vw'}>
                <Typography width={"50%"} fontWeight={'600'} fontSize={"0.8vw"}>Date</Typography>
                <Typography width={"50%"} fontWeight={'600'} fontSize={"0.8vw"}>No of Patient</Typography>
              </Box>
              <Box height={"57vh"} overflow={"scroll"} mt={"0.5vw"}>
                {this.state.unlockDocData && this.state.unlockDocData.length > 0 ?
                  this.state.unlockDocData.map((list) => {
                    return (
                      <Box>
                        <Box component={'div'} className="eMed_Header_Request_item" style={{ cursor: "pointer" }} width={'35vw'} onClick={() => { this.setState({ unlockDate: list?.appointment_date?.split("T")[0], unlockNotespopup: false }) }}>
                          <Box width={'50%'}>
                            <Typography fontWeight={'600'} fontSize={"0.85vw"}>{list?.appointment_date ? list?.appointment_date : "-"}</Typography>
                          </Box>
                          <Box width={'50%'}>
                            <Typography fontWeight={'600'} fontSize={"0.85vw"}>
                              {list?.total ? list?.total : "-"}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    )
                  })
                  :
                  <Box>
                    <Box className="eMed_Header_Request_item" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '20vh' }}>
                      <Typography>{t("NoRecordsFound")}</Typography>
                    </Box>
                  </Box>
                }
              </Box>
            </Box>
          </div>
        </div>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  // TransferAppointmentTable = () => {
  //   const { t } = this.props
  //   try {
  //     return (
  //       <div>
  //         <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: "0.65vw" }}>
  //           <div>Transfer Appointment</div>
  //         </div>
  //         {this.state.transferReqData && this.state.transferReqData.length > 0 ?
  //           <div className='eMed_App_DataView' style={{ width: '55vw' }}>
  //             <Box sx={{ maxHeight: '45vw', overflow: 'auto', border: '1px solid lightgray' }} component={'div'}>
  //               <Table stickyHeader size='small'>
  //                 <TableHead>
  //                   <TableRow>
  //                     <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Specialization</TableCell>
  //                     <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Doctor Name</TableCell>
  //                     <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Patient Details</TableCell>
  //                     <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Transfer Notes</TableCell>
  //                     <TableCell align='center' sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Action</TableCell>
  //                   </TableRow>
  //                 </TableHead>
  //                 <TableBody>
  //                   {this.state.transferReqData?.length > 0 ? this.state.transferReqData?.map((item, index) => (
  //                     <TableRow key={index}>
  //                       <TableCell style={{ fontSize: "0.9vw" }}>{item?.specialization_name ? item?.specialization_name : '-'}</TableCell>
  //                       <TableCell style={{ fontSize: "0.9vw" }}>{`${item?.from_doctor__title ? item?.from_doctor__title : ""} ${item?.from_doctor__first_name ? item?.from_doctor__first_name : "-"} ${item?.from_doctor__initial ? item?.from_doctor__initial : ""}`}</TableCell>
  //                       <TableCell style={{ fontSize: "0.9vw" }}>
  //                         <div>
  //                           <div style={{ fontSize: "0.9vw" }}>{`${item?.first_name ? item?.first_name : ""}${item?.last_name ? item?.last_name : " "}`}</div>
  //                           <div style={{ fontSize: "0.75vw" }}>{`${item?.patient_mobile ? item?.patient_mobile : "-"} | ${item?.patient_account_number ? item?.patient_account_number : "-"}`}</div>
  //                         </div>
  //                       </TableCell>
  //                       <TableCell>
  //                         {item?.transfer_notes ? item?.transfer_notes?.length > 15 ?
  //                           <Tooltip placement='top' title={item?.transfer_notes}>
  //                             <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.transfer_notes?.slice(0, 15) + '...'}</Typography>
  //                           </Tooltip> :
  //                           <Typography fontSize={'0.9vw'}>{item?.transfer_notes ? item?.transfer_notes : "-"}</Typography>
  //                           : "-"}
  //                       </TableCell>
  //                       <TableCell align='center'>
  //                         <Box component={'div'} display={'flex'} flexDirection={"row"} justifyContent={'center'}>
  //                           <Tooltip title={t("Accept Request")} arrow placement='top'>
  //                             <IconButton onClick={() => {
  //                               this.setState({ TransAppoint: false }, () => {
  //                                 this.cancelTransRequest(item?.id, "Approved")
  //                               })
  //                             }}>
  //                               <CheckCircleIcon sx={{ height: '1.8vw', width: '1.8vw' }} color='primary' />
  //                             </IconButton>
  //                           </Tooltip>
  //                           <Tooltip title={t("Cancel Request")} arrow placement='top'>
  //                             <IconButton onClick={() => { this.cancelTransRequest(item?.id, "Cancelled") }}>
  //                               <CancelIcon sx={{ height: '1.8vw', width: '1.8vw' }} color='error' />
  //                             </IconButton>
  //                           </Tooltip>
  //                         </Box>
  //                       </TableCell>
  //                     </TableRow>
  //                   )) : null}
  //                 </TableBody>
  //               </Table>
  //             </Box>
  //           </div> :
  //           <div><Typography id='eMed_Pres_pop_NORec' style={{ marginTop: "10vw" }}>{"No records found"}</Typography></div>}
  //       </div>
  //     );
  //   } catch (error) {
  //     this.errorMessage(error.message)
  //   }
  // }

  renderTransferListPopup = () => {
    try {
      this.state.transferReqData?.forEach((element, index) => element.sno = index + 1)
      const column = [
        {
          field: 'patientDetails', headerName: 'Patient Details', flex: 0.143,
          renderCell: (params) => {
            let patientName = params?.row?.patientDetails
            let patientAccMob = params?.row?.patientUnidMob
            return (
              <Box component={'div'}>
                {patientName ? patientName?.length > 20 ?
                  <Tooltip placement='top' title={patientName}><Box fontWeight={600} fontSize={'0.9vw'}>{patientName?.slice(0, 20) + '...'}</Box></Tooltip> :
                  <Box fontWeight={600} fontSize='0.9dvw'>{patientName}</Box> : '-'}
                {patientAccMob ? patientAccMob?.length > 20 ?
                  <Tooltip placement='top' title={patientAccMob}><Box fontSize={'0.8dvw'} color={Colors.grayShade}>{patientAccMob?.slice(0, 20) + '...'}</Box></Tooltip> :
                  <Box fontSize={'0.8dvw'} color={Colors.grayShade}>{patientAccMob}</Box> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'from_doctor__first_name', headerName: 'Previous Consultant', flex: 0.143,
          renderCell: (params) => {
            let doctorName = params?.row?.doctorName
            let specialisation = params?.row?.specialization_name
            return (
              <Box>
                {doctorName ? doctorName?.length > 12 ?
                  <Tooltip placement='top' title={doctorName}><Box fontSize={'0.9dvw'} fontWeight={600}>{doctorName?.slice(0, 12) + '...'}</Box></Tooltip> :
                  <Box fontSize={'0.9dvw'} fontWeight={600}>{doctorName}</Box> : '-'}
                {specialisation ? specialisation?.length > 12 ?
                  <Tooltip placement='top' title={specialisation}><Box fontSize={'0.8dvw'} color={Colors.grayShade}>{specialisation?.slice(0, 12) + '...'}</Box></Tooltip> :
                  <Box fontSize={'0.8dvw'} color={Colors.grayShade}>{specialisation}</Box> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'purpose_of_visit', headerName: 'Purpose of Visit', flex: 0.143,
          renderCell: (params) => {
            let pov = params?.row?.purpose_of_visit
            return (
              pov ? pov?.length > 15 ?
                <Tooltip placement='top' title={pov}><Box>{pov?.slice(0, 15) + '...'}</Box></Tooltip> :
                pov : '-'
            )
          }
        },
        {
          field: 'transfer_notes', headerName: 'Transfer Notes', flex: 0.11,
          renderCell: (params) => {
            let notes = params?.row?.transfer_notes
            return (
              <Box>
                {notes ? notes?.length > 15 ?
                  <Tooltip placement='top' title={notes}><Box>{notes?.slice(0, 15) + '...'}</Box></Tooltip> :
                  notes : '-'}
              </Box>
            )
          }
        },
        {
          field: 'specilaization', headerName: 'Specializiation', flex: 0.183,
          renderCell: (params) => {
            let specialization = params?.row?.specialization_name
            return (
              <Box component={'div'}>
                {specialization ? specialization?.length > 20 ?
                  <Tooltip placement='top' title={specialization}><Box>{specialization?.slice(0, 20) + '...'}</Box></Tooltip> :
                  specialization : '-'}
              </Box>
            )
          }
        },
        {
          field: 'Doctor Name', headerName: 'Doctor Name', flex: 0.183,
          renderCell: (params) => {
            let docName = params?.row?.doctor_name
            return (
              <Box component={'div'}>
                 {docName ? docName?.length > 20 ?
                    <Tooltip placement='top' title={docName}><Box>{docName?.slice(0, 20) + '...'}</Box></Tooltip> :
                    docName : '-' }
              </Box>
            )
          }
        },
        {
          field: 'action', headerName: 'Action', flex: 0.1,
          renderCell: (params) => {
            return (
              <Box component={'div'}>
                <Tooltip placement='top' title='Create Appointment'><Button
                  className='Common_Btn_Min_Width'
                  startIcon={<CheckCircleOutlineIcon color='primary' />}
                  onClick={() => this.cancelTransRequest(params?.row?.id, 'Approved')}
                /></Tooltip>
                <Tooltip placement='top' title={'Cancel'}>
                  <Button
                    className='Common_Btn_Min_Width'
                    startIcon={<CancelIcon color='error' />}
                    onClick={() => this.cancelTransRequest(params?.row?.id, 'Cancelled')}
                  ></Button>
                </Tooltip>
              </Box>
            )
          }
        },
      ]
      return (
        <Box component={'div'}>
          <Dialog
            open={this.state.TransAppoint}
            maxWidth="lg"
            fullWidth
          >
            <Box className='emedhub_popup_lobby' p={'1rem'}>
              <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Box component={'div'} display={'flex'} alignItems={'center'} mb={'0.5rem'}>
                  <Typography fontSize={'0.9dvw'} fontWeight={600} mr={'1rem'}>Transferred List</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      open={this.state.transDatePickerOpen}
                      onOpen={() => { this.setState({ transDatePickerOpen: true }) }}
                      onClose={() => { this.setState({ transDatePickerOpen: false }) }}
                      value={this.state.datePickerTrans}
                      name={"datePicker"}
                      inputFormat='DD-MM-YYYY'
                      views={["year", "month", "day"]}
                      onChange={(newDate) => {
                        this.setState({ datePickerTrans: newDate }, () => this.getTransferAppointmentData());
                      }}
                      renderInput={(params) => (
                        <TextField
                          onKeyDown={(e) => e.preventDefault()}
                          style={{ width: '10vw' }}
                          size='small'
                          {...params}
                          onClick={() => { this.setState({ transDatePickerOpen: true }) }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Box>
                <Button
                  className='Common_Btn_Min_Width'
                  onClick={() => this.setState({ TransAppoint: false })}
                >
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                </Button>
              </Box>
              <Box component={'div'} height={'30dvw'}>
                <DataGrid
                  columns={column}
                  rows={this.state.transferReqData}
                  getRowId={(row) => row['sno']}
                  page={this.state.transPage}
                  pageSize={this.state.transPageSize}
                  localeText={{
                    toolbarColumns: "",
                    toolbarDensity: "",
                    toolbarExport: "",
                    toolbarFilters: "",
                    toolbarExportPrint: ""
                  }}
                  components={{
                    NoRowsOverlay: () => (
                      <Box className='' sx={{ position: 'relative', top: '10vw', left: '33vw' }}>
                        {'No Records To Be Shown'}
                      </Box>
                    )
                  }}
                  onPageChange={(newPage) => { this.setState({ transPage: newPage }) }}
                  onPageSizeChange={(newPageSize) => this.setState({ transPageSize: newPageSize })}
                  rowsPerPageOptions={[10, 20, 30]}
                  pagination
                  headerHeight={40}
                  disableSelectionOnClick
                  loading={this.state.loading}
                />
              </Box>
            </Box>
          </Dialog>
        </Box>
      )
    } catch (error) {
      this.errorMsgFunc(error.message)
    }
  }

  // renderTelephonicTab = () => {
  //   try {
  //     let states = this.state
  //     return (
  //       <Box height={"40.2vh"} width = {"52.5vw"}>
  //         <Grid container className='eMed_IPappoint_Grid_row'>
  //           <Grid item xs={4} paddingTop={"1vw"}>
  //             <TextField
  //               sx={{ width: '14vw', position: "relative" }}
  //               size='small'
  //               inputProps={{ maxLength: 15 }}
  //               label={Object.keys(this.state.docSelectedRequestPatient).length > 0 ? "Mobile Number *" : "Mobile / UHID *"}
  //               value={this.state.docRequestMobileNumber}
  //               InputProps={{
  //                 endAdornment: this.state.isDocAppointRequest ?
  //                   <InputAdornment position="end"><CircularProgress size={15} /></InputAdornment>
  //                   : null,
  //               }}
  //               onChange={(e) => {

  //                 let number = CommonValidation.numberOnly(e.target.value);
  //                 this.setState({ docRequestMobileNumber: e.target.value, }, () => {
  //                   if (Object.keys(this.state.docSelectedRequestPatient).length > 0) {
  //                     this.setState({
  //                       docSelectedRequestPatient: {},
  //                       docRequestPatientName: "",
  //                       docRequestPatientAge: "",
  //                       docRequestPatientDOB: null,
  //                       docRequestPatientGender: "",
  //                     })
  //                   }
  //                   if (number && this.state.docRequestMobileNumber?.length >= 10) {
  //                     this.setState({ }, () => { this.DoctorPatientSearch(true, this.state.docRequestMobileNumber) })
  //                   }
  //                 })
  //               }}
  //               onKeyDown={(e) => {
  //                 e.stopPropagation()
  //                 if (this.state.docRequestPatientListAnchor) {
  //                   if (this.state.docRequestMobileNumber.length > 5 && e.key === "Enter") {
  //                     this.setState({}, () => { this.DoctorPatientSearch(true, this.state.docRequestMobileNumber) })
  //                   }
  //                   if (this.state.docRequestMobileNumber.length <= 5 && e.key === "Enter") {
  //                     this.errorMessage("Enter atleast 6 Characters for search")
  //                   }
  //                 } else {
  //                   this.setState({
  //                     docRequestPatientListAnchor: e.currentTarget
  //                   }, () => {
  //                     if (this.state.docRequestMobileNumber.length > 5 && e.key === "Enter") {
  //                       this.setState({}, () => { this.DoctorPatientSearch(true, this.state.docRequestMobileNumber) })
  //                     }
  //                     if (this.state.docRequestMobileNumber.length <= 5 && e.key === "Enter") {
  //                       this.errorMessage("Enter atleast 6 Characters for search")
  //                     }
  //                   })
  //                 }
  //               }}
  //             />
  //             <Menu
  //               open={this.state.docRequestPatientMenuPop}
  //               anchorEl={this.state.docRequestPatientListAnchor}
  //               // sx={{ position: 'absolute', top: '11vw', left: '-10vw', maxHeight: '20vw', overflow: 'auto' }}
  //               className="eMed_Header_CreateRequest_Pop"
  //               onClose={() => {
  //                 this.setState({ docRequestPatientMenuPop: false, docRequestPatientListAnchor : null, docSearchedRequestPatientList : [] })
  //               }}
  //               // anchorOrigin={{
  //               //   vertical: 'top',
  //               //   horizontal: 'center',
  //               // }}
  //               // transformOrigin={{
  //               //   vertical: 'top',
  //               //   horizontal: 'center',
  //               // }}
  //             >
  //               <Typography className='eMed_Request_sugg_Head'>Patient Name | UHID</Typography>
  //               {
  //                 this.state.docSearchedRequestPatientList?.length > 0 ? this.state.docSearchedRequestPatientList?.map((item, index) => {
  //                   let PatientFullName = `${(item?.first_name ? item?.first_name : "")} ${(item?.last_name ? item?.last_name : "")}`
  //                   return (
  //                     <MenuItem key={index} onClick={() => {
  //                       this.setState({
  //                         docSelectedRequestPatient: item,
  //                         docRequestPatientMenuPop: false,
  //                         docRequestMobileNumber: item?.mobile_number,
  //                         docRequestPatientName: item?.first_name ? item?.first_name + " " + item?.last_name : "-",
  //                         docRequestPatientAge: item?.patient_age ? item?.patient_age : CalculateAgeFromDob(item.dob !== null ? new Date(item?.dob) : new Date(item?.approx_dob)),
  //                         address_1: item?.address_line_1 ? item?.address_line_1 : "",
  //                         address_2: item?.address_line_2 ? item?.address_line_2 : "",
  //                         city: item?.city_name ? item?.city_name : "",
  //                         state_code: item?.state_name ? State.getStatesOfCountry(this.state.AllCountry?.find((list) => (list.name === item?.country))?.isoCode)?.find((list) => (list.name === item?.state_name))?.isoCode : "",
  //                         country_code: item?.country ? this.state.AllCountry?.find((list) => (list.name === item?.country))?.isoCode : "",
  //                         pin_code: item?.pincode ? item?.pincode : "",
  //                       })
  //                     }}
  //                       sx={{ width: '14vw' }}>
  //                       <Box sx={{ display: 'flex', alignItems: 'center', width: '14vw' }}>
  //                         {(PatientFullName?.length > 15) ? <Tooltip title={PatientFullName} placement='top' arrow><div>
  //                           <Typography fontWeight={600} fontSize={"0.8vw"} paddingRight={"0.3vw"}>{(PatientFullName?.length > 12 ? PatientFullName?.slice(0, 10) + ("...") : PatientFullName)}</Typography></div>
  //                         </Tooltip> : <Typography fontWeight={600} fontSize={"0.8vw"} paddingRight={"0.3vw"}>{PatientFullName}</Typography>} | {item?.patient_account_number?.length > 10 ? <Tooltip title={item?.patient_account_number} placement='top' arrow><div>
  //                           <Typography paddingX={"0.3vw"} fontSize={"0.8vw"}>{("..." + item?.patient_account_number?.slice(-8))}</Typography></div>
  //                         </Tooltip> : <Typography paddingX={"0.3vw"} fontSize={"0.8vw"}>{item?.patient_account_number}</Typography>}
  //                       </Box>
  //                     </MenuItem>
  //                   )
  //                 }) : null
  //               }
  //             </Menu>
  //           </Grid>
  //           <Grid item xs={4} paddingTop={"1vw"} >
  //             <TextField
  //               sx={{ width: '14vw' }}
  //               autoComplete='off'
  //               disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
  //               label="Patient Name *"
  //               value={this.state.docRequestPatientName}
  //               onChange={(e) => {
  //                 var isAlpha = CommonValidation.alphabetOnly(e.target.value)
  //                 if (isAlpha || e.target.value == "") {
  //                   this.setState({ docRequestPatientName: e.target.value })
  //                 }
  //               }}
  //               size='small'
  //               onKeyDown={(e) => { e.stopPropagation() }}
  //             />
  //           </Grid>
  //           <Grid item xs={4} paddingTop={"1vw"}>
  //             <TextField
  //               sx={{ width: '14vw' }}
  //               inputProps={{ maxLength: 3 }}
  //               autoComplete='off'
  //               disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
  //               label="Patient Age"
  //               value={this.state.docRequestPatientAge}
  //               onChange={(e) => {
  //                 let number = CommonValidation.numberOnly(e.target.value);
  //                 if ((e.target.value < 150) && (number || e.target.value === "")) {
  //                   this.setState({ docRequestPatientAge: e.target.value })
  //                 }
  //               }}
  //               size='small'
  //             />
  //           </Grid>
  //         </Grid>
  //         <Grid container className='eMed_IPappoint_Grid_row'  >
  //           {/* ======> Commented for doctor and specilization not in doctor module */}
  //           {/* <Grid item xs={4}>
  //             {this.renderDropdown("Doctor", "0vw", this.state.filteredDocList.length > 0 ? this.state.filteredDocList : this.state.doctorList, "RequestSelectedDocID")}
  //           </Grid>
  //           <Grid item xs={4}>
  //             {this.renderDropdown("Specialization", "0vw", this.state.spcInfo, "RequestSelectedSpecID")}
  //           </Grid> */}
  //           <Grid item xs={4} >
  //             <Box sx={{ width: '93%', mt: '1vw' }}>
  //               <LocalizationProvider dateAdapter={AdapterDateFns}>
  //                 <DateTimePicker
  //                   open={this.state.docDateOpen}
  //                   onOpen={() => { this.setState({ docDateOpen: true }) }}
  //                   onClose={() => { this.setState({ docDateOpen: false }) }}
  //                   inputFormat='dd-MM-yyyy & hh:mm a'
  //                   value={this.state.docRequestAppointDatetym}
  //                   disabled={this.state.doceditPatientId}
  //                   minDate={new Date()}
  //                   maxDate={new Date((new Date).getFullYear(), (new Date).getMonth() + 3, 0)}
  //                   onChange={(newDate) => {
  //                     if (newDate === null) {
  //                       this.setState({ docRequestAppointDatetym: new Date() })
  //                       // , () => this.getDoctorsList(true))
  //                     }
  //                     else {
  //                       this.setState({ docRequestAppointDatetym: newDate })
  //                       // , () => this.getDoctorsList(true))
  //                     }
  //                   }}
  //                   renderInput={(params) => <TextField
  //                     size='small'
  //                     inputProps={{ style: { fontSize: '0.8vw' } }}
  //                     onKeyDown={(e) => e.preventDefault()}
  //                     disabled={this.state.doceditPatientId}
  //                     onClick={() => { this.setState({ docDateOpen: true }) }}
  //                     {...params}
  //                     sx={{width: "14vw"}}
  //                     variant='outlined'
  //                     label="Appointment Date & Time *"
  //                   />}
  //                 />
  //               </LocalizationProvider>
  //             </Box>
  //           </Grid>
  //           <Grid item xs={8}>
  //             <Box>
  //               <Autocomplete
  //                 inputProps={{ maxLength: 250 }}
  //                 options={this.state.POVList}
  //                 getOptionLabel={(options) => options}
  //                 onChange={(e, value) => {
  //                   this.setState({
  //                     docRequestpurposeOfVisit: value
  //                   })
  //                 }}
  //                 onKeyDown={(e) => { e.stopPropagation() }}
  //                 clearIcon={false}
  //                 size='small'
  //                 sx={{ mt: "1vw", width: '31vw' }}
  //                 value={this.state.docRequestpurposeOfVisit}
  //                 renderInput={(params) => <TextField onChange={(event) => {
  //                   this.setState({
  //                     docRequestpurposeOfVisit: event.target.value
  //                   })
  //                 }}
  //                   {...params}
  //                   placeholder="Purpose Of Visit"
  //                 />}
  //               />
  //             </Box>
  //           </Grid>
  //         </Grid>

  //         <Grid container className='eMed_IPappoint_Grid_row' marginTop={"1vw"}>
  //               <Grid item xs={4}>
  //                 {
  //                   <TextField
  //                     sx={{ width: "14vw" }}
  //                     size="small"
  //                     autoComplete='off'
  //                     inputProps={{ maxLength: 100 }}
  //                     label={("Address 01")}
  //                     value={this.state.address_1}
  //                     disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
  //                     onChange={(e) => {
  //                       this.setState({ address_1: e.target.value })
  //                     }}
  //                     onKeyDown={(e) => {
  //                       e.stopPropagation()}}
  //                   />
  //                 }
  //               </Grid>
  //               <Grid item xs={4}>
  //                 {
  //                   <TextField
  //                     sx={{ width: "14vw" }}
  //                     size="small"
  //                     inputProps={{ maxLength: 100 }}
  //                     label={("Address 02")}
  //                     disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
  //                      autoComplete='off'
  //                     value={this.state.address_2}
  //                     onChange={(e) => {
  //                       this.setState({ address_2: e.target.value })
  //                     }}
  //                     onKeyDown={(e) => {
  //                       e.stopPropagation()}}
  //                   />
  //                 }
  //               </Grid>
  //               <Grid item xs={4} >
  //                 <Autocomplete
  //                   sx={{ width: "14vw" }}
  //                   size="small"
  //                   options={states.cityName ? states.cityName : []}
  //                   getOptionLabel={(option) => typeof (option) === "string" ? option : option.name}
  //                   disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
  //                   onChange={(e, value) => {
  //                     this.setState({
  //                       city: value?.name ? value?.name : '',
  //                       // pin_code: '',
  //                     })
  //                   }}
  //                   clearIcon={false}
  //                   value={states.city}
  //                   renderInput={(params) => (
  //                     <TextField
  //                       label={"City"}
  //                        autoComplete='off'
  //                       InputProps={{ ...params.InputProps }}
  //                       onChange={(e) => this.setState({
  //                         city: e.target.value,
  //                         // pin_code: ''
  //                       })}  
  //                    {...params}
  //                     />)}
  //                   onKeyDown={(e) => e.key === "Enter" ? e.preventDefault() : null}
  //                 />


  //               </Grid>
  //             </Grid>


  //             <Grid container className='eMed_IPappoint_Grid_row' marginTop={"1vw"}>
  //               <Grid item xs={4}>
  //                 <FormControl size='small' sx={{ width: '12vw' }}>
  //                   <InputLabel id="title-select-label">{"Select State"}</InputLabel>
  //                   <Select
  //                      sx={{ width: '14vw' }}
  //                     MenuProps={{ style: { maxHeight: 250, maxWidth: '12vw' } }}
  //                     labelId='gender-select-label'
  //                     size='small'
  //                     label={"Select State"}
  //                     disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
  //                     value={states.state_code}
  //                     onChange={(e) => {
  //                       this.setState({ state_code: e.target.value },
  //                         () => {
  //                           this.setState({ cityName: City.getCitiesOfState(this.state.country_code, this.state.state_code), city: '' })
  //                         })
  //                     }}
  //                   >
  //                     {
  //                       states.AllStates.map((list) => (
  //                         <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
  //                       ))
  //                     }
  //                   </Select>
  //                 </FormControl>
  //               </Grid>
  //               <Grid item xs={4}>
  //                 <FormControl size='small' sx={{ width: '12vw', maxWidth: '12vw' }}>
  //                   <InputLabel id="title-select-label">{"Select Country"}</InputLabel>
  //                   <Select
  //                     // disabled={this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)}
  //                     sx={{ width: '14vw' }}
  //                     MenuProps={{ style: { maxHeight: 250, maxWidth: '12vw' } }}
  //                     labelId='gender-select-label'
  //                     label={"Select Country"}
  //                     disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
  //                     size='small'
  //                     value={states.country_code}
  //                     onChange={(e) => {
  //                       this.setState({ country_code: e.target.value, state_code: "", city: '' }, () => {
  //                         this.setState({ AllStates: State.getStatesOfCountry(this.state.country_code), cityName: '' })
  //                       })
  //                     }}
  //                   >
  //                     {
  //                       states.AllCountry.map((list) => (
  //                         <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
  //                       ))
  //                     }
  //                   </Select>
  //                 </FormControl>
  //               </Grid>
  //               <Grid item xs={4} >
  //                 <TextField
  //                 sx={{ width: '14vw' }}
  //                   // disabled={((data.label === "First Name") ? Object.keys(this.state.RequestedPatientData).length > 0 : false) || (this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess))}
  //                    autoComplete='off'
  //                   inputProps={{ maxLength: 6 }}
  //                   label={"Pincode"}
  //                   variant="outlined"
  //                   value={this.state.pin_code}
  //                   disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
  //                   onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
  //                   onChange={(e) => {
  //                     if ((CommonValidation.numberOnly(e.target.value) || e.target.value == "") && e.target.value.length <= 6) {
  //                       this.state.pin_code = e.target.value
  //                       this.setState({
  //                         states
  //                       }, () => {
  //                         if (this.state.pin_code && this.state.pin_code.length === 6) {
  //                           this.getPincodeToCity(this.state.pin_code)
  //                         }
  //                       })
  //                     }
  //                   }}

  //                   size="small"
  //                 />
  //               </Grid>
  //             </Grid>

          



  //         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  //           <Typography marginLeft={"2vw"}>{Object.keys(this.state.SelectedRequestPatient).length > 0 ? `UHID : ${this.state.SelectedRequestPatient?.patient_account_number}` : ""}</Typography>
  //           <Box className="eMed_CreateRequest_BtnBox">
  //             <Button size='small' id="eMed_Config_btn" sx={{ marginRight: '1vw' }} onClick={() => { this.docClearRequestData() }} variant='outlined'>Clear</Button>
  //             <Button size='small' id="eMed_Config_btn" disabled={this.state.isClked} variant='contained' onClick={() => this.setState({ isClked: true }, () => this.CreateAppointRequest(true))}>{this.state.doceditAppointmentId ? "Update Request" : "Create Request"}</Button>
  //           </Box>
  //         </Box>
  //       </Box>
  //     )
  //   } catch (error) {
  //     this.errorMessage(error.message)
  //   }
  // }
  // Doctor Appointment Request Popup ends =====>

  // Radiology Starts ====> 

  lodaerFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  getRadiologyPatientData = (id, update, billSummaryId, data, isFrom) => {
    try {
      this.lodaerFunction(true)
      RestAPIService.getAll(Serviceurls.FO_PATIENT_UPDATE + '?patient_id=' + id)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.lodaerFunction(false)
            this.setState({
              patientDetails: response?.data?.data
            }, () => {
              if (update === 'update') {
                setCachevalue(JSON.stringify(this.state.patientDetails), "RadPatientData")
                this.props.history.push({ pathname: `/${GetInvestigationName()}Home/Demographics/Update`, state: { radUpdate: true, } })
              } else if (update === 'savedBill') {
                this.props.history.push({ pathname: `/${GetInvestigationName()}Home/Patient/Billing`, state: { fromSavedBill: true, patientData: this.state.patientDetails, billSummaryId: billSummaryId } })
              } else if (update === "TransmitToFoRad") {
                setCachevalue(JSON.stringify(this.state.patientDetails), 'RadPatientData')
                this.props.history.push({ pathname: '/Billing/RadiologyBilling', state: { patientData: this.state.patientDetails, forTransmit: true, TransmitData: data || {} } })
              } else {
                setCachevalue(JSON.stringify(this.state.patientDetails), 'RadPatientData')
                if (isFrom === "isFromIpBill") {
                  setCachevalue(JSON.stringify(true), 'IsFromIPBill')
                }else if(isFrom === "isFromOPBill"){
                  setCachevalue(JSON.stringify(true), 'IsFromOPBill')
                }
                if(localGetItem('isNewBilling') === 'true'){
                  setCachevalue(this.state.patientDetails?.patient_id,'OP_CreateAppointment_PatientId')
                  this.props.history.push({ pathname: `/${GetInvestigationName()}Home/NewQuickBilling`})
                }else{
                this.props.history.push({ pathname: `/${GetInvestigationName()}Home/Demographics`, state: { patientData: this.state.patientDetails, forRadCreate: true, TransmitData: data || {} } })
                }
              }
            })
          }
        }).catch((error) => {
          this.lodaerFunction(false)
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.lodaerFunction(false)
      this.errorMessage(error.message)
    }
  }
getS3Keys = async (documents) => {
  try {
    if (!documents || documents.length === 0) {
      return;
    }

    let previewItems = [];

    for (const doc of documents) {
      const docName = doc.document_name;
      const docKey = doc.document_file;

      const response = await RestAPIService.getAllTwo(
        Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(docKey)
      );

      if (response?.data?.status === "success") {
        const fileUrl = response.data.data;

        if (docName.toLowerCase().includes(".pdf")) {
          const base64 = await fetchAndConvertToBase64(fileUrl);

          const pdfBase64 = base64.replace(
            "data:binary/octet-stream;",
            "data:application/pdf;"
          );

          previewItems.push({ type: "pdf", url: pdfBase64, name: docName });
        }

      } else {
        console.log("Invalid response:", response?.data);
      }
    }

    this.setState({
      printPreviewPop: true,
      printPreviewData: previewItems,
      pdfName: "Result Preview"
    });

  } catch (error) {
    console.log("S3 preview error:", error);
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: "Error fetching S3 URL"
    });
  }
};

  getPatientHistoryPrint = (id) => {
    try {
      let api = localGetItem("isNewBilling") === "true"? Serviceurls.NEW_RAD_RESULT_PRINT : Serviceurls.RAD_RESULT_PRINT
        RestAPIService.getAllPrint(`${api}?id=${id}&export_type=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          if (error?.response?.data?.message === "'NoneType' object has no attribute 'split'" || error?.response?.data?.message === "'NoneType' object has no attribute 'replace'") {
            this.errorMessage("No data found", false);
          } else {
            this.errorMessage(error.response?.data?.message, false);
          }
        })

    } catch (error) {
      this.errorMessage(error.message || "Unexpected error");
    }
  };
  getAllDocuments = (details) => {
    if (!details || details.length === 0) return [];

    let docs = [];

    details.forEach((d) => {
      if (d.result_document && Array.isArray(d.result_document)) {
        docs.push(...d.result_document);
      }
    });

    return docs;
  };
  hasDocuments = (details) => {
    if (!details || details.length === 0) return false;

    for (const d of details) {
      if (Array.isArray(d.result_document) && d.result_document.length > 0) {
        return true;
      }
    }
    return false;
  };
  closePrintPreview = () => {
    this.setState({
      printPreviewPop: false,
      printPreviewData: [],
      pdfName: ''
    })
  }

  radiologyPatientSearch() {
    try {
      let { t } = this.props;
      let clinicId = this.state.loggedInuserInfo?.clinic_id
      let API_URL = ''
      this.isPatientisSearching(true)
      var DobDate = new Date(this.state.FilterDob)
      var date = this.state.FilterDob ? DateTime.fromJSDate(DobDate).toFormat('yyyy-MM-dd') : ""
      API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${this.state.PatientNameSearchKey}&address_key=${this.state.PatientAddressKey}&father_husband_key=${this.state.PatientFathHusKey}&mother_name_key=${this.state.PatientMotherKey}&uhid=${this.state.FilterUHID}&dob=${date}&clinic_id=${clinicId}`
      RestAPIService.getAll(API_URL).
        then((response) => {
          if (response.data.status === "success") {
            this.isPatientisSearching(false)
            this.setState({
              searchPatientRadiologyList: response.data.data,
              // RequestPatientMenuPop: response?.data?.data?.patient?.length > 0 ? true : false
            }, () => {
              if (this.state.PatientNameSearchKey !== "" || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "") {
                if (response.data.data?.length > 0) {
                  this.setState({ PatientSearchClicked: true, AddressFilterClicked: false })
                } else {
                  this.isPatientisSearching(false)
                  this.errorMessage(t("NoRecordsFound"))
                }
              }
            })
          }
          else {
            this.isPatientisSearching(false)
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error?.message)
          }
          this.isPatientisSearching(false)
        })
    }
    catch (e) {
      this.isPatientisSearching(false)
      this.errorMessage(e.message)
    }
  }

  RadiologyHeaderSearch = () => {
    const { t } = this.props;
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser
    return (
      <Box sx={{ marginLeft: '3.2vw' }}>
        <Box component={'div'} display={'flex'} flexDirection={'row'} sx={{ borderRadius: "0.3vw" }}>
          {(UserData?.module_name === "Radiology" || UserData?.module_name === "Investigation") ?
             <PatientHeaderSearch
                t={this.props.t}
                isLoading={this.state.isPatientisSearching}
                filterVisible={this.state.PatientAddressKey === "" && this.state.PatientFathHusKey === "" && this.state.PatientMotherKey === "" && this.state.FilterDob === null && this.state.FilterUHID === ""}                
                flterOpen = {this.handleFilterOpen}
                faceOpen = {this.handleFaceOpen}
                module_name = {UserData?.module_name}
                faceVisible = {this.state.isfaceRecognizationEnabled}
                onSearchSubmit={this.handleSearchSubmit}
                onClear={this.handleSearchClear}
                searchValue={this.state.PatientNameSearchKey}
              />
            // <OutlinedInput
            //   placeholder={t("SearchPatients")}
            //   onKeyDown={(event) => {
            //     if (event.key === "Enter" && event.target.value != "" && event.target.value?.length > 2) {
            //       event.preventDefault();
            //       this.radiologyPatientSearch()
            //     } else if (event.key === "Enter" && event.target.value === "" && event.target.value.length <= 0) {
            //       this.setState({ PatientSearchClicked: false })
            //     }
            //   }}
            //   onChange={(e) => {
            //     this.setState({
            //       PatientNameSearchKey: e.target.value
            //     })
            //   }}
            //   value={this.state.PatientNameSearchKey}
            //   size="small"
            //   className='eMed_header_Input'
            //   endAdornment={
            //     <Box component={'div'} display={'flex'} flexDirection={'row'}>
            //       <Divider orientation="vertical" variant="middle" flexItem />
            //       {this.state.isPatientisSearching ?
            //         <Box sx={{ display: 'flex', alignItems: "center", justifyContent: "center", width: '2.5vw' }}>
            //           <InputAdornment position="end"><CircularProgress size={15} /></InputAdornment>
            //         </Box> :
            //         <Tooltip title={t("Search")} arrow>
            //           <IconButton disabled={this.state.PatientNameSearchKey === "" && this.state.PatientAddressKey === "" && this.state.PatientFathHusKey === "" && this.state.PatientMotherKey === "" && this.state.FilterDob === null && this.state.FilterUHID === ""}
            //             onClick={(e) => {
            //               if ((this.state.PatientNameSearchKey !== "" && this.state.PatientNameSearchKey.length > 2) || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "") {
            //                 this.radiologyPatientSearch()
            //               }
            //             }} position="end">
            //             <SearchIcon />
            //           </IconButton>
            //         </Tooltip>}
            //       <Tooltip title={t("Filter")} arrow>
            //         <IconButton onClick={() => { this.setState({ AddressFilterClicked: true }) }} position="end">
            //           <Badge color="error" size='small' variant="dot" max={999} invisible={this.state.PatientAddressKey === "" && this.state.PatientFathHusKey === "" && this.state.PatientMotherKey === "" && this.state.FilterDob === null && this.state.FilterUHID === ""}>
            //             <FilterAltIcon />
            //           </Badge>
            //         </IconButton>
            //       </Tooltip>
            //       {this.state.isfaceRecognizationEnabled ? <Tooltip title={t("FaceRecognition")} arrow>
            //         <IconButton onClick={() => { this.setState({ docFaceRecogClicked: true },()=>{ this.getConnectedDevices()}) }} position="end">
            //           <CenterFocusWeakIcon />
            //         </IconButton>
            //       </Tooltip> : null}
            //     </Box>
            //   }
            // />
            : null}
        </Box>
        <Menu
          open={this.state.PatientSearchClicked}
          className="eMed_rad_header_search"
          disableAutoFocus
          disableEnforceFocus
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          MenuListProps={{
            autoFocus: false
          }}
          onClose={() => {
            this.setState({
              PatientSearchClicked: false,
              // PatientNameSearchKey: "",
              PatientAddressKey: "",
              PatientFathHusKey: "",
              FilterDob : null ,
              FilterUHID : "",
              FilterIP: "",
              FilterOP: "",
            })
          }}
        >     
          {
            this.state.searchPatientRadiologyList?.length > 0 ?
              this.state.searchPatientRadiologyList?.map((list) => {
                let PatientFullName = `${list.first_name} ${list.last_name}`
                list["patient_name"] = PatientFullName
                list["patient_mobile_number"] = list.mobile_number
                list["patient_photo_url"] = list.photo_url
                 let getRadPateintHistoryData = () => {
                    try {
                      const radiologyId = JSON.parse(localGetItem('loggedInUserInfo'))?.radiology_id;
                      const clinicId = JSON.parse(localGetItem('loggedInUserInfo'))?.clinic_id
                      RestAPIService.getAll(Serviceurls.RAD_PATIENT_BILLS_HISTORY +`?patient_id=${this.state.patientDatasRow?.patient_id}`+ `&radiology_id=${radiologyId}`+`&clinic_id=${clinicId}`)
                        .then((response) => {
                          if (response.data.status === 'success') {
                            this.setState({
                              patientHistory: response.data.data,
                              loading: false
                            })
                          }
                        }).catch((error) => {
                          if (error?.response?.data?.message) {
                            this.errorMessage(error.response.data.message)
                          } else {
                            this.errorMessage(error.message)
                          }
                        })
                    } catch (error) {
                      this.errorMessage(error.message)
                    }
                  }
                let routeToDemograhics = (params) => {
                  this.setState({
                    patientDatasRow: params,
                    radHistoryPopup: true
                  }, () => getRadPateintHistoryData() )
                }
               

                
                
                return (
                  <Box>
                    <Box className="eMed_Header_Search_item">
                      <CommonPatientDetails data={list} fromSearch={true} />
                      {<Box component={'div'} className="eMed_Header_Search_icons">
                        <Tooltip title={t("EditPatientDetails")} arrow>
                          <IconButton emed_tid='rad_app_lst_edt_btn' onClick={() => {
                            this.setState({
                              PatientNameSearchKey: "",
                              PatientAddressKey: "",
                              PatientFathHusKey: "",
                              FilterDob: null,
                              FilterUHID: "",
                              PatientSearchClicked: false,
                              SearchedPatientList: []
                            }, () => {
                              this.getRadiologyPatientData(list?.patient_id, 'update')
                            })
                          }}
                            position="end">
                            <Edit color='primary' />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={t("CreateAppointment")} arrow>
                          <IconButton emed_tid='rad_app_crte_btn' onClick={() => {
                            this.setState({
                              PatientNameSearchKey: "",
                              PatientAddressKey: "",
                              PatientFathHusKey: "",
                              FilterDob: null,
                              FilterUHID: "",
                              PatientSearchClicked: false,
                              SearchedPatientList: []
                            }, () => {
                              this.getRadiologyPatientData(list?.patient_id)
                            })
                          }}
                            position="end">
                            <PersonAddAlt1Icon color='primary' />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={t("Patient History")} arrow>
                          <IconButton emed_tid='rad_app_crte_btn' onClick={() => {
                            this.setState({
                              PatientNameSearchKey: "",
                              PatientAddressKey: "",
                              PatientFathHusKey: "",
                              FilterDob: null,
                              FilterUHID: "",
                              PatientSearchClicked: false,
                              SearchedPatientList: []
                            }, () => {
                              routeToDemograhics(list)
                            })
                          }}
                            position="end">
                            <HistoryIcon color='primary' />
                          </IconButton>
                        </Tooltip>
                        {/* <Typography>{list.appointment_date && formatDate(list.appointment_date)}</Typography> */}
                      </Box>}
                    </Box>           

                    <Divider />
                  </Box>
                )
              }) : null
          }
        </Menu>
        <Menu
          open={this.state.AddressFilterClicked}
          className="eMed_Header_Filter_Pop"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={() => {
            this.setState({ AddressFilterClicked: false })
          }}
        >
          {this.DynamicFilterFeilds(true)}
        </Menu>

      </Box>
    )
  }

  getRadAppointmentListData = (fromoplist = false) => {
    try {
      let fromDate = fromoplist ? this.state.opListDate : this.state.radAppointmentDate
      let startDate = new Date(fromDate)
      let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      let selectedID = JSON.parse(localGetItem('SelectedDoctorClinicId'))
      let clinicId = JSON.parse(localGetItem('loggedInUserInfo'))
      this.setState({opListData: []})
      RestAPIService.getAll(Serviceurls.RAD_APPOINTMENT_GET + `?search_date=${date}&clinic_id=${clinicId?.clinic_id || (selectedID || null)}&doctor_id=${clinicId?.doctor_id || ""}`)
        .then((response) => {
          if (response.data.status === 'success') {
            let opListFilter = response?.data?.data?.filter(item => !item?.is_ip)
            this.setState({
              radAppointmentList: response.data.data,
              dupAppointmentList: JSON.stringify(response.data.data),
              opListData:opListFilter,
              dupOpList:JSON.stringify(opListFilter)
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  GetRtWalkinData = () => {
    try {
      let fromDate = this.state.opListDate
      let startDate = new Date(fromDate)
      let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      let clinicId = JSON.parse(localGetItem('loggedInUserInfo'))
      RestAPIService.getAll(Serviceurls.RT_WALKIN_APPOINTMENTS + `?date=${date}` + '&clinic_id=' + clinicId?.clinic_id)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              walkInAppointData: response.data.data,
              dupwalkInAppointData: JSON.stringify(response.data.data),
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  
  isPharmaMoveToCashCounterFlowEnabled = () => {
    try {
      return JSON.parse(localGetItem('enable_cash_counter_bill_modification') || 'false')
    } catch {
      return false
    }
  }

  getRefundRequestData = () => {
    try {
      RestAPIService.getAll(Serviceurls.NEW_BILING_CANCEL_REQUEST)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              CashCounterRefundRequestList: response.data.data,
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getPharmaCashCounterBillsCount = () => {
    try {
      if (!this.isPharmaMoveToCashCounterFlowEnabled()) {
        this.setState({ pharmaCashCounterBillsCount: 0 })
        return
      }
      const fromDate = this.state.pharmaCashCounterBillsDate
      const startDate = new Date(fromDate)
      const dateStr = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      RestAPIService.getAll(Serviceurls.PHARMA_CASH_COUNTER_BILL_DETAILS + (dateStr ? '?date=' + dateStr : ''))
        .then((response) => {
          const list = (response?.data?.status === 'success' && response?.data?.data) ? (Array.isArray(response.data.data) ? response.data.data : (response.data.data?.list || response.data.data?.bills || [])) : []
          this.setState({ pharmaCashCounterBillsCount: list?.length || 0 })
        })
        .catch(() => {
          this.setState({ pharmaCashCounterBillsCount: 0 })
        })
    } catch (error) {
      this.setState({ pharmaCashCounterBillsCount: 0 })
    }
  }
  getPharmaCashCounterBillsList = () => {
    try {
      if (!this.isPharmaMoveToCashCounterFlowEnabled()) {
        this.setState({
          pharmaCashCounterBillsLoad: false,
          pharmaCashCounterBillsList: [],
          dupPharmaCashCounterBillsList: '[]',
          pharmaCashCounterBillsCount: 0,
        })
        return
      }
      this.setState({ pharmaCashCounterBillsLoad: true })
      const fromDate = this.state.pharmaCashCounterBillsDate
      const startDate = new Date(fromDate)
      const dateStr = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      RestAPIService.getAll(Serviceurls.PHARMA_CASH_COUNTER_BILL_DETAILS + (dateStr ? '?date=' + dateStr : ''))
        .then((response) => {
          const list = (response?.data?.status === 'success' && response?.data?.data) ? (Array.isArray(response.data.data) ? response.data.data : (response.data.data?.list || response.data.data?.bills || [])) : []
          this.setState({
            pharmaCashCounterBillsList: list,
            dupPharmaCashCounterBillsList: JSON.stringify(list),
            pharmaCashCounterBillsCount: list?.length || 0,
            pharmaCashCounterBillsLoad: false
          })
        })
        .catch((error) => {
          this.setState({
            pharmaCashCounterBillsList: [],
            dupPharmaCashCounterBillsList: '[]',
            pharmaCashCounterBillsCount: 0,
            pharmaCashCounterBillsLoad: false
          })
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ pharmaCashCounterBillsLoad: false })
      this.errorMessage(error.message)
    }
  }

  closeRadAppointment = () => {
    this.setState({
      rad_appointment: false,
      radAppointmentDate: new Date()
    }, () => this.getRadAppointmentListData())
  }

  renderRadAppointments = () => {
    try {
      return (
        <Box component={'div'}>
          <Menu
            id="basic-menu"
            anchorEl={this.state.radAppAnchorEL}
            open={this.state.rad_appointment}
            onClose={() => this.closeRadAppointment()}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            sx={{ position: 'absoulte', top: '2.5vw' }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'bottom',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'bottom',
            }}
          >
            <Box component={'div'} p={'0.5vw'}>
              <Box component={'div'} display={'flex'} justifyContent={'space-between'}>
                <Typography fontWeight={600} fontSize={'0.9vw'}>Appointments</Typography>
                <Box component={'div'} onClick={() => this.closeRadAppointment() } sx={{ cursor: 'pointer' }}>
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                </Box>
              </Box>
              <Box component={'div'} mt={'0.5vw'} display={'flex'}>
                <TextField
                  size='small'
                  value={this.state.searchRadAppointment}
                  onChange={(e) => this.setState({ searchRadAppointment: e.target.value }, () => {
                    let dupAppointmentList = JSON.parse(this.state.dupAppointmentList)
                    if (this.state.searchRadAppointment !== '') {
                      dupAppointmentList = dupAppointmentList.filter((item) => {
                        return (
                          (item?.patient_name === '' ? '' : item?.patient_name?.toLowerCase()?.includes(this.state.searchRadAppointment?.toLowerCase())))
                      })
                      this.setState({ radAppointmentList: dupAppointmentList })
                    } else {
                      this.setState({ radAppointmentList: dupAppointmentList })
                    }
                  })}
                  sx={{ width: '20vw', mr: '1vw' }}
                  placeholder='Search Appointment....'
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    open={this.state.DatePickerOpen}
                    onOpen={() => { this.setState({ DatePickerOpen: true }) }}
                    onClose={() => { this.setState({ DatePickerOpen: false }) }}
                    value={this.state.radAppointmentDate}
                    name={"datePicker"}
                    inputFormat='DD-MM-YYYY'
                    views={["year", "month", "day"]}
                    onChange={(newDate) => { this.setState({ radAppointmentDate: newDate }, () => this.getRadAppointmentListData()) }}
                    renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()}
                      style={{ width: '10vw' }} size='small' {...params}
                      onClick={() => { this.setState({ DatePickerOpen: true }) }} />}
                  />
                </LocalizationProvider>
              </Box>
              {this.state.radAppointmentList?.length > 0 ? this.state.radAppointmentList?.map((item, index) => {
                return (
                  <Box component={'div'} key={index} display={'flex'} alignItems={'center'} mt={'1vw'}>
                    <Box component={'div'} display={'flex'} alignItems={'center'} width={'22vw'}>
                      <Box component={'div'} display={'flex'} alignItems={'center'} mr={'0.5vw'}>
                        <Box component={'img'}
                          src={item?.patient_photo_url === null || item?.patient_photo_url === "" || item?.patient_photo_url === undefined ? item?.patient_gender === "Male" || item?.patient_gender === "m" || item?.gender === "m" ? ImagePaths.Male.default : ImagePaths.Female.default : item?.patient_photo_url} height={'2.8vw'} width={'2.8vw'}
                          border={`1.8px solid ${(item?.patient_type === "new_patient" || item?.patient__patient_type === 1) ? "#F1584A" : (item?.patient_type === "old_patient") || (item?.patient_type === "establish_patient") || (item?.patient__patient_type === 3) ? "#800080" : '#29B6F6'}`}
                          borderRadius={'50px'}
                        />
                      </Box>
                      <Box component={'div'}>
                        {item?.patient_name ?
                          item?.patient_name?.length > 14 ?
                            <Tooltip placement='top' title={item?.patient_name} arrow><Typography component={'div'} fontWeight={600} fontSize={'0.9vw'} >{item?.patient_name?.slice(0, 14) + '...'}
                              <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600}>{`${item?.patient_age ? item?.patient_age : '-'}/${item?.patient_gender ? (item?.patient_gender)?.toUpperCase() : '-'}`}</Typography>
                            </Typography></Tooltip> :
                            <Typography component={'div'} fontWeight={600} fontSize={'0.9vw'} >{item?.patient_name}
                              <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600} ml={'0.5vw'}>{`${item?.patient_age ? item?.patient_age : '-'}/${item?.patient_gender ? (item?.patient_gender)?.toUpperCase() : '-'}`}</Typography>
                            </Typography>
                          : '-'}
                        <Typography component={'div'} color={Colors.grayShade} fontSize={'0.8vw'}>{item?.patient_account_number ? item.patient_account_number : '-'} |
                          <Typography component={'span'} fontSize={'0.8vw'} color={Colors.grayShade}>{item?.patient_mobile_number ? item?.patient_mobile_number : '-'}</Typography>
                        </Typography>
                      </Box>
                      {item?.op_number ? <Box component={'div'}><Typography component={'div'} color={Colors.grayShade} fontSize={'0.8vw'}>{item?.op_number}</Typography></Box> : null}
                    </Box>
                    <Box component={'div'}>
                      <Button variant='contained' size='small' emed_tid='rad_ip_req_btn'
                        onClick={() => this.setState({ radAppAnchorEL: null, searchRadAppointment: '', rad_appointment: false, radAppointmentDate: new Date() }, () => {
                          this.getRadiologyPatientData(item?.patient_id, null, null, null, "isFromOPBill")
                        })}
                      >Proceed</Button>
                    </Box>
                  </Box>
                )
              }) : <Typography display={'flex'} justifyContent={'center'} mt={'2vw'}>No Records To Be Shown</Typography>}
            </Box>
          </Menu>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getRadIPListData = () => {
    try {
      let startDate = new Date(this.state.radIpListDate)
      let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')

      RestAPIService.getAll(Serviceurls.IP_LIST_LABHOME)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              radIpList: response.data.data,
              dupIpListData: JSON.stringify(response.data.data)
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderRadIpAppointmentList = () => {
    try {
      return (
        <Box component={'div'}>
          <Menu
            id="basic-menu"
            anchorEl={this.state.radReqAnchorEl}
            open={this.state.rad_request}
            onClose={() => this.setState({ rad_request: false })}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            sx={{ position: 'absoulte', top: '2.5vw', left: '0.9vw' }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'bottom',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'bottom',
            }}
          >
            <Box component={'div'} p={'0.5vw'}>
              <Box component={'div'} display={'flex'} justifyContent={'space-between'}>
                <Typography fontWeight={600} fontSize={'0.9vw'}>IP List</Typography>
                <Box component={'div'} onClick={() => this.setState({ rad_request: false })} sx={{ cursor: 'pointer' }}>
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                </Box>
              </Box>
              <Box component={'div'} mt={'0.5vw'} display={'flex'}>
                <TextField
                  size='small'
                  value={this.state.searchRadIpList}
                  onChange={(e) => this.setState({ searchRadIpList: e.target.value }, () => {
                    let dupIpListData = JSON.parse(this.state.dupIpListData)
                    if (this.state.searchRadIpList !== '') {
                      dupIpListData = dupIpListData.filter((item) => {
                        return (
                          (item?.patient_name === '' ? '' : item?.patient_name?.toLowerCase()?.includes(this.state.searchRadIpList?.toLowerCase())))
                      })
                      this.setState({ radIpList: dupIpListData })
                    } else {
                      this.setState({ radIpList: dupIpListData })
                    }
                  })}
                  sx={{ width: '20vw', mr: '1vw' }}
                  placeholder='Search IP List....'
                />
                {/* commented for if date search asked in further .... */}
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    open={this.state.radDatePickerOpen}
                    onOpen={() => { this.setState({ radDatePickerOpen: true }) }}
                    onClose={() => { this.setState({ radDatePickerOpen: false }) }}
                    value={this.state.radIpListDate}
                    name={"datePicker"}
                    inputFormat='DD-MM-YYYY'
                    views={["year", "month", "day"]}
                    onChange={(newDate) => { this.setState({ radIpListDate: newDate }, () => this.getRadIPListData()) }}
                    renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()}
                      style={{ width: '10vw' }} size='small' {...params}
                      onClick={() => { this.setState({ radDatePickerOpen: true }) }} />}
                  />
                </LocalizationProvider> */}
              </Box>
              {this.state.radIpList?.length > 0 ? this.state.radIpList?.map((item, index) => {
                return (
                  <Box component={'div'} key={index} display={'flex'} alignItems={'center'} mt={'1vw'}>
                    <Box component={'div'} display={'flex'} alignItems={'center'} width={'22vw'}>
                      <Box component={'div'} display={'flex'} alignItems={'center'} mr={'0.5vw'}>
                        <Box component={'img'}
                          src={item?.patient_photo_url === null || item?.patient_photo_url === "" || item?.patient_photo_url === undefined ? item?.patient_gender === "Male" || item?.patient_gender === "m" || item?.gender === "m" ? ImagePaths.Male.default : ImagePaths.Female.default : item?.photo_url} height={'2.8vw'} width={'2.8vw'}
                          border={`1.8px solid ${(item?.patient_type === "new_patient" || item?.patient__patient_type === 1) ? "#F1584A" : (item?.patient_type === "old_patient") || (item?.patient_type === "establish_patient") || (item?.patient__patient_type === 3) ? "#800080" : '#29B6F6'}`}
                          borderRadius={'50px'}
                        />
                      </Box>
                      <Box component={'div'}>
                        {item?.patient_name ?
                          item?.patient_name?.length > 14 ?
                            <Tooltip placement='top' title={item?.patient_name} arrow><Typography component={'div'} fontWeight={600} fontSize={'0.9vw'}>{item?.patient_name?.slice(0, 14) + '...'}
                              <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600}>{`${item?.patient_age ? item?.patient_age : '-'}/${item?.patient__gender ? (item?.patient__gender)?.toUpperCase() : '-'}`}</Typography>
                            </Typography></Tooltip> :
                            <Typography component={'div'} fontWeight={600} fontSize={'0.9vw'}>{item?.patient_name}
                              <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600}>{`${item?.patient_age ? item?.patient_age : '-'}/${item?.patient__gender ? (item?.patient__gender)?.toUpperCase() : '-'}`}</Typography>
                            </Typography>
                          : '-'}
                        <Typography component={'div'} color={Colors.grayShade} fontSize={'0.8vw'}>{item?.patient_account_number ? item?.patient_account_number : '-'} |
                          <Typography component={'span'} fontSize={'0.8vw'} color={Colors.grayShade}>{item?.patient_mobile_number ? item?.patient_mobile_number : '-'}</Typography>
                        </Typography>
                        <Typography component={'div'} color={Colors.grayShade} fontSize={'0.8vw'}>{"IP No."} |
                          <Typography component={'span'} fontSize={'0.8vw'} color={Colors.grayShade}>{item?.ip_number ? item?.ip_number : '-'}</Typography>
                        </Typography>
                      </Box>
                    </Box>
                    <Box component={'div'}>
                      <Button variant='contained' size='small' emed_tid='rad_op_req_btn'
                        onClick={() => this.setState({ radReqAnchorEl: null, searchRadIpList: '', rad_request: false }, () => {
                          this.getRadiologyPatientData(item?.patient_id, null, null, null, 'isFromIpBill')
                        })}
                      >Proceed</Button>
                    </Box>
                  </Box>
                )
              }) : <Typography display={'flex'} justifyContent={'center'} mt={'2vw'}>No Records To Be Shown</Typography>}
            </Box>
          </Menu>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  deleteSavedBillData = () => {
    try {
      let data = {}
      this.setState({ removeData: true })
      RestAPIService.delete(Serviceurls.RAD_PATIENT_SAVED_BILL_LIST + '?id=' + this.state.selectedSavedId, data)
        .then((response) => {
          if (response.data.status === 'success') {
            this.successMessage(response.data.message)
            this.setState({
              rad_saved_bill: false,
              radSavedBillAnchcor: null,
              saveReason: false,
              removeData: false,
              selectedSavedId: null,
              radSavedBillDate: new Date()
            }, () => this.getRadSavedBillList())
          }
        }).catch((error) => {
          this.setState({ removeData: false })
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ removeData: false })
      this.errorMessage(error.message)
    }
  }

  getRadSavedBillList = () => {
    try {
      this.setState({radSavedLoad:true})
      let date = DateTime.fromJSDate(this.state.radSavedBillDate)?.toFormat('yyyy-MM-dd')
      RestAPIService.getAll(Serviceurls.RAD_PATIENT_SAVED_BILL_LIST + `?date=${date}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              radSavedBillListData: response.data.data,
              dupRadSavedBill: JSON.stringify(response.data.data),
              radSavedLoad:false
            })
          }
        }).catch((error) => {
          this.setState({radSavedLoad:false})
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({radSavedLoad:false})
      this.errorMessage(error.message)
    }
  }

  radSavedBillList = () => {
    try {
      return (
        <Box component={'div'}>
          <Menu
            id="basic-menu"
            anchorEl={this.state.radSavedBillAnchcor}
            open={this.state.rad_saved_bill}
            onClose={() => { this.setState({ rad_saved_bill: false, radSavedBillDate: new Date(), searchRadSavdBill: '' }, () => this.getRadSavedBillList()) }}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            sx={{ position: 'absoulte', top: '2.5vw', left: '0.9vw' }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'bottom',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'bottom',
            }}
          >
            <Box component={'div'} p={'0.5vw'}>
              <Box component={'div'} display={'flex'} justifyContent={'space-between'}>
                <Typography fontWeight={600} fontSize={'0.9vw'}>Saved Bill List</Typography>
                <Box component={'div'} onClick={() => this.setState({ rad_saved_bill: false, radSavedBillDate: new Date(), searchRadSavdBill: '' }, () => this.getRadSavedBillList())} sx={{ cursor: 'pointer' }}>
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                </Box>
              </Box>
              <Box component={'div'} mt={'0.5vw'} display={'flex'}>
                <TextField
                  size='small'
                  value={this.state.searchRadSavdBill}
                  onChange={(e) => this.setState({ searchRadSavdBill: e.target.value }, () => {
                    let dupIpListData = JSON.parse(this.state.dupRadSavedBill)
                    if (this.state.searchRadSavdBill !== '') {
                      dupIpListData = dupIpListData.filter((item) => {
                        return (
                          (item?.patient_name === '' ? '' : item?.patient_name?.toLowerCase()?.includes(this.state.searchRadSavdBill?.toLowerCase())))
                      })
                      this.setState({ radSavedBillListData: dupIpListData })
                    } else {
                      this.setState({ radSavedBillListData: dupIpListData })
                    }
                  })}
                  sx={{ width: '20vw', mr: '1vw' }}
                  placeholder='Search Saved List....'
                />
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    open={this.state.radDatePickerOpen}
                    onOpen={() => { this.setState({ radDatePickerOpen: true }) }}
                    onClose={() => { this.setState({ radDatePickerOpen: false }) }}
                    className="Lab_SavedBill_date"
                    id="Lab_SavedBill_date"
                    label={("")}
                    inputFormat={"dd-MM-yyyy"}
                    autoComplete="off"
                    value={this.state.radSavedBillDate}
                    onChange={(newDate) => {
                      this.setState({
                        radSavedBillDate: newDate,
                      }, () => {
                        this.getRadSavedBillList()
                      })
                    }}
                    renderInput={(params) =>
                      <TextField {...params} size='small' sx={{ marginRight: '0.4vw' }}
                        error={this.state.expDateerror}
                        helperText={this.state.expDatehelpertext}
                        onClick={() => { this.setState({ radDatePickerOpen: true }) }} />}
                  />
                </LocalizationProvider>
              </Box>
              {this.state.radSavedLoad ? <Box component={'div'} display={'flex'} justifyContent={'center'} p={'1vw'}><CircularProgress color='primary'/></Box> : 
              this.state.radSavedBillListData?.length > 0 ? this.state.radSavedBillListData?.map((item, index) => {
                return (
                  <Box component={'div'} key={index} display={'flex'} alignItems={'center'} mt={'1vw'}>
                    <Box component={'div'} display={'flex'} alignItems={'center'} width={'22vw'}>
                      <Box component={'div'} display={'flex'} alignItems={'center'} mr={'0.5vw'}>
                        <Box component={'img'}
                          src={item?.patient_photo_url === null || item?.patient_photo_url === "" || item?.patient_photo_url === undefined ? item?.patient_gender === "Male" || item?.patient_gender === "m" || item?.gender === "m" ? ImagePaths.Male.default : ImagePaths.Female.default : item?.photo_url} height={'2.8vw'} width={'2.8vw'}
                          border={`1.8px solid ${(item?.patient_type === "new_patient" || item?.patient__patient_type === 1) ? "#F1584A" : (item?.patient_type === "old_patient") || (item?.patient_type === "establish_patient") || (item?.patient__patient_type === 3) ? "#800080" : '#29B6F6'}`}
                          borderRadius={'50px'}
                        />
                      </Box>
                      <Box component={'div'}>
                        {item?.patient_name ?
                          item?.patient_name?.length > 14 ?
                            <Tooltip placement='top' title={item?.patient_name} arrow>
                              <Typography component={'div'} fontWeight={600} fontSize={'0.9vw'}>{item?.patient_name?.slice(0, 14) + '...'}
                                <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600}>{` ${item?.patient_age ? item?.patient_age : '-'}/${item?.patient_gender ? (item?.patient_gender)?.toUpperCase() : '-'}`}</Typography>
                              </Typography>
                            </Tooltip> :
                            <Typography component={'div'} fontWeight={600} fontSize={'0.9vw'}>{item?.patient_name}
                              <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600}>{` ${item?.patient_age ? item?.patient_age : '-'}/${item?.patient_gender ? (item?.patient_gender)?.toUpperCase() : '-'}`}</Typography>
                            </Typography>
                          : '-'}
                        <Typography component={'div'} color={Colors.grayShade} fontSize={'0.8vw'}>{item?.patient_account_number ? item?.patient_account_number : '-'} |
                          <Typography component={'span'} fontSize={'0.8vw'} color={Colors.grayShade}>{item?.patient_mobile_number ? item?.patient_mobile_number : '-'}</Typography>
                        </Typography>
                      </Box>
                    </Box>
                    <Box component={'div'}>
                      <Button variant='contained' sx={{ mr: '0.5vw' }} size='small' emed_tid={'rad_pat_sav_bill_btn'}
                        onClick={() => this.setState({ radSavedBillAnchcor: null, searchRadSavdBill: '', rad_saved_bill: false, radSavedBillDate: new Date() }, () => {
                          setCachevalue(JSON.stringify(item), 'RadPatientData')
                          this.getRadiologyPatientData(item?.patient_id, 'savedBill', item?.bill_summary_id)
                        })}
                      >Proceed</Button>
                      <Button variant='contained' color='error' size='small' emed_tid='rad_sav_dlt_btn'
                        onClick={() => this.setState({ saveReason: true, selectedSavedId: item?.bill_summary_id })}
                      ><Close /></Button>
                    </Box>
                  </Box>
                )
              }) : <Typography display={'flex'} justifyContent={'center'} mt={'2vw'}>No Records To Be Shown</Typography>}
            </Box>
          </Menu>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getRadTransmitList = () => {
    try {
      const date = DateTime.fromJSDate(new Date(this.state.radTransFltDate)).toFormat('yyyy-MM-dd');
      RestAPIService.getAll(`${Serviceurls.RAD_PATIENT_TRANSMIT_GET}?search_key=${this.state.srchRadTranskey}&transmit_date=${date}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              radTransmitList: response.data.data,
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getSpecialTransmitPrint = (patient_id, transmit_id) => {
    try {
      RestAPIService.getAll(`${Serviceurls.RAD_PATIENT_TRANSMIT_GET}?export_type=pdf&patient_id=${patient_id}&transmitted_id=${transmit_id}`).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          this.errorMessage(error.response?.data?.message)
        })
    } catch (error) {
      this.errorMessage("Error occured on print")
    }
  }

  onCloseRadTransmit = () => {
    this.setState({
      rad_transmit: false,
      radTransFltDate: new Date()
    }, () => this.getRadTransmitList())
  }

  renderRadTransmit = (fromFo) => {
    try {
      return (
        <Box component={'div'}>
          <Menu
            id="basic-menu"
            anchorEl={this.state.radTransAnchorEL}
            open={this.state.rad_transmit}
            onClose={this.onCloseRadTransmit}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            sx={{ position: 'absoulte', top: '2.5vw' }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'bottom',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'bottom',
            }}
          >
            <Box component={'div'} p={'0.5vw'}>
              <Box component={'div'} display={'flex'} justifyContent={'space-between'}>
                <Typography fontWeight={600} fontSize={'0.9vw'}>Transmit</Typography>
                <Box component={'div'} onClick={this.onCloseRadTransmit} sx={{ cursor: 'pointer' }}>
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                </Box>
              </Box>
              <Box component={'div'} mt={'0.5vw'} display={'flex'}>
                <TextField
                  size='small'
                  value={this.state.srchRadTranskey}
                  onChange={(e) => {
                    this.setState({
                      srchRadTranskey: e.target.value
                    }, () => {
                      this.getRadTransmitList()
                    })
                  }}
                  sx={{ width: '20vw', mr: '1vw' }}
                  placeholder='Search Patient...'
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    open={this.state.DatePickerOpen}
                    onOpen={() => { this.setState({ DatePickerOpen: true }) }}
                    onClose={() => { this.setState({ DatePickerOpen: false }) }}
                    value={this.state.radTransFltDate}
                    name={"datePicker"}
                    inputFormat='DD-MM-YYYY'
                    views={["year", "month", "day"]}
                    onChange={(newDate) => { this.setState({ radTransFltDate: newDate }, () => this.getRadTransmitList()) }}
                    renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()}
                      style={{ width: '10vw' }} size='small' {...params}
                      onClick={() => { this.setState({ DatePickerOpen: true }) }} />}
                  />
                </LocalizationProvider>
              </Box>
              {this.state.radTransmitList?.length > 0 ? this.state.radTransmitList?.map((item, index) => {
                return (
                  <Box component={'div'} key={index} display={'flex'} alignItems={'center'} mt={'1vw'}>
                    <Box component={'div'} display={'flex'} alignItems={'center'} width={'22vw'}>
                      <Box component={'div'} display={'flex'} alignItems={'center'} mr={'0.5vw'}>
                        <Box component={'img'}
                          src={item?.patient_photo_url === null || item?.patient_photo_url === "" || item?.patient_photo_url === undefined ? item?.patient_gender === "Male" || item?.patient_gender === "m" || item?.gender === "m" ? ImagePaths.Male.default : ImagePaths.Female.default : item?.patient_photo_url} height={'2.8vw'} width={'2.8vw'}
                          border={`1.8px solid ${(item?.patient_type === "new_patient" || item?.patient__patient_type === 1) ? "#F1584A" : (item?.patient_type === "old_patient") || (item?.patient_type === "establish_patient") || (item?.patient__patient_type === 3) ? "#800080" : '#29B6F6'}`}
                          borderRadius={'50px'}
                        />
                      </Box>
                      <Box component={'div'}>
                        {item?.patient_name ?
                          item?.patient_name?.length > 14 ?
                            <Tooltip placement='top' title={item?.patient_name} arrow><Typography component={'div'} fontWeight={600} fontSize={'0.9vw'}>{item?.patient_name?.slice(0, 14) + '...'}
                              <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600}>{`${item?.patient_age ? item?.patient_age : '-'}/${item?.patient_gender ? (item?.patient_gender)?.toUpperCase() : '-'}`}</Typography>
                            </Typography></Tooltip> :
                            <Typography component={'div'} fontWeight={600} fontSize={'0.9vw'}>{item?.patient_name}
                              <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600} ml={"0.5vw"}>{`${item?.patient_age ? item?.patient_age : '-'}/${item?.patient_gender ? (item?.patient_gender)?.toUpperCase() : '-'}`}</Typography>
                            </Typography>
                          : '-'}
                        <Typography component={'div'} color={Colors.grayShade} fontSize={'0.8vw'}>{item?.patient_account_number ? item.patient_account_number : '-'} |
                          <Typography component={'span'} fontSize={'0.8vw'} color={Colors.grayShade}>{item?.patient_mobile_number ? item?.patient_mobile_number : '-'}</Typography>
                        </Typography>
                      </Box>
                    </Box>
                    <Box component={'div'}>
                      <Button variant='contained' size='small' emed_tid='rad_ip_req_btn'
                        onClick={() => {
                          this.setState(
                            { radTransAnchorEL: null, srchRadTranskey: '', rad_transmit: false, radTransFltDate: new Date() },
                            () => {
                              const updatedLineItems = [];
                              let specialTestTransmitIds = null;
                              item.line_items.forEach((element) => {
                                if (element.special_test_name) {
                                  specialTestTransmitIds = element.transmit_summary_ids;
                                } else {
                                  updatedLineItems.push(element);
                                }
                              });
                              if (specialTestTransmitIds) {
                                this.getSpecialTransmitPrint(item?.patient_id, specialTestTransmitIds);
                              }
                              const updatedItem = { ...item, line_items: updatedLineItems };
                              this.getRadiologyPatientData(item?.patient_id, fromFo ? "TransmitToFoRad" : "", "", updatedItem);
                            }
                          );
                        }}
                      >Proceed</Button>
                    </Box>
                  </Box>
                )
              }) : <Typography display={'flex'} justifyContent={'center'} mt={'2vw'}>No Records To Be Shown</Typography>}
            </Box>
          </Menu>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  // printRadiologyAppointment = () => {
  //   try{
  //     let AppDate = JSON.parse(getCachevalue('RadAppointmentDate'))
  //     let startDate = AppDate ? AppDate?.slice(0,10) : DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd') 
  //     let AppStatus = JSON.parse(getCachevalue('RadAppointmentStatus'))


  //     RestAPIService.getAll(Serviceurls.RAD_PATIENT_APPOINTMENT_LIST + `?date=${startDate}&export=pdf`)
  //       .then((response) => {
  //         const file = new Blob(
  //           [response.data],
  //           { type: 'application/pdf' });
  //         const fileURL = URL.createObjectURL(file);
  //         window.open(fileURL);
  //       }).catch((error) => {
  //         if (error?.response?.data?.message) {
  //           this.errorMessage(error.response.data.message)
  //         } else {
  //           this.errorMessage(error.message)
  //         }
  //       })
  //   }catch(error){
  //     this.errorMessage(error.message)
  //   }
  // }

  popupClose = () => {
    this.setState({
      saveReason: false,
    })
  }

  addCancelComments = (comments) => {
    this.deleteSavedBillData(comments)
  }

  // Radiology Ends =====>

  ignoreSmsAlert = () => {
    try {
      let data = {
        show_sms_alert: false
      }
      RestAPIService.create(data, Serviceurls.FO_SMS_CONFIG_ALERT_REMOVE)
        .then((response) => {
          if (response?.data?.status === "success") {
            this.setState({ smsAlert: false })
            localSetItem("show_sms_alert", false)
          }
        }).catch(error => {
          if (error?.response?.data?.status === "fail") {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })

    } catch (e) {
      this.errorMessage(e?.message)
    }
  }
  ignorewhatsappAlert = () => {
    try {
      let data = {
        whatsappAlert: false
      }
      RestAPIService.create(data, Serviceurls.WHATSAPP_ALERT_REMOVE)
        .then((response) => {
          if (response?.data?.status === "success") {
            this.setState({ whatsappAlert: false })
            localSetItem("show_whatsapp_alert", false)
          }
        }).catch(error => {
          if (error?.response?.data?.status === "fail") {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })

    } catch (e) {
      this.errorMessage(e?.message)
    }
  }

  ignoreSubscriptionAlert = () => {
    try {
      RestAPIService.create({}, Serviceurls.SUBSCRIPTION_ALERT_REMOVE)
        .then((response) => {
          if (response?.data?.status === "success") {
            this.setState({ subscription_alert_message: "" })
            localSetItem("subscription_alert_message", "")
          }
        }).catch(error => {
          this.errorMessage(error.response.data.message || error.message)
        })
    } catch (e) {
      this.errorMessage(e?.message)
    }
  }

  closeDrQueue = () => {
    if (this.state.DocQueuePopup) {
      this.setState({
        DocQueuePopup: false,
      }, () => this.getDoctorQueueData())
    }
  }

  callPatientSend = (id) => {
    console.log("Sending callPatientSend via WebSocket:", id, this.PaitentCall);
    const payload = JSON.stringify({ id: id ?? null });
    if (this.PaitentCall && this.PaitentCall.readyState === WebSocket.OPEN) {
      this.PaitentCall.send(payload)
    } else {
      console.log("PaitentCall socket not open. Message not sent.", {
        readyState: this.PaitentCall?.readyState
      });
    this.pendingPatientCallPayload = payload;
    this.FoCallPatientConnect();
    }
  }

  handleFOCheckBoxHandler = (e, index)=>{
    try{
      let value = e.target.checked
      if (this.state.doctorFOPrintList[index]['label'] === 'All') {
        this.state.doctorFOPrintList[index]['is_checked'] = value
        this.setState({ doctorFOPrintList: this.state.doctorFOPrintList }, () => {
          if (this.state.doctorFOPrintList[index]['label'] === 'All' && this.state.doctorFOPrintList[index]['is_checked']) {
            this.state.doctorFOPrintList?.forEach(element => element.is_checked = true)
            this.setState({ doctorFOPrintList: this.state.doctorFOPrintList })
          } else {
            this.state.doctorFOPrintList?.forEach(element => element.is_checked = false)
            this.setState({ doctorFOPrintList: this.state.doctorFOPrintList })
          }
        })
      } else {
        this.state.doctorFOPrintList[index]['is_checked'] = value
        this.setState({ doctorFOPrintList: this.state.doctorFOPrintList }, () => {
          let filterArray = this.state.doctorFOPrintList?.filter(item => item?.label !== 'All')
          let checkAll = filterArray?.every(item => item.is_checked)
          this.state.doctorFOPrintList?.forEach(element => {
            if (element.label === 'All' && checkAll) {
              element.is_checked = true
            } else if (!checkAll && element.label === 'All') {
              element.is_checked = false
            }
          })
          this.setState({ doctorFOPrintList: this.state.doctorFOPrintList })
        })
      
    }

  }catch(error){
    this.errorMessage(error.message)
  }
}

  handleNewCheckBoxHandler = (e, index) => {
    try {
      let value = e.target.checked
      if (this.state.isOPT) {
        if (this.state.doctorPrintList['opt_doctor'][index]['label'] === 'Full Report') {
          this.state.doctorPrintList['opt_doctor'][index]['is_checked'] = value
          this.setState({ doctorPrintList: this.state.doctorPrintList }, () => {
            if (this.state.doctorPrintList['opt_doctor'][index]['label'] === 'Full Report' && this.state.doctorPrintList['opt_doctor'][index]['is_checked']) {
              this.state.doctorPrintList?.opt_doctor?.forEach(element => element.is_checked = true)
              this.setState({ doctorPrintList: this.state.doctorPrintList })
            } else {
              this.state.doctorPrintList?.opt_doctor?.forEach(element => element.is_checked = false)
              this.setState({ doctorPrintList: this.state.doctorPrintList })
            }
          })
        } else {
          this.state.doctorPrintList['opt_doctor'][index]['is_checked'] = value
          this.setState({ doctorPrintList: this.state.doctorPrintList }, () => {
            let filterArray = this.state.doctorPrintList?.opt_doctor?.filter(item => item?.label !== 'Full Report')
            let checkAll = filterArray?.every(item => item.is_checked)
            this.state.doctorPrintList?.opt_doctor?.forEach(element => {
              if (element.label === 'Full Report' && checkAll) {
                element.is_checked = true
              } else if (!checkAll && element.label === 'Full Report') {
                element.is_checked = false
              }
            })
            this.setState({ doctorPrintList: this.state.doctorPrintList })
          })
        }

      } else {
        if (this.state.doctorPrintList['other_doctor'][index]['label'] === 'Full Report') {
          this.state.doctorPrintList['other_doctor'][index]['is_checked'] = value
          this.setState({ doctorPrintList: this.state.doctorPrintList }, () => {
            if (this.state.doctorPrintList['other_doctor'][index]['label'] === 'Full Report' && this.state.doctorPrintList['other_doctor'][index]['is_checked']) {
              this.state.doctorPrintList?.other_doctor?.forEach(element => element.is_checked = true)
              this.setState({ doctorPrintList: this.state.doctorPrintList })
            } else {
              this.state.doctorPrintList?.other_doctor?.forEach(element => element.is_checked = false)
              this.setState({ doctorPrintList: this.state.doctorPrintList })
            }
          })
        } else {
          this.state.doctorPrintList['other_doctor'][index]['is_checked'] = value
          this.setState({ doctorPrintList: this.state.doctorPrintList }, () => {
            let filterArray = this.state.doctorPrintList?.other_doctor?.filter(item => item?.label !== 'Full Report')
            let checkAll = filterArray?.every(item => item.is_checked)
            this.state.doctorPrintList?.other_doctor?.forEach(element => {
              if (element.label === 'Full Report' && checkAll) {
                element.is_checked = true
              } else if (!checkAll && element.label === 'Full Report') {
                element.is_checked = false
              }
            })
            this.setState({ doctorPrintList: this.state.doctorPrintList })
          })
        }
      }
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getDoctorNotesPrintTemplate = () => {
    try {
      this.setState({ printLoad: true })
      let clinic_id = this.state.doctorClinicId ? this.state.doctorClinicId : this.state.SelectedDoctorClinic
      RestAPIService.getAllTwo(Serviceurls.DOC_OPT_CONFIG)
        .then((response) => {
          if (response.data.status === 'success') {
            let Doctor_Print_Layout = JSON.parse(JSON.stringify(DOC_PRINT_DEFAULT))
            if (this.state.isENT) {
              let ENTLayout = { is_checked: true, label: 'Clinical Examination', value: 'ClinicExaminationImage' }
              Doctor_Print_Layout.other_doctor?.push(ENTLayout)
            }
            if (this.state.specialization === "OBSTETRICS & GYNECOLOGY") {
              let OBGYNPrintorder = [
                { is_checked: false, label: 'Ovulation', value: 'Ovulation', print_order: 16, isAdvance: true },
                { is_checked: false, label: 'Antenatal', value: 'Antenatal', print_order: 17, isAdvance: true },
                { is_checked: false, label: 'Medication History', value: 'MedicalHistory', print_order: 18, isAdvance: true },
                { is_checked: false, label: 'Hospitalization History', value: 'HospitalizationHistory', print_order: 19, isAdvance: true },
                { is_checked: false, label: 'Social History', value: 'SocialHistory', print_order: 20, isAdvance: true },
                { is_checked: false, label: 'Family History', value: 'FamilyHistory', print_order: 21, isAdvance: true },
                { is_checked: false, label: 'OBGYN History', value: 'OBGYNHistory', print_order: 22, isAdvance: true },
              ]
              Doctor_Print_Layout.other_doctor = [...Doctor_Print_Layout.other_doctor, ...OBGYNPrintorder];
            }
            let docNotes = response.data.data.doc_notes_print_template
              ? { ...response.data.data.doc_notes_print_template } // Creating a copy
              : { ...Doctor_Print_Layout }; // Fallback if response is missing

            // Sorting `opt_doctor`
            if (docNotes.opt_doctor) {
              docNotes.opt_doctor = [...docNotes.opt_doctor]?.sort((a, b) => (a.print_order) - (b.print_order));
            }

            // Sorting `other_doctor`
            if (docNotes.other_doctor) {
              docNotes.other_doctor = [...docNotes.other_doctor]?.sort((a, b) => (a.print_order) - (b.print_order));
            }

            // Updating state
            this.setState({
              doctorPrintList: docNotes,
              dupDocPrintList: JSON.stringify(docNotes),
              printLoad: false
            });


            localSetItem('app_landing_sts', response.data.data.app_landing_sts ? JSON.stringify(response.data.data.app_landing_sts) : JSON.stringify('All'))
            localSetItem('drug_search', JSON.stringify(response?.data?.data?.drug_search))
            localSetItem('other_investigation_config',JSON.stringify(response?.data?.data?.other_investigation_config || OTHER_INVESTIGATION_CONFIG_DATA))
            localSetItem('show_address_field_prescription', JSON.stringify(response?.data?.data?.show_address_field_prescription_print))
            localSetItem('complaints_common_textbox', JSON.stringify(response?.data?.data?.complaints_common_textbox))
            localSetItem('show_quantity_in_prescription', JSON.stringify(response?.data?.data?.show_quantity_in_prescription))
            localSetItem('prescription_save_transmit', JSON.stringify(response?.data?.data?.prescription_save_transmit))
            localSetItem('prescription_language', JSON.stringify(response?.data?.data?.prescription_language))
          }
        }).catch((error) => {
          this.setState({ printLoad: false })
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ printLoad: false })
      this.errorMessage(error.message)
    }
  }

  getFODoctorNotesPrint = () => {
    try {
      let notesList = [];
      let states = this.state
      let flag = false

      flag = states.doctorFOPrintList?.every(item => !item.is_checked)
      let all = states.doctorFOPrintList?.find(item => item?.label === 'All')
      if (all?.is_checked) {
        notesList?.push('All')
      } else {
        states.doctorFOPrintList?.filter(item => item?.is_checked && item.label !== 'All')?.forEach(element => {
          if (element?.is_checked) {
            notesList?.push(element?.value)
          }
        })
      }

      if (!flag) {
        let admissionDetail = getCachevalue("IppatientData") ? JSON.parse((getCachevalue("IppatientData"))) : null
        let admissionID = admissionDetail.id ? admissionDetail.id : null
        RestAPIService.getAllTwo(`${Serviceurls.FO_DOCNOTES_PRINT}?ip_admission_id=${admissionID}&doctor_notes=${notesList}`)
          .then((response) => {
            this.setState({ openFoNotesPrintAnchor: null, openFODocNotesPrint: false, doctorFOPrintList: FO_DOC_PRINT_DEFAULT ? JSON.parse(JSON.stringify(FO_DOC_PRINT_DEFAULT)) :[],   },)
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            
          }).catch((error) => {
            if (error?.response?.data?.message) {
              this.errorMessage(error.response.data.message)
            } else {
              this.errorMessage(error.message)
            }
          })
      } else {
        this.errorMessage('Please Select Atleast one for Print')
      }
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  getOTAppointmentListPrint = () => {
    try {
      let fromDate = getCachevalue('OTFromDate')
      let toDate = getCachevalue('OTToDate')
      let status = getCachevalue('OTStatus')
      this.setState({ printOTApp: true })
      RestAPIService.GetWithoutReplica(Serviceurls.GET_OT_APPOINTMENT_LIST + `?from_date=${fromDate}&to_date=${toDate}&status=${status}&export_type=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ printOTApp: false })
        }).catch((error) => {
          this.setState({ printOTApp: false })
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ printOTApp: false })
      this.errorMessage(error.message)
    }
  }

  closeOTRequestPopup = () => {
    if (this.state.OT_IP_Request) {
      this.setState({
        OT_IP_Request: false,
        AcceptRequest: true,
      })
      this.getBadgeCount()
    }
  }

  isGetCalled = (isCalled) => {
    if (isCalled === false) {
      this.setState({
        AcceptRequest: false,
      })
    }
  }
  // lab IP Request Popup

  getLaboratoryListData = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_IP_LABLIST + '?transmit_date=')
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              labNameList: response.data.data,
              labId: response.data.data[0]?.laboratory_id,
              labName: response.data.data[0]?.laboratory_name
            })
          }
        }).catch((error) => {
          this.setState({ printOTApp: false })
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getIpLabRequestListData = () => {
    try {
      let todayDate = new Date(this.state.labIpReqDate)
      let date = DateTime.fromJSDate(todayDate).toFormat('yyyy-MM-dd')
      this.setState({ ipReqLoad: true })
      RestAPIService.getAll(Serviceurls.LAB_IP_REQUEST_TRANSMIT + '?date=' + date + '&laboratory_id=' + this.state.labId)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              ipLabRequestList: response.data.data,
              dupLabReqList: JSON.stringify(response.data.data),
              ipReqLoad: false
            })
          }
        }).catch((error) => {
          this.setState({ ipReqLoad: false })
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ ipReqLoad: false })
      this.errorMessage(error.message)
    }
  }

  searchLabIpReqList = (fromTransmit = false) => {
    try {
      let states = this.state
      if (fromTransmit) {
        let dupLabTransList = JSON.parse(this.state.dupLabTraList)
        if (states.searchLabIpTrans !== '') {
          let data = dupLabTransList?.filter(item => item.patient_account_number?.toLowerCase()?.includes(states.searchLabIpTrans?.toLowerCase()) || item.patient_mobile_number?.toLowerCase()?.includes(states.searchLabIpTrans?.toLowerCase()) || item.patient_name?.toLowerCase()?.includes(states.searchLabIpTrans?.toLowerCase()))
          this.setState({ ipLabTransmitList: data })
        } else {
          this.setState({ ipLabTransmitList: dupLabTransList })
        }
      } else {
        let dupLabReqList = JSON.parse(this.state.dupLabReqList)
        if (states.searchLabIpRequest !== '') {
          let data = dupLabReqList?.filter(item => item.patient_account_number?.toLowerCase()?.includes(states.searchLabIpRequest?.toLowerCase()) || item.patient_mobile_number?.toLowerCase()?.includes(states.searchLabIpRequest?.toLowerCase()) || item.patient_name?.toLowerCase()?.includes(states.searchLabIpRequest?.toLowerCase()))
          this.setState({ ipLabRequestList: data })
        } else {
          this.setState({ ipLabRequestList: dupLabReqList })
        }
      }
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderLabIpRequestPopup = () => {
    try {
      let FromFO = (window.location.pathname === '/Billing' || window.location.pathname === '/Billing/LabBilling') ? true : false
      return (
        <Menu
          elevation={1}
          anchorEl={this.state.ipReqAnchor}
          open={this.state.isIPRequest}
          sx={{ mt: '3vw' }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        >
          <Box component={'div'} width={FromFO ? '37vw' : '28vw'} maxHeight={'28vw'} overflow={'auto'} p={'0vw 0.5vw'}>
            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
              <Typography fontWeight={600}>IP Request List</Typography>
              <Button className='Common_Btn_Min_Width'
                onClick={() => this.setState({ isIPRequest: false, ipReqAnchor: null, labDatePickerOpen: false, labIpReqDate: new Date() }, () => { if (FromFO) { this.getLaboratoryListData() } })}
              >
                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
              </Button>
            </Box>
            <Box component={'div'} m={'0.5vw 0.5vw'} display={'flex'}>
              <TextField
                autoComplete='off'
                size='small'
                sx={{ width: FromFO ? '11vw' : '15vw', mr: '1vw' }}
                value={this.state.searchLabIpRequest}
                onChange={(e) => this.setState({ searchLabIpRequest: e.target.value }, () => this.searchLabIpReqList())}
                label={'Search Patient Name'}
                onKeyDown={(e) => { e.stopPropagation() }}
              />
              {FromFO ?
                <Autocomplete
                  clearIcon
                  size='small'
                  sx={{ width: '13vw', mr: '0.5vw' }}
                  options={this.state.labNameList}
                  getOptionLabel={(option) => typeof (option) === 'string' ? option : option.laboratory_name}
                  value={this.state.labName}
                  onChange={(e, value) => {
                    this.setState({
                      labId: value['laboratory_id'],
                      labName: value['laboratory_name']
                    }, () => this.getIpLabRequestListData())
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  renderInput={(params) => <TextField {...params} label='Select Laboratory' />}
                /> : null
              }
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={this.state.labDatePickerOpen}
                  onOpen={() => { this.setState({ labDatePickerOpen: true }) }}
                  onClose={() => { this.setState({ labDatePickerOpen: false }) }}
                  value={this.state.labIpReqDate}
                  name={"datePicker"}
                  inputFormat='DD-MM-YYYY'
                  views={["year", "month", "day"]}
                  onChange={(newDate) => { this.setState({ labIpReqDate: newDate }, () => { this.getIpLabRequestListData() }) }}
                  maxDate={new Date()}
                  renderInput={(params) => <TextField
                    onKeyDown={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }} style={{ width: '9.5vw' }} size='small' {...params} inputProps={{ ...params.inputProps, 'emed_tid': 'IP_Date_Search' }} onClick={() => { this.setState({ labDatePickerOpen: true }) }} />}
                />
              </LocalizationProvider>
            </Box>
            <Box component={'div'}>
              {this.state.ipReqLoad ?
                <Box component={'div'} pb={'0.5vw'} borderBottom={'1.5px solid lightgray'} mb={'0.5vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                  <CircularProgress size='small' color='primary' />
                </Box> :
                this.state.ipLabRequestList?.length > 0 ? this.state.ipLabRequestList?.map((item, index) => {
                  return (
                    <Box component={'div'} key={index} pb={'0.5vw'} borderBottom={'1.5px solid lightgray'} mb={'0.5vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                      <Box component={'div'} alignItems={'center'} width={'13vw'}>
                        {item?.patient_name?.length > 15 ?
                          <Tooltip placement='top' title={item?.patient_name}><Typography fontSize={'0.9vw'} fontWeight={600}>{item?.patient_name?.slice(0, 20) + '...'}</Typography></Tooltip> :
                          <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.patient_name}</Typography>}
                        <Typography fontSize={'0.8vw'} color={Colors.grayShade}>{`${item?.patient_mobile_number} - ${item?.patient_account_number}`}</Typography>
                      </Box>
                      <Box component={'div'}>
                        <Typography fontSize={'0.9vw'} fontWeight={600}>Date</Typography>
                        <Typography fontSize={'0.8vw'} color={Colors.grayShade}>{item?.transmit_date ? item?.transmit_date : '-'}</Typography>
                      </Box>
                      <Box component={'div'}>
                        <Button variant='contained'
                          onClick={() => {
                            if (FromFO) {
                              let path = window.location.pathname === '/Billing/LabBilling' ? '/Billing/LabBilling' : '/Billing'
                              this.props.history.push({ pathname: path, state: { savedTransmitList: item } })
                              this.setState({ isIPRequest: false, ipReqAnchor: null, labDatePickerOpen: false, labIpReqDate: new Date() })
                              setTimeout(() => {
                                this.props.history.push({ pathname: path, state: { savedTransmitList: {} } })
                              }, 1000)
                            } else {
                              this.props.history.push({ pathname: "/MainHome", state: { savedTransmitList: item } })
                              this.setState({ isIPRequest: false, ipReqAnchor: null, labDatePickerOpen: false, labIpReqDate: new Date() })
                              setTimeout(() => {
                                this.props.history.push({ pathname: "/MainHome", state: { savedTransmitList: {} } })
                              }, 2000)
                            }
                          }}
                          sx={{ textTransform: 'capitalize' }}
                        >Proceed</Button>
                      </Box>
                    </Box>
                  )
                }) :
                  <Box component={'div'} pb={'0.5vw'} borderBottom={'1.5px solid lightgray'} mb={'0.5vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    <Typography fontWeight={600} fontSize={'0.9vw'}>No Records To Be Shown</Typography>
                  </Box>
              }
            </Box>
          </Box>
        </Menu>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderOpListPopup = (FromCashCounter = false) => {
    try {
      return (
        <Box component={'div'}>
          <Menu
            id="basic-menu"
            anchorEl={this.state.isOpListAnchor}
            open={this.state.isOpList || this.state.rtWalkinOpen}
            // onClose={() => this.setState({ isOpList: false, opListDate: new Date() }, () => this.getRadAppointmentListData())}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            sx={{ position: 'absoulte', top: '2.5vw' }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'bottom',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'bottom',
            }}
          >
            <Box component={'div'} p={'0.5vw'}>
              <Box component={'div'} display={'flex'} justifyContent={'space-between'}>
                <Typography fontWeight={600} fontSize={'0.9vw'}>{this.state.rtWalkinOpen ? "RT Walkin Appointments" : "Appointments"}</Typography>
                <Box component={'div'} onClick={() => this.setState({ isOpList: false, rtWalkinOpen : false, opListDate: new Date() }, () => { this.state.rtWalkinOpen ? this.GetRtWalkinData() : this.getRadAppointmentListData(true) })} sx={{ cursor: 'pointer' }}>
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                </Box>
              </Box>
              <Box component={'div'} mt={'0.5vw'} display={'flex'}>
                <TextField
                  size='small'
                  value={this.state.searchOpList}
                  onChange={(e) => this.setState({ searchOpList: e.target.value }, () => {
                    if (this.state.rtWalkinOpen) {
                      let dupOpList = JSON.parse(this.state.dupwalkInAppointData)
                      if (this.state.searchOpList !== '') {
                        dupOpList = dupOpList.filter((item) => {
                          return (
                            (item?.patient_names === '' ? '' : item?.patient_names?.toLowerCase()?.includes(this.state.searchOpList?.toLowerCase())))
                        })
                        this.setState({ walkInAppointData: dupOpList })
                      } else {
                        this.setState({ walkInAppointData: dupOpList })
                      }
                    } else {
                      let dupOpList = JSON.parse(this.state.dupOpList)
                      if (this.state.searchOpList !== '') {
                        dupOpList = dupOpList.filter((item) => {
                          return (
                            (item?.patient_name === '' ? '' : item?.patient_name?.toLowerCase()?.includes(this.state.searchOpList?.toLowerCase())))
                        })
                        this.setState({ opListData: dupOpList })
                      } else {
                        this.setState({ opListData: dupOpList })
                      }
                    }

                  })}
                  onKeyDown={(e) => {
                    e.stopPropagation()
                  }}
                  sx={{ width: '20vw', mr: '1vw' }}
                  placeholder='Search Appointment....'
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    open={this.state.opListDatePickerOpen}
                    onOpen={() => { this.setState({ opListDatePickerOpen: true }) }}
                    onClose={() => { this.setState({ opListDatePickerOpen: false }) }}
                    value={this.state.opListDate}
                    name={"datePicker"}
                    inputFormat='DD-MM-YYYY'
                    views={["year", "month", "day"]}
                    onChange={(newDate) => { this.setState({ opListDate: newDate }, () => { this.state.rtWalkinOpen ? this.GetRtWalkinData() : this.getRadAppointmentListData(true) }) }}
                    renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()}
                      style={{ width: '10vw' }} size='small' {...params}
                      onClick={() => { this.setState({ opListDatePickerOpen: true }) }} />}
                  />
                </LocalizationProvider>
              </Box>
              {
                this.state.rtWalkinOpen ?
                  <Box component={'div'} maxHeight={'60dvh'} overflow={'auto'}>
                    {this.state.walkInAppointData?.length > 0 ? this.state.walkInAppointData?.map((item, index) => {
                      const modulePaths = {
                        front_office: '/HospitalBilling/HospitalBilling',
                        Laboratory: '/LabBilling/HospitalBilling',
                        Radiology: '/RadiologyBilling/HospitalBilling',
                        Investigation: `/${GetInvestigationName()}Billing/HospitalBilling`,
                        Doctor: '/DoctorBilling'
                      };
                      const { module_name } = this.state.loggedInuserInfo || {};
                      const targetPath = modulePaths[module_name];
                      return (
                        <Box component={'div'} key={index} display={'flex'} alignItems={'center'} mt={'1vw'}>
                          <Box component={'div'} display={'flex'} alignItems={'center'} width={'22vw'}>
                            <Box component={'div'} display={'flex'} alignItems={'center'} mr={'0.5vw'}>
                              <Box component={'img'}
                                src={item?.patient_photo_url === null || item?.patient_photo_url === "" || item?.patient_photo_url === undefined ? item?.patient_gender === "Male" || item?.patient_gender === "m" || item?.gender === "m" ? ImagePaths.Male.default : ImagePaths.Female.default : item?.patient_photo_url} height={'2.8vw'} width={'2.8vw'}
                                border={`1.8px solid ${(item?.patient_type === "new_patient" || item?.patient__patient_type === 1) ? "#F1584A" : (item?.patient_type === "old_patient") || (item?.patient_type === "establish_patient") || (item?.patient__patient_type === 3) ? "#800080" : '#29B6F6'}`}
                                borderRadius={'50px'}
                              />
                            </Box>
                            <Box component={'div'}>
                              {item?.patient_names ?
                                item?.patient_names?.length > 14 ?
                                  <Tooltip placement='top' title={item?.patient_names} arrow><Typography component={'div'} fontWeight={600} fontSize={'0.9vw'} >{item?.patient_names?.slice(0, 14) + '...'}
                                    <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600}>{`${item?.patient_age ? item?.patient_age : '-'}/${item?.patient_gender ? (item?.patient_gender)?.toUpperCase() : '-'}`}</Typography>
                                  </Typography></Tooltip> :
                                  <Typography component={'div'} fontWeight={600} fontSize={'0.9vw'} >{item?.patient_names}
                                    <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600} ml={'0.5vw'}>{`${item?.patient_age ? item?.patient_age : '-'}/${item?.patient_gender ? (item?.patient_gender)?.toUpperCase() : '-'}`}</Typography>
                                  </Typography>
                                : '-'}
                              <Typography component={'div'} color={Colors.grayShade} fontSize={'0.8vw'}>{item?.patient_uhid ? item.patient_uhid : '-'} |
                                <Typography component={'span'} fontSize={'0.8vw'} color={Colors.grayShade}>{item?.mobile_number ? item?.mobile_number : '-'}</Typography>
                              </Typography>
                            </Box>
                            {item?.op_number ? <Box component={'div'}><Typography component={'div'} color={Colors.grayShade} fontSize={'0.8vw'}>{item?.op_number}</Typography></Box> : null}
                          </Box>
                          <Box component={'div'}>
                            <Button variant='contained' size='small' emed_tid='rad_ip_req_btn'
                              onClick={() => {
                                this.setState({ isOpListAnchor: null, searchOpList: '', rtWalkinOpen: false, opListDate: new Date() }, () => {
                                  this.props?.history?.push({ pathname: "/HospitalBilling/CashCounter", states: { FromRT: true, RtWalkInDetails: item } })
                                });
                              }}
                            >Proceed</Button>
                          </Box>
                        </Box>
                      )
                    }) : <Typography display={'flex'} justifyContent={'center'} mt={'2vw'}>No Records To Be Shown</Typography>}
                  </Box>
                  :
                  <Box component={'div'} maxHeight={'60dvh'} overflow={'auto'}>
                    {this.state.opListData?.length > 0 ? this.state.opListData?.map((item, index) => {
                      const modulePaths = {
                        front_office: '/HospitalBilling/HospitalBilling',
                        Laboratory: '/LabBilling/HospitalBilling',
                        Radiology: '/RadiologyBilling/HospitalBilling',
                        Investigation: `/${GetInvestigationName()}Billing/HospitalBilling`,
                        Doctor: '/DoctorBilling'
                      };
                      const { module_name } = this.state.loggedInuserInfo || {};
                      const targetPath = modulePaths[module_name];
                      return (
                        <Box component={'div'} key={index} display={'flex'} alignItems={'center'} mt={'1vw'}>
                          <Box component={'div'} display={'flex'} alignItems={'center'} width={'22vw'}>
                            <Box component={'div'} display={'flex'} alignItems={'center'} mr={'0.5vw'}>
                              <Box component={'img'}
                                src={item?.patient_photo_url === null || item?.patient_photo_url === "" || item?.patient_photo_url === undefined ? item?.patient_gender === "Male" || item?.patient_gender === "m" || item?.gender === "m" ? ImagePaths.Male.default : ImagePaths.Female.default : item?.patient_photo_url} height={'2.8vw'} width={'2.8vw'}
                                border={`1.8px solid ${(item?.patient_type === "new_patient" || item?.patient__patient_type === 1) ? "#F1584A" : (item?.patient_type === "old_patient") || (item?.patient_type === "establish_patient") || (item?.patient__patient_type === 3) ? "#800080" : '#29B6F6'}`}
                                borderRadius={'50px'}
                              />
                            </Box>
                            <Box component={'div'}>
                              {item?.patient_name ?
                                item?.patient_name?.length > 14 ?
                                  <Tooltip placement='top' title={item?.patient_name} arrow><Typography component={'div'} fontWeight={600} fontSize={'0.9vw'} >{item?.patient_name?.slice(0, 14) + '...'}
                                    <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600}>{`${item?.patient_age ? item?.patient_age : '-'}/${item?.patient_gender ? (item?.patient_gender)?.toUpperCase() : '-'}`}</Typography>
                                  </Typography></Tooltip> :
                                  <Typography component={'div'} fontWeight={600} fontSize={'0.9vw'} >{item?.patient_name}
                                    <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600} ml={'0.5vw'}>{`${item?.patient_age ? item?.patient_age : '-'}/${item?.patient_gender ? (item?.patient_gender)?.toUpperCase() : '-'}`}</Typography>
                                  </Typography>
                                : '-'}
                              <Typography component={'div'} color={Colors.grayShade} fontSize={'0.8vw'}>{item?.patient_account_number ? item.patient_account_number : '-'} |
                                <Typography component={'span'} fontSize={'0.8vw'} color={Colors.grayShade}>{item?.patient_mobile_number ? item?.patient_mobile_number : '-'}</Typography>
                              </Typography>
                              {item?.op_number ? <Box component={'div'}><Typography component={'div'} color={Colors.grayShade} fontSize={'0.8vw'}>{item?.op_number}</Typography></Box> : null}
                            </Box>
                          </Box>
                          <Box component={'div'}>
                            <Button variant='contained' size='small' emed_tid='rad_ip_req_btn'
                              onClick={() => {
                                this.setState({ isOpListAnchor: null, searchOpList: '', isOpList: false, opListDate: new Date() }, () => {
                                  if (FromCashCounter) {
                                    const cashmodulePaths = {
                                      front_office: '/HospitalBilling/CashCounter',
                                      Laboratory: '/LabBilling/CashCounter',
                                      Radiology: '/RadiologyBilling/CashCounter',
                                      Investigation: `/${GetInvestigationName()}Billing/CashCounter`,
                                      Pharmacy: '/PharmacyBilling/CashCounter'
                                    };
                                    const { module_name } = this.state.loggedInuserInfo || {};
                                    const cashtargetPath = cashmodulePaths[module_name];
                                    this.props.history?.push({ pathname: cashtargetPath, states: { patient_details: item, fromPharmacy: module_name === 'Pharmacy' ? true : false, from_op_list: true, module: "op" } });
                                  } else {
                                    this.props.history?.push({ pathname: targetPath, state: { opListData: item, fromOpList: true } });
                                    setTimeout(() => this.props.history?.push({ pathname: targetPath, state: {} }), 5000);
                                  }
                                });
                              }}
                            >Proceed</Button>
                          </Box>
                        </Box>
                      )
                    }) : <Typography display={'flex'} justifyContent={'center'} mt={'2vw'}>No Records To Be Shown</Typography>}
                  </Box>

              }

            </Box>
          </Menu>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getIpAdmissionListData = () => {
    try{
      RestAPIService.getAll(Serviceurls.IP_ADMISSION_LIST_HOME)
      .then((response) => {
        if(response?.data?.status === 'success'){
          this.setState({
            ipList:response?.data?.data,
            dupIpList:JSON.stringify(response?.data?.data)
          })
        }
      }).catch(error => {
          this.setState({ ipListLoad: false })
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    }catch(error){
      this.errorMessage(error.message)
    }
  }

  getDraftBillData = () => {
    try {
      let startDate = new Date(this.state.opDraftDate)
      let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      this.setState({ opDraftLoad: true })
      let moduleType = this.state.loggedInuserInfo?.module_name === 'Laboratory' ? 'LAB' : 
      this.state.loggedInuserInfo?.module_name === 'Radiology' ? 'RADIOLOGY' : this.state.loggedInuserInfo?.module_name === 'Investigation' ? GetInvestigationName() : this.state.loggedInuserInfo?.module_name === 'Doctor' ? 'Doctor' : this.state.loggedInuserInfo?.module_name === 'Investigation' ? GetInvestigationName() : ''
      RestAPIService.getAll(Serviceurls.NEW_BILLING_SAVED_BILL_GET + '?date=' + date + '&module_type=' + moduleType)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({ 
              opDraftList: response?.data?.data, 
              dupOpDraftList:JSON.stringify(response?.data?.data),
              opDraftLoad: false
             })
          }
        }).catch(error => {
          this.setState({ opDraftLoad: false })
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ opDraftLoad: false })
      this.errorMessage(error.message)
    }
  }

  renderPatientCard = (item) => {
    try {
      let gender = item?.gender === 'm' ? 'M' : item?.gender === 'f' ? 'F' : 'T'
      let patientName = `${item?.patient_name || item?.first_name} ${item?.patient_age_str || item?.patient_age}/${gender}`
      let uhidMob = `${item.patient_account_number} | ${item?.mobile_number || item?.patient_mobile_number}`
      let profile = item?.photo_url ? item?.photo_url : gender === 'M' ? ImagePaths.Male.default : ImagePaths.Female.default
      let borderColor = (item?.patient_type === 'New Patient' || item?.patient_type === 'new_patient') ? '#F1584A' : (item?.patient_type === 'Review Patient' || item?.patient_type === 'review_patient') ? '#29B6F6' : '#800080'
      let consultantName = item?.doctor_name || '-'
      return (
        <Box component={'div'} sx={{ backgroundColor: "white" }}>
            <Box component={'div'} sx={{ width: "17.3vw" }}>
              <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'flex-start'} >
                <Box component={'div'} mr={'0.5rem'} sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box component={'img'} src={profile} height={'5dvh'} width={'2.3dvw'} borderRadius={'50%'} border={`2px solid ${borderColor}`} />
                </Box>
                <Box component={'div'}>
                  {patientName ? patientName?.length > 25 ?
                    <Tooltip placement='top' title={patientName}><Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT}>{patientName?.slice(0, 25) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT}>{patientName}</Typography> : '-'}
                  {uhidMob ? uhidMob?.length > 30 ?
                    <Tooltip placement='top' title={uhidMob}><Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{uhidMob?.slice(0, 30) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{uhidMob}</Typography> : '-'}
                </Box>
              </Box>
            </Box>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  onDeleteNewDraftItem = (item) => {
    try {
      let data = { id: item?.id }
      RestAPIService.delete(Serviceurls.NEW_COMPLETE_BILLS_GET, data)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.successMessage(response?.data?.message)
            this.getDraftBillData()
            this.getBadgeCount()
          }
        }).catch(error => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  PrintCancelledData(Billid) {
    try {
      RestAPIService.getAll(Serviceurls.NEW_OP_INVOICE_PRINT + `?invoce_id=${Billid}`).
        then((response) => {
          if (response) {
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //Open the URL on new Window
            window.open(fileURL);
          }
        }).catch((error) => {
          this.errorMessage(error?.message)
        })
    } catch (e) {
      this.errorMessage(e?.message)
    }
  }

  renderOPDraftPopup = () => {
    try {
      let FromFO = (window.location.pathname === '/Billing' || window.location.pathname === '/Billing/HospitalBilling') ? true : false
      this.state.opDraftList?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        {
          field: 'patient_details', headerName: 'Patient Details', flex: 0.28,
          renderCell: (params) => {
            return (
              <Box>{this.renderPatientCard(params?.row?.patient_data)}</Box>
            )
          }
        },
        {
          field: 'op_number', headerName: 'OP Number', flex: 0.17,
          renderCell: (params) => {
            let opNumber = params?.row?.op_number
            return (
              <Box>
                {opNumber ? opNumber?.length > 15 ?
                  <Tooltip placement='top' title={opNumber}><Typography fontSize={'0.9rem'} fontWeight={600}>{'...' + opNumber?.slice(-15)}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600}>{opNumber}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'draft_details', headerName: 'Draft Details', flex: 0.2,
          renderCell: (params) => {
            let tempInvoice = params?.row?.temp_invoice_number
            return (
              <Box>
                {tempInvoice ? tempInvoice?.length > 15 ?
                  <Tooltip placement='top' title={tempInvoice}><Typography fontSize={'0.9rem'} fontWeight={600}>{'...' + tempInvoice?.slice(-15)}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600}>{tempInvoice}</Typography> : '-'}
                <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{params?.row?.invoice_date}</Typography>
              </Box>
            )
          }
        },
        {
          field: 'doctor_details', headerName: 'Doctor/Nurse Details', flex: 0.2,
          renderCell: (params) => {
            let doctorName = params?.row?.patient_data?.doctor_name
            let doctorSpec = params?.row?.patient_data?.specialization_name
            return (
              <Box>
                {doctorName ? doctorName?.length > 15 ?
                  <Tooltip placement='top' title={doctorName}><Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName?.slice(0, 15) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName}</Typography> : '-'}
                {doctorSpec ? doctorSpec?.length > 15 ?
                  <Tooltip placement='top' title={doctorSpec}><Typography fontSize={'0.8rem'} color={Colors.grayShade}>{doctorSpec?.slice(0, 15) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{doctorSpec}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'action', headerName: 'Action', flex: 0.15 ,align:'center',
          renderCell: (params) => {
            const modulePaths = {
              front_office: '/HospitalBilling/HospitalBilling',
              Laboratory: '/LabBilling/HospitalBilling',
              Radiology: '/RadiologyBilling/HospitalBilling',
              Investigation: `/${GetInvestigationName()}Billing/HospitalBilling`,
              Doctor: '/DoctorBilling'
            };
            const { module_name } = this.state.loggedInuserInfo || {};
            const targetPath = modulePaths[module_name];
            return (
              <Box>
                {targetPath && (
                  <>
                    <IconButton
                      onClick={() => {
                        this.setState(
                          { isOpDraft: false, isOpDraftAnchor: null, opDraftDate: new Date(), opDraftDatePickerOpen: false, searchOpDraftList: '' },
                          () => {
                            this.props.history?.push({ pathname: targetPath, state: { draftData: params?.row, fromDraft: true } });
                            setTimeout(() => this.props.history?.push({ pathname: targetPath, state: {} }), 5000);
                          }
                        );
                      }}
                    >
                      <Box component={'img'} src={ImagePaths.CreateBill.default} height={'1.5dvw'} width={'1.8dvw'} />
                    </IconButton>
                    <IconButton
                      onClick={() => {this.onDeleteNewDraftItem(params?.row)}}
                    >
                      <Box component={'img'} src={ImagePaths.Delete.default} height={'1.5dvw'} width={'1.8dvw'} />
                    </IconButton>
                    {(localGetItem("isNewBilling") === "true" && localGetItem("print_option_for_draft_bills") === "true") ? <IconButton
                      onClick={() => { this.PrintCancelledData(params?.row?.id)}}
                    >
                      <Box component={'img'} src={ImagePaths.PrintIcons.default} height={'1.5dvw'} width={'1.8dvw'} />
                    </IconButton> : null}
                  </>
                )}
              </Box>
            )
          }
        },
      ]
      return (
        <Dialog open={this.state.isOpDraft} maxWidth='md' fullWidth>
          <Box component={'div'} className='com_billing_popup' p={'0.5vw'}>
            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
              <Typography fontWeight={600}>OP Draft List</Typography>
              <Button className='Common_Btn_Min_Width'
                onClick={() => this.setState({ isOpDraft: false, isOpDraftAnchor: null, opDraftDatePickerOpen: false, opDraftDate: new Date(),searchOpDraftList:'' }, () => {  this.getDraftBillData() })}
              >
                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
              </Button>
            </Box>
            <Box component={'div'} m={'0.5vw 0.5vw'} display={'flex'}>
              <TextField
                autoComplete='off'
                size='small'
                sx={{ width: '20vw', mr: '1vw' }}
                value={this.state.searchOpDraftList}
                onChange={(e) => this.setState({ searchOpDraftList: e.target.value },() => {
                  let dupOpDraftList = JSON.parse(this.state.dupOpDraftList)
                  if (this.state.searchOpDraftList !== '') {
                    dupOpDraftList = dupOpDraftList.filter((item) => {
                      return (
                        (item?.patient_name === '' ? '' : item?.patient_data?.patient_name?.toLowerCase()?.includes(this.state.searchOpDraftList?.toLowerCase())) ||
                        (item?.patient_mobile_number === '' ? '' : item?.patient_data?.patient_mobile_number?.toLowerCase()?.includes(this.state.searchOpDraftList?.toLowerCase())) || 
                        (item?.patient_account_number === '' ? '' : item?.patient_data?.patient_account_number?.toLowerCase()?.includes(this.state.searchOpDraftList?.toLowerCase())) || 
                        (item?.op_number === '' ? '' : item?.patient_data?.op_number?.toLowerCase()?.includes(this.state.searchOpDraftList?.toLowerCase())) ||
                        (item?.temp_invoice_number === '' ? '' : item?.patient_data?.temp_invoice_number?.toLowerCase()?.includes(this.state.searchOpDraftList?.toLowerCase()))
                      )
                    })
                    this.setState({ opDraftList: dupOpDraftList })
                  } else {
                    this.setState({ opDraftList: dupOpDraftList })
                  }
                })}
                label={'Search Patient Name'}
                onKeyDown={(e) => { e.stopPropagation() }}
              />
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={this.state.opDraftDatePickerOpen}
                  onOpen={() => { this.setState({ opDraftDatePickerOpen: true }) }}
                  onClose={() => { this.setState({ opDraftDatePickerOpen: false }) }}
                  value={this.state.opDraftDate}
                  name={"datePicker"}
                  inputFormat='DD-MM-YYYY'
                  views={["year", "month", "day"]}
                  onChange={(newDate) => { this.setState({ opDraftDate: newDate }, () => { this.getDraftBillData() }) }}
                  maxDate={new Date()}
                  renderInput={(params) => <TextField
                    onKeyDown={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }} style={{ width: '9.5vw' }} size='small' {...params} inputProps={{ ...params.inputProps, 'emed_tid': 'IP_Date_Search' }} onClick={() => { this.setState({ opDraftDatePickerOpen: true }) }} />}
                />
              </LocalizationProvider> */}
            </Box>
            <Box component={'div'} height={'30dvw'} mt={'0.5rem'}>
              <DataGrid
                rows={this.state.opDraftList}
                page={this.state.opDraftPage}
                columns={columns}
                getRowId={(row) => row.sno}
                pageSize={this.state.opDraftPageSize}
                onPageChange={(opDraftPage) => { this.setState({ opDraftPage: opDraftPage }) }}
                onPageSizeChange={(opDraftPageSize) => this.setState({ opDraftPageSize: opDraftPageSize })}
                rowsPerPageOptions={[10, 20, 30]}
                loading={this.state.opDraftLoad}
                localeText={{
                  toolbarColumns: "",
                  toolbarDensity: "",
                  toolbarExport: "",
                  toolbarFilters: "",
                  toolbarExportPrint: ""
                }}
                components={{
                  // Toolbar: CommonGridHeader.CommonToolBar,
                  // Toolbar: this.gridToolBar,
                  NoRowsOverlay: () => (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center',height:'100%' }}>
                      {("No Records To Be Shown")}
                    </Box>
                  )
                }}
                headerHeight={40}
              />
            </Box>
          </Box>
        </Dialog>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getOpOrderListData = () => {
    try{
      let startDate = new Date(this.state.opOrderDate)
      let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      this.setState({ opOrderLoad: true })
      let moduleType = this.state.loggedInuserInfo?.module_name === 'Laboratory' ? 'LAB' : 
      this.state.loggedInuserInfo?.module_name === 'Radiology' ? 'RADIOLOGY' : ''
      RestAPIService.getAll(Serviceurls.NEW_BILLING_OP_ORDER_LIST + '?date=' + date + '&module_type=' + moduleType)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({ 
              opOrderList: response?.data?.data, 
              dupOpOrderList:JSON.stringify(response?.data?.data),
              opOrderLoad: false 
            })
          }
        }).catch(error => {
          this.setState({ opOrderLoad: false })
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    }catch(error){
      this.setState({opOrderLoad:false})
      this.errorMessage(error.message)
    }
  }

  renderOpOrderPopup = () => {
    try {
      let FromFO = (window.location.pathname === '/Billing' || window.location.pathname === '/Billing/HospitalBilling') ? true : false
      this.state.opOrderList?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        {
          field: 'patient_details', headerName: 'Patient Details', flex: 0.3,
          renderCell: (params) => {
            return (
              <Box>{this.renderPatientCard(params?.row)}</Box>
            )
          }
        },
        {
          field: 'op_number', headerName: 'OP Number', flex: 0.2,
          renderCell: (params) => {
            let opNumber = params?.row?.op_number
            return (
              <Box>
                {opNumber ? opNumber?.length > 15 ?
                  <Tooltip placement='top' title={opNumber}><Typography fontSize={'0.9rem'} fontWeight={600}>{'...' + opNumber?.slice(-15)}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600}>{opNumber}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'order_details', headerName: 'Order Details', flex: 0.2,
          renderCell: (params) => {
            let orderInvoice = params?.row?.order_number
            return (
              <Box>
                {orderInvoice ? orderInvoice?.length > 15 ?
                  <Tooltip placement='top' title={orderInvoice}><Typography fontSize={'0.9rem'} fontWeight={600}>{'...' + orderInvoice?.slice(-15)}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600}>{orderInvoice}</Typography> : '-'}
                <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{convertDateTime(params?.row?.order_date)}</Typography>
              </Box>
            )
          }
        },
        {
          field: 'doctor_details', headerName: 'Doctor/Nurse Details', flex: 0.2,
          renderCell: (params) => {
            let doctorName = params?.row?.doctor_name
            let doctorSpec = params?.row?.specialization_name
            return (
              <Box>
                {doctorName ? doctorName?.length > 15 ?
                  <Tooltip placement='top' title={doctorName}><Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName?.slice(0, 15) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName}</Typography> : '-'}
                {doctorSpec ? doctorSpec?.length > 15 ?
                  <Tooltip placement='top' title={doctorSpec}><Typography fontSize={'0.8rem'} color={Colors.grayShade}>{doctorSpec?.slice(0, 15) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{doctorSpec}</Typography> : ''}
              </Box>
            )
          }
        },
        {
          field: 'action', headerName: 'Action', flex: 0.1,
          renderCell: (params) => {
            const modulePaths = {
              front_office: '/HospitalBilling/HospitalBilling',
              Laboratory: '/LabBilling/HospitalBilling',
              Radiology: '/RadiologyBilling/HospitalBilling',
              Investigation: `/${GetInvestigationName()}Billing/HospitalBilling`,
              Doctor: '/DoctorBilling'
            };
            const { module_name } = this.state.loggedInuserInfo || {};
            const targetPath = modulePaths[module_name];
            return (
              <Box>
                {targetPath && (
                  <IconButton
                    onClick={() => {
                      this.setState(
                        { isOpOrder: false, isOpOrderAnchor: null, opOrderDate: new Date(), opOderDatePickerOpen: false,searchOpOderList:'' },
                        () => {
                          this.props.history?.push({ pathname: targetPath, state: { orderData: params?.row, fromOrder: true } });
                          setTimeout(() => this.props.history?.push({ pathname: targetPath, state: {} }), 5000);
                        }
                      );
                    }}
                  >
                    <Box component={'img'} src={ImagePaths.CreateBill.default} height={'1.5dvw'} width={'1.8dvw'} />
                  </IconButton>
                )}
              </Box>
            )
          }
        },
      ]
      return (
        <Dialog open={this.state.isOpOrder} maxWidth='md' fullWidth>
          <Box component={'div'} className='com_billing_popup' p={'0.5vw'}>
            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
              <Typography fontWeight={600}>OP Order List</Typography>
              <Button className='Common_Btn_Min_Width'
                onClick={() => this.setState({ isOpOrder: false, isOpOrderAnchor: null, opOderDatePickerOpen: false, opOrderDate: new Date(),searchOpOderList:'' }, () => { this.getOpOrderListData() })}
              >
                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
              </Button>
            </Box>
            <Box component={'div'} display={'flex'} mb={'0.5rem'}>
              <TextField
                autoComplete='off'
                size='small'
                sx={{ width: '20vw', mr: '1vw' }}
                value={this.state.searchOpOderList}
                onChange={(e) => this.setState({ searchOpOderList: e.target.value }, () => {
                  let dupOpOrderList = JSON.parse(this.state.dupOpOrderList)
                  if (this.state.searchOpOderList !== '') {
                    dupOpOrderList = dupOpOrderList.filter((item) => {
                      return (
                        (item?.patient_name === '' ? '' : item?.patient_name?.toLowerCase()?.includes(this.state.searchOpOderList?.toLowerCase())) ||
                        (item?.patient_mobile_number === '' ? '' : item?.patient_mobile_number?.toLowerCase()?.includes(this.state.searchOpOderList?.toLowerCase())) ||
                        (item?.patient_account_number === '' ? '' : item?.patient_account_number?.toLowerCase()?.includes(this.state.searchOpOderList?.toLowerCase())) ||
                        (item?.op_number === '' ? '' : item?.op_number?.toLowerCase()?.includes(this.state.searchOpOderList?.toLowerCase())) ||
                        (item?.order_number === '' ? '' : item?.order_number?.toLowerCase()?.includes(this.state.searchOpOderList?.toLowerCase()))
                      )
                    })
                    this.setState({ opOrderList: dupOpOrderList })
                  } else {
                    this.setState({ opOrderList: dupOpOrderList })
                  }
                })}
                label={'Search Patient Name'}
                onKeyDown={(e) => { e.stopPropagation() }}
              />
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={this.state.opOderDatePickerOpen}
                  onOpen={() => { this.setState({ opOderDatePickerOpen: true }) }}
                  onClose={() => { this.setState({ opOderDatePickerOpen: false }) }}
                  value={this.state.opOrderDate}
                  name={"datePicker"}
                  inputFormat='DD-MM-YYYY'
                  views={["year", "month", "day"]}
                  onChange={(newDate) => { this.setState({ opOrderDate: newDate }, () => { }) }}
                  maxDate={new Date()}
                  renderInput={(params) => <TextField
                    onKeyDown={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }} style={{ width: '9.5vw' }} size='small' {...params} inputProps={{ ...params.inputProps, 'emed_tid': 'IP_Date_Search' }} onClick={() => { this.setState({ opOderDatePickerOpen: true }) }} />}
                />
              </LocalizationProvider> */}
            </Box>
            <Box component={'div'} height={'30dvw'}>
              <DataGrid
                rows={this.state.opOrderList}
                page={this.state.opOrderPage}
                columns={columns}
                getRowId={(row) => row.sno}
                pageSize={this.state.opOrderPageSize}
                onPageChange={(opOrderPage) => { this.setState({ opOrderPage: opOrderPage }) }}
                onPageSizeChange={(opOrderPageSize) => this.setState({ opOrderPageSize: opOrderPageSize })}
                rowsPerPageOptions={[10, 20, 30]}
                loading={this.state.opOderLoad}
                localeText={{
                  toolbarColumns: "",
                  toolbarDensity: "",
                  toolbarExport: "",
                  toolbarFilters: "",
                  toolbarExportPrint: ""
                }}
                components={{
                  // Toolbar: CommonGridHeader.CommonToolBar,
                  // Toolbar: this.gridToolBar,
                  NoRowsOverlay: () => (
                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
                      {("No Records To Be Shown")}
                    </Box>
                  )
                }}
                headerHeight={40}
              />
            </Box>
          </Box>
        </Dialog>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getApproverListData = () => {
    try {
      let userId = localGetItem('loggedUserId')
      let startDate = new Date(this.state.approverDate)
      let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      this.setState({ approverLoad: true })
      var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
      var UserData = myUser
      RestAPIService.getAll((this.state?.isRTConcession ? Serviceurls.RT_DOCTOR_TRANSMIT_APPROVAL : Serviceurls.NEW_BILLING_PENDING_LIST) + '?approver_id=' + userId + '&request_status=Requested' + '&date=' + date)
        .then((response) => {
          if (response?.data?.status === 'success') {
            let RequestsList = response?.data?.data?.filter((list)=>(list?.module_type !== "IP" || UserData?.module_name === "front_office")) || []
            this.setState({ 
              approverList:RequestsList,
              dupApproverList:JSON.stringify(RequestsList), 
              approverLoad: false })
            if (this.state.searchApproverList !== '') {
              var dupApproverList = RequestsList?.filter((item) => {
                return (
                  (item?.patient_name === '' ? '' : item?.patient_name?.toLowerCase()?.includes(this.state.searchApproverList?.toLowerCase())) ||
                  (item?.patient_mobile_number === '' ? '' : item?.patient_mobile_number?.toLowerCase()?.includes(this.state.searchApproverList?.toLowerCase())) ||
                  (item?.patient_account_number === '' ? '' : item?.patient_account_number?.toLowerCase()?.includes(this.state.searchApproverList?.toLowerCase()))
                )
              })
              this.setState({ approverList: dupApproverList })
            }
          }
        }).catch((error) => {
          this.setState({ approverLoad: false })
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error?.message)
          }
        })
    } catch (error) {
      this.setState({ approverLoad: false })
      this.errorMessage(error.message)
    }
  }

  renderAppoverListPopup = () => {
    try{
      this.state.approverList?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        {
          field: 'patient_details', headerName: 'Patient Details', flex: 0.3,
          renderCell: (params) => {
            return (
              <Box>{this.renderPatientCard(params?.row)}</Box>
            )
          }
        },
        ...(this.state.isRTConcession ? [] : [{
          field: 'requested_details', headerName: 'Requested Details', flex: 0.2,
          renderCell: (params) => {
            let opNumber = params?.row?.request_number
            return (
              <Box>
                {opNumber ? opNumber?.length > 15 ?
                  <Tooltip placement='top' title={opNumber}><Typography fontSize={'0.9rem'} fontWeight={600}>{'...' + opNumber?.slice(-15)}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600}>{opNumber}</Typography> : '-'}
              </Box>
            )
          }
        }]),
        {
          field: 'request_type', headerName: 'Request Type', flex: 0.2,
          renderCell: (params) => {
            let orderInvoice = 'Concession'
            let reqDate = this.state.isRTConcession ? formatDateAndTimeMeth2(params?.row?.created_date) : `${params?.row?.request_date} ${params?.row?.request_time}`
            return (
              <Box>
                {orderInvoice ? orderInvoice?.length > 15 ?
                  <Tooltip placement='top' title={orderInvoice}><Typography fontSize={'0.9rem'} fontWeight={600}>{'...' + orderInvoice?.slice(-15)}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600}>{orderInvoice}</Typography> : '-'}
                <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{reqDate}</Typography>
              </Box>
            )
          }
        },
        ...(this.state.isRTConcession ? [
          {
            field: 'created_by', headerName: 'Raised By', flex: 0.2,
            renderCell: (params) => {
              let doctorName = params?.row?.created_by
              return (
                <Box>
                  {doctorName ? doctorName?.length > 15 ?
                    <Tooltip placement='top' title={doctorName}><Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName?.slice(0, 15) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName}</Typography> : '-'}
                </Box>
              )
            }
          },
        ] : [
          {
            field: 'requested_by', headerName: 'Raised By', flex: 0.2,
            renderCell: (params) => {
              let doctorName = params?.row?.requested_by
              let doctorSpec = params?.row?.specialization_name
              return (
                <Box>
                  {doctorName ? doctorName?.length > 15 ?
                    <Tooltip placement='top' title={doctorName}><Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName?.slice(0, 15) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName}</Typography> : '-'}
                </Box>
              )
            }
          },
        ]),
        {
          field: 'action', headerName: 'Action', flex: 0.1,
          renderCell: (params) => {
            const modulePaths = {
              front_office: '/HospitalBilling/HospitalBilling',
              Laboratory: '/LabBilling/HospitalBilling',
              Radiology: '/RadiologyBilling/HospitalBilling',
              Investigation: `/${GetInvestigationName()}Billing/HospitalBilling`,
            };
            const { module_name } = this.state.loggedInuserInfo || {};
            const targetPath = modulePaths[module_name];
            return (
              <Box>
                {targetPath && (
                  <IconButton
                    onClick={() => {
                      if (this.state.isRTConcession) {
                        this.setState({ RTDiscApprovalDeails : params?.row, openApproverList: false, approverDate: new Date(), approverDatePickerOpen: false, searchApproverList: '' })
                      } else {
                        this.setState({ openApproverList: false, approverDate: new Date(), approverDatePickerOpen: false, searchApproverList: '' },
                          () => {
                            if (params?.row?.ip_admission_id) {
                              this.props.history?.push({ pathname: "/IPHome/FinalSettlement", state: { Patient_details: params?.row, approver_id: params?.row?.approver_id, ip_admission_id: params?.row?.ip_admission_id, fromApprover: true } })
                            }
                            else {
                              this.props.history?.push({
                                pathname: targetPath, state: {
                                  patientDetails: params?.row, appointment_id: params?.row?.appointment_id,
                                  invoiceId: params?.row?.op_bill_id, fromApprover: true, pending_list_id: params?.row?.id, approver_id: params?.row?.approver_id, requested_from: params?.row?.request_from
                                }
                              });
                              setTimeout(() => this.props.history?.push({ pathname: targetPath, state: {} }), 5000);
                            }
                          }
                        );
                      }
                    }}
                  >
                    <Box component={'img'} src={ImagePaths.CreateBill.default} height={'1.5dvw'} width={'1.8dvw'} />
                  </IconButton>
                )}
              </Box>
            )
          }
        },
      ]
      return (
        <Dialog open={this.state.openApproverList} maxWidth='md' fullWidth>
          <Box component={'div'} className='com_billing_popup' p={'0.5rem'}>
            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
              <Typography fontWeight={600}>Approvals List</Typography>
              <Button className='Common_Btn_Min_Width'
                onClick={() => this.setState({ openApproverList: false, approverDatePickerOpen: false, approverDate: new Date(), searchApproverList: '', isRTConcession: false }, () => { this.getApproverListData() })}
              >
                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
              </Button>
            </Box>
            <Box component={'div'} display={'flex'} mb={'0.5rem'}>
              <TextField
                autoComplete='off'
                size='small'
                sx={{ width: '20vw', mr: '1vw' }}
                value={this.state.searchApproverList}
                onChange={(e) => this.setState({ searchApproverList: e.target.value }, () => {
                  let dupApproverList = JSON.parse(this.state.dupApproverList)
                  if (this.state.searchApproverList !== '') {
                    dupApproverList = dupApproverList.filter((item) => {
                      return (
                        (item?.patient_name === '' ? '' : item?.patient_name?.toLowerCase()?.includes(this.state.searchApproverList?.toLowerCase())) ||
                        (item?.patient_mobile_number === '' ? '' : item?.patient_mobile_number?.toLowerCase()?.includes(this.state.searchApproverList?.toLowerCase())) ||
                        (item?.patient_account_number === '' ? '' : item?.patient_account_number?.toLowerCase()?.includes(this.state.searchApproverList?.toLowerCase()))
                      )
                    })
                    this.setState({ approverList: dupApproverList })
                  } else {
                    this.setState({ approverList: dupApproverList })
                  }
                })}
                label={'Search Patient Name'}
                onKeyDown={(e) => { e.stopPropagation() }}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={this.state.approverDatePickerOpen}
                  onOpen={() => { this.setState({ approverDatePickerOpen: true }) }}
                  onClose={() => { this.setState({ approverDatePickerOpen: false }) }}
                  value={this.state.approverDate}
                  name={"datePicker"}
                  inputFormat='DD-MM-YYYY'
                  views={["year", "month", "day"]}
                  onChange={(newDate) => { this.setState({ approverDate: newDate }, () => { this.getApproverListData() }) }}
                  maxDate={new Date()}
                  renderInput={(params) => <TextField
                    onKeyDown={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }} style={{ width: '9.5vw' }} size='small' {...params} inputProps={{ ...params.inputProps, 'emed_tid': 'IP_Date_Search' }} onClick={() => { this.setState({ approverDatePickerOpen: true }) }} />}
                />
              </LocalizationProvider>
              {this.state.loggedInuserInfo?.enable_radiotherapy ?
                <Box sx={{ display: 'flex', alignItems: 'center', ml: '1vw' }}>
                  <Typography fontSize={'0.8rem'} sx={{ color: !this.state.isRTConcession ? 'primary.main' : 'text.secondary' }}>Concession Request</Typography>
                  <Switch
                    size="small"
                    checked={this.state.isRTConcession}
                    onChange={(e) => this.setState({ isRTConcession: e.target.checked }, () => { this.getApproverListData() })}
                  />
                  <Typography fontSize={'0.8rem'} sx={{ color: this.state.isRTConcession ? 'primary.main' : 'text.secondary' }}>RT Concession Request</Typography>
                </Box> : null}
            </Box>
            <Box component={'div'} height={'30dvw'}>
              <DataGrid
                rows={this.state.approverList}
                page={this.state.approverPage}
                columns={columns}
                getRowId={(row) => row.sno}
                pageSize={this.state.approverPageSize}
                onPageChange={(approverPage) => { this.setState({ approverPage: approverPage }) }}
                onPageSizeChange={(approverPageSize) => this.setState({ approverPageSize: approverPageSize })}
                rowsPerPageOptions={[10, 20, 30]}
                loading={this.state.approverLoad}
                localeText={{
                  toolbarColumns: "",
                  toolbarDensity: "",
                  toolbarExport: "",
                  toolbarFilters: "",
                  toolbarExportPrint: ""
                }}
                components={{
                  // Toolbar: CommonGridHeader.CommonToolBar,
                  // Toolbar: this.gridToolBar,
                  NoRowsOverlay: () => (
                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
                      {("No Records To Be Shown")}
                    </Box>
                  )
                }}
                headerHeight={40}
              />
            </Box>
          </Box>
        </Dialog>
      )
    }catch(error){
      this.errorMessage(error.message)
    }
  }

  getFOLabTransmitListData = () => {
    try {
      let todayDate = new Date(this.state.labIpTransDate)
      let date = DateTime.fromJSDate(todayDate).toFormat('yyyy-MM-dd')
      this.setState({ ipTraLoad: true })
      let APIURL = ""
      if (window.location.pathname === "/Billing/MultiBilling") {
        let modules = []
        if (this.state.IncludeLab) {
          modules.push("Laboratory")
        }
        if (this.state.IncludeRadiology) {
          modules.push("Radiology")
        }
        APIURL = Serviceurls.LAB_MULTIBILL_TRANSMIT_GET + "?search_key=" + "&transmit_date=" + date + '&laboratory_id=' + this.state.labId + '&module=' + modules
      } else {
        APIURL = Serviceurls.LAB_PATIENT_TRANSMIT_GET + "?search_key=" + "&transmit_date=" + date + '&lab_id=' + this.state.labId
      }
      RestAPIService.getAll(APIURL)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              ipLabTransmitList: response.data.data,
              dupLabTraList: JSON.stringify(response.data.data),
              ipTraLoad: false
            })
          }
        }).catch((error) => {
          this.setState({ ipTraLoad: false })
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ ipTraLoad: false })
      this.errorMessage(error.message)
    }
  }

  getSpecialTransmitPrint = (patient_id, transmitedId) => {
    try {
      RestAPIService.getAll(Serviceurls.LAB_PATIENT_TRANSMIT_GET + `?export_type=pdf&patient_id=${patient_id}&lab_id=${this.state.labId}&transmitted_id=${transmitedId}`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderFOTransmitPopup = () => {
    try {
      return (
        <Menu
          elevation={1}
          anchorEl={this.state.ipTransAnchor}
          open={this.state.isIPTrans}
          sx={{ mt: '3vw' }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        >
          <Box component={'div'} width={'37vw'} maxHeight={'28vw'} overflow={'auto'} p={'0vw 0.5vw'}>
            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
              <Typography fontWeight={600}>Transmit List</Typography>
              <Button className='Common_Btn_Min_Width'
                onClick={() => this.setState({
                  isIPTrans: false,
                  ipTransAnchor: null,
                  labTransDatePickerOpen: false,
                  labIpTransDate: new Date()
                }, () => this.getLaboratoryListData())}
              >
                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
              </Button>
            </Box>
            <Box component={'div'} m={'0.5vw 0.5vw'} display={'flex'}>
              <TextField
                autoComplete='off'
                size='small'
                sx={{ width: '11vw', mr: '1vw' }}
                value={this.state.searchLabIpTrans}
                onChange={(e) => this.setState({ searchLabIpTrans: e.target.value }, () => this.searchLabIpReqList(true))}
                label={'Search Patient Name'}
                onKeyDown={(e) => { e.stopPropagation() }}
              />
              <Autocomplete
                clearIcon
                size='small'
                sx={{ width: '13vw', mr: '0.5vw' }}
                options={this.state.labNameList}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.laboratory_name}
                value={this.state.labName}
                onChange={(e, value) => {
                  this.setState({
                    labId: value['laboratory_id'],
                    labName: value['laboratory_name']
                  }, () => this.getFOLabTransmitListData())
                }}
                onKeyDown={(e) => e.stopPropagation()}
                renderInput={(params) => <TextField {...params} label='Select Laboratory' />}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={this.state.labTransDatePickerOpen}
                  onOpen={() => { this.setState({ labTransDatePickerOpen: true }) }}
                  onClose={() => { this.setState({ labTransDatePickerOpen: false }) }}
                  value={this.state.labIpTransDate}
                  name={"datePicker"}
                  inputFormat='DD-MM-YYYY'
                  views={["year", "month", "day"]}
                  onChange={(newDate) => { this.setState({ labIpTransDate: newDate }, () => this.getFOLabTransmitListData()) }}
                  maxDate={new Date()}
                  renderInput={(params) => <TextField
                    onKeyDown={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }} style={{ width: '9.5vw' }} size='small' {...params} inputProps={{ ...params.inputProps, 'emed_tid': 'IP_Date_Search' }} onClick={() => { this.setState({ labTransDatePickerOpen: true }) }} />}
                />
              </LocalizationProvider>
            </Box>
            <Box component={'div'}>
              {this.state.ipTraLoad ?
                <Box component={'div'} pb={'0.5vw'} borderBottom={'1.5px solid lightgray'} mb={'0.5vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                  <CircularProgress size='small' color='primary' />
                </Box> :
                this.state.ipLabTransmitList?.length > 0 ? this.state.ipLabTransmitList?.map((item, index) => {
                  return (
                    <Box component={'div'} key={index} pb={'0.5vw'} borderBottom={'1.5px solid lightgray'} mb={'0.5vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                      <Box component={'div'} alignItems={'center'} width={'13vw'}>
                        {item?.patient_name?.length > 15 ?
                          <Tooltip placement='top' title={item?.patient_name}><Typography fontSize={'0.9vw'} fontWeight={600}>{item?.patient_name?.slice(0, 20) + '...'}</Typography></Tooltip> :
                          <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.patient_name}</Typography>}
                        <Typography fontSize={'0.8vw'} color={Colors.grayShade}>{`${item?.patient_mobile_number} - ${item?.patient_account_number}`}</Typography>
                      </Box>
                      <Box component={'div'}>
                        <Typography fontSize={'0.9vw'} fontWeight={600}>Date</Typography>
                        <Typography fontSize={'0.8vw'} color={Colors.grayShade}>{item?.transmit_date ? item?.transmit_date : '-'}</Typography>
                      </Box>
                      <Box component={'div'}>
                        <Button variant='contained'
                          onClick={() => {
                            let path = window.location.pathname === '/Billing/LabBilling' ? '/Billing/LabBilling' : '/Billing'
                            let specialTestTransmitIds = null; let lineItemsList = [];
                            item.line_items?.forEach(element => {
                              if (element.special_test_name) {
                                specialTestTransmitIds = element.transmit_summary_ids;
                              } else {
                                lineItemsList.push(element)
                              }
                            })
                            if (specialTestTransmitIds) {
                              this.getSpecialTransmitPrint(item?.patient_id, specialTestTransmitIds);
                            }
                            if (lineItemsList?.length > 0) {
                              item.line_items = lineItemsList
                              this.props.history.push({ pathname: path, state: { savedTransmitList: item } })
                              this.setState({ isIPTrans: false, ipTransAnchor: null, labIpTransDate: new Date(), labTransDatePickerOpen: false })
                              setTimeout(() => {
                                this.props.history.push({ pathname: path, state: { savedTransmitList: {} } })
                              }, 2000)
                            }
                          }}
                          sx={{ textTransform: 'capitalize' }}
                        >Proceed</Button>
                      </Box>
                    </Box>
                  )
                }) :
                  <Box component={'div'} pb={'0.5vw'} borderBottom={'1.5px solid lightgray'} mb={'0.5vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    <Typography fontWeight={600} fontSize={'0.9vw'}>No Records To Be Shown</Typography>
                  </Box>
              }
            </Box>
          </Box>
        </Menu>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderMultiBillingTransmitPopup = () => {
    try {
      return (
        <Menu
          elevation={1}
          anchorEl={this.state.ipTransAnchor}
          open={this.state.isIPTrans && (window.location.pathname === "/Billing/MultiBilling")}
          sx={{ mt: '3vw' }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        >
          <Box component={'div'} width={'37vw'} maxHeight={'28vw'} overflow={'auto'} p={'0vw 0.5vw'}>
            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
              <Typography fontWeight={600}>Transmit List</Typography>
              <Button className='Common_Btn_Min_Width'
                onClick={() => this.setState({
                  isIPTrans: false,
                  ipTransAnchor: null,
                  labTransDatePickerOpen: false,
                  labIpTransDate: new Date()
                }, () => this.getLaboratoryListData())}
              >
                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
              </Button>
            </Box>
            <Box ml={"0.5vw"}>
              <FormControlLabel control={<Checkbox checked={this.state.IncludeLab} onChange={(e) => { this.setState({ IncludeLab: e.target.checked }, () => this.getFOLabTransmitListData()) }} size='small' />} label={"Laboratory"} />
              <FormControlLabel control={<Checkbox checked={this.state.IncludeRadiology} onChange={(e) => { this.setState({ IncludeRadiology: e.target.checked }, () => this.getFOLabTransmitListData()) }} size='small' />} label={"Radiology"} />
            </Box>
            <Box component={'div'} m={'0.5vw 0.5vw'} display={'flex'}>
              <TextField
                autoComplete='off'
                size='small'
                sx={{ width: '11vw', mr: '1vw' }}
                value={this.state.searchLabIpTrans}
                onChange={(e) => this.setState({ searchLabIpTrans: e.target.value }, () => this.searchLabIpReqList(true))}
                label={'Search Patient Name'}
                onKeyDown={(e) => { e.stopPropagation() }}
              />
              <Autocomplete
                clearIcon
                size='small'
                sx={{ width: '13vw', mr: '0.5vw', visibility : this.state.IncludeLab ? 'visible' : 'hidden' }}
                options={this.state.labNameList}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.laboratory_name}
                value={this.state.labName}
                onChange={(e, value) => {
                  this.setState({
                    labId: value['laboratory_id'],
                    labName: value['laboratory_name']
                  }, () => this.getFOLabTransmitListData())
                }}
                onKeyDown={(e) => e.stopPropagation()}
                renderInput={(params) => <TextField {...params} label='Select Laboratory' />}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={this.state.labTransDatePickerOpen}
                  onOpen={() => { this.setState({ labTransDatePickerOpen: true }) }}
                  onClose={() => { this.setState({ labTransDatePickerOpen: false }) }}
                  value={this.state.labIpTransDate}
                  name={"datePicker"}
                  inputFormat='DD-MM-YYYY'
                  views={["year", "month", "day"]}
                  onChange={(newDate) => { this.setState({ labIpTransDate: newDate }, () => this.getFOLabTransmitListData()) }}
                  maxDate={new Date()}
                  renderInput={(params) => <TextField
                    onKeyDown={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }} style={{ width: '9.5vw' }} size='small' {...params} inputProps={{ ...params.inputProps, 'emed_tid': 'IP_Date_Search' }} onClick={() => { this.setState({ labTransDatePickerOpen: true }) }} />}
                />
              </LocalizationProvider>
            </Box>
            <Box component={'div'}>
              {this.state.ipTraLoad ?
                <Box component={'div'} pb={'0.5vw'} borderBottom={'1.5px solid lightgray'} mb={'0.5vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                  <CircularProgress size='small' color='primary' />
                </Box> :
                this.state.ipLabTransmitList?.length > 0 ? this.state.ipLabTransmitList?.map((item, index) => {
                  return (
                    <Box component={'div'} key={index} pb={'0.5vw'} borderBottom={'1.5px solid lightgray'} mb={'0.5vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                      <Box component={'div'} alignItems={'center'} width={'13vw'}>
                        {item?.patient_name?.length > 15 ?
                          <Tooltip placement='top' title={item?.patient_name}><Typography fontSize={'0.9vw'} fontWeight={600}>{item?.patient_name?.slice(0, 20) + '...'}</Typography></Tooltip> :
                          <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.patient_name}</Typography>}
                        <Typography fontSize={'0.8vw'} color={Colors.grayShade}>{`${item?.patient_mobile_number} - ${item?.patient_account_number}`}</Typography>
                      </Box>
                      <Box component={'div'}>
                        <Typography fontSize={'0.9vw'} fontWeight={600}>Date</Typography>
                        <Typography fontSize={'0.8vw'} color={Colors.grayShade}>{item?.transmit_date ? item?.transmit_date : '-'}</Typography>
                      </Box>
                      <Box component={'div'}>
                        <Button variant='contained'
                          onClick={() => {
                            this.setState({ isIPTrans: false, ipTransAnchor: null, labIpTransDate: new Date(), labTransDatePickerOpen: false }, () => {
                              this.props.history.push({ pathname: "/Billing/MultiBilling", state: { TransmitData: item } })
                            })
                          }}
                          sx={{ textTransform: 'capitalize' }}
                        >Proceed</Button>
                      </Box>
                    </Box>
                  )
                }) :
                  <Box component={'div'} pb={'0.5vw'} borderBottom={'1.5px solid lightgray'} mb={'0.5vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    <Typography fontWeight={600} fontSize={'0.9vw'}>No Records To Be Shown</Typography>
                  </Box>
              }
            </Box>
          </Box>
        </Menu>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderUpdateAbhaPopup = () => {
    try {
        if (!this.state.AbhaExistingData || !this.state.AbhaPatientdata) return null;
        return (
            <Box
                sx={{
                    position: "fixed",
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: "rgba(0,0,0,0.3)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                {this.state.isLoader && (
                <Box
                    sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    bgcolor: 'rgba(255,255,255,0.5)',
                    zIndex: 10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 2
                    }}
                >
                    <CircularProgress />
                </Box>
                )}
                <Box sx={{ background: "#fff", p: 4, borderRadius: 2, minWidth: 700, maxWidth: "90vw" }}>
                    <Typography variant="h5" mb={2} align="center">
                        Update Patient Data
                    </Typography>
                    <Typography variant="subtitle1" mb={3} align="center" color="primary">
                        Patient already linked with this hospital - UHID is {this.state.AbhaPatientUHID}
                    </Typography>
                    <Grid container spacing={3}>
                        {/* Existing Patient Section */}
                        <Grid item xs={12} md={6}>
                            <Box sx={{ border: "1px solid #ccc", borderRadius: 2, p: 2, background: "#f9f9f9", maxHeight: "55vh", overflowY: "auto" }}>
                                <Typography variant="subtitle2" mb={1} color="textSecondary">
                                    Existing Patient Data
                                </Typography>
                                <Typography><strong>Name:</strong> {[this.state.AbhaExistingData?.first_name, this.state.AbhaExistingData?.middle_name, this.state.AbhaExistingData?.last_name].filter(Boolean).join(" ")}</Typography>
                                <Typography><strong>Mobile:</strong> {this.state.AbhaExistingData?.mobile}</Typography>
                                <Typography><strong>ABHA Address:</strong> {(this.state.AbhaExistingData?.abha_health_address)}</Typography>
                                <Typography><strong>ABHA Number:</strong> {(this.state.AbhaExistingData?.abha_health_id)}</Typography>
                                <Typography><strong>Gender:</strong> {this.state.AbhaExistingData?.gender}</Typography>
                                <Typography><strong>DOB:</strong> {this.state.AbhaExistingData?.dob}</Typography>
                                <Typography><strong>Address:</strong> {this.state.AbhaExistingData?.address}</Typography>
                                <Typography><strong>Pincode:</strong> {this.state.AbhaExistingData?.pincode}</Typography>
                                <Typography><strong>District:</strong> {this.state.AbhaExistingData?.dst_name}</Typography>
                                <Typography><strong>State:</strong> {this.state.AbhaExistingData?.state_name}</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box sx={{ border: "1px solid #ccc", borderRadius: 2, p: 2, background: "#f9f9f9", position: "relative", maxHeight: "55vh", overflowY: "auto" }}>
                                <Typography variant="subtitle2" mb={1} color="textSecondary">
                                    ABHA Data
                                </Typography>
                                <Typography><strong>Name:</strong> {this.state.AbhaPatientdata?.name}</Typography>
                                <Typography><strong>Mobile:</strong> {this.state.AbhaPatientdata?.mobile_number}</Typography>
                                <Typography><strong>ABHA Address:</strong> {(this.state.AbhaPatientdata?.abha_health_address)}</Typography>
                                <Typography><strong>ABHA Number:</strong> {(this.state.AbhaPatientdata?.abha_health_id)}</Typography>
                                <Typography><strong>Gender:</strong> {this.state.AbhaPatientdata?.gender}</Typography>
                                <Typography><strong>DOB:</strong> {this.state.AbhaPatientdata?.dob}</Typography>
                                <Typography><strong>Address:</strong> {[this.state.AbhaPatientdata?.address_line_1,this.state.AbhaPatientdata?.address_line_2].filter(Boolean).join(" ")}</Typography>
                                <Typography><strong>Pincode:</strong> {this.state.AbhaPatientdata?.pincode}</Typography>
                                <Typography><strong>District:</strong> {this.state.AbhaPatientdata?.city}</Typography>
                                <Typography><strong>State:</strong> {this.state.AbhaPatientdata?.state}</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box display="flex" justifyContent="flex-end" mt={4}>
                        <Button
                            variant="outlined"
                            color="primary"
                            sx={{mr: 2}}
                            onClick={() => {
                                this.setState({
                                  isUpdateAbhaPopup: false,
                                  AbhaExistingData: null,
                                  AbhaPatientUHID: null,
                                  AbhaPatientdata: null,
                                  AbhaCompareQrID: null
                                })
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                this.postAbhaQrRegister(this.state.AbhaCompareQrID)
                            }}
                        >
                            Proceed
                        </Button>
                    </Box>
                </Box>
            </Box>
        );
    } catch (e) {
        console.error("Error rendering update ABHA popup:", e);
        return null;
    }
  }

  clearCacheData = (path) => {
    try{
      if (path !== "IPHome") {
        this.setState({ isLoader: true  })
      }
      clearCachevalue("patientData")
      clearCachevalue("IppatientData")
      clearCachevalue("withoutAppointment")
      clearCachevalue("OP_CreateAppointment_PatientId")
      clearCachevalue("OTpatientData")
      clearCachevalue("AppRequestPatientData");
      clearCachevalue('DoctorPatientData')
      clearCachevalue('updatePatient')
      clearCachevalue('filteredData')
      clearCachevalue('RadPatientData')
      clearCachevalue('Laboratory_id')
      clearCachevalue('IsFromIPBill')
      clearCachevalue('IsFromOPBill')
      clearCachevalue('SelectedDate')
      clearCachevalue('SelectedOPDate')
      clearCachevalue('reservePatientData')
      clearCachevalue('provisional_diagnosis')
      clearCachevalue('openAlertPopup')
      clearCachevalue('path_name')
      clearCachevalue('component')
      clearCachevalue('InRTDocApprovals')
      clearCachevalue('RtDosimetristPatientData')
      
      if (window.location.pathname === "/NoAccess") {
        clearCachevalue("isForCancelBill")
        clearCachevalue("IsForCheckedOut")
        clearCachevalue("IsPORequestEdit")
        clearCachevalue("isCanteenOverall")
        clearCachevalue("DisableAllActions")
        clearCachevalue("isInRadiologyBilling")
      }
      
      this.isPatientisSearching(false)
    }catch(error){
      this.errorMessage(error.message)
    }
  }

  closeAlertPopup = () => {
    try {
      let path = JSON.parse(getCachevalue('path_name'))?.menuName
      this.onClick(this.props.history.push(`/${path.replace(/\s/g, '')}`),)
      this.clearCacheData(path)
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  renderRedundRequestPopup = () => {
    try {
      return (
        <Menu
          elevation={1}
          anchorEl={this.state.ipTransAnchor}
          open={this.state.isIPTrans && (window.location.pathname === "/HospitalBilling/CashCounter" || window.location.pathname ==="/LabBilling/CashCounter" || window.location.pathname === `/${GetInvestigationName()}Billing/CashCounter` || window.location.pathname === "/PharmacyBilling/CashCounter")}
          sx={{ mt: '3vw' }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        >
          <Box component={'div'} width={'67vw'} maxHeight={'28vw'} overflow={'auto'} p={'0vw 0.5vw'}>
            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
              <Typography fontWeight={600}>Refund Request</Typography>
              <Button className='Common_Btn_Min_Width'
                onClick={() => this.setState({
                  isIPTrans: false,
                  ipTransAnchor: null,
                  labTransDatePickerOpen: false,
                  labIpTransDate: new Date()
                })}
              >
                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
              </Button>
            </Box>
            {/* <Box component={'div'} m={'0.5vw 0.5vw'} display={'flex'}>
              <TextField
                autoComplete='off'
                size='small'
                sx={{ width: '11vw', mr: '1vw' }}
                value={this.state.searchLabIpTrans}
                onChange={(e) => this.setState({ searchLabIpTrans: e.target.value }, () => this.searchLabIpReqList(true))}
                label={'Search Patient Name'}
                onKeyDown={(e) => { e.stopPropagation() }}
              />
            </Box> */}
            <Box component={'div'}>
              {this.state.ipTraLoad ?
                <Box component={'div'} pb={'0.5vw'} borderBottom={'1.5px solid lightgray'} mb={'0.5vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                  <CircularProgress size='small' color='primary' />
                </Box> :
                <Box sx={{ width: "65dvw" }}>
                  <TableContainer sx={{ margin: "auto", mt: '1dvh' }}>
                    <Table size='small'>
                      <TableHead>
                        <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                          <TableCell>Patient Details</TableCell>
                          <TableCell>OP/IP Number</TableCell>
                          <TableCell>Bill Details</TableCell>
                          <TableCell>Amount</TableCell>
                          <TableCell>Type</TableCell>
                          <TableCell>Cancel Remarks</TableCell>
                          <TableCell>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.CashCounterRefundRequestList.map((patient) => (
                          <TableRow key={patient.id}>
                            <TableCell><CommonPatientDetails data={patient} /></TableCell>
                            <TableCell>{patient?.walk_in_number ? patient?.walk_in_number : patient.op_number ? patient.op_number : patient.ip_numbers ? patient.ip_numbers : patient?.self_patient}</TableCell>
                            <TableCell>
                              <Typography variant="body2">{patient.invoice_number}</Typography>{patient.invoice_date && <Typography variant="caption">{formatDateAndTimeMeth2(patient.invoice_date)}</Typography>}</TableCell>
                            <TableCell>{AmountFormat(patient.net_amount)}</TableCell>
                            <TableCell>{patient.request_type || "-"}</TableCell>
                            <TableCell>{patient.cancel_reason ? patient.cancel_reason?.length > 18 ?
                              <Tooltip placement='top' title={patient.cancel_reason} arrow>
                                <div>{patient.cancel_reason.slice(0, 18) + "..."}</div></Tooltip> :
                              patient.cancel_reason : "-"}</TableCell>
                            <TableCell>
                              <Tooltip title={"Process Refund"} arrow placement="top">
                                <IconButton color="primary" onClick={() => {
                                  this.setState({
                                    isIPTrans: false
                                  }, () => {
                                    if (patient?.bill_module === "RT") {
                                      this.props.history.push({ pathname: "/HospitalBilling/CashCounter", states: { patient_details: { ...patient, patient_account_number: patient?.uhid }, from_refund_request: true, refund_details: patient, fromRTRefund: true } })
                                    } else {
                                      this.props.history.push({
                                        pathname: (this.state.loggedInuserInfo?.module_name === 'front_office' ? "/HospitalBilling/CashCounter" : this.state.loggedInuserInfo?.module_name === 'Laboratory' ? '/LabBilling/CashCounter' :
                                          this.state.loggedInuserInfo?.module_name === 'Pharmacy' ? '/PharmacyBilling/CashCounter' : `/${GetInvestigationName()}Billing/CashCounter`), states: { patient_details: { ...patient, patient_account_number: patient?.uhid }, from_refund_request: true, refund_details: patient }
                                      })
                                    }

                                  })
                                }}>
                                  <ReceiptIcon />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              }
            </Box>
          </Box>
        </Menu>
      )  
      } catch (error) {
        this.errorMessage(error.message)
      }
  }

  renderPharmaCashCounterBillsPopup = () => {
    try {
      const { t } = this.props;
      const list = this.state.pharmaCashCounterBillsList || [];
      return (
        <Menu
          elevation={1}
          anchorEl={this.state.pharmaCashCounterBillsAnchor}
          open={this.state.pharmaCashCounterBillsOpen && window.location.pathname === '/PharmacyBilling/CashCounter'}
          onClose={() => this.setState({ pharmaCashCounterBillsOpen: false, pharmaCashCounterBillsAnchor: null, pharmaCashCounterBillsList: [], dupPharmaCashCounterBillsList: '[]', pharmaCashCounterBillsDate: new Date(), searchPharmaCashCounterBills: '' })}
          sx={{ mt: '3vw' }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Box component={'div'} width={'33vw'} maxHeight={'70dvh'} overflow={'auto'} p={'0.5vw'}>
            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} mb={'0.5vw'}>
              <Typography fontWeight={600}>{t('Cash Counter Patient List')}</Typography>
              <IconButton size="small" onClick={() => this.setState({ pharmaCashCounterBillsOpen: false, pharmaCashCounterBillsAnchor: null, pharmaCashCounterBillsList: [], dupPharmaCashCounterBillsList: '[]', pharmaCashCounterBillsDate: new Date(), searchPharmaCashCounterBills: '' })}>
                <img src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} alt="close" />
              </IconButton>
            </Box>
            <Box component={'div'} mt={'0.5vw'} display={'flex'} alignItems={'center'} gap={'1vw'} flexWrap="wrap">
              <TextField
                size="small"
                value={this.state.searchPharmaCashCounterBills}
                onChange={(e) => {
                  const search = e.target.value;
                  this.setState({ searchPharmaCashCounterBills: search }, () => {
                    try {
                      const dup = this.state.dupPharmaCashCounterBillsList ? JSON.parse(this.state.dupPharmaCashCounterBillsList) : [];
                      const filtered = search === '' ? dup : dup.filter((item) => {
                        const name = (item?.patient_name || item?.patient_names || (item?.first_name || '') + ' ' + (item?.last_name || '') || '').toLowerCase();
                        const uhid = (item?.patient_account_number || item?.uhid || item?.patient_uhid || '').toLowerCase();
                        const mobile = (item?.patient_mobile_number || item?.mobile_number || '').toLowerCase();
                        const s = search.toLowerCase();
                        return name.includes(s) || uhid.includes(s) || mobile.includes(s);
                      });
                      this.setState({ pharmaCashCounterBillsList: filtered });
                    } catch (err) { }
                  });
                }}
                onKeyDown={(e) => e.stopPropagation()}
                sx={{ width: '18vw', minWidth: '120px' }}
                placeholder={t('Search Patient...')}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={this.state.pharmaCashCounterBillsDatePickerOpen}
                  onOpen={() => this.setState({ pharmaCashCounterBillsDatePickerOpen: true })}
                  onClose={() => this.setState({ pharmaCashCounterBillsDatePickerOpen: false })}
                  value={this.state.pharmaCashCounterBillsDate}
                  inputFormat="DD-MM-YYYY"
                  views={['year', 'month', 'day']}
                  onChange={(newDate) => {
                    this.setState({ pharmaCashCounterBillsDate: newDate || new Date() }, () => this.getPharmaCashCounterBillsList());
                  }}
                  renderInput={(params) => (
                    <TextField
                      onKeyDown={(e) => e.preventDefault()}
                      size="small"
                      sx={{ width: '12vw', minWidth: '110px' }}
                      {...params}
                      onClick={() => this.setState({ pharmaCashCounterBillsDatePickerOpen: true })}
                    />
                  )}
                />
              </LocalizationProvider>
            </Box>
            <TableContainer sx={{ maxHeight: '50dvh', mt: '0.5vw' }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                    <TableCell sx={{ fontWeight: 600 }}>{t('Patient Details')}</TableCell>
                    <TableCell sx={{ fontWeight: 600, marginLeft: '0.75vw' }} align="center">{t('Action')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {list.length > 0 ? list.map((item, index) => (
                    <TableRow key={item?.id || index}>
                      <TableCell>
                        <Box component={'div'} display={'flex'} alignItems={'center'}>
                          <Box component={'img'}
                            src={item?.patient_photo_url || item?.photo_url || (item?.patient_gender === 'Female' || item?.patient_gender === 'f' ? ImagePaths.Female?.default : ImagePaths.Male?.default)}
                            height={'2.5vw'} width={'2.5vw'}
                            borderRadius={'50px'}
                            sx={{ objectFit: 'cover', border: '1.8px solid #ddd', mr: 1 }}
                          />
                          <Box>
                            <Typography fontWeight={600} fontSize={'0.85vw'}>
                              {item?.patient_name || item?.patient_names || (item?.first_name || '') + ' ' + (item?.last_name || '') || '-'}
                            </Typography>
                            <Typography color={Colors.grayShade} fontSize={'0.75vw'}>
                              {item?.patient_account_number || item?.uhid || item?.patient_uhid || '-'} | {item?.patient_mobile_number || item?.mobile_number || '-'}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell align="right">
                        <Box component={'div'} display={'flex'} gap={'0.5vw'} justifyContent="flex-end">
                          {/* <Button size="small" variant="outlined" color="error" sx={{ textTransform: 'capitalize' }}
                            onClick={() => this.setState({ returnAllBillsPopup: true, returnAllBillsPatient: item })}
                          >
                            {t('Return')}
                          </Button> */}
                          <Button size="small" variant="contained" color="primary" sx={{ textTransform: 'capitalize' }}
                            onClick={() => {
                              this.setState({ pharmaCashCounterBillsOpen: false, pharmaCashCounterBillsAnchor: null, pharmaCashCounterBillsList: [], dupPharmaCashCounterBillsList: '[]', pharmaCashCounterBillsDate: new Date(), searchPharmaCashCounterBills: '' }, () => {
                                this.props.history?.push({
                                  pathname: '/PharmacyBilling/CashCounter',
                                  states: {
                                    patient_details: { ...item, patient_account_number: item?.patient_account_number || item?.uhid, is_self: item?.patient_id === null || item?.patient_id === undefined },
                                    from_pharma_bills_list: true,
                                    module: (item?.module)?.toLowerCase(),
                                    from_pharmacy: true,
                                    search_label: (item?.module)?.toLowerCase() === 'op' ? 'appointment_id' : 'ip_admission_id',
                                    search_value: item?.module_id
                                  }
                                });
                              });
                            }}
                          >
                            {t('Proceed')}
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )) : (
                    <TableRow>
                      <TableCell colSpan={2} align="center" sx={{ py: 3 }}>
                        <Typography color="textSecondary">{t('No records found')}</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Menu>
      );
    } catch (error) {
      this.errorMessage(error.message);
      return null;
    }
  }

  renderReturnAllBillsPopup = () => {
    const { t } = this.props;
    const patient = this.state.returnAllBillsPatient;
    return (
      <Dialog open={this.state.returnAllBillsPopup} onClose={() => this.setState({ returnAllBillsPopup: false, returnAllBillsPatient: null })}>
        <Box p={'1.5vw'} minWidth={'22vw'}>
          <Typography fontWeight={600} fontSize={'1vw'} mb={'1vw'}>{t('Confirm Return')}</Typography>
          <Typography fontSize={'0.95vw'} mb={'1.5vw'}>{t('Are you sure do you want to return all bills against this patient?')}</Typography>
          <Box display={'flex'} justifyContent={'flex-end'} gap={'0.75vw'}>
            <Button size='small' variant='outlined' onClick={() => this.setState({ returnAllBillsPopup: false, returnAllBillsPatient: null })}>
              {t('Close')}
            </Button>
            <Button size='small' variant='contained' onClick={() => {
              RestAPIService.create({
                patient_id: patient?.patient_id || null,
                patient_mobile_number: patient?.patient_mobile_number || patient?.mobile_number || '',
                patient_name: patient?.patient_name || patient?.patient_names || ((patient?.first_name || '') + ' ' + (patient?.last_name || '')).trim() || '',
              }, Serviceurls.PHARMA_CASH_COUNTER_RETURN_ALL_BILLS)
                .then((response) => {
                  if (response.data.status === 'success') {
                    this.setState({ returnAllBillsPopup: false, returnAllBillsPatient: null });
                    this.successMessage(response.data.message);
                    this.getPharmaCashCounterBillsList();
                  } else {
                    this.errorMessage(response.data.message);
                  }
                })
                .catch((error) => {
                  this.errorMessage(error?.response?.data?.message || error.message);
                });
            }}>
              {t('Yes')}
            </Button>
          </Box>
        </Box>
      </Dialog>
    );
  }

  render() {
    const { isOnline } = this.state;
    if (this.state.clinicId !== null) { localSetItem("clinicId", this.state.clinicId) }
    const { t } = this.props;
    const theme = this.props;
    const { history } = this.props;
    var { clinicData } = this.state
    const { role, subscriptionData, showLockPopup } = this.context || {};
    const rawMenuList = this.returnSideMenus();
    const menuList = filterMenuBySubscription(rawMenuList, subscriptionData, role);
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser
    let ModuleData = localGetItem("ModulesList") ? JSON.parse(localGetItem("ModulesList")) : []
    let DisableSwitchModule = (ModuleData?.length === 1 && ModuleData[0]?.data?.length === 1) ? true : false
    let noReturn = JSON.parse(localGetItem("pharmacy_rtn_period"))
    let showNewBilling = JSON.parse(localGetItem('isNewBilling'))

    if (!this.context) {
      return <div>Loading permissions...</div>;
    }
    
    if (localGetItem("isLoggedIn")) {
      return (
        <div>
          <Box className='eMed_muiDrawer' >
            <CssBaseline />
            <AppBar sx={{ minHeight: '4.1vw' }} position="fixed" open={this.state.drawer_Open}>

              <Toolbar>
              {(UserData?.module_name === "Laboratory") && this.state.selectedPageName === "MainHome" && (this.state.selectedSubScreen === "Status" || this.state.selectedSubScreen === "LabHome") && (!window.location.href.includes("/Results")) && (!window.location.href.includes("/LabBilling/NewQuickBilling")) && !(window.location.href.includes("/Dashboard")) ?
                  showNewBilling ?
                  (this.state.selectedSubScreen !== "LabHome" ? 
                    <div className={this.state.labType === "Inhouse Laboratory" ? "" : ""}>
                      {this.LabHeaderSearch()}
                    </div> : null) :
                    (this.state.selectedSubScreen !== "Status" ? 
                    <div className={this.state.labType === "Inhouse Laboratory" ? "" : ""}>
                      {this.LabHeaderSearch()}
                    </div> : null ) : null
                    }
                {this.renderLabHistoryPopup()}
                {((UserData?.module_name === "front_office" || UserData?.module_name === "nurse") && ((window.location.pathname === "/OPHome") || (window.location.pathname === "/IPHome"))) ? this.FOheaderSearch() : null}
                {(this.props?.history?.location?.state?.IP_patientData || this.props.history?.location?.state?.patientData) || showNewBilling ? null :
                  (UserData?.module_name === "front_office" && getCachevalue("isForCancelBill") !== "true" && ((window.location.pathname === "/Billing") || (window.location.pathname === "/Billing/LabBilling"))) ? this.LabHeaderSearch(true) : null}
                {(UserData?.module_name === "front_office" && getCachevalue("isForCancelBill") !== "true" && window.location.pathname === `/Billing/${GetInvestigationName()}Billing` && !getCachevalue('isInRadiologyBilling')) ? this.LabHeaderSearch(true, true) : null}
                {(UserData?.module_name === "Pharmacy" && ((window.location.pathname === "/PharmacyBilling"))) ? this.PharmaheaderSearch() : null}
                {((UserData?.module_name === 'Doctor' || UserData?.module_name === 'Optometry' || getCachevalue("DoctorToCounsellor") === "true" || UserData?.clinic_staff) && ((window.location.pathname === "/DoctorHome"))) || (UserData?.clinic_staff && window.location.pathname === "/IPDoctorHome") ? this.DoctorHeaderSearch() : null}
                {((UserData?.module_name === 'Radiology' || UserData?.module_name === 'Investigation') && ((window.location.pathname === `/${GetInvestigationName()}Home`))) ? this.RadiologyHeaderSearch() : null}
                {((getCachevalue("DoctorUserChanged") === "true") && ((window.location.pathname === "/Counsellor"))) ? this.RenderMultiDoctorList() : null}

                <div className='eMed_headContent'>
                </div>

                <div className='eMed_appbar_menu'>
                  {/* <AppBarMenus DialogClose={this.DialogClose}/> */}
                  {AppBarMenus.Menus.map((menu) => (
                    <div >
                      <Tooltip title={t(menu.menuName)} placement='top' arrow>
                        {/* <IconButton id="eMed_menu_icons" onClick={() => this.setState({ menuComp: true })} sx={{ color: Colors.ContrastText }} > */}

                        <Avatar id='eMed_IconAvatar' sx={{ bgcolor: Colors.IconCircleBgColor, boxShadow: 3 }} onClick={() => this.setState({ menuComp: true })}>
                          {menu.icon}
                        </Avatar>
                        {/* </IconButton> */}
                      </Tooltip>
                      {this.state.menuComp ? <Settings DialogClose={this.ModuleDialogClose} Success={this.ModuleSuccess} /> : null}
                    </div>
                  ))}
                </div>
                <div className='savedBillFieldHeader'>
                  {((this.state.selectedPageName === "MainHome") && !(window.location.pathname === "/Dashboard") && !(window.location.pathname === "/Results") && (this.state.selectedSubScreen === "LabHome") && (this.state.loginType === 'Laboratory' || this.state.loginType === GetInvestigationName())) || (window.location.pathname === "/CanteenHome" && !getCachevalue("isCanteenOverall")) || ((this.state.selectedPageName === "MainHome" && this.state.selectedSubScreen === "Order") || (window.location.pathname === `/${GetInvestigationName()}Order` || window.location.pathname === `/${GetInvestigationName()}Order/Order`)) ?
                    <div>
                      <button emed_tid="IPAdmissionToBill_btn" className='fo_requests_icon' onClick={() => { this.setState({ Lab_IpPatientList: true }) }}>
                        <Badge badgeContent={this.state.badgeCount?.lab_inpatient_count ? this.state.badgeCount?.lab_inpatient_count : this.state.badgeCount?.rad_iplist_count} max={999} color="error">
                          <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Ip_list.default} alt='Request'></img>
                        </Badge>
                        <Typography fontSize={'0.7vw'}>{t('IP List')}</Typography>
                      </button>
                    </div> : null}

                  {((this.state.selectedPageName === "MainHome") && !(window.location.pathname === "/Dashboard") && !(window.location.pathname === "/Results") && (this.state.selectedSubScreen === "LabHome") && (this.state.loginType === 'Laboratory')) ?
                    <div>
                      <button emed_tid="IPAdmissionToBill_btn" className='fo_requests_icon' onClick={() => { this.setState({ is_labOpList_clked: true }) }}>
                        <Badge badgeContent={this.state.badgeCount?.lab_appointment_count} color="error" max={999}>
                          <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyApp.default} alt='Request'></img>
                        </Badge>
                        <Typography fontSize={'0.7vw'}>{t('Appointments')}</Typography>
                      </button>
                    </div> : null}

                  {
                    this.state.labType === "Inhouse Laboratory" && this.state.selectedSubScreen === "LabHome" && !(window.location.pathname === "/Dashboard") && !(window.location.pathname === "/Results") ?
                      this.state.selectedPageName === "MainHome" ?
                        <div>
                          <button emed_tid="IPAdmissionToBill_btn" className='fo_requests_icon' onClick={() => { this.setState({ isTranmitedBill: true }) }}>
                            <Badge badgeContent={this.state.badgeCount?.lab_test_transmit_count} color="error" max={999}>
                              <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyIPReturn.default} alt='transmit'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'}>{t('Transmit')}</Typography>
                          </button>
                        </div>
                        : null
                      : null}
                  {/* Lab IP Request Starts ==> */}
                  {((this.state.selectedPageName === "MainHome" && this.state.selectedSubScreen === "LabHome") && !(window.location.pathname === "/Dashboard") && !(window.location.pathname === "/Results") && (this.state.loginType === 'Laboratory')) ?
                    <Tooltip title={'IP Request'} arrow>
                      <div>
                        <button emed_tid="IpToBill_btn" className='fo_requests_icon' onClick={(e) => { this.setState({ ipReqAnchor: e.currentTarget, isIPRequest: true }, () => this.getIpLabRequestListData()) }}>
                          <Badge badgeContent={this.state.badgeCount?.lab_ip_request_count} color="error" max={999}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.RequestsIcon.default} alt='Request'></img>
                          </Badge>
                          <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>{t('IP Request')}</Typography>
                        </button>
                      </div>
                    </Tooltip>
                    : null}
                  {this.renderLabIpRequestPopup()}
                  {/* Lab IP Request Ends ===> */}
                  {this.state.selectedPageName === "MainHome" && this.state.selectedSubScreen === "LabHome" && !(window.location.pathname === "/Dashboard") && !(window.location.pathname === "/Results") && (this.state.loginType === 'Laboratory') ?
                    <Tooltip title={'Saved Bills'} arrow>
                      <div>
                        <button emed_tid="SavedToBill_btn" className='fo_requests_icon' onClick={() => { this.setState({ isSavedBill: true }) }}>
                          <Badge badgeContent={this.state.badgeCount?.lab_bill_count} color="error" max={999}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacySaveBill.default} alt='Request'></img>
                          </Badge>
                          <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>{t('Saved Bills')}</Typography>
                        </button>
                      </div>
                    </Tooltip>
                    : null}
                  {(((this.state.selectedPageName === "MainHome" || (window.location.pathname === "/Results"))&& !(window.location.pathname === "/Dashboard") &&
                    !(window.location.pathname === "/LabBilling/NewQuickBilling") && (this.state.loginType === 'Laboratory')) || 
                    ((window.location.pathname === "/OPHome") && UserData?.module_name !== "nurse" && UserData?.service_type !== "OPTOMETRY") ||
                    ((window.location.pathname === "/IPHome" || window.location.pathname === `/${GetInvestigationName()}Home` || window.location.pathname === "/PharmacyBilling")
                      && showNewBilling && localGetItem('set_due_date_for_credit_billing') === "true")) ?
                    <Tooltip title={t('Notification')} arrow>
                    <div>
                      <button className='fo_requests_icon' emed_tid='op_home_notification_popUp'
                        onClick={() => {
                          (this.state.loginType === 'Laboratory' && !showNewBilling) ? this.getLabNotificationData() : this.getNotificationData();
                          this.setState({ notifyPopup: true })
                        }}
                      >
                        <Badge showZero={true} badgeContent={this.state.notifyCount} color="error">
                          <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Notification.default} alt='Notification'></img>
                        </Badge>
                        <Typography fontSize={'0.7vw'}>{t('Notification')}</Typography>
                      </button>
                    </div>
                  </Tooltip> : null}
                  {
                    (window.location.pathname === "/OPHome") && UserData?.module_name !== "nurse" && UserData?.service_type !== "OPTOMETRY" ?
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        {this.state.loggedInuserInfo?.is_qms_enabled ?
                          <Box display={'flex'}>
                            <Tooltip title={t('Doctor Queue')} arrow>
                              <div>
                                <button className='fo_requests_icon' emed_tid='op_home_drQueue_popUp'
                                  onClick={(e) => { this.setState({ DocQueuePopup: true }) }}
                                >
                                  <Badge showZero={true} badgeContent={this.state.drQueueData?.length} color="error">
                                    <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.DocCallOnIcon.default} alt='DrQueue'></img>
                                  </Badge>
                                  <Typography fontSize={'0.7vw'}>{t('Queue')}</Typography>
                                </button>
                              </div>
                            </Tooltip>
                          </Box>
                          : null}
                        <Tooltip title={t('AppReq')} arrow>
                          <div>
                            <button className='fo_requests_icon'
                              onClick={(e) => {
                                let POVList = localGetItem("PurposeOfVisit") ? localGetItem("PurposeOfVisit") : '[]'
                                let array = []
                                JSON.parse(POVList)?.forEach(element => array.push(element.reason));
                                this.setState({
                                  RequestPopUp: true,
                                  RequestAnchor: e.currentTarget,
                                  POVList: array
                                }, () => {
                                  this.getAppointRequests(true)
                                  // this.getDoctorsList(true)
                                })
                              }}
                            >
                              <Badge badgeContent={this.state.FoRequestList.length} color="error" max={999}>
                                <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.RequestsIcon.default} alt='Request'></img>
                              </Badge>
                              <Typography fontSize={'0.7vw'}>{t('Request')}</Typography>
                            </button>
                          </div>
                        </Tooltip>
                      </div> : null
                  }
                  {
                    // Uma = 204 , masonic = 173
                    (window.location.pathname === "/OPHome" && this.state.loggedInuserInfo?.show_qr_entry) ?
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <Tooltip title={t('QR Entry')} arrow>
                          <div>
                            <button emed_tid="qr_entry_list" className='fo_requests_icon'
                              onClick={(e) => {
                                this.setState({ QREntryPopUp: true, RequestAnchor: e.currentTarget }, () => {
                                  this.getQREntryList()
                                })
                              }}
                            >
                              <Badge badgeContent={this.state.QrEntryList.length} color="error" max={999}>
                                <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.QRIcon.default} alt='QR Entry'></img>
                              </Badge>
                              <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>{t('QR Entry')}</Typography>
                            </button>
                          </div>
                        </Tooltip>
                      </div> : null
                  }
                  {
                    // Uma = 204 , masonic = 173
                    ((window.location.pathname === "/ABDM/Register" || window.location.pathname === "/ABDM") && this.state.hasAbha) ?
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <Tooltip title={t('QR Entry')} arrow>
                          <div>
                            <button emed_tid="abha_qr_entry_list" className='fo_requests_icon'
                              onClick={(e) => {
                                this.setState({ AbhaQrPopUp: true, RequestAnchor: e.currentTarget }, () => {
                                  this.getAbhaQrList()
                                })
                              }}
                            >
                              <Badge badgeContent={this.state.AbhaQrList.length} color="error" max={999}>
                                <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.QRIcon.default} alt='QR Entry'></img>
                              </Badge>
                              <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>{t('QR Entry')}</Typography>
                            </button>
                          </div>
                        </Tooltip>
                      </div> : null
                  }
                  {window.location.pathname === "/OPHome" ?
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <Tooltip title={t('Follow-up')} arrow>
                        <div>
                          <button className='fo_requests_icon' onClick={() => { this.setState({ FollowupPopup: true, follow_up_date: new Date() }, () => { this.getFollowUpData() }) }}>
                            <Badge badgeContent={this.state.followUpData?.length} color="error" max={999}>
                              <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.TransAppoint.default} alt='Transfer'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} style={{ width: "3.5vw" }}>{t('Follow-up')}</Typography>
                          </button>
                        </div>
                      </Tooltip>
                    </div>
                    : null}
                  {window.location.pathname === "/IPHome" && <Tooltip title={t('OP Request')} arrow>
                    <div>
                      <button emed_tid="appointment_list_print_btn" className='fo_requests_icon' onClick={() => {
                        this.setState({ oPRequestPopUp: true })
                      }} disabled={this.state.oPRequestPopUp}>
                        <Badge badgeContent={this.state.badgeCount?.op_to_ip_list_count || 0} color="error" max={999}>
                          <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.opRequestIcon.default} alt='op Request' />
                        </Badge>
                        <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>{t('OP Request')}</Typography>
                      </button>
                    </div>
                  </Tooltip>}
                  {((window.location.pathname === "/IPHome") || window.location.pathname === "/IPDoctorHome") && UserData?.module_name !== "nurse" ?
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <Tooltip title={window.location.pathname === "/OPHome" ? t('AppPrint') : t('IPAppPrint')} arrow>
                        <div>
                          <button emed_tid="appointment_list_print_btn" className='fo_requests_icon' onClick={() => { 
                              this.printIPAppList(window.location.pathname === "/IPDoctorHome")
                          }} disabled={this.state.disableBtn}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Print.default} alt='Request'></img>
                            <Typography fontSize={'0.7vw'}>{t('Print')}</Typography>
                          </button>

                        </div>
                      </Tooltip>
                    </div> : null}
                  {((window.location.pathname === "/Counsellor")) && UserData?.module_name === "counsellor" ?
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <Tooltip title={window.location.pathname === "/Counsellor" ? t('AppPrint') : t('AppPrint')} arrow>
                        <div>
                          <button emed_tid="appointment_list_print_btn" className='fo_requests_icon' onClick={() => { this.CounsellerModulePrint() }} disabled={this.state.disableBtn}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Print.default} alt='Request'></img>
                            <Typography fontSize={'0.7vw'}>{t('Print')}</Typography>
                          </button>

                        </div>
                      </Tooltip>
                    </div> : null}
                  {(window.location.pathname === "/DoctorHome") && UserData?.module_name == "Doctor" && UserData?.service_type !== "OPTOMETRY" ?
                    <div style={{ display: 'flex', flexDirection: 'row', visibility:getCachevalue('DoctorUserChanged') === 'true' ? 'hidden' : 'visible' }}>
                      <Tooltip title={t('Follow-up')} arrow>
                        <div>
                          <button className='fo_requests_icon' onClick={() => { this.setState({ FollowupPopup: true, follow_up_date: new Date() }, () => { this.getFollowUpData() }) }}>
                            <Badge badgeContent={this.state.followUpData?.length} color="error" max={999}>
                              <img style={{ height: '1.7vw', width: '1.7vw' }} src={ImagePaths.TransAppoint.default} alt='Transfer'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} style={{ width: "3.5vw" }}>{t('Follow-up')}</Typography>
                          </button>
                        </div>
                      </Tooltip>
                    </div>
                    : null}
                  {(window.location.pathname === "/DoctorHome") && UserData?.module_name === "Doctor" && UserData?.service_type !== "OPTOMETRY" ? (
                    <div style={{ display: 'flex', flexDirection: 'row', visibility:getCachevalue('DoctorUserChanged') === 'true' ? 'hidden' : 'visible' }}>
                      <Tooltip title={t('Doctor Requests')} arrow>
                        <div>
                          <button
                            className='fo_requests_icon'
                            onClick={() => {
                              this.setState(
                                { DoctorRequestPopup: true }, 
                                () => { this.getDoctorRequestData() } 
                              )
                            }}
                          >
                            <Badge
                              badgeContent={this.state.doctorRequestData?.length}
                              color="error"
                              max={999}
                            >
                              <img
                                style={{ height: '1.7vw', width: '1.7vw', marginBottom: '0.3vw', marginRight:'0.6vw' }}
                                src={ImagePaths.RequestsIcon.default}
                                alt='DoctorRequest'
                              />
                            </Badge>
                            <Typography fontSize={'0.55vw'} style={{ width: "5vw" }}>
                              {t('Doctor Requests')}
                            </Typography>
                          </button>
                        </div>
                      </Tooltip>
                    </div>
                  ) : null}
                  {(window.location.pathname === "/DoctorHome") && UserData?.module_name == "Doctor" && UserData?.service_type !== "OPTOMETRY" ?
                    <div style={{ display: 'flex', flexDirection: 'row', visibility:getCachevalue('DoctorUserChanged') === 'true' ? 'hidden' : 'visible' }}>
                      <Tooltip title={t('Unlocked Notes')} arrow>
                        <div style={{ marginRight: "0.6vw" }}>
                          <button className='fo_requests_icon' onClick={() => { this.setState({ unlockNotespopup: true }) }}>
                            <Badge badgeContent={this.state.unlockDocDataCount} color="error" max={999}>
                              <img style={{ height: '1.7vw', width: '1.7vw' }} src={ImagePaths.LockBtn.default} alt='Transfer'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} style={{ width: "6vw" }}>{t('Unlocked Notes')}</Typography>
                          </button>
                        </div>
                      </Tooltip>
                    </div>
                    : null}
                  {(window.location.pathname === "/DoctorHome") && UserData?.module_name == "Doctor" && UserData?.service_type !== "OPTOMETRY" ?
                    <div style={{ display: 'flex', flexDirection: 'row', visibility:getCachevalue('DoctorUserChanged') === 'true' ? 'hidden' : 'visible' }}>
                      <Tooltip title={t('Transfer Request')} arrow>
                        <div style={{ marginRight: "0.5vw" }}>
                          <button className='fo_requests_icon' onClick={() => { this.setState({ TransAppoint: true }) }}>
                            <Badge badgeContent={this.state.transferReqData?.length} color="error" max={999}>
                              <img style={{ height: '1.7vw', width: '1.7vw' }} src={ImagePaths.TransAppoint.default} alt='Transfer'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} style={{ width: "6.5vw" }}>{t('Transfer Request')}</Typography>
                          </button>
                        </div>
                      </Tooltip>
                    </div>
                    : null}
                  {window.location.pathname === "/PharmacyBilling" && UserData?.module_name !== "nurse" ?
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <Tooltip title={'Indent Request'} arrow>
                        <div>
                          <button emed_tid="IpReturn_btn" className='fo_requests_icon' onClick={() => { this.props.history.push('/PharmacyStockTransfer') }}>
                            <Badge badgeContent={this.state.indent_Count?.total ? this.state.indent_Count?.total : 0} color="error" max={999}>
                              <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.indentApprove.default} alt='Request'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>{t('Indent Request')}</Typography>
                          </button>
                        </div>
                      </Tooltip>
                      {UserData?.pharmacy_type === 'Inhouse Pharmacy' ?
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <Tooltip title={'In Patients Returns'} arrow>
                            <div>
                              <button emed_tid="IpReturn_btn" className='fo_requests_icon' onClick={() => { if (noReturn?.rtn_type === 'No Return') { this.errorMessage("Return is Not Allowed") } else { this.setState({ ph_returns: true }) } }}>
                                <Badge badgeContent={this.state.badgeCount?.pharmacy_IP_return_count} color="error" max={999}>
                                  <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyIPReturn.default} alt='Request'></img>
                                </Badge>
                                <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>{t('IP Returns')}</Typography>
                              </button>
                            </div>
                          </Tooltip>
                          <Tooltip title={'In Patients Request'} arrow>
                            <div>
                              <button emed_tid="IpRequest_btn" className='fo_requests_icon' onClick={() => { this.setState({ ph_request: true }) }}>
                                <Badge badgeContent={this.state.badgeCount?.pha_ip_request_count} color="error" max={999}>
                                  <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyIPRequest.default} alt='Request'></img>
                                </Badge>
                                <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>{t('IP Request')}</Typography>
                              </button>
                            </div>
                          </Tooltip>
                          <Tooltip title={'IP Admission List'} arrow>
                            <div>
                              <button emed_tid="IPAdmissionToBill_btn" className='fo_requests_icon' onClick={() => { this.setState({ ph_IpPatientList: true }) }}>
                                <Badge badgeContent={this.state.badgeCount?.pha_inpatient_count} color="error" max={999}>
                                  <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Ip_list.default} alt='Request'></img>
                                </Badge>
                                <Typography fontSize={'0.7vw'}>{t('IP List')}</Typography>
                              </button>
                            </div>
                          </Tooltip>
                          <Tooltip title={'Appointments'} arrow>
                            <div>
                              <button emed_tid="AppointsToBill_btn" className='fo_requests_icon' onClick={() => { this.setState({ ph_Appointments: true }) }}>
                                <Badge badgeContent={this.state.badgeCount?.pharmacy_appointment_count} color="error" max={999}>
                                  <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyApp.default} alt='Request'></img>
                                </Badge>
                                <Typography fontSize={'0.7vw'}>{t('Appointments')}</Typography>
                              </button>
                            </div>
                          </Tooltip>
                        </div>
                        : null}

                      <Tooltip title={'Saved Bills'} arrow>
                        <div>
                          <button emed_tid="SavedToBill_btn" className='fo_requests_icon' onClick={() => { this.setState({ ph_SavedBill: true }) }}>
                            <Badge badgeContent={this.state.badgeCount?.pharmacy_bill_count} color="error" max={999}>
                              <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacySaveBill.default} alt='Request'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>{t('Saved Bills')}</Typography>
                          </button>
                        </div>
                      </Tooltip>
                      {UserData?.pharmacy_type === 'Inhouse Pharmacy' ?
                        <div>
                          <Tooltip title={'Prescription'} arrow>
                            <div>
                              <button emed_tid="PrescToBill_btn" className='fo_requests_icon' onClick={() => { this.setState({ ph_Prescrition: true }) }}>
                                <Badge badgeContent={this.state.badgeCount?.pha_prescription_count} color="error" max={999}>
                                  <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Pharmacypres.default} alt='Request'></img>
                                </Badge>
                                <Typography fontSize={'0.7vw'}>{t('Prescription')}</Typography>
                              </button>
                            </div>
                          </Tooltip>
                        </div> : null}

                    </div> : null}
                  {
                    window.location.pathname === "/SubLocationBilling" ?
                      <div style={{ marginRight: "1vw", display: 'flex', flexDirection: 'row' }}>
                        <Tooltip title={'Indent Request'} arrow>
                          <div>
                            <button emed_tid="IpReturn_btn" className='fo_requests_icon' onClick={() => { this.props.history.push('/SubLocationStockTransfer') }}>
                              <Badge badgeContent={this.state.indent_Count?.total ? this.state.indent_Count?.total : 0} color="error" max={999}>
                                <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.indentApprove.default} alt='Request'></img>
                              </Badge>
                              <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>{t('Indent Request')}</Typography>
                            </button>
                          </div>
                        </Tooltip>
                        <Tooltip title={'Saved Bills'} arrow>
                          <div>
                            <button emed_tid="SavedToBill_btn" className='fo_requests_icon' onClick={() => { this.setState({ ph_SavedBill: true }) }}>
                              <Badge badgeContent={this.state.badgeCount?.pharmacy_bill_count} color="error" max={999}>
                                <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacySaveBill.default} alt='Request'></img>
                              </Badge>
                              <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>{t('Saved Bills')}</Typography>
                            </button>
                          </div>
                        </Tooltip>
                      </div> : null
                  }
                  {/* Doctor Print and Appointment Request Starts ========> */}
                  {
                    (window.location.pathname === "/DoctorHome") && UserData?.module_name !== "nurse" && UserData?.service_type !== "OPTOMETRY" && !UserData?.clinic_staff ?
                      getCachevalue('DoctorUserChanged') === 'true' ? null :
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <Tooltip title={t('AppReq')} arrow>
                          <div>
                            <button className='fo_requests_icon'
                              onClick={(e) => {
                                let POVList = localGetItem("PurposeOfVisit") ? localGetItem("PurposeOfVisit") : '[]'
                                let array = []
                                JSON.parse(POVList)?.forEach(element => array.push(element.reason));
                                this.setState({
                                  openDoctorAppointment: true,
                                  doctorAppointmentAnchor: e.currentTarget,
                                  POVList: array
                                })
                              }}
                            >
                              <Badge badgeContent={this.state.doctorAppointmentData.length} color="error" max={999}>
                                <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.RequestsIcon.default} alt='Request'></img>
                              </Badge>
                              <Typography fontSize={'0.7vw'}>{t('Request')}</Typography>
                            </button>
                          </div>
                        </Tooltip>
                      </div> : null
                  }
                  {((window.location.pathname === "/DoctorHome")) && UserData?.module_name !== "nurse" && !UserData?.clinic_staff ?
                  getCachevalue('DoctorUserChanged') === 'true' ? null :
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <Tooltip title={'Print'} arrow>
                        <div>
                          <button className='fo_requests_icon' onClick={(e) => { this.setState({ openDoctorPrint: true, doctorAnchor: e.currentTarget }) }}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Print.default} alt='Request'></img>
                            <Typography fontSize={'0.7vw'}>{t('Print')}</Typography>
                          </button>
                        </div>
                      </Tooltip>
                    </div> : null}
                  {((window.location.pathname === "/DoctorHome/DoctorNotes")) && UserData?.module_name !== "nurse" && UserData?.service_type !== "OPTOMETRY" ?
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <Tooltip title={'Doctor Notes Print'} arrow>
                        <div>
                          <button className='fo_requests_icon' onClick={(e) => { this.setState({ openDoctorNotesPrint: true, openDoctorNotesPrintAnchor: e.currentTarget }) }}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Print.default} alt='Request'></img>
                            <Typography fontSize={'0.7vw'}>{t('Print')}</Typography>
                          </button>
                        </div>
                      </Tooltip>
                    </div> : null}

                    {(((window.location.pathname === "/IPHome/PatientDetails/ClinicalNotes") || (window.location.pathname === "/IPHome/PatientDetails/History") || (window.location.pathname === "/IPHome/PatientDetails/SurgeryNotes"))) ?
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <Tooltip title={'Print'} arrow>
                        <div>
                          <button className='fo_requests_icon' onClick={(e) => { this.setState({ openFODocNotesPrint: true, openFoNotesPrintAnchor: e.currentTarget }) }}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Print.default} alt='Request'></img>
                            <Typography fontSize={'0.7vw'}>{t('Print')}</Typography>
                          </button>
                        </div>
                      </Tooltip>
                    </div> : null}

                  {((window.location.pathname === "/DoctorHome/DocImmunization")) ?
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <Tooltip title={'Doctor Notes Print'} arrow>
                        <div>
                          <button className='fo_requests_icon' onClick={(e) => { this.printImmunizationData() }}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Print.default} alt='Request'></img>
                            <Typography fontSize={'0.7vw'}>{t('Print')}</Typography>
                          </button>
                        </div>
                      </Tooltip>
                    </div> : null}
                  {((window.location.pathname === "/DoctorHome/History/MedicalHistory")) && UserData?.module_name !== "nurse" ?
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <Tooltip title={'History Print'} arrow>
                        <div>
                          <button className='fo_requests_icon' onClick={(e) => { this.printDoctorHistoryData() }}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Print.default} alt='Request'></img>
                            <Typography fontSize={'0.7vw'}>{t('Print')}</Typography>
                          </button>
                        </div>
                      </Tooltip>
                    </div> : null}
                  {(window.location.pathname === "/OTHome") && UserData?.module_name === "ot_management" ?
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <Tooltip title={'Indent Request'} arrow>
                        <div>
                          <button emed_tid="IpReturn_btn" className='fo_requests_icon' onClick={() => { this.props.history.push('/OTStockTransfer') }}>
                            <Badge badgeContent={this.state.indent_Count?.total ? this.state.indent_Count?.total : 0} color="error" max={999}>
                              <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.indentApprove.default} alt='Request'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>{t('Indent Request')}</Typography>
                          </button>
                        </div>
                      </Tooltip>
                      <Tooltip title={t('IP Requests')} arrow>
                        <div>
                          <button emed_tid={"ot_ip_request_btn"} className='fo_requests_icon' onClick={() => { this.setState({ OT_IP_Request: true }) }}>
                            <Badge badgeContent={this.state.badgeCount?.ot_ip_request} color="error" max={999}>
                              <img style={{ height: '1.7vw', width: '1.7vw' }} src={ImagePaths.RequestsIcon.default} alt='Transfer'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} style={{ width: "3.8vw" }}>{t('IP Requests')}</Typography>
                          </button>
                        </div>
                      </Tooltip>
                      <Tooltip title={t('Requests')} arrow>
                        <div>
                          <button className='fo_requests_icon' onClick={() => { this.setState({ OTrequestPopup: true }) }}>
                            <Badge badgeContent={this.state.OTreqData?.length} color="error" max={999}>
                              <img style={{ height: '1.7vw', width: '1.7vw' }} src={ImagePaths.RequestsIcon.default} alt='Transfer'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} style={{ width: "3.5vw" }}>{t('Requests')}</Typography>
                          </button>
                        </div>
                      </Tooltip>
                    </div>
                    : null}
                  {((window.location.pathname === "/OTHome") || (window.location.pathname === "/IPHome/OThome")) ?
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <Tooltip title={'Print'} arrow>
                        <div>
                          <button className='fo_requests_icon' disabled={this.state.printOTApp} onClick={(e) => { this.getOTAppointmentListPrint() }}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Print.default} alt='Request'></img>
                            <Typography fontSize={'0.7vw'}>{t('Print')}</Typography>
                          </button>
                        </div>
                      </Tooltip>
                    </div> : null}
                </div>
                {/* Print Menu */}
                <Menu
                  anchorEl={this.state.doctorAnchor}
                  sx={{ position: 'absoulte', top: '2.5vw', left: '0.7vw' }}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'bottom',
                  }}
                  transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'bottom',
                  }}
                  open={this.state.openDoctorPrint}
                  onClose={() => {
                    this.setState({ openDoctorPrint: false })
                  }}
                >
                  <Box component={'div'} p={'1vw'}>
                    <FormGroup>
                      <FormControlLabel control={<Checkbox checked={this.state.all} onChange={(e) => { this.handleCheckBox(e, "all") }} />} label="All" />
                      <FormControlLabel control={<Checkbox checked={this.state.booked} onChange={(e) => { this.handleCheckBox(e, "booked") }} />} label="Booked" />
                      <FormControlLabel control={<Checkbox checked={this.state.arrived} onChange={(e) => { this.handleCheckBox(e, "arrived") }} />} label="Arrived" />
                      <FormControlLabel control={<Checkbox checked={this.state.withNurse} onChange={(e) => { this.handleCheckBox(e, "withNurse") }} />} label="With Nurse" />
                      <FormControlLabel control={<Checkbox checked={this.state.withDoctor} onChange={(e) => { this.handleCheckBox(e, "withDoctor") }} />} label="With Doctor" />
                      <FormControlLabel control={<Checkbox checked={this.state.completed} onChange={(e) => { this.handleCheckBox(e, "completed") }} />} label="Completed" />
                      <FormControlLabel control={<Checkbox checked={this.state.cancelled} onChange={(e) => { this.handleCheckBox(e, "cancelled") }} />} label="Cancelled" />
                    </FormGroup>
                    <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                      <Button
                        sx={{ height: '2vw', width: '5vw', mr: '1vw', textTransform: 'capitalize' }}
                        variant='contained'
                        onClick={() => {
                          if (((window.location.pathname === "/DoctorHome") && (UserData?.service_type === "OPTOMETRY"))) {
                            this.optometryPrintAppList()
                          } else {
                            this.postDoctorPrint()
                          }
                        }
                        }
                      >
                        Print
                      </Button>
                      <Button
                        variant='outlined'
                        sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
                        onClick={() => this.setState({ doctorAnchor: null, openDoctorPrint: false })}
                      >
                        cancel
                      </Button>
                    </Box>
                  </Box>
                </Menu>
                {this.doctorAppointmentRequest()}
                <Menu
                  anchorEl={this.state.openDoctorNotesPrintAnchor}
                  sx={{ position: 'absolute', top: '2.5vw', left: '0.7vw' }}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'bottom',
                  }}
                  transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'bottom',
                  }}
                  open={this.state.openDoctorNotesPrint}
                  onClose={() => {
                    this.setState({ openDoctorNotesPrint: false })
                  }}
                >
                  <Box component={'div'} p={'1vw'} maxHeight={'30vw'} overflow={'auto'} maxWidth={'20vw'}>
                    {this.state.isOPT ?
                      this.state.doctorPrintList?.opt_doctor?.map((item, index) => {
                        return (
                          <FormGroup>
                            <FormControlLabel key={index} control={<Checkbox checked={item?.is_checked} onChange={(e) => { this.handleNewCheckBoxHandler(e, index) }} />} label={item?.label} />
                          </FormGroup>
                        )
                      }) : this.state.doctorPrintList?.other_doctor?.map((item, index) => {
                        return (
                          <FormGroup>
                            <FormControlLabel key={index} control={<Checkbox checked={item?.is_checked} onChange={(e) => { this.handleNewCheckBoxHandler(e, index) }} />}
                              label={<span style={{
                                wordBreak: "break-all",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                                display: "block",
                                maxWidth: "100%",
                              }}>
                                {item?.label}
                              </span>} />
                          </FormGroup>
                        )
                      })
                    }
                  </Box>

                  <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    <Button
                      sx={{ height: '2vw', width: '5vw', mr: '1vw', textTransform: 'capitalize' }}
                      variant='contained'
                      onClick={() => this.getDoctorNotesPrint()}
                    >
                      Print
                    </Button>
                    <Button
                      sx={{ height: '2vw', width: '5vw', mr: '1vw', textTransform: 'capitalize' }}
                      variant='contained'
                      onClick={() => this.onClickDoctorNotesDefault()}
                    >
                      Default
                    </Button>
                    <Button
                      variant='outlined'
                      sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
                      onClick={() => this.setState({ openDoctorNotesPrintAnchor: null, openDoctorNotesPrint: false, doctorPrintList: JSON.parse(this.state.dupDocPrintList) })}
                    >
                      cancel
                    </Button>
                  </Box>
                </Menu>
                {/* Doctor Print and Appointment Menu Ends */}

                {/* Fo Doctor notes Print Starts */}
                <Menu
                  anchorEl={this.state.openFoNotesPrintAnchor}
                  sx={{ position: 'absolute', top: '2.5vw', left: '-5vw' }}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'bottom',
                  }}
                  transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'bottom',
                  }}
                  open={this.state.openFODocNotesPrint}
                  onClose={() => {
                    this.setState({ openFODocNotesPrint: false })
                  }}
                >
                  <Box component={'div'} p={'1vw'} maxHeight={'30vw'} overflow={'auto'}>
                    {  this.state.doctorFOPrintList?.map((item, index) => {
                        return (
                          <FormGroup>
                            <FormControlLabel key={index} control={<Checkbox checked={item?.is_checked}
                             onChange={(e) => { this.handleFOCheckBoxHandler(e, index) }} 
                             />}
                              label={item?.label} />
                          </FormGroup>
                        )
                      })
                    }
                  </Box>

                  <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    <Button
                      sx={{ height: '2vw', width: '5vw', mr: '1vw', textTransform: 'capitalize' }}
                      variant='contained'
                      onClick={() => this.getFODoctorNotesPrint()}
                    >
                      Print
                    </Button>
                    {/* <Button
                      sx={{ height: '2vw', width: '5vw', mr: '1vw', textTransform: 'capitalize' }}
                      variant='contained'
                      onClick={() => this.onClickDoctorNotesDefault(true)}
                    >
                      Default
                    </Button> */}
                    <Button
                      variant='outlined'
                      sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
                      onClick={() => this.setState({ openFoNotesPrintAnchor: null, openFODocNotesPrint: false, doctorFOPrintList: FO_DOC_PRINT_DEFAULT ? JSON.parse(JSON.stringify(FO_DOC_PRINT_DEFAULT)) : [] })}
                    >
                      cancel
                    </Button>
                  </Box>
                </Menu>
                {/* Fo DocNotes print end */}


                {/* Radiology Appointment Starts ====> */}
                {((window.location.pathname === `/${GetInvestigationName()}Home`)) && UserData?.module_name !== "nurse" ?
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {showNewBilling ? null :
                      <>
                        <div>
                          <button emed_tid="saveToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ rad_saved_bill: true, radSavedBillAnchcor: e.currentTarget }) }}>
                            <Badge badgeContent={this.state.radSavedBillListData?.length} color="error" max={999}>
                              <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacySaveBill.default} alt='Appointment'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>Saved Bill</Typography>
                          </button>
                          {this.radSavedBillList()}
                        </div>
                        <div>
                          <button emed_tid="IpRequest_btn" className='fo_requests_icon' onClick={(e) => { this.setState({ rad_request: true, radReqAnchorEl: e.currentTarget }) }}>
                            <Badge badgeContent={this.state.radIpList?.length} color="error" max={999}>
                              <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Ip_list.default} alt='Request'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>Ip List</Typography>
                          </button>
                          {this.renderRadIpAppointmentList()}
                        </div>
                        <div>
                          <button emed_tid="AppointsToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ rad_appointment: true, radAppAnchorEL: e.currentTarget }) }}>
                            <Badge badgeContent={this.state.radAppointmentList?.length} color="error" max={999}>
                              <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.RequestsIcon.default} alt='Appointment'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>Appointments</Typography>
                          </button>
                          {this.renderRadAppointments()}
                        </div>
                      </>
                    }

                    {/* <div>
                      <button className='fo_requests_icon' onClick={(e) => { this.printRadiologyAppointment() }}>
                        <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Print.default} alt='Request'></img>
                        <Typography fontSize={'0.7vw'}>{t('Print')}</Typography>
                      </button>
                    </div> */}
                  </div> : null}

                {/* Radiology Appointment Ends ====> */}
                {/* FO Lab Billing Icons Starts ===>  */}
                {(this.props?.history?.location?.state?.IP_patientData || this.props.history?.location?.state?.patientData) ? null :
                  (window.location.pathname === '/HospitalBilling' || window.location.pathname === '/HospitalBilling/HospitalBilling') ||
                    (window.location.pathname === '/Billing' || window.location.pathname === '/Billing/LabBilling') ||
                    (window.location.pathname === '/DoctorBilling' || window.location.pathname === '/DoctorBilling/DoctorBilling') ?
                    showNewBilling ?
                      <Box component={'div'} display={'flex'}>
                        <div hidden={(getCachevalue('FromOtherScreen') === 'true') ? true : false}>
                          <button emed_tid="IpReqToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ isOpList: true, isOpListAnchor: e.currentTarget }, () => {this.getRadAppointmentListData()}) }}>
                            <Badge badgeContent={this.state.badgeCount?.op_list_count} color="error" max={999}>
                              <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.RequestsIcon.default} alt='Req'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>OP List</Typography>
                          </button>
                          {this.renderOpListPopup()}
                        </div>
                        <div hidden={getCachevalue('FromOtherScreen') === 'true' ? true : false}>
                          <button emed_tid="IpReqToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ isOpDraft: true, isOpDraftAnchor: e.currentTarget }, () => this.getDraftBillData()) }}>
                            <Badge badgeContent={this.state.badgeCount?.op_draft_list_count} color="error" max={999}>
                              <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyIPReturn.default} alt='Req'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>Draft</Typography>
                          </button>
                          {this.renderOPDraftPopup()}
                        </div>
                        <div hidden={getCachevalue('FromOtherScreen') === 'true' ? true : false}>
                          <button emed_tid="IpReqToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ isOpOrder: true, isOpOrderAnchor: e.currentTarget }, () => this.getOpOrderListData()) }}>
                            <Badge badgeContent={this.state.badgeCount?.op_order_list_count} color="error" max={999}>
                              <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyIPReturn.default} alt='Req'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>Order List</Typography>
                          </button>
                          {this.renderOpOrderPopup()}
                        </div>
                      </Box> :
                      <Box component={'div'} display={'flex'}>
                        <div>
                          <button emed_tid="IpReqToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ isIPRequest: true, ipReqAnchor: e.currentTarget }, () => this.getIpLabRequestListData()) }}>
                            <Badge badgeContent={this.state.badgeCount?.lab_ip_request_count} color="error" max={999}>
                              <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.RequestsIcon.default} alt='Req'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>Ip Request</Typography>
                          </button>
                          {this.renderLabIpRequestPopup()}
                        </div>
                        <div>
                          <button emed_tid="IpReqToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ isIPTrans: true, ipTransAnchor: e.currentTarget }, () => this.getFOLabTransmitListData()) }}>
                            <Badge badgeContent={this.state.badgeCount?.lab_test_transmit_count} color="error" max={999}>
                              <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyIPReturn.default} alt='Req'></img>
                            </Badge>
                            <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>Transmit</Typography>
                          </button>
                          {this.renderFOTransmitPopup()}
                        </div>
                      </Box>
                    : null}
                {/* FO Lab Billing Icons Ends ===>  */}
                {/* radiology and fo radiology bill transmit  */}
                {((window.location.pathname === `/${GetInvestigationName()}Home` || window.location.pathname === `/Billing/${GetInvestigationName()}Billing`) && UserData?.module_name !== "nurse" && !getCachevalue("isInRadiologyBilling")) || (window.location.pathname === `/${GetInvestigationName()}Billing` && !getCachevalue("isInRadiologyBilling") || window.location.pathname === `/${GetInvestigationName()}Billing/HospitalBilling`) ?
                  showNewBilling ?
                    <>
                      <div hidden={getCachevalue('FromOtherScreen') === 'true' ? true : false}>
                        <button emed_tid="IpReqToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ isOpList: true, isOpListAnchor: e.currentTarget }) }}>
                          <Badge badgeContent={this.state.badgeCount?.op_list_count} color="error" max={999}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.RequestsIcon.default} alt='Req'></img>
                          </Badge>
                          <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>OP List</Typography>
                        </button>
                        {this.renderOpListPopup()}
                      </div>
                      <div hidden={getCachevalue('FromOtherScreen') === 'true' ? true : false}>
                        <button emed_tid="IpReqToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ isOpDraft: true, isOpDraftAnchor: e.currentTarget }, () => this.getDraftBillData()) }}>
                          <Badge badgeContent={this.state.badgeCount?.op_draft_list_count} color="error" max={999}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyIPReturn.default} alt='Req'></img>
                          </Badge>
                          <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>Draft</Typography>
                        </button>
                        {this.renderOPDraftPopup()}
                      </div>
                      {/* <div hidden={getCachevalue('FromOtherScreen') === 'true' ? true : false}>
                        <button emed_tid="IpReqToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ isOpOrder: true, isOpOrderAnchor: e.currentTarget }, () => this.getOpOrderListData()) }}>
                          <Badge badgeContent={this.state.badgeCount?.op_order_list_count} color="error" max={999}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyIPReturn.default} alt='Req'></img>
                          </Badge>
                          <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>Order List</Typography>
                        </button>
                        {this.renderOpOrderPopup()}
                      </div> */}
                    </>
                     :
                    <div>
                      <button emed_tid="IPAdmissionToBill_btn" className='fo_requests_icon' onClick={(e) => { this.setState({ rad_transmit: true, radTransAnchorEL: e.currentTarget }) }}>
                        <Badge badgeContent={this.state.radTransmitList?.length || 0} color="error">
                          <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyIPReturn.default} alt='transmit'></img>
                        </Badge>
                        <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>{t('Transmit')}</Typography>
                      </button>
                      {this.renderRadTransmit(window.location.pathname === `/Billing/${GetInvestigationName()}Billing`)}
                    </div>
                  : null}
                
                {(window.location.pathname === '/PharmacyBilling/CashCounter' && JSON.parse(localGetItem('enable_cash_counter_bill_modification') || 'false') && localGetItem('from_cash_counter_edit') !== 'true') ?
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Tooltip title={t('Bills')} arrow>
                      <div>
                        <button emed_tid="PharmaCashCounterBills_btn" className='fo_requests_icon' onClick={(e) => {
                          this.setState({ pharmaCashCounterBillsOpen: true, pharmaCashCounterBillsAnchor: e.currentTarget }, () => this.getPharmaCashCounterBillsList());
                        }}>
                          <Badge badgeContent={this.state.pharmaCashCounterBillsCount} color="error" max={999}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PHBills.default} alt='Bills' />
                          </Badge>
                          <Typography fontSize={'0.7vw'}>{t('Bills')}</Typography>
                        </button>
                      </div>
                    </Tooltip>
                    {this.renderPharmaCashCounterBillsPopup()}
                    {this.renderReturnAllBillsPopup()}
                  </div>
                  : null}
                {(window.location.pathname === "/HospitalBilling/CashCounter" || window.location.pathname === "/LabBilling/CashCounter" || window.location.pathname === `/${GetInvestigationName()}Billing/CashCounter` || window.location.pathname === '/PharmacyBilling/CashCounter') && localGetItem('from_cash_counter_edit') !== 'true' ? <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <Tooltip title={'Appointments'} arrow>
                    <div>
                      <button emed_tid="AppointsToBill_btn" className='fo_requests_icon' onClick={(e) => { this.setState({ isOpList: true, isOpListAnchor: e.currentTarget }) }}>
                        <Badge badgeContent={this.state.opListData?.length} color="error" max={999}>
                          <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.RequestsIcon.default} alt='Req'></img>
                        </Badge>
                        <Typography fontSize={'0.7vw'}>{t('OP List')}</Typography>
                      </button>
                    </div>
                  </Tooltip>
                  {UserData?.module_name === "front_office" || UserData?.module_name === 'Pharmacy' ? <Tooltip title={'IP List'} arrow>
                    <div>
                      <button emed_tid="AppointsToBill_btn" className='fo_requests_icon' onClick={(e) => { this.setState({ cash_IpList: true }) }}>
                        <Badge badgeContent={this.state.badgeCount?.ip_list_count_for_cash_counter} color="error" max={999}>
                          <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Ip_list.default} alt='Req'></img>
                        </Badge>
                        <Typography fontSize={'0.7vw'}>{t('IP List')}</Typography>
                      </button>
                    </div>
                  </Tooltip> : null}
                  {(UserData?.module_name === "front_office" && UserData?.enable_radiotherapy) ? <Tooltip title={'RT Walkin'} arrow>
                    <div>
                      <button emed_tid="AppointsToBill_btn" className='fo_requests_icon' onClick={(e) => { this.setState({ rtWalkinOpen : true, isOpListAnchor: e.currentTarget }) }}>
                        <Badge badgeContent={this.state.dupwalkInAppointData ? JSON.parse(this.state.dupwalkInAppointData)?.length : 0} color="error" max={999}>
                          <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.RequestsIcon.default} alt='Req'></img>
                        </Badge>
                        <Typography fontSize={'0.7vw'}>{t('Walkin')}</Typography>
                      </button>
                    </div>
                  </Tooltip> : null}
                  {this.renderOpListPopup(true)}
                  <div>
                    <button emed_tid="IpReqToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ isIPTrans: true, ipTransAnchor: e.currentTarget }) }}>
                      <Badge badgeContent={this.state.CashCounterRefundRequestList?.length} color="error" max={999}>
                        <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyIPReturn.default} alt='Req'></img>
                      </Badge>
                      <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>{"Refund Request"}</Typography>
                    </button>
                    {this.renderRedundRequestPopup()}
                  </div>
                </div> : null}
                {(window.location.pathname === "/Billing/MultiBilling" && getCachevalue("patientData") === null && getCachevalue("IppatientData") === null) ?  <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <Tooltip title={'IP Admission List'} arrow>
                    <div>
                      <button emed_tid="IPAdmissionToBill_btn" className='fo_requests_icon' onClick={() => { this.setState({ ph_IpPatientList: true }) }}>
                        <Badge badgeContent={this.state.badgeCount?.pha_inpatient_count} color="error" max={999}>
                          <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.Ip_list.default} alt='Request'></img>
                        </Badge>
                        <Typography fontSize={'0.7vw'}>{t('IP List')}</Typography>
                      </button>
                    </div>
                  </Tooltip>
                  <Tooltip title={'Appointments'} arrow>
                    <div>
                      <button emed_tid="AppointsToBill_btn" className='fo_requests_icon' onClick={() => { this.setState({ ph_Appointments: true }) }}>
                        <Badge badgeContent={this.state.badgeCount?.pharmacy_appointment_count} color="error" max={999}>
                          <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyApp.default} alt='Request'></img>
                        </Badge>
                        <Typography fontSize={'0.7vw'}>{t('Appointments')}</Typography>
                      </button>
                    </div>
                  </Tooltip>
                  <div>
                    <button emed_tid="IpReqToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ isIPTrans: true, ipTransAnchor: e.currentTarget }, () => this.getFOLabTransmitListData()) }}>
                      <Badge color="error" max={999}>
                        <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyIPReturn.default} alt='Req'></img>
                      </Badge>
                      <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>Transmit</Typography>
                    </button>
                    {this.renderMultiBillingTransmitPopup()}
                  </div>
                </div> : null}
                {this.AppointmentRequestPop()}
                {this.NotificationPopup()}
                {this.QREntryList()}
                {this.AbhaQrList()}
                {/* New Lab Order,draft */}
                {
                ((window.location.pathname === "/LabBilling" || window.location.pathname === "/LabBilling/HospitalBilling") ||
                  (this.state.selectedPageName === "MainHome" && this.state.selectedSubScreen === "Status" && !(window.location.pathname === "/Dashboard") &&
                   !(window.location.pathname === "/LabBilling/NewQuickBilling") && !(window.location.pathname === "/Results") && (this.state.loginType === 'Laboratory'))) ?
                   showNewBilling ?
                   <>
                      <div hidden={getCachevalue('FromOtherScreen') === 'true' ? true : false}>
                        <button emed_tid="IpReqToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ isOpList: true, isOpListAnchor: e.currentTarget }) }}>
                          <Badge badgeContent={this.state.badgeCount?.op_list_count} color="error" max={999}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.RequestsIcon.default} alt='Req'></img>
                          </Badge>
                          <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>OP List</Typography>
                        </button>
                        {this.renderOpListPopup()}
                      </div>
                      <div hidden={getCachevalue('FromOtherScreen') === 'true' ? true : false}>
                        <button emed_tid="IpReqToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ isOpDraft: true, isOpDraftAnchor: e.currentTarget }, () => this.getDraftBillData()) }}>
                          <Badge badgeContent={this.state.badgeCount?.op_draft_list_count} color="error" max={999}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyIPReturn.default} alt='Req'></img>
                          </Badge>
                          <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>Draft</Typography>
                        </button>
                        {this.renderOPDraftPopup()}
                      </div>
                      {/* <div hidden={getCachevalue('FromOtherScreen') === 'true' ? true : false}>
                        <button emed_tid="IpReqToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ isOpOrder: true, isOpOrderAnchor: e.currentTarget }, () => this.getOpOrderListData()) }}>
                          <Badge badgeContent={this.state.badgeCount?.op_order_list_count} color="error" max={999}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.PharmacyIPReturn.default} alt='Req'></img>
                          </Badge>
                          <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>Order List</Typography>
                        </button>
                        {this.renderOpOrderPopup()}
                      </div> */}
                      </> : null : null}
                {localGetItem('isNewBilling') === 'true' && localGetItem('old_to_new_migrated') === 'true' && (
                  window.location.href.includes('/ChartDashboard') ||
                  window.location.href.includes('/FOReports') ||
                  ((window.location.pathname === '/BillingTransaction' || window.location.pathname.startsWith('/BillingTransaction/')) &&
                    this.state.loggedInuserInfo?.module_name === 'front_office')
                ) ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', width: '15%', marginTop:'0.5vw' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: '#fff',
                            '&.Mui-checked': {
                              color: '#fff',
                            },
                          }}
                          size="small"
                          checked={localGetItem('chart_dashboard_new_billing') === 'false'}
                          onChange={(e) => {
                            localSetItem('chart_dashboard_new_billing', e.target.checked ? 'false' : 'true');
                            this.forceUpdate();
                            window.dispatchEvent(new CustomEvent(BILLING_DATA_TOGGLE_EVENT, { bubbles: true }));
                          }}
                        />
                      }
                      label={<Typography>Previous Version Data</Typography>}
                    />
                  </Box>
                ) : null}
                {!(window.location.href.includes("/Dashboard")) && this.state.loggedInuserInfo?.is_checker ? 
                   <div hidden={getCachevalue('FromOtherScreen') === 'true' ? true : false}>
                        <button emed_tid="IpReqToBill_btn" id="basic-button" className='fo_requests_icon' onClick={(e) => { this.setState({ openApproverList: true }, () => this.getApproverListData()) }}>
                          <Badge badgeContent={this.state.isRTConcession ? this.state.badgeCount?.rt_approval_count : this.state.badgeCount?.approver_list_count} color="error" max={999}>
                            <img style={{ height: '1.5vw', width: '1.5vw' }} src={ImagePaths.ApproverIcon.default} alt='Req'></img>
                          </Badge>
                          <Typography fontSize={'0.7vw'} whiteSpace={'nowrap'}>Approvals</Typography>
                        </button>
                        {this.renderAppoverListPopup()}
                      </div> : null}
                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.isSavedBill}
                  onClose={this.savedBillClose}
                  maxWidth={"md"}
                  PaperProps={{
                    style: {
                      //  marginLeft: '76vw',
                      //  marginTop: "-13vw"
                    }
                  }}
                >
                  <div className='emed_Dialogboxwidth'>
                    <Saved_Bill properties={this.props} onClickSavedBills={this.onClickSavedBills} selectedSubScreen={this.state.selectedSubScreen} savedBillStatus={this.getListCount} />
                  </div>
                </Dialog>
                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.isTranmitedBill}
                  onClose={this.transmitedClose}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialogboxwidth'>
                    <Transmit properties={this.props} onClickTranmittedBills={this.onClickTranmittedBills} TransmitBillCount={this.getListCount} />
                  </div>
                </Dialog>
                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.ph_returns}
                  onClose={this.returnClose}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Pres'>
                    <IPReturns properties={this.props} onClickreturnClose={this.onClickreturnClose} />
                  </div>
                </Dialog>
                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.ph_Prescrition}
                  onClose={this.PrescriptionClose}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Pres'>
                    <Prescription properties={this.props} getPharmaPrescriptionCount={this.getListCount} onClickPrescriptionClose={this.onClickPrescriptionClose} />
                  </div>
                </Dialog>
                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.DocQueuePopup}
                  onClose={this.closeDrQueue}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Pres'>
                    <DrQueuePopup data={this.state.drQueueData} date={this.state.datePicker} onClose={this.closeDrQueue} callPatient={this.callPatientSend.bind(this)} />
                  </div>
                </Dialog>
                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.ph_SavedBill}
                  onClose={this.savedBillClose}
                  maxWidth={"md"}
                >
                  <div className='emed_Dia_SaveBill'>
                    <SavedBill properties={this.props} isFromSubLocation={this.state.loginType === "sub_location"} getPharmaSavedBillCount={this.getListCount} onClickSavedBillClose={this.onClickSavedBillClose} />
                  </div>
                </Dialog>
                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.ph_request}
                  onClose={this.requestClose}
                  maxWidth={"md"}
                  // sx={{overflowY: 'hidden'}}
                  style={{ overflowY: 'hidden' }}
                  
                >
                  <div className='emed_Dialog_Pres'  style={this.state.loggedInuserInfo?.allow_ip_request_cancel_in_pharmacy ? {width:"42vw"} : {width:"36vw"}}>
                    <IPRequest properties={this.props} onClickrequestClose={this.onClickrequestClose} recallKey={this.state.loggedInuserInfo?.allow_ip_request_cancel_in_pharmacy} />
                  </div>
                </Dialog>

                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.oPRequestPopUp}
                  onClose={() => { this.setState({ oPRequestPopUp: false }) }}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Appoin' style={{ width: '45vw', height: "35vw" }}>
                    <OpToIpPopup properties={this.props} countList={this.getListCount} onClkClose={(flag) => { this.setState({ oPRequestPopUp: flag }) }}/>
                  </div>
                </Dialog>

                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.ph_IpPatientList}
                  onClose={() => { this.setState({ ph_IpPatientList: false }) }}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Appoin' style={{ width: '38vw' }}>
                    <Appointments properties={this.props} onClickAppointClose={(flag) => { this.setState({ ph_IpPatientList: flag }) }} isFromPharmaApp={true} isFromIpAdmission={true} FromMultiBilling={(window.location.pathname === "/Billing/MultiBilling")}/>
                  </div>
                </Dialog>

                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.ph_Appointments}
                  onClose={() => { this.setState({ ph_Appointments: false }) }}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Appoin'>
                    <Appointments properties={this.props} onClickAppointClose={(flag) => { this.setState({ ph_Appointments: flag }) }} isFromPharmaApp={true} FromcashCounter={(window.location.pathname === "/HospitalBilling/CashCounter" || window.location.pathname ==="/LabBilling/CashCounter" || window.location.pathname === `/${GetInvestigationName()}Billing/CashCounter`)} FromMultiBilling={(window.location.pathname === "/Billing/MultiBilling")}/>
                  </div>
                </Dialog>

                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.Lab_IpPatientList}
                  onClose={() => { this.setState({ Lab_IpPatientList: false }) }}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Appoin' style={{ width: '38vw' }}>
                    <LabIPList properties={this.props} onClickIPListClose={(flag) => { this.setState({ Lab_IpPatientList: flag }) }} IPListLabCount={this.getListCount} />
                  </div>
                </Dialog>

                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.is_labOpList_clked}
                  onClose={() => { this.setState({ is_labOpList_clked: false }) }}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Appoin' style={{ width: '38dvw' }}>
                    <Appointments properties={this.props} onClickAppointClose={(flag) => { this.setState({ is_labOpList_clked: flag }) }} isFromLabHome={true} />
                  </div>
                </Dialog>

                {/* <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.TransAppoint}
                  onClose={() => { this.setState({ TransAppoint: false }) }}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Appoin' style={{ width: '57vw' }}>
                    {this.TransferAppointmentTable()}
                  </div>
                </Dialog> */}
                {this.renderTransferListPopup()}
                {
                  this.state.isAbhaQrRegistered ?
                  <ConfirmPopup
                  cnfAlertPopupClose={() => this.setState({ isAbhaQrRegistered: false, abhaPopupData: {} })}
                  cnfTitle={"Patient Registered Successfully"}
                  cnfAbhaRegister={this.state.abhaPopupData}
                  btnText1={"OK"}
                  btnText2={""}
                  btn2Hide={true}
                  />
                  : null
                }

                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.unlockNotespopup}
                  onClose={() => { this.setState({ unlockNotespopup: false }) }}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Appoin' style={{ width: '38vw' }}>
                    {this.unlockNotesTable()}
                  </div>
                </Dialog>

                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.DoctorRequestPopup}
                  onClose={() => { this.setState({ DoctorRequestPopup: false }, () => this.getDoctorRequestData()) }}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Appoin' style={{ width: '57vw' }}>
                    {this.DoctorRequestDetails()}
                  </div>
                </Dialog>


                <Modal
                  open={this.state.FollowupPopup}
                  onClose={() => { this.setState({ FollowupPopup: false, follow_up_date: new Date() }, () => this.getFollowUpData()) }}
                >
                  <div className='emed_DialogboxOrder_Modal' >
                    {this.FollowupTable()}
                  </div>
                </Modal>

                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.OTrequestPopup}
                  onClose={() => { this.setState({ OTrequestPopup: false }) }}
                  maxWidth={"md"}
                  emed_tid="ot_request_dialog"
                >
                  <div className='emed_Dialog_Appoin' style={{ width: '57vw' }} emed_tid="ot_request_dialog_content">
                    {this.OTRequestTable()}
                  </div>
                </Dialog>

                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.OTallocationPopup}
                  onClose={() => { this.setState({ OTallocationPopup: false }) }}
                  maxWidth={"md"}
                  emed_tid="ot_allocation_dialog"
                >
                  <div className='emed_Dialog_Appoin' style={{ width: '30vw', height: "45vh" }} emed_tid="ot_allocation_dialog_content">
                    {this.OTallocationTable()}
                  </div>
                </Dialog>

                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.OT_IP_Request}
                  onClose={() => { this.closeOTRequestPopup() }}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Appoin' style={{ width: '55dvw', height: '65dvh' }}>
                    <OtIpRequestPopup properties={this.props} onClickClose={() => this.closeOTRequestPopup()} />
                  </div>
                </Dialog>
                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.cash_IpList}
                  onClose={() => { this.setState({ cash_IpList: false }) }}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Appoin' style={{ width: '38vw' }}>
                    <CashCounterIPList properties={this.props} onClickIPListClose={(flag) => { this.setState({ cash_IpList: flag }) }} IPListLabCount={this.getListCount} />
                  </div>
                </Dialog>

                {this.state.sourceOpen ? this.renderSourcePopUp(this.state.uploadData, this.state.selectedImageRowId) : null}

                <div className='fieldHeaderfordoctor'>
                  {window.location.pathname === "/Dashboard" ?
                    <div className='eMed_profile'>
                      <div className='eMed_user'>
                        <label className='eMed_loginuser'>{localGetItem("LogedUserName")}</label>
                      </div>
                    </div> :
                    <div className='eMed_profile'>
                      <div className='eMed_user'>
                        <label className='eMed_loginuser'>{this.state.loginName}</label>
                      </div>
                      <div className='eMed_servicetype'>
                        <label className='eMed_LoginType'>{getCachevalue("DoctorUserChanged") === "true" ? "Doctor" : (this.state.loginType === "master_record_department" ? "Master Record Department" : this.state.loginType === "ot_management" ? "Operation Theatre" : this.state.loginType === "asset_management" ? "Asset Management" : this.state.loginType === "front_office" ? "Front Office" : this.state.loginType)}</label>
                      </div>
                    </div>}
                  <div className='eMed_Avatar'>
                    <Box >
                      <Tooltip title="Profile" arrow>
                        <IconButton disabled={(!(window.location.pathname === "/NoAccess") && (getCachevalue("isForCancelBill") === "true" || getCachevalue("IsForCheckedOut") === "true" || getCachevalue("isInRadiologyBilling") === "true" || (getCachevalue("DisableAllActions") === "true"))) || window.location.pathname === '/video-call'} onClick={(e) => { this.setState({ anchorElUser: true, anchorElUser: e.currentTarget }) }}>
                          <Avatar sx={{ bgcolor: Colors.IconCircleBgColor, boxShadow: 3, color: Colors.ThemeColor }} id="eMed_Icons_Avatar" />
                        </IconButton>
                      </Tooltip>
                      <Menu
                        id="eMed_profileMenu"
                        // anchorEl={this.state.anchorElUser}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        open={this.state.anchorElUser}
                        onClose={this.handleCloseUserMenu}
                        sx={{ marginRight: '5vw' }}
                        TransitionProps={{
                          timeout: 0
                        }}
                      >

                        <div className='eMed_AvatarMenu'>
                          {(this.state.loginType === 'Doctor' || DisableSwitchModule) ? null :
                            !(window.location.href.includes("/Dashboard")) ?
                              <MenuItem onClick={() => {
                                this.handleCloseUserMenu()
                                this.setState({
                                  loginName: "",
                                  loginType: '',
                                  clinicId: null,
                                  badgeCount: {},
                                  anchorElUser: false,
                                  PatientNameSearchKey: '',
                                  pharmaNameSearchKey: '',
                                  searchkey: '',
                                  RTDiscApprovalDeails: null,
                                  isRTConcession: false,
                                }, () => {
                                  this.WebSocketDisconnect()
                                  localClearItem("AccessToken")
                                  localClearItem("loggedInUserInfo")
                                  localClearItem("clinicId")
                                  localClearItem("DoctorsList")
                                  clearCachevalue("isCanteenOverall")
                                  clearCachevalue("IsPORequestEdit")
                                  clearCachevalue('Laboratory_id')
                                  clearCachevalue('subInbound')
                                  clearCachevalue('subOutbound')
                                  clearCachevalue('branchInbound')
                                  clearCachevalue('branchOutbound')
                                  clearCachevalue('subTotal')
                                  clearCachevalue('branchTotal')
                                  clearCachevalue('LabStatusDateFilter')
                                  clearCachevalue('LabSpecimenModuleFilter')
                                  clearCachevalue('LabSpecimenStatusFilter')
                                  clearCachevalue('LabModuleFilter')
                                  clearCachevalue('DoctorHomePageSize')
                                  clearCachevalue('LabCancelledDateFilter')
                                  clearCachevalue('LabStatusDateCustumFilter')
                                  clearCachevalue('LabTstReportDateFilter')
                                  clearCachevalue('LabForTechDateFilter')
                                  clearCachevalue('SelectedOPDate')
                                  clearCachevalue('SelectedDate')
                                  clearCachevalue('OP_CreateAppointment_PatientId')
                                  clearCachevalue('BillType')
                                  clearCachevalue('FromOtherScreen')
                                  clearCachevalue('Status')
                                  clearCachevalue('FormDate')
                                  clearCachevalue('ToDate')
                                  clearCachevalue('RtDosimetristPatientData')
                                  localClearItem('is_investigation_module')
                                  localClearItem('investigation_name')
                                  localClearItem('globalDateFilter')
                                  history.push('/Dashboard');
                                  this.setState({
                                    selectedMenuId: null,
                                    selectedPageName: "",
                                    FoNotifyList: {},
                                    notifyCount: 0,
                                  })
                                  clearAccessCache()
                                })
                              }}>
                                <GridViewIcon sx={{ color: Colors.ThemeColor, marginRight: '0.5vw' }} />
                                {t('SwitchModule')}
                              </MenuItem>
                              : null
                          }
                          {(this.state.loginType === 'Doctor' && myUser?.is_qms_enabled) ?
                            <MenuItem onClick={() => {
                              this.setState({
                                anchorElUser: false,
                              }, () => {
                                history.push('/ViewDoctorProfile')
                              })
                            }}>
                              <AccountBoxIcon sx={{ color: Colors.ThemeColor, marginRight: '0.5vw' }} />
                              {`${t('View Profile')}`}
                            </MenuItem> : null}
                          <MenuItem onClick={() => { this.logout() }}>
                            <ExitToAppIcon sx={{ color: Colors.ThemeColor, marginRight: '0.5vw' }} />
                            {t('Logout')} / <span>{ContentInTooltip(localGetItem("LogedUserName"), 15)}</span>
                          </MenuItem>
                        </div>

                      </Menu>
                    </Box>
                  </div>
                </div>
              </Toolbar>
            </AppBar>
            {this.state.searchPatientDetails && this.state.searchPatientDetails.length > 0 && this.state.isPatientSearch ?
              <Paper className='Patient_Details_Search'>
                {this.state.searchPatientDetails.map((item, index) => {
                  return (
                    <div className='Lab_Home_Saved_Bill' >
                      <Avatar id='eMed_IconAvatar' src={item.photo_url ? item.photo_url : ImagePaths.Default} sx={{ boxShadow: 3, minWidth: '13%', marginTop: '1vh', marginRight: '2vh', marginBottom: '1vh' }} />
                      <div style={{ minWidth: '55%' }}>
                        <Typography sx={{ margin: "0vw" }}>{item.first_name}</Typography>
                        <div className='search_sub_container'>
                          <Typography className='savedTextLight' sx={{ fontSize: "0.8vw" }}>{item.mobile_number}</Typography>
                          <Typography className='savedTextLight' sx={{ fontSize: "0.8vw", marginLeft: "0.5vw" }}>{" | " + item.patient_account_number ? item.patient_account_number : ""}</Typography>
                        </div>
                      </div>
                      <button size="small" className='Lab_Search_Button' onClick={() => {
                        history.push({ pathname: "/LabHome", state: { searchPatientDetails: item } })
                        this.setState({
                          isPatientSearch: false
                        })
                      }}><p className='Lab_saved_Bill_Text'>{'Proceed'}</p></button>
                    </div>
                  )
                })
                }
              </Paper> : null
            }
            {!(window.location.href.includes("/Dashboard")) ?
              <Drawer className='eMed_Drawer' sx={{ display: window.location.pathname === '/video-call' ? 'none' : '' }}
                variant="permanent" open={this.state.drawer_Open} >
                <DrawerHeader className='eMed_drawerlogo' sx={{ backgroundColor: Colors.pageTopBackground }}>
                  {/* <img className='img_logo1' src={Fulllogo} alt="logo" /> */}
                  <IconButton onClick={this.handleDrawerClose}>
                    {theme.direction === 'rtl' ? <ChevronRightIcon sx={{ color: Colors.ListIcons }} /> : <ChevronLeftIcon sx={{ color: Colors.ListIcons }} />}
                  </IconButton>
                </DrawerHeader>
                <List id="eMed_side_list">
                  {(getCachevalue("DoctorUserChanged") !== "true") && menuList.map((item, index) => {
                    let DisplayLabel = item.label.split(" ");

                    const isSubscriptionRestricted = this.state.subscription_expired === true
                      && restrictedLabels.has(item.label);

                    // Allow side menu navigation when on NoAccess page
                    const isOnNoAccessPage = window.location.pathname === "/NoAccess";

                    // disable all sidemenu during from cancel bill
                    // But allow navigation when on NoAccess page so users can navigate away
                    const isOtherDisabled = !isOnNoAccessPage && (
                      getCachevalue("isForCancelBill") === "true" ||
                      // getCachevalue("isForVisitreport") === "true" ||
                      getCachevalue("IsForCheckedOut") === "true" ||
                      getCachevalue("IsPORequestEdit") === "true" ||
                      getCachevalue("isCanteenOverall") === "true" ||
                      getCachevalue("DisableAllActions") === "true" ||
                      getCachevalue("isInRadiologyBilling") === "true"
                    );

                    const isDisabled = isOtherDisabled || isSubscriptionRestricted;
                    return (
                      <React.Fragment key={index}>
                        <ListItem
                          disabled={isDisabled}
                          className='eMed_menuItems'
                          sx={{
                            // color: window.location.href.toLowerCase().includes(item.menuName.replace(/\s/g, '').toLowerCase()) ? Colors.ContrastText : Colors.ListItems,
                            // backgroundColor: window.location.href.toLowerCase().includes(item.menuName.replace(/\s/g, '').toLowerCase()) ? Colors.ThemeColor : Colors.pageTopBackground,
                            // borderRadius: this.state.drawer_Open ? "5%" : "20%",
                            maxWidth: '3.3vw',
                            marginBottom: '1.5vh',
                            alignItems: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 0
                          }}
                          // button 
                          key={item.menuName}
                          checked={this.state.checked}
                          onClick={() => {
                            // if (role === "admin" && item.is_locked) {
                            //   showLockPopup(item.menuName);
                            // } else 
                            if (!isDisabled) {
                              // Clear disabling cache values when navigating from NoAccess page
                              // This ensures menu items remain enabled when navigating to accessible screens
                              if (window.location.pathname === "/NoAccess") {
                                clearCachevalue("isForCancelBill")
                                clearCachevalue("IsForCheckedOut")
                                clearCachevalue("IsPORequestEdit")
                                clearCachevalue("isCanteenOverall")
                                clearCachevalue("DisableAllActions")
                                clearCachevalue("isInRadiologyBilling")
                              }
                              
                              this.setState({
                                selectedMenuId: item.id,
                                selectedSubMenuId: null,
                                selectedPageName: item.menuName,
                                searchkey: "",
                                configSearch: '',
                                inventorySearch: "",
                                reportSearch: "",
                                purchaseSearch: '',
                                clinic_name: null,
                                PatientNameSearchKey: "",
                                PatientAddressKey: "",
                                PatientFathHusKey: "",
                                badgeCount: {},
                                PatientMotherKey: "",
                                pharmaNameSearchKey: "",
                                FilterIP: "",
                                FilterOP: "",
                              }, () => {
                                // if(getCachevalue('component') === 'true'){
                                //   setCachevalue(JSON.stringify(item),'path_name')
                                // }else{
                                  if(item.menuName !== "Billing Transaction"){
                                    localClearItem('globalDateFilter')
                                  }
                                  this.onClick(this.props.history.push(`/${item.menuName.replace(/\s/g, '')}`),)
                                  this.clearCacheData(item?.menuName)
                                // }
                              })
                            }
                          }}>
                          <Tooltip placement='right' title={t(item.label)} disableInteractive arrow>
                            <Badge color="error" badgeContent={(item.menuName === 'Pharmacy Stock Transfer' || item.menuName === 'SubLocation Stock Transfer' || item.menuName === 'OT Stock Transfer') ? (this.state.indent_Count?.total ? this.state.indent_Count?.total : 0) : 0} showZero={false}>
                              <ListItemIcon emed_tid={`${'ph_' + item.label}`} className='eMed_menuIcon' sx={{ display: 'flex', flexDirection: 'column', padding: 0, alignItems: 'center' }}>
                                <Avatar
                                  src={
                                    ((window.location.pathname.split("/")[1] === item.menuName.replace(/\s/g, '')) || ( item?.menuName === "MainHome" && window.location.pathname === "/Results")  ) ? item.OnIcon.default : item.OffIcon.default
                                  }
                                  sx={((window.location.pathname.split("/")[1] === item.menuName.replace(/\s/g, '')) || ( item?.menuName === "MainHome" && window.location.pathname === "/Results")) ? { width: '3vw', height: '3vw' } : { width: '2.5vw', height: '2.5vw' }}
                                  variant="square"
                                />
                                {
                                  DisplayLabel.map((list) => (
                                    <Typography component={'p'} style={{ color: window.location.href.toLowerCase().includes(item.menuName.replace(/\s/g, '').toLowerCase()) ? Colors.themeDark : Colors.disableLabelColor, whiteSpace: "pre-line", alignContent: "center", justifyContent: "center" }} variant="caption" sx={{ maxWidth: '3.3vw', fontSize: '0.6vw' }}>{list}</Typography>
                                  ))
                                }

                              </ListItemIcon>
                            </Badge>
                          </Tooltip>
                          {/* <ListItemText primary={t(item.menuName)} className='eMed_menuText' /> */}
                        </ListItem>
                      </React.Fragment>
                    )
                  })}

                </List>
              </Drawer> : null}
            <Box component="main" sx={{ flexGrow: 1, minWidth: '10vw', pl: '3vw', pr: '1vw' }} >
              <RouterComponent reportSearch={this.state.reportSearch} inventorySearch={this.state.inventorySearch}
                purchaseSearch={this.state.purchaseSearch} configSearch={this.state.configSearch}
                clearSearch={this.clearSearch} changeScreen={this.changeScreen}
                subScreenChange={this.subScreenChange} isSearchClear={this.isSearchClear}
                clinicId={this.state.clinicId} getSavedBillStatus={this.getListCount}
                getTransmitBillCount={this.getListCount} getRadTransmitCount={this.getRadTransmitBillCount}
                getIPListCount={this.getListCount} getPharmaSavedBillCount={this.getListCount}
                getPharmaPrescriptionCount={this.getListCount} changeDate={this.state.unlockDate}
                isOPT={this.state.isOPT} OTRequest={this.state.AcceptRequest} isGetCalled={this.isGetCalled}
                CallPatientTrigger={this.state.CallPatientTrigger} ClearCalledTrigger={this.ClearCalledTrigger}
                getcountNotification={this.getcountNotification} closeAlertPopup={this.closeAlertPopup} 
                getbillingCount={this.getListCount} getRefundRefundCOunt={this.getRefundRefundCOunt} getListCount={this.getListCount}
                triggerNotifyCount = {this.triggerNotifyCount} getOptSuggestionData = {this.getOptSuggestionData}/>
            </Box>
          </Box>
          <Loader loaderOpen={this.state.isLoader} />
          {this.state.ModuleSucessPop ?
            <DialogPop
              type={"Notification"}
              DialogClose={this.dialogCloseFunction}
              header={"Message"}
              content={"Primary Modules Updated Successfully"}
              icon={<img className="eMed_dilboxAnimations" alt="Warning" src={Success} />}
              secondary={"Close"}
              closeButton={this.dialogCloseFunction} />
            : null}
          <Box sx={{ height: '1vh', width: '100%', zIndex: 1200, position: 'fixed', borderTop: '1px solid lightgrey', backgroundColor: Colors.BgColor, }}></Box>
          <Box sx={{ height: '5vh', width: '100%', zIndex: 1200, position: 'fixed', backgroundColor: Colors.ThemeColor, alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'row' }}>
            <Avatar
              src={ImagePaths.Logo.default}
              sx={{ width: '1vw', height: '1vw', marginRight: '0.25vw' }}
            />
            <Typography color={Colors.white} fontSize={'1vw'}>www.emedhub.in</Typography>
            <Typography sx={{ paddingLeft: 2, paddingRight: 5 }} color={Colors.white} fontSize={'1vw'}>{APP_Version_Label}</Typography>
            <Typography color={Colors.white} fontSize={'1vw'}>{APP_Support_Label}</Typography>
            {(UserData?.module_name === "front_office" || UserData?.module_name === "Pharmacy" || UserData?.module_name === "Laboratory") ? window.location.pathname === '/Dashboard' ? null :
              <IconButton color="primary" aria-label="add item" sx={{ marginLeft: 5, marginRight: '0.25vw' }}
                onClick={() => {
                  this.setState({
                    isHelpdeskClicked: true
                  })
                }}
              >
                <HelpOutline color="action" sx={{ width: '1.2vw', height: '1.2vw', marginLeft: '0.25vw' }} />
                <Typography color={Colors.white} fontSize={'1vw'}>Customer Support</Typography>
              </IconButton> : null}
          </Box>
          {this.state.deletePopup ? <DeletePopup
            DeletTitle={`Are you sure you want to cancel this appointment ?`}
            deleteAlertPopupClose={this.popupClose.bind(this)}
            removeData={this.removeappointment.bind(this)}
          /> : null}
          {
            this.state.isErrorMsg ?
              <ToastMsg
                severity={'error'}
                msg={this.state.isErrorMsgText}
                msgPop={this.msgClose.bind(this)}
              />
              : this.state.isSuccessMsg ?
                <ToastMsg
                  severity={'success'}
                  msg={this.state.isSuccessMsgText}
                  msgPop={this.msgClose.bind(this)}
                /> : null
          }
          {
            this.state.isInfoMsg ?
              <ToastMsg
                severity={'info'}
                msg={this.state.isInfoMsgText}
                msgPop={this.msgClose.bind(this)}
                rightside={true}
              /> : null
          }
          {
            this.state.isViewHistory ?
              <CommonPopUp width={"75vw"}
                backgroundColor={Colors.white}
                popUpClose={this.PopUpClose.bind(this)}
                title={this.state.testName}
                component={this.viewCultureTest.bind(this, this.state.viewCultureData)} />
              : null
          }
          {this.state.isViewOgtt && this.ogttTestView()}
          {this.state.IdleAlertPopup ?
            <Box className="IdleNotiContainer">
              <Paper>
                <div className='IdleNotiWrapper'>
                  <div className='NotiHeaderContainer'>
                    <div className='NotiIcon'><WarningIcon sx={{ height: '1.5vw', width: '1.5vw', color: "white" }} /></div>
                    <div className='NotiText' style={{ fontWeight: 600 }}>System Logout Alert ! </div>
                  </div>
                  <div className='NotiPara' style={{ paddingLeft: "10vw" }}>
                    {"Your session will expire in few minutes due to inactivity. Please continue your activity to stay logged in."}
                  </div>
                </div>
              </Paper>
            </Box>
            : null}
          {this.state.smsAlert ?
            <Box className="IdleNotiContainer">
              <Paper>
                <div className='IdleNotiWrapper' style={{ justifyContent: 'space-between' }}>
                  <div className='NotiHeaderContainer'>
                    <div className='NotiIcon'><WarningIcon sx={{ height: '1.5vw', width: '1.5vw', color: "white" }} /></div>
                    <div className='NotiText' style={{ fontWeight: 600 }}>Account has reached the threshold limit. Renew your subscription to maintain lag free SMS service</div>
                  </div>
                  <div>
                    <Button variant='outlined' sx={{ color: 'white' }} onClick={this.ignoreSmsAlert}>Ignore</Button>
                  </div>
                </div>
              </Paper>
            </Box>
            : null}
          {this.state.whatsappAlert ?
            <Box className="IdleNotiContainer">
              <Paper>
                <div className='IdleNotiWrapper' style={{ justifyContent: 'space-between' }}>
                  <div className='NotiHeaderContainer'>
                    <div className='NotiIcon'><WarningIcon sx={{ height: '1.5vw', width: '1.5vw', color: "white" }} /></div>
                    <div className='NotiText' style={{ fontWeight: 600 }}>Account has reached the threshold limit. Renew your subscription to maintain lag free WhatsApp service</div>
                  </div>
                  <div>
                    <Button variant='outlined' sx={{ color: 'white' }} onClick={this.ignorewhatsappAlert}>Ignore</Button>
                  </div>
                </div>
              </Paper>
            </Box>
            : null}
          {this.state.FaceRecogClicked ? this.OpenFaceRecogPop() : this.state.docFaceRecogClicked ? this.OpenFaceRecogPop(true) : null}
          {this.renderHelpDeskPopup()}
          {!isOnline ?
            <Box className="NotiContainer">
              <Paper>
                <div className='NotiWrapper'>
                  <div className='NotiHeaderContainer'>
                    <div className='NotiIcon'><ErrorIcon sx={{ height: '1.5vw', width: '1.5vw', color: "white" }} /></div>
                    <div className='NotiText'>Notification </div>
                  </div>
                  <div className='NotiPara'>
                    {NO_Internet_Connection}
                  </div>
                </div>
              </Paper>
            </Box>
            : null}
          {this.state.isUpdateAbhaPopup ? 
          this.renderUpdateAbhaPopup() : null
          }
          {this.state.saveReason ?
            <DeletePopup
              DeletTitle={`Are you sure do you want to delete the saved bill ?`}
              deleteAlertPopupClose={this.popupClose}
              removeData={this.deleteSavedBillData}
              disable={this.state.removeData}
            />
            : null}
          {this.state.pharmaBillsDenyPopupOpen ? (
            <DeletePopup
              DeletTitle={'Are you sure you want to deny?'}
              DeleteNotify={'This action cannot be undone'}
              deleteAlertPopupClose={() => this.setState({ pharmaBillsDenyPopupOpen: false, pharmaBillsDenySelectedItem: null })}
              removeData={() => {
                this.setState({ pharmaBillsDenyPopupOpen: false, pharmaBillsDenySelectedItem: null }, () => {
                  this.getPharmaCashCounterBillsList();
                });
              }}
            />
          ) : null}
          <Box component={'div'}>
            <Modal open={this.state.radHistoryPopup}>
              <Box
                component={'div'}
                sx={{
                  position: 'absolute',
                  top: '55%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: "60vw",
                  height: "58.6vh",
                  backgroundColor: "white",
                  borderRadius: "8px",
                  paddingBottom: "0.5vw"
                }}
              >
                <Box
                  height="7vh"
                  pl="1vw"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography fontSize="0.9vw" fontWeight={600}>History</Typography>
                  <Button onClick={() => this.setState({ radHistoryPopup: false, patientHistory: [] })}>
                    <Box component="img" src={ImagePaths.LabCloseButton.default} height="1vw" width="1vw" />
                  </Button>
                </Box>

                  <Divider />

                <Box p="0.5vw">
                  <Box margin="0.5vw" border="1px solid lightgray">
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ textAlign: "left !important", fontSize: "0.9vw", fontWeight: 600 }}>S.no</TableCell>
                          <TableCell sx={{ textAlign: "left !important", fontSize: "0.9vw", fontWeight: 600, }}>Date & time</TableCell>
                          <TableCell sx={{ textAlign: "left !important", fontSize: "0.9vw", fontWeight: 600 }}>Service</TableCell>
                          <TableCell sx={{ textAlign: "center !important", fontSize: "0.9vw", fontWeight: 600, }}>Result</TableCell>
                        </TableRow>
                      </TableHead>
                    </Table>
                    <Box sx={{ maxHeight: "44vh", overflowY: "auto" }}>
                      <Table size="small">
                        <TableBody>
                          {this.state.patientHistory?.length > 0 ? (
                            this.state.patientHistory.map((item, index) => {
                              const serviceName = `${item?.service_type} - ${item?.service_name}`;
                              return (
                                <TableRow key={index}>
                                  <TableCell sx={{ textAlign: "left" }}>{index + 1}</TableCell>
                                  <TableCell sx={{ textAlign: "center" }}>{item?.report_date}</TableCell>

                                  <TableCell sx={{ textAlign: "center" }}>
                                    {serviceName.length > 25 ? (
                                      <Tooltip title={serviceName}>
                                        <div>{serviceName.slice(0, 25) + "..."}</div>
                                      </Tooltip>
                                    ) : (
                                      serviceName
                                    )}
                                  </TableCell>

                                  <TableCell sx={{ textAlign: "center !important" }}>
                                    <Tooltip title="Print">
                                      <Button
                                        sx={{
                                          "&.Mui-disabled": {
                                            cursor: "not-allowed !important",
                                            pointerEvents: "auto !important",
                                          },
                                        }}
                                        disabled={!(item?.result_status === "Completed" || item?.result_status === "Dispatched")}
                                        onClick={() => this.getPatientHistoryPrint(item?.id)} className='eMed_usrconf_btn'>
                                        <img src={ImagePaths.PrintIcons.default} alt="print" className='eMed_action_img' />
                                      </Button>
                                    </Tooltip>
                                    <Tooltip title={"Preview"} placement="top" arrow>
                                      <Button sx={{
                                        bgcolor: '#04B7B1', '&:hover': {
                                          bgcolor: '#04B7B1',
                                        },
                                        "&.Mui-disabled": {
                                          // bgcolor: "#A5A5A5 !important",
                                          cursor: "not-allowed !important",
                                          pointerEvents: "auto !important",
                                        },
                                      }}
                                        disabled={!this.hasDocuments(item?.service_details) || !(item?.result_status === "Completed" || item?.result_status === "Dispatched")}
                                        className='eMed_usrconf_btn'
                                        onClick={
                                          this.hasDocuments(item?.service_details)
                                            ? () => this.getS3Keys(this.getAllDocuments(item?.service_details))
                                            : undefined
                                        }
                                      >
                                        <DescriptionIcon sx={{ width: '1.3vw', height: '1.3vw', color: 'white' }}
                                        />


                                      </Button>
                                    </Tooltip>
                                  </TableCell>
                                </TableRow>
                              )
                            })
                          ) : (
                            <TableRow>
                              <TableCell>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    fontSize: "0.9vw",
                                    fontWeight: 500,
                                    color: "#555",
                                      // height:'30vh'
                                  }}
                                >
                                  No Records To Be Shown
                                </Box>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>

                    </Box>

                  </Box>
                </Box>

              </Box>
            </Modal>
          </Box>
          {
            this.state.pdfPreview ?
              <DocumentPreviewPop
                Data={this.state.pdfData}
                ImageData = {this.state.ImgData}
                Title={"PDF Preview"}
                ClosePopUp={this.ClosePopUp.bind(this)}
              /> : null
          }
          {
            (this.state.loggedInuserInfo?.is_user === false && this.state.subscription_alert_message && this.state.subscription_alert_message !== "null" && this.state.subscription_alert_message !== "undefined") ?
              <Box className="IdleNotiContainer">
                <Paper>
                  <div className='IdleNotiWrapper' style={{ justifyContent: 'space-between', backgroundColor: "#F19C38" }}>
                    <div className='NotiHeaderContainer'>
                      <div className='NotiIcon'><WarningIcon sx={{ height: '1.5vw', width: '1.5vw', color: "white" }} /></div>
                      <div className='NotiText' style={{ fontWeight: 600 }}>{this.state.subscription_alert_message}</div>
                    </div>
                    <div>
                      <Button variant='outlined' sx={{ color: 'white' }} onClick={this.ignoreSubscriptionAlert}>Ignore</Button>
                    </div>
                  </div>
                </Paper>
              </Box> : null
          }
          {this.state.printPreviewPop ?
            <DocumentPreviewPop
              Data={this.state.printPreviewData}
              Title={this.state.pdfName}
              BillData={this.state.patientDatasRow?.id}
              ClosePopUp={() => { this.closePrintPreview() }}
              history={this.props.history}
            /> : null}
          {this.state?.RTDiscApprovalDeails ?
            <RTDiscApprovalPopup
              data={this.state.RTDiscApprovalDeails}
              onClose={(apicall) => {
                this.setState({ RTDiscApprovalDeails: null, isRTConcession: false })
                if (apicall) {
                    
                }
              }}
            /> : null}
        </div>
      )
    } else {
      return (<RouterComponent />)
    }
  }
}
export default withRouter(withTranslation()(MiniDrawer));